import { useContext } from 'react'
import { StateContext } from "../context/GlobalState";

export function GetText() {

    let text = "";
    let { lang } = useContext(StateContext)

    if (lang === "ua") {
        text = {
            Navigation: [
                {
                    menu: "Країни",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/az",
                            name: "Азербайджан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/al",
                            name: "Албанія",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/bg",
                            name: "Болгарія",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/am",
                            name: "Вірменія",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },

                        {
                            link: "/country/ge",
                            name: "Грузія",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Киргизстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "Північна Македонія",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Монголія",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "Об'єднані Арабські Емірати",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Сербія",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словенія",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Словаччина",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сінгапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Таджикістан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Туреччина",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Туркменістан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/hu",
                            name: "Угорщина",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/uz",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        },
                        {
                            link: "/country/ua",
                            name: "Україна",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорватія",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        }
                    ]
                },
                {
                    menu: "Рішення",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Вендори МУК"
                        },
                        {
                            link: "/solutions",
                            name: "Рішення МУК"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Каталог продуктів і сервісів"
                        }
                    ]
                },
                {
                    menu: "Новини",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Новини і Акції"
                        },
                        {
                            link: "/muk-review",
                            name: "Журнал МУК"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Відео"
                        }
                    ]
                },
                {
                    menu: "Напрями",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Дистрибуція IT"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Навчальний центр"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Сервісний центр"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "Хмарні сервіси MUK Cloud"
                        }
                    ]
                },
                {
                    menu: "Про компанію",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Головне про МУК"
                        },
                        {
                            link: "https://muk.group/download/files/corporate_profile.pdf",
                            name: "Корпоративний профайл"
                        },
                        {
                            link: "/vacancies",
                            name: "Вакансії"
                        }
                    ]
                },
                {
                    menu: "Дилерський розділ",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.az/",
                            name: "Азербайджан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албанія",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Болгарія",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Вірменія",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },

                        {
                            link: "https://b2b.muk.ge/",
                            name: "Грузія",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Киргизстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "Північна Македонія",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Монголія",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },

                        {
                            link: "https://b2b.muk.ua/",
                            name: "Об'єднані Арабські Емірати",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },


                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Сербія",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словенія",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Таджикістан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туреччина",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туркменістан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Україна",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хорватія",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Міжнародний проєктний VAD IT-дистриб'ютор",
                paragraph: "Вважають нас надійним мультивендорним IT-дистриб'ютором, довіряють нашому багаторічному досвіду, технічній компетенції та налагодженій партнерській моделі роботи",
                partner: "Стати партнером"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Міжнародний дистриб'ютор",
                    text: "Географія МУК включає 16 країн Європи та Азії та безперервно розширюється"
                },
                {
                    icon: "fa fa-star",
                    title: "Понад 25 років успіху",
                    text: "МУК утримує лідерські позиції з 1997 року"
                },
                {
                    icon: "fa fa-users",
                    title: "Унікальна експертиза",
                    text: "Інженерна команда МУК впорається з будь-яким, навіть найскладнішим завданням"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ виробників",
                    text: "У дистриб'юторському портфелі МУК понад 100 світових А-брендів і їхня кількість постійно збільшується"
                }
            ],
            ServicesInfo: {
                title: "Напрями діяльності МУК"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Дистрибуція IT",
                    text: "МУК – VAD-дистриб'ютор, орієнтований на проєктний IT-бізнес. Ми понад 25 років успішно розвиваємо дилерську мережу в країнах Європи та Азії.\nЗа допомогою штату сертифікованих фахівців МУК надає партнерам високий рівень проєктного консалтингу та технічну підтримку, цим генерує додаткову цінність пропонованих рішень.\nІнженери МУК реалізують консалтинг і технічну підтримку програмних і апаратних рішень , проводять аудити наявних систем і допомагають з реалізацією тестових стендів. Наш парк тестового обладнання дозволяє змоделювати й реалізувати широкий спектр завдань у реальних умовах.\nМУК активно допомагає інтеграторам у виборі та проєктуванні оптимальних рішень.\nКоманда МУК включає понад 500 фахівців різних технологічних напрямів, які мають сертифікати провідних світових IT-виробників.",
                    activ1: "Міжнародна логістика, формування складів",
                    activ2: "Маркетингова та консалтингова підтримка партнерів",
                    activ3: "Підвищення цінності рішень за рахунок власної компетенції",
                    activ4: "Виведення продуктів на ринок, просування та формування попиту",
                    activ5: "Технічна підтримка, гарантійне та післягарантійне обслуговування",
                    activ6: "Розвиток партнерської мережі"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Хмарні продукти MUK Cloud Solution Provider",
                    text: "Хмарні рішення МУК для бізнесу MUK Cloud Solutions – це готові до швидкого старту комплекти рішень і послуг, спрямовані на забезпечення безперервності бізнесу, підвищення ефективності роботи й мобільності співробітників, з наданням сучасних захищених засобів колективної взаємодії.\nЗ їхньою допомогою ви зможете швидко та ефективно впровадити хмарні технології в інфраструктуру вашої організації. Концепція Cloud Solution Provider – це канал продажів, у якому доступні хмарні сервіси Microsoft Office 365, AZURE, EMS, D365 та інші з оплатою помісячно.\nМУК пропонує створення інфраструктури з нуля. Мінімальні капітальні витрати. Оптимальні операційні витрати на оренду хмарних ресурсів і сервісне обслуговування. Масштабування інфраструктури (зростання підприємства, нові територіальні офіси, сплески навантаження, що плануються). Нові послуги в хмарі, інтегровані з наземною інфраструктурою.",
                    activ1: "Зберігання резервних копій (файли, віртуальні машини, бази даних) у хмарі.",
                    activ2: "Захист від аварійних збоїв, відновлення. Кластери високої доступності на рівні віртуальних машин або баз даних SQL.",
                    activ3: "Управління мобільними пристроями.",
                    activ4: "Захист корпоративної інформації та листування",
                    activ5: "Розгортання SharePoint online, Exchange online, Skype for business on-line.",
                    activ6: "Розгортання та налаштування веб-сайтів, міграція сайтів у хмару."
                },
                {
                    icon: "fa fa-wrench",
                    name: "Сервісний центр «МУК-Сервіс»",
                    text: "Компанія «МУК-Сервіс» з 2002 року успішно надає послуги з ремонту комп'ютерної техніки й на сьогодні є авторизованим сервісним центром APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, НР, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom та інших виробників. Система менеджменту якості компанії «МУК-Сервіс» підтверджена сертифікатом ISO 9001 Бюро Міжнародної Сертифікації.\nЩоб оперативно впоратися з будь-якою несправністю, необхідно бути справжнім спеціалістом. Наші майстри, отримуючи досвід і щоденну практику, вирішують будь-яку несправність. Професіоналізм приходить із досвідом, ми самовдосконалюємось і підвищуємо рівень своїх знань. Персонал сервісного центру складається з сертифікованих спеціалістів, що гарантує замовникам якісний і професійний ремонт обладнання. «МУК-Сервіс» має всі необхідні технічні можливості для забезпечення якісного сервісного обслуговування. Сервісний центр виконує технічне обслуговування, гарантійний і негарантійний ремонт будь-якого рівня складності. Компанія «МУК-Сервіс» надає послуги з оренди й аутсорсингу обладнання, інсталяції та технічного обслуговування, а також інформаційно-консалтингові послуги для корпоративних клієнтів на території України, Вірменії, Грузії, Молдови, Таджикистану та Казахстану.",
                    activ1: "Гарантійний ремонт",
                    activ2: "Негарантійний ремонт",
                    activ3: "Діагностика обладнання",
                    activ4: "Продаж запчастин",
                    activ5: "Аудит сервісних контрактів",
                    activ6: "Оренда та аутсорсинг обладнання"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Навчальний центр МУК",
                    text: "Навчальний центр МУК – лідер на ринку освітніх послуг у сфері ІТ з більш ніж з 15-річним стажем та наявністю низки унікальних авторизацій, команди кваліфікованих інструкторів та сучасної навчальної інфраструктури.\nПортфель НЦ МУК включає понад 300 навчальних курсів від провідних ІТ-компаній.\nСеред статусів слід зазначити: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nНавчальний центр MUK Навчальний центр МУК має доступ до найсучаснішого навчального обладнання. Якість викладання нашими інструкторами підтверджується протягом багатьох років високими оцінками слухачів в Україні та за її межами."
                }
            ],
            Vendors: {
                title: "Вендори МУК",
                country: "Країна",
                solution: "Рішення",
                name: "Назва",
                all: "Усе",
                namePlaceholder: "Почніть вводити назву вендора",
                notInfo: "Інформацію не заповнено"
            },
            VendorsForCountry: {
                title: "Вендори МУК, доступні в країні"
            },
            VendorsForSolution: {
                title: "Вендори МУК, за рішенням"
            },
            VendorDetail: {
                title: "АВТОРИЗОВАНИЙ ДИСТРИБ'ЮТОР"
            },
            Gallery: {
                title: "Рішення МУК"
            },
            Distribution: {
                title: "Дистрибуція ІТ"
            },
            Partner: {
                title: "Стати партнером",
                description: "Будь ласка, заповніть форму нижче, щоб надіслати нам електронний лист, і ми зв'яжемося з вами якнайшвидше.",
                nm: "ПІБ",
                ph: "Телефон",
                em: "Email",
                com: "Компанія",
                sitecom: "Сайт компанії",
                dir: "Напрям діяльності",
                found: "Звідки про нас дізналися",
                send: "Надіслати",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Відправити резюме",
                description: "Будь ласка, заповніть форму нижче, щоб надіслати нам електронний лист, і ми зв'яжемося з вами якнайшвидше.",
                vac: "Вакансія, що цікавить",
                nm: "ПІБ",
                ph: "Контактний телефон",
                em: "Email",
                file: "Файл резюме (PDF або DOC)",
                note: "Супровідний лист",
                send: "Надіслати",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "МУК будує бізнес на принципах партнерства та співпраці",
                advantages: "Переваги",
                paragraph: "МУК з моменту свого заснування робить ставку на прозорість у відносинах із постачальниками та замовниками. Відданість правилам партнерства дозволила МУК заробити довіру ринку та сформувати репутацію лідера",
                Why: [
                    "Інновації",
                    "Відповідальність",
                    "Чесність",
                    "Рівні можливості працевлаштування"

                ],
                Why2: [
                    "Робота в команді та повага",
                    "Навчання",
                    "Соціальна відповідальність"
                ]
            },
            News: {
                title: "Новини МУК",
                showAll: "Показати все",
                showMore: "Показати ще",
                news: "Новина",
                akcii: "Акція"
            },
            Vacancies: {
                title: "Вакансії МУК",
                resume: "Надіслати резюме",
                country: "Країна",
                all: "Усе",
                search: "Пошук",
                namePlaceholder: "Почніть вводити назву",
                filterInfo: "За цими фільтрами вакансій немає",
                notInfo: "Інформацію не заповнено",
                back: "Назад"
            },
            MukReview: {
                title: "Випуски журналу \"MUK-REVIEW\"",
                vupysk: "Випуск"
            },
            OMuk: {
                title: "Головне про МУК",
                p1: "Група компаній МУК розпочала свою діяльність у 1997 році. Наш основний напрям роботи – проєктно-орієнтована дистрибуція провідних IT-продуктів у галузі гібридних і хмарних рішень, конвергенції центрів обробки даних, інформаційної безпеки, мобільних пристроїв та Інтернету речей, аналітики даних і штучного інтелекту.",
                p2: "Завдяки нашій глобальній дистриб'юторській мережі ми виводимо на локальні ринки перспективних IT-вендорів та їхні нові продукти, беремо активну участь у формуванні попиту.",
                p3: "Ми поєднуємо експертні технічні та ринкові знання з прогресивною програмою підтримки партнерів. Тісно співпрацюючи з нашими дилерами, ми прагнемо забезпечити їхнє динамічне зростання та розвиток, досягаючи результатів разом.",
                bp1: "ІНФОРМАЦІЙНІ ТЕХНОЛОГІЇ – ЦЕ МИ!",
                p4: "Компанія МУК була піонером у сфері розповсюдження інформаційних технологій більш ніж 25 років тому. Сьогодні МУК відіграє важливу роль у передачі технологій від тих, хто їх розробляє, тим, хто їх впроваджує та використовує.",
                ul: "Чотири цифри, що характеризують МУК як надійного партнера та ефективного дистриб'ютора:",
                li1: "1. Понад 25 років досвіду та довіри.",
                li2: "2. Понад 100 вендорів рівня А-бренд (компанії зі світовими іменами та перевіреними продуктами).",
                li3: "3. Кожен вендорський напрям має своїх менеджерів, пресейл та інженерів, тому наш штат складається з більш ніж 500 спеціалістів.",
                li4: "4. Наразі ми обслуговуємо понад 4000 активних партнерів, серед яких не лише класичні IT-інтегратори, а й виробничі підприємства, будівельні компанії, консалтингові фірми, розробники програмного забезпечення, які використовують наші продукти у своїх поставках.",
                bp2: "СТРАТЕГІЯ",
                p5: "Наша стратегія полягає в тому, щоб бути визнаним як постачальниками, так і реселлерами як провідний IT-дистриб'ютор завдяки величезному досвіду, високій компетенції та присутності в різних країнах світу.",
                bp3: "МІСІЯ",
                p6: "Наша місія – надавати нашим Партнерам інноваційні рішення та якісну продукцію точно у строк.",
                p7: "Ми самовіддано працюємо в напрямі просування технологічних продуктів і рішень з метою задоволення ринкового попиту, що росте, і збільшуючи цінність як для постачальника, так і для торгового посередника за рахунок своєчасної доступності товарів і глибоких знань про продукти.",
                p8: "МУК планомірно працює над створенням попиту й виведенням продуктів на ринок, а також над генерацією вигідних можливостей для наших реселерів за допомогою партнерської програми, ефективного ланцюжка постачання та навчання.",
                p9: "Ми прагнемо підтримувати атмосферу, яка розширює можливості наших співробітників, визнає їхні досягнення та допомагає адаптуватися до ділового середовища, що постійно змінюється. МУК мотивує співробітників до сталого особистісного та професійного зростання.",
                bp4: "ПАРТНЕРСТВО І ВІДПОВІДАЛЬНІСТЬ",
                p10: "МУК сповідує виключно партнерську модель ведення справ. Ми не працюємо з кінцевими замовниками та робимо ставку на розвиток дилерської мережі. Серед кінцевих замовників наших партнерів є всі галузі вітчизняного бізнесу: ретейл, промисловість, фінанси та державний сектор.",
                p11: "Ми поділяємо з нашими партнерами відповідальність на шляху досягнення успіху. Наше кредо: «Йдемо разом, отже, йдемо разом до кінця». Ми підтримуємо наших партнерів у складних ситуаціях і разом радіємо перемогам, і, як показав досвід, спільних перемог у нас є значно більше, ніж поразок.",
                p12: "МУК своєю багаторічною роботою довів спроможність своєї мультивендорної стратегії, за якої всі вендори в нашому портфелі отримують рівні шанси на розвиток і роботу в конкурентному ринковому середовищі. Ми залишаємо за партнерами право вибору стратегії роботи в проєктах, при цьому допомагаємо сформувати комплексні рішення, консультуючи по всьому циклу продажу: від зняття завдання до впровадження та обслуговування.",
                bp5: "НАШІ ЦІННОСТІ",
                p13: "МУК повністю зосереджена на підвищенні успіху своїх ділових партнерів і співробітників, дотримуючись таких цінностей, як інновації, відповідальність, чесність, рівність можливостей і командна робота, повага, навчання та соціальна ",
                bp6: "Рівні можливості працевлаштування",
                p14: "Заявки від кандидатів на вакантні посади розглядаються нами без урахування раси, статі, релігії, кольору шкіри, національного походження, віку, гендерної ідентичності та виразу, інвалідності, сексуальної орієнтації, статусу ветерана чи інших факторів, які не пов'язані з кваліфікацією конкретної посади.",
                bp7: "Інновації",
                p15: "Ми постійно шукаємо кращі способи приносити користь нашим клієнтам, постачальникам і колегам. Ми очікуємо змін і проактивно створюємо рішення, адаптовані під них.",
                bp8: "Відповідальність",
                p16: "Ми говоримо те, що робимо, і робимо те, що говоримо. Ми постійно досягаємо результатів, які відповідають або перевершують очікуванням наших партнерів і постачальників.",
                bp9: "Чесність",
                p17: "Ми дотримуємося найвищих етичних стандартів, демонструючи чесність і справедливість у кожній дії, яку ми робимо, скрізь і завжди.",
                bp10: "Робота в команді та повага",
                p18: "Ми поважаємо права та переконання наших колег, партнерів і суспільства. Ми ставимося до інших з високим ступенем гідності, рівності та довіри, використовуючи різноманітність для досягнення наших спільних цілей. Як команда ми робимо більше, ніж індивідуально.",
                bp11: "Навчання",
                p19: "Ми постійно отримуємо нові знання, щоб підвищити продуктивність і забезпечити зростання компанії та нас самих.",
                bp12: "Соціальна відповідальність",
                p20: "Ми активно шукаємо можливості збалансувати нашу фінансову, соціальну та екологічну відповідальність задля досягнення позитивних результатів для різних зацікавлених сторін у всьому світі. На цьому шляху ми прагнемо співпраці, прозорості та інновацій.",
                bp13: "ЧОМУ МУК?",
                p21: "В особі МУК наші партнери отримують надійного дистриб'ютора та значну перевагу в конкуренції.",
                p22: "Наші партнери легко адаптуються до мінливих тенденцій ринку, відзначаючи гнучкість сервісів та послуг МУК. Оскільки ми працюємо з найпрогресивнішими постачальниками, наші клієнти завжди знаходять нові можливості для розвитку свого бізнесу.",
                p23: "Наші гнучкі варіанти фінансування розроблені для наших клієнтів, чи то індивідуальне рішення, чи спеціалізовані кредитні лінії, ми полегшуємо партнерам ведення бізнесу.",
                p24: "Всі питання, що виникають, ми вирішуємо за допомогою виділених менеджерів з роботи з клієнтами та фахівців із продуктів, закріплених за різними вендорами. Всі необхідні вам знання зібрані в одному місці, а наша професійна підготовка та широка маркетингова підтримка означають, що ви можете бути впевнені у всьому, що ми робимо.",
                p25: "МУК – це досвідчена компанія, яка дає вам гнучкість та швидке реагування на потреби вашого бізнесу та замовників.",
                p26: "Наш діапазон комерційних ініціатив гарантує вам відмінну якість роботи. Ми також можемо допомогти нашим клієнтам отримати вигоду від досвідченої міжнародної логістики, навчального та сервісного центрів, підрозділи хмарних продуктів.",
                p27: "Ми, як ніхто інший, знаємо, що хороший робочий процес означає хороші продажі, і ми розуміємо, що швидкість реакції, проактивність і управління ризиками є важливою частиною успішного бізнесу нашого партнера та його репутацією перед клієнтами. Тому ми створили електронні інструменти, які покращують ваші бізнес-процеси і спрощують швидкість взаємодії.",
                p28: "Ми допомагаємо збільшувати ваш дохід і прибутковість на кожному етапі шляху"

            },
            Privacy: {
                title: "Політика конфіденційності та умови використання",
                p1: "Я згоден з умовами конфіденційності і дозволяю використовувати мої персональні дані на законних засадах.",
                bp1: "Персональні дані",
                p2: "На виконання вимог Закону України \"Про захист персональних даних\" даю згоду на обробку моїх персональних даних з метою забезпечення реалізації цивільно-правових відносин, в тому числі, на перевірку зазначеної в реєстраційній формі інформації.",
                p3: "Ми цінуємо Ваше право на особисте життя та нерозголошення Вашої персональної інформації. Ця Політика конфіденційності – правило, яким користуються всі співробітники нашої компанії, та регламентує збір і використання особистої інформації, яка може бути запрошена/отримана при відвідуванні нашого веб-сайту та додатку.",
                bp2: "Як ми збираємо інформацію",
                p4: "Особиста інформація, як ми зазначили вище, надходить безпосередньо від Вас, та з Вашого відома. Так, коли Ви реєструєтеся на сайті, ми отримуємо надану Вами інформацію.",
                bp3: "Розголошення та передача даних",
                p5: "Інформація, яку ми збираємо, використовується виключно на сайті та в додатку виставки, а також у сервісах, які мають відношення до організації заходу. Ми можемо надавати загальні дані нашим партнерам для надання сервісів згідно темі маркетингової акції/вебінару/події, на яку отримано реєстрацію від учасника/користувача. Ми розкриваємо особисту інформацію лише у випадках, визначених чинним законодавством України.",
                bp4: "Інформаційні розсилки",
                p6: "Ви також даєте згоду на отримання інформації, в тому числі рекламного характеру, і дозволяєте здійснювати в вашу адресу смс розсилки, розсилки за допомогою інформаційно-комунікаційних сервісів, таких як Viber, а також інші види розсилок і повідомлень з використанням будь-яких засобів зв'язку.",
                bp5: "Оновлення цього попередження",
                p7: "Ми можемо в односторонньому порядку змінювати або оновлювати частини цієї політики в будь-який час, без попереднього повідомлення. Будь-ласка, час від часу переглядайте Політику конфіденційності, щоб знати про її зміни та оновлення. Усі зміни до цієї Політики конфіденційності набувають чинності з моменту їх публікації.",
                p8: "У випадку визнання недійсною або нездійсненною будь-якої частини даної Політики конфіденційності, інші її частини будуть залишатися чинними.",
            },
            Contact: {
                question: "Виникли питання?",
                description: "Будь ласка, заповніть форму нижче, щоб надіслати нам електронного листа, і ми зв'яжемося з вами якнайшвидше.",
                send: "Відправити",
                nm: "Ім'я",
                ad: "Адреса",
                ph: "Телефон",
                em: "E-mail",
                ms: "Повідомлення",
                contactInfo: "Контактна інформація",
                address: "Україна, м.Київ 03151, вул. Донецька 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Усі права захищені."
            }
        }
    }

    if (lang === "ru") {
        text = {
            Navigation: [
                {
                    menu: "Страны",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/az",
                            name: "Азербайджан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/al",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Армения",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/bg",
                            name: "Болгария",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hu",
                            name: "Венгрия",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ge",
                            name: "Грузия",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Кыргызстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "Северная Македония",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Монголия",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Словакия",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Таджикистан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tm",
                            name: "Туркменистан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/tr",
                            name: "Турция",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/uz",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        },
                        {
                            link: "/country/ua",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        }
                    ]
                },
                {
                    menu: "Решения",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Вендоры MUK"
                        },
                        {
                            link: "/solutions",
                            name: "Решения MUK"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Каталог продуктов и сервисов"
                        }
                    ]
                },
                {
                    menu: "Новости",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Новости и Акции"
                        },
                        {
                            link: "/muk-review",
                            name: "Журнал MUK"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Видео"
                        }
                    ]
                },
                {
                    menu: "Направления",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Дистрибьюция IT"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Учебный центр"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Сервисный центр"
                        },
                        {
                            link: "https://cloud.muk.ua/ru/",
                            name: "Облачные сервисы MUK Cloud"
                        }
                    ]
                },
                {
                    menu: "О компании",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Главное о MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Корпоративный профайл"
                        },
                        {
                            link: "/vacancies",
                            name: "Вакансии"
                        }
                    ]
                },
                {
                    menu: "Дилерский раздел",
                    href: "",
                    podmenu:
                        [
                            {
                                link: "https://b2b.muk.az/",
                                name: "Азербайджан",
                                flag: "az.svg",
                                id: 20,
                                iso: "az"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "Албания",
                                flag: "al.png",
                                id: 12,
                                iso: "al"
                            },
                            {
                                link: "https://b2b.muk.am/",
                                name: "Армения",
                                flag: "am.svg",
                                id: 1,
                                iso: "am"
                            },
                            {
                                link: "http://b2b.mukcomputers.bg/",
                                name: "Bulgaria",
                                flag: "bg.png",
                                id: 22,
                                iso: "bg"
                            },
                            {
                                link: "https://b2b.muk.ge/",
                                name: "Грузия",
                                flag: "ge.svg",
                                id: 3,
                                iso: "ge"
                            },
                            {
                                link: "https://b2bnew.muk.kz/",
                                name: "Казахстан",
                                flag: "kz.png",
                                id: 4,
                                iso: "kz"
                            },
                            {
                                link: "https://b2b.muk.kg/",
                                name: "Кыргызстан",
                                flag: "kg.png",
                                id: 5,
                                iso: "kg"
                            },
                            {
                                link: "https://b2b.muk.mk/",
                                name: "Северная Македония",
                                flag: "mk.png",
                                id: 15,
                                iso: "mk"
                            },
                            {
                                link: "https://b2b.muk.md/",
                                name: "Молдова",
                                flag: "md.png",
                                id: 6,
                                iso: "md"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "Монголия",
                                flag: "mn.png",
                                id: 7,
                                iso: "mn"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "United Arab Emirates",
                                flag: "ae.png",
                                id: 23,
                                iso: "ae"
                            },

                            {
                                link: "https://b2b.muk.co.rs/",
                                name: "Сербия",
                                flag: "rs.png",
                                id: 16,
                                iso: "rs"
                            },
                            {
                                link: "https://b2b.muk.si/",
                                name: "Словения",
                                flag: "si.png",
                                id: 17,
                                iso: "si"
                            },
                            {
                                link: "https://b2b.muk.tj/",
                                name: "Таджикистан",
                                flag: "tj.png",
                                id: 8,
                                iso: "tj"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "Туркменистан",
                                flag: "tm.png",
                                id: 9,
                                iso: "tm"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "Турция",
                                flag: "tr.svg",
                                id: 21,
                                iso: "tr"
                            },
                            {
                                link: "https://b2b.muk.uz/",
                                name: "Узбекистан",
                                flag: "uz.svg",
                                id: 10,
                                iso: "uz"
                            },
                            {
                                link: "https://b2b.muk.ua/",
                                name: "Украина",
                                flag: "ua.png",
                                id: 11,
                                iso: "ua"
                            },
                            {
                                link: "https://b2b.muk.com.hr/",
                                name: "Хорватия",
                                flag: "hr.png",
                                id: 18,
                                iso: "hr"
                            }
                        ]

                }
            ],
            Header: {
                titleOne: "Международный проектный VAD IT дистрибутор",
                paragraph: "Партнеры MUK видят в нас надежного мультивендорного IT дистрибутора, доверяют нашему многолетнему опыту, технической компетенции и отлаженной партнерской модели работы",
                partner: "Стать партнером"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Международный дистрибутор",
                    text: "География MUK включает 16 стран Европы и Азии и непрерывно расширяется"
                },
                {
                    icon: "fa fa-star",
                    title: "Более 25 лет успеха",
                    text: "MUK удерживает лидерские позиции с 1997 года"
                },
                {
                    icon: "fa fa-users",
                    title: "Уникальная  экспертиза",
                    text: "Инженерная команда MUK справится с любой, даже самой сложной задачей"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ производителей",
                    text: "В дистрибуторском портфеле MUK более 100 мировых А-брендов и их количество постоянно увеличивается"
                }
            ],
            ServicesInfo: {
                title: "Направления деятельности MUK"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Дистрибьюция IT",
                    text: "MUK – VAD-дистрибутор, ориентированный на проектный IT бизнес. Мы более 25 лет успешно развиваем дилерскую сеть в странах Европы и Азии.\nС помощью штата сертифицированных специалистов MUK предоставляет партнерам высокий уровень проектного консалтинга и техническую поддержку, этим генерирует дополнительную ценность предлагаемых решений.\nИнженеры MUK реализуют консалтинг и техническую поддержку программных и аппаратных решений, проводят аудиты существующих систем и помогают с реализацией тестовых стендов. Наш парк тестового оборудования позволяет смоделировать и реализовать широкий спектр задач в реальных условиях.\nMUK активно помогает интеграторам в выборе и проектировании оптимальных решений.\nКоманда MUK включает более 500 специалистов различных технологических направлений, которые имеют сертификаты ведущих мировых IT производителей.",
                    activ1: "Международная логистика, формирование складов",
                    activ2: "Маркетинговая и консалтинговая поддержка партнеров",
                    activ3: "Повышение ценности решений за счет собственной компетенции",
                    activ4: "Вывод продуктов на рынок, продвижение и формирование спроса",
                    activ5: "Техническая поддержка, гарантийное и постгарантийное обслуживание",
                    activ6: "Развитие партнерской сети"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Облачные продукты MUK Cloud Solution Provider",
                    text: "Облачные решения MUK для бизнеса MUK Cloud Solutions – это готовые к быстрому старту комплекты решений и услуг, направленные на обеспечение непрерывности бизнеса, повышение эффективности работы и мобильности сотрудников, с предоставлением современных защищенных средств коллективного взаимодействия.\nС их помощью Вы сможете быстро и эффективно внедрить облачные технологии в инфраструктуру Вашей организации. Концепция Cloud Solution Provider – это канал продаж, в котором доступны облачные сервисы Microsoft Office 365, AZURE, EMS, D365 и другие с оплатой помесячно.\nMUK предлагает создание инфраструктуры 'с нуля'. Минимальные капитальные затраты. Оптимальные операционные расходы на аренду облачных ресурсов и сервисное обслуживание. Масштабирование инфраструктуры (рост предприятия, новые территориальные офисы, планируемые всплески нагрузки). Новые сервисы в облаке, интегрированные с наземной инфраструктурой.",
                    activ1: "Хранение резервных копий (файлы, виртуальные машины, базы данных) в облаке.",
                    activ2: "Защита от аварийных сбоев, восстановление. Кластеры высокой доступности на уровне виртуальных машин или баз данных SQL.",
                    activ3: "Управление мобильными устройствами.",
                    activ4: "Защита корпоративной информации и переписки",
                    activ5: "Развёртывание SharePoint on-line, Exchange on-line, Skype for business on-line.",
                    activ6: "Развертывание и настройка веб-сайтов, миграция сайтов в облако."
                },
                {
                    icon: "fa fa-wrench",
                    name: "Сервисный центр MUK Service",
                    text: "Компания MUK Сервис с 2002 года успешно оказывает услуги по ремонту компьютерной техники и на сегодня является авторизованным сервисным центром APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, НР, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom и других производителей. Система менеджмента качества компании «MUK-Сервис» подтверждена сертификатом ISO 9001 Бюро Международной Сертификации.\nЧтобы оперативно справиться с любой неисправностью, необходимо быть настоящим специалистом. Наши мастера, получая опыт и ежедневную практику, решают любую неисправность. Профессионализм приходит с опытом, мы самосовершенствуемся и повышаем уровень своих знаний. Персонал сервисного центра состоит из сертифицированных специалистов, что гарантирует заказчикам качественный и профессиональный ремонт оборудования. MUK Сервис располагает всеми необходимыми техническими возможностями для обеспечения качественного сервисного обслуживания. Сервисный центр выполняет техническое обслуживание, гарантийный и не гарантийный ремонт любого уровня сложности. Компания MUK Сервис предоставляет услуги по аренде и аутсорсингу оборудования, инсталляции и техническому обслуживанию, а также информационно-консалтинговые услуги для корпоративных клиентов на территории Украины, Армении, Грузии, Молдовы, Таджикистана и Казахстана.",
                    activ1: "Гарантийный ремонт",
                    activ2: "Негарантийный ремонт",
                    activ3: "Диагностика оборудования",
                    activ4: "Продажа запчастей",
                    activ5: "Аудит сервисных контрактов",
                    activ6: "Аренда и аутсорсинг оборудования"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Учебный центр MUK",
                    text: "Учебный центр MUK – лидер на рынке образовательных услуг в сфере ИТ с более чем с 15-летним стажем и наличием ряда уникальных авторизаций, команды квалифицированных инструкторов и современной учебной инфраструктурой.\nПортфель УЦ MUK включает более 300 учебных курсов от ведущих ИТ-компаний.\nСреди статусов следует отметить: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nУчебный центр MUK имеет доступ к самому современному учебному оборудованию. Качество преподавания нашими инструкторами подтверждается в течение уже многих лет высокими оценками слушателей в Украине и за ее пределами."
                }
            ],
            Vendors: {
                title: "Вендоры MUK",
                country: "Страна",
                solution: "Решенние",
                name: "Название",
                all: "Все",
                namePlaceholder: "Начните вводить название вендора",
                notInfo: "Информация не заполнена"
            },
            VendorsForCountry: {
                title: "Вендоры MUK, доступные в стране"
            },
            VendorsForSolution: {
                title: "Вендоры MUK, по решению"
            },
            VendorDetail: {
                title: "АВТОРИЗОВАННЫЙ ДИСТРИБУТОР"
            },
            Gallery: {
                title: "Решения MUK"
            },
            Distribution: {
                title: "Дистрибьюция ІТ"
            },
            Partner: {
                title: "Стать партнером",
                description: "Пожалуйста, заполните форму ниже, чтобы отправить нам электронное письмо, и мы свяжемся с вами как можно скорее.",
                nm: "ФИО",
                ph: "Телефон",
                em: "Email",
                com: "Компания",
                sitecom: "Сайт компании",
                dir: "Направление деятельности",
                found: "Откуда о нас узнали",
                send: "Отправить",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Отправить резюме",
                description: "Пожалуйста, заполните форму ниже, чтобы отправить нам электронное письмо, и мы свяжемся с вами как можно скорее.",
                vac: "Интересующая вакансия",
                nm: "ФИО",
                ph: "Контактный телефон",
                em: "Email",
                file: "Файл резюме (PDF или DOC)",
                note: "Сопроводительное письмо",
                send: "Отправить",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK строит бизнес на принципах партнерства и сотрудничества",
                advantages: "Преимущества",
                paragraph: "MUK с момента своего основания делет ставку на прозрачность в отношениях с поставщиками и заказчиками. Преданность правилам партнерства позволила MUK заработать доверие рынка и сформировать репутацию лидера.",
                Why: [
                    "Инновации",
                    "Ответственность",
                    "Честность",
                    "Равные возможности трудоустройства"

                ],
                Why2: [
                    "Работа в команде и уважение",
                    "Обучение",
                    "Социальная ответственность"
                ]
            },
            News: {
                title: "Новости MUK",
                showAll: "Показать все",
                showMore: "Показать еще",
                news: "Новость",
                akcii: "Акция"
            },
            Vacancies: {
                title: "Вакансии MUK",
                resume: "Отправить резюме",
                country: "Страна",
                all: "Все",
                search: "Поиск",
                namePlaceholder: "Начните вводить название",
                filterInfo: "По данным фильтрам вакансий нету",
                notInfo: "Информация не заполнена",
                back: "Назад"
            },
            MukReview: {
                title: "Выпуски журнала \"MUK-REVIEW\"",
                vupysk: "Выпуск"
            },
            OMuk: {
                title: "Главное о MUK",
                p1: "Группа компаний MUK начала свою деятельность в 1997 году. Наше основное направление работы – проектно-ориентированная дистрибьюция ведущих IT-продуктов в области гибридных и облачных решений, конвергенции центров обработки данных, информационной безопасности, мобильных устройств и Интернета вещей, аналитики данных и искусственного интеллекта.",
                p2: "Благодаря нашей глобальной дистрибуторской сети мы выводим на локальные рынки перспективных IT вендоров и их новые продукты, активно участвуем в формировании спроса.",
                p3: "Мы сочетаем экспертные технические и рыночные знания с прогрессивной программой поддержки партнеров. Тесно сотрудничая с нашими дилерами, мы стремимся обеспечить их динамичный рост и развитие, добиваясь результатов вместе.",
                bp1: "ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ – ЭТО МЫ!",
                p4: "Компания MUK была пионером в сфере распространения информационных технологий более 25 лет назад. Сегодня MUK играет важную роль в передаче технологий от тех,кто их разрабатывает, тем, кто их внедряет и использует.",
                ul: "Четыре цифры, характеризующие MUK, как надежного партнера и эффективного дистрибутора:",
                li1: "1. Более 25 лет опыта и доверия.",
                li2: "2. Более 100 вендоров уровня А-бренд (компании с мировыми именами и проверенными продуктами).",
                li3: "3.  Каждое вендорское направление имеет своих менеджеров, пресейл и инженеров, поэтому наш штат состоит из более 500 специалистов.",
                li4: "4. В данный момент мы обслуживаем более 4000 активных партнеров, среди которых не только классические IT интеграторы, но и производственные предприятия, строительные компании, консалтинговые фирмы, разработчики программного обеспечения, которые используют наши продукты в своих поставках.",
                bp2: "СТРАТЕГИЯ",
                p5: "Наша стратегия состоит в том, чтобы быть признанным как поставщиками, так и реселлерами в качестве ведущего IT дистрибутора, благодаря огромному опыту, высокой компетенции и присутствию в разных странах мира.",
                bp3: "МИССИЯ",
                p6: "Наша миссия – предоставлять нашим Партнерам инновационные решения и качественную продукцию точно в срок.",
                p7: "Мы самоотверженно трудимся в направлении продвижения технологических продуктов и решений, с целью удовлетворения растущего рыночного спроса и увеличивая ценность как для поставщика, так и для торгового посредника за счет своевременной доступности товаров и глубоких знаний о продуктах.",
                p8: "MUK планомерно работает над созданием спроса и выводом продуктов на рынок, а также над генерацией выгодных возможностей для наших реселлеров при помощи партнерской программы, эффективной цепочки поставок и обучения.",
                p9: "Мы стремимся поддерживать атмосферу, которая расширяет возможности наших сотрудников, признает их достижения и помогает адаптироваться к постоянно меняющейся деловой среде. MUK мотивирует сотрудников к устойчивому личностному и профессиональному росту.",
                bp4: "ПАРТНЕРСТВО И ОТВЕТСТВЕННОСТЬ",
                p10: "MUK исповедует исключительно партнерскую модель ведения дел. Мы не работаем с конечными заказчиками и делаем ставку на развитие дилерской сети. Среди конечных заказчиков наших партнеров есть все отрасли отечественного бизнеса: ритейл, промышленность, финансы и государственного сектор.",
                p11: "Мы разделяем с нашими партнерами ответственность на пути достижения успеха. Наше кредо: «Идем вместе, значит, идем вместе до конца». Мы поддерживаем наших партнеров в сложных ситуациях и вместе радуемся победам, и, как показал опыт, совместных побед у нас значительно больше, чем поражений.",
                p12: "MUK своей многолетней работой доказал состоятельность своей мультивендорной стратегии, при которой все вендоры в нашем портфеле получают равные шансы на развитие и работу в конкурентной рыночной среде. Мы оставляем за партнерами право выбора стратегии работы в проектах, при этом помогаем сформировать комплексные решения, консультируя по всему циклу продаж: от снятия задачи до внедрения и обслуживания.",
                bp5: "НАШИ ЦЕННОСТИ",
                p13: "MUK целиком сосредоточенна повышении успеха своих деловых партнеров и сотрудников, придерживаясь таких ценностей, как инновации, ответственность, честность, равенство возможностей и командная работа, уважение, обучение и социальная ответственность.",
                bp6: "Равные возможности трудоустройства",
                p14: "Заявки от кандидатов на вакантные должности рассматриваются нами без учета расы, пола, религии, цвета кожи, национального происхождения, возраста, гендерной идентичности и выражения, инвалидности, сексуальной ориентации, статуса ветерана или других факторов, не связанных с квалификацией конкретной должности.",
                bp7: "Инновации",
                p15: "Мы постоянно ищем лучшие способы приносить пользу нашим клиентам, поставщикам и коллегам. Мы ожидаем изменений и проактивно создаем решения, адаптированные под них.",
                bp8: "Ответственность",
                p16: "Мы говорим то, что делаем, и делаем то, что говорим. Мы постоянно добиваемся результатов, которые соответствуют или превосходят ожиданиям наших партнеров и поставщиков.",
                bp9: "Честность",
                p17: "Мы соблюдаем самые высокие этические стандарты, демонстрируя честность и справедливость в каждом действии, которое мы предпринимаем, везде ивсегда.",
                bp10: "Работа в команде и уважение",
                p18: "Мы уважаем права и убеждения наших коллег, партнеров и общества. Мы относимся к другим с высочайшей степенью достоинства, равенства идоверия, используя разнообразие для достижения наших общих целей. Как команда, мы делаем больше, чем индивидуально.",
                bp11: "Обучение",
                p19: "Мы постоянно приобретаем новые знания, чтобы повысить производительность и обеспечить рост компании и нас самих.",
                bp12: "Социальная ответственность",
                p20: "Мы активно ищем возможности сбалансировать нашу финансовую, социальную и экологическую ответственность для достижения положительных результатов для различных заинтересованных сторон во всем мире. На этом пути мы стремимся к сотрудничеству, прозрачности и инновациям.",
                bp13: "ПОЧЕМУ MUK?",
                p21: "В лице MUK наши партнеры получают надежного дистрибутора и значительное превосходство в конкуренции.",
                p22: "Наши партнеры легко адаптируются к меняющимся тенденциям рынка, отмечая гибкость сервисов и услуг MUK. Поскольку мы работаем с наиболее прогрессивными поставщиками, наши клиенты всегда находят новые возможности для развития своего бизнеса.",
                p23: "Наши гибкие варианты финансирования разработаны для наших клиентов, будь то индивидуальное решение или специализированные кредитные линии, мы облегчаем партнерам ведение бизнеса.",
                p24: "Все возникающие вопросы, мы решаем с помощью выделенных менеджеров по работе с клиентами и специалистов по продуктам, закрепленных заразными вендорами. Все необходимые вам знания собраны в одном месте, анаша профессиональная подготовка и широкая маркетинговая поддержка означают, что вы можете быть уверены во всем, что мы делаем.",
                p25: "MUK – это опытная компания, которая дает вам гибкость и быстрое реагирование на потребности вашего бизнеса и заказчиков.",
                p26: "Наш диапазон коммерческих инициатив гарантирует вам превосходное качество работы. Мы также можем помочь нашим клиентам получить выгоду от опытной международной логистики, учебного и сервисного центров, подразделения облачных продуктов.",
                p27: "Мы, как никто другой, знаем, что хороший рабочий процесс означает хорошие продажи, и мы понимаем, что скорость реакции, проактивность и управление рисками – важная часть успешного бизнеса нашего партнера и его репутация перед клиентами. Поэтому мы создали электронные инструменты, которые улучшают ваши бизнес процессы и упрощают скорость взаимодействия.",
                p28: "Мы помогаем увеличивать ваш доход и прибыльность на каждом этапе пути."

            },
            Privacy: {
                title: "Политика конфиденциальности и условия использования",
                p1: "Я согласен с условиями конфиденциальности и разрешаю использовать мои персональные данные на законных основаниях.",
                bp1: "Персональные данные",
                p2: "Для выполнения требований Закона Украины \"О защите персональных данных\" даю согласие на обработку моих персональных данных с целью обеспечения реализации гражданско-правовых отношений, в том числе, на проверку указанной в регистрационной форме информации.",
                p3: "Мы ценим Ваше право на личную жизнь и неразглашение Вашей персональной информации. Эта Политика конфиденциальности - правило, которым пользуются все сотрудники нашей компании, и регламентирует сбор и использование личной информации, которая может быть запрошена / получена при посещении нашего веб-сайта и приложения.",
                bp2: "Как мы собираем информацию",
                p4: "Личная информация, как уже отмечено выше, поступает непосредственно от Вас, и с Вашим подтверждением. Так, когда Вы регистрируетесь на сайте, мы получаем предоставленную Вами информацию.",
                bp3: "Разглашение и передача данных",
                p5: "Информация, которую мы собираем, используется исключительно на сайте и в приложении выставки, а также в сервисах, которые имеют отношение к организации мероприятия. Мы можем предоставлять общие данные нашим партнерам для предоставления сервисов согласно теме маркетинговой акции/вебинара/события, на которую получена регистрация от участника/пользователя. Мы раскрываем личную информацию только в случаях, определенных действующим законодательством Украины.",
                bp4: "Информационные рассылки",
                p6: "Вы также даете согласие на получение информации, в том числе рекламного характера, и позволяете осуществлять в ваш адрес смс рассылки, рассылки с помощью информационно-коммуникационных сервисов, таких как Viber, а также другие виды рассылок и уведомлений с использованием любых средств связи.",
                bp5: "Обновления этого предупреждения",
                p7: "Мы можем в одностороннем порядке изменять или обновлять части этой политики в любое время, без предварительного уведомления. Пожалуйста, время от времени просматривайте Политику конфиденциальности, чтобы знать о ее изменениях и обновлениях. Все изменения в этой Политики конфиденциальности вступают в силу с момента их опубликования.",
                p8: "В случае признания недействительной или неосуществимой любой части данной Политики конфиденциальности, другие ее части будут оставаться в силе.",
            },
            Contact: {
                question: "Возникли вопросы?",
                description: "Пожалуйста, заполните форму ниже, чтобы отправить нам электронное письмо, и мы свяжемся с вами как можно скорее.",
                send: "Отправить",
                nm: "Имя",
                ad: "Адрес",
                ph: "Телефон",
                em: "Email",
                ms: "Сообщение",
                contactInfo: "Контактная информация",
                address: "Украина, г.Киев 03151, ул. Донецкая 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Все права защищены."
            }
        }
    }

    if (lang === "en") {
        text = {
            Navigation: [
                {
                    menu: "Countries",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/hu",
                            name: "Hungary",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapore",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Solutions",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK vendors"
                        },
                        {
                            link: "/solutions",
                            name: "MUK solutions"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Catalogue of products and services"
                        }
                    ]
                },
                {
                    menu: "News",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "News and Deals"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK journal"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "ACTIVITIES",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT Distribution"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Training center"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Service center"
                        },
                        {
                            link: "https://cloud.muk.ua/en/",
                            name: "MUK Cloud services"
                        }
                    ]
                },
                {
                    menu: "About company",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "About MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Corporative profile"
                        },
                        {
                            link: "/vacancies",
                            name: "Careers"
                        }
                    ]
                },
                {
                    menu: "Dealer section",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "INTERNATIONAL PROJECT VALUE-ADDED IT DISTRIBUTOR",
                paragraph: "Welcome to MUK – a reliable multi-vendor IT distributor. We earned credibility through years of experience, technical expertise and well-established partnership type of work with MUK Partners.",
                partner: "Become a partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "International distributor",
                    text: "MUK operates in 16 countries of Europe and Asia, and continue to expand"
                },
                {
                    icon: "fa fa-star",
                    title: "25+ years of success",
                    text: "MUK holds a leading position in distribution since 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Unique expertise",
                    text: "Teams of engineers handle the most complicated tasks"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ manufacturers",
                    text: "MUK distributor’s portfolio contains more than 100 international A-brands and never cease to grow"
                }
            ],
            ServicesInfo: {
                title: "MUK Scope of Activities"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT Distribution",
                    text: "MUK is a value-added distributor focused on IT project business. We have been successfully developing a dealer network in Europe and Asia for more than 25 years. With the help of our certified specialists, MUK company provides partners with the high level of project consulting and technical support to generate additional value for the proposed solutions. MUK engineers ensure consulting and technical support for software and hardware solutions, conduct audits of existing systems and help with the implementation of test benches. Our stock of test equipment allows us to simulate and implement a wide range of tasks in real conditions. MUK actively assists integrators in choosing and designing optimal solutions. The MUK team includes over 500 specialists in various technology areas who are certified by the world's leading IT manufacturers.",
                    activ1: "International logistics, formation of stocks",
                    activ2: "Marketing and consulting support for partners",
                    activ3: "Increasing solutions’ value through our own expertize",
                    activ4: "Product launch, promotion and demand generation",
                    activ5: "Technical support, warranty and post-warranty service",
                    activ6: "Partner network development"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider, Cloud products",
                    text: "MUK Cloud Solutions for Business are quick-start suites of solutions and services aimed at ensuring business continuity, increasing work efficiency and mobility of employees with the provision of modern secure collaboration tools. With their help, you can quickly and efficiently implement cloud technologies in the infrastructure of your organization. The Cloud Solution Provider concept is a sales channel, in which Microsoft Office 365, AZURE, EMS, D365 and other cloud services are available on a monthly payment basis. MUK offers the creation of infrastructure 'from scratch'. Minimum capital costs. Optimal operating costs for cloud resources rental and maintenance. Infrastructure scaling – enterprise growth, new territorial offices, planned load bursts. New cloud services integrated with ground infrastructure.",
                    activ1: "Storing backups (files, virtual machines, databases) in the cloud",
                    activ2: "Crash protection, recovery. High availability cluster at virtual machines or SQL databases level",
                    activ3: "Mobile device management",
                    activ4: "Corporate information and correspondence protection",
                    activ5: "SharePoint online, Exchange online, Skype for business online deployment",
                    activ6: "Deployment and setting of websites, migration of websites to the cloud"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service Center",
                    text: "It takes a true professional to fix any malfunction. Gaining experience and daily practice, our repairers ensure the best quality of service. As professionalism comes with experience, MUK Service company has been successfully providing computer repair services since 2002, and today we are an authorized service center for APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom and other manufacturers. MUK Service quality management system is confirmed by the ISO 9001 of the Bureau of International Certification. Our service center has all necessary technical capabilities and certified professionals to guarantee our clients high-quality equipment repair. The service center performs maintenance, warranty and non-warranty repairs of any level of complexity. MUK Service company provides equipment rental and outsourcing, installation and maintenance services, as well as information and consulting services for corporate clients in Ukraine, Armenia, Georgia, Moldova, Tajikistan and Kazakhstan.",
                    activ1: "Warranty repair",
                    activ2: "Non-warranty repair",
                    activ3: "Equipment diagnostics",
                    activ4: "Spare parts sale",
                    activ5: "Service contracts audit",
                    activ6: "Outsourcing and equipment rental"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK Training Center",
                    text: "MUK Training Center is a market leader in IT educational services with more than 15 years of experience, a number of unique authorizations, a team of qualified instructors, and a modern training infrastructure. The MUK TC portfolio is based on 300+ training courses from leading IT companies. Noteworthy statuses include: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner, and many others. MUK Training center has access to the best of modern educational equipment. The quality of our training programs has received the highest marks from students in Ukraine and abroad."
                }
            ],
            Vendors: {
                title: "MUK vendors",
                country: "Country",
                solution: "Solution",
                name: "Name",
                all: "All",
                namePlaceholder: "Start typing the vendor's name",
                notInfo: "Information is not filled in"
            },
            VendorsForCountry: {
                title: "MUK vendors available in the country"
            },
            VendorsForSolution: {
                title: "MUK vendors by solution"
            },
            VendorDetail: {
                title: "AUTHORIZED DISTRIBUTOR"
            },
            Gallery: {
                title: "MUK solutions"
            },
            Distribution: {
                title: "IT Distribution"
            },
            Partner: {
                title: "Become a partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK builds its business on the partnership and cooperation principles",
                advantages: "Benefits",
                paragraph: "MUK has been focusing on transparency in relations with suppliers and customers since its foundation. Devotion to the rules of partnership has allowed MUK to earn the trust of the market and build a leader's reputation.",
                Why: [
                    "Innovations",
                    "Responsibility",
                    "Integrity",
                    "Equal employment opportunities"

                ],
                Why2: [
                    "Teamwork and respect",
                    "Training",
                    "Social responsibility"
                ]
            },
            News: {
                title: "MUK news",
                showAll: "Show more",
                showMore: "Show more",
                news: "News",
                akcii: "Deal"
            },
            Vacancies: {
                title: "Careers",
                resume: "Send a CV",
                country: "Country",
                all: "All",
                search: "Search",
                namePlaceholder: "Start typing the name",
                filterInfo: "No jobs matching these filters",
                notInfo: "Information is not filled in",
                back: "Back"

            },
            MukReview: {
                title: " \"MUK-REVIEW\" journal issues",
                vupysk: "Issue"
            },
            OMuk: {
                title: "About MUK",
                p1: "The MUK group of companies started its activity in 1997. Our main area of work is the project-oriented distribution of leading IT products in the field of hybrid and cloud solutions, data center convergence, information security, mobile devices and the Internet of things, data analytics and artificial intelligence.",
                p2: "Thanks to our global distribution network, we bring promising IT vendors and their new products to local markets and actively participate in demand formation.",
                p3: "We combine expert technical and market knowledge with a progressive partner support program. Working closely with our dealers, we strive to ensure their dynamic growth and development, achieving results together.",
                bp1: "WE ARE THE INFORMATION TECHNOLOGIES!",
                p4: "MUK company has been a pioneer in information technology distribution for over 25 years. Today, MUK plays an important role in transferring technologies from those who develop it to those who implement and use it.",
                ul: "Here are the four figures characterizing MUK as a reliable partner and efficient distributor:",
                li1: "1. More than 25 years of experience and trust.",
                li2: "2. More than 100 vendors of A-brand level (worldwide known companies with proven products).",
                li3: "3. Each vendor's area has its managers, presales and engineers, so our staff consists of over 500 specialists.",
                li4: "4. We currently serve over 4000 active partners, including classical IT integrators but manufacturing enterprises, construction companies, consulting companies, and software developers who use our products in their deliveries.",
                bp2: "STRATEGY",
                p5: "Our strategy is to be recognized by both suppliers and resellers as a leading IT distributor, thanks to our vast experience, high competence and presence in different countries of the world.",
                bp3: "MISSION",
                p6: "Our mission is to provide our Partners with innovative solutions and quality products just in time.",
                p7: "We work dedicatedly to promote technology products and solutions to meet growing market demand and add value to both suppliers and resellers through prompt product availability and in-depth product knowledge.",
                p8: "MUK is systematically working to create demand and product launch, as well as generate profitable opportunities for our resellers through an affiliate program, an efficient supply chain and training.",
                p9: "We strive to maintain an environment that empowers our people, recognizes their accomplishments and helps them adapt to an ever-changing business environment. MUK motivates employees for sustainable personal and professional growth.",
                bp4: "PARTNERSHIP AND RESPONSIBILITY",
                p10: "MUK adheres to an exclusive partner business model. We do not work with end customers and rely on the development of the dealer network. Among our partners' end customers are all domestic business sectors: retail, industry, finance and the public sector.",
                p11: "We share the responsibility for achieving success with our partners. Our credo: \"We go together, so we go together to the end.\" We support our partners in difficult situations and celebrate victories together, and, as experience has shown, we have much more common wins than defeats.",
                p12: "With its many years of work, MUK has proven the viability of its multi-vendor strategy in which all vendors in our portfolio get an equal chance to develop and work in a competitive market environment. We reserve the right for partners to choose a strategy for working on projects while helping to create complex solutions, advising on the entire sales cycle: from task removal to implementation and maintenance.",
                bp5: "OUR VALUES",
                p13: "MUK is fully focused on enhancing the success of its business partners and employees by adhering to the values of innovation, responsibility, integrity, equal opportunities and teamwork, respect, learning and social responsibility.",
                bp6: "Equal employment opportunities",
                p14: "We consider job applications from candidates without regard to race, gender, religion, skin color, ethnical background, age, gender identity and expression, disability, sexual orientation, veteran status or other factors not related to qualification for a certain position.",
                bp7: "Innovation",
                p15: "We are constantly looking for better ways to benefit our clients, suppliers and colleagues. We anticipate changes in proactively creating solutions fit for them.",
                bp8: "Responsibility",
                p16: "We say what we do, and we do what we say. We consistently achieve results that meet or exceed the expectations of our partners and suppliers.",
                bp9: "Integrity",
                p17: "We maintain the highest ethical standards demonstrating integrity and fairness in every action we take, everywhere and at all times.",
                bp10: "Teamwork and respect",
                p18: "We respect the rights and beliefs of our colleagues, partners and society. We treat others with the highest level of dignity, equality and trust, using diversity to achieve our common goals. As a team, we do more than individually.",
                bp11: "Training",
                p19: "We are constantly learning to increase productivity and to ensure the growth of our company and ourselves.",
                bp12: "Social responsibility",
                p20: "We actively look for ways to balance our financial, social and ecological responsibilities to achieve positive results for various stakeholders worldwide. On this path, we strive to cooperation, transparency and innovation.",
                bp13: "WHY MUK?",
                p21: "Our partners get a reliable distributor and a significant competitive edge with MUK.",
                p22: "Our partners easily adapt to changing market trends noting the flexibility of MUK services. Since we work with the most progressive suppliers, our clients always find new opportunities to grow their businesses.",
                p23: "Our flexible financing options are designed for our clients, whether it's a bespoke solution or dedicated credit lines, we make it easy for partners to do business.",
                p24: "We resolve all arising issues with the help of dedicated account managers and product specialists assigned to different vendors. All the knowledge you need is gathered in one place, and our professional training and extensive marketing support mean you can be sure in everything we do.",
                p25: "MUK is an experienced company providing you with flexibility and responsiveness to the needs of your business and customers.",
                p26: "Our commercial initiatives range guarantees you an excellent quality of work. We also can help our clients benefit from experienced international logistics, training and service centers, cloud products department.",
                p27: "We know better than anyone that a good workflow means good sales, and we understand that responsiveness, proactivity and risk management are an important part of our partner's successful business and their reputation with customers. Therefore, we have created electronic tools that improve your business processes and simplify the speed of interaction.",
                p28: "We help increase your income and profitability every step of the way."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "If you have any questions?",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                send: "Send",
                nm: "Name",
                ad: "Address",
                ph: "Telephone",
                em: "Email",
                ms: "Message",
                contactInfo: "Contact details",
                address: "16/2 Donetska str., Kyiv 03151, Ukraine",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "All rights reserved."
            }
        }
    }

    if (lang === "az") {
        text = {
            Navigation: [
                {
                    menu: "Ölkələr",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albaniya",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azərbaycan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Xorvatiya",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Gürcüstan",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Qazaxıstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Qırğızıstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/hu",
                            name: "Macarıstan",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Monqolustan",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbiya",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Sloveniya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Sinqapur",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tacikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Türkiyə",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Türkmənistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukrayna",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Özbəkistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Həllər",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK vendorları"
                        },
                        {
                            link: "/solutions",
                            name: "MUK həlləri"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Məhsullar və xidmətlər kataloqu"
                        }
                    ]
                },
                {
                    menu: "Xəbərlər",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Xəbərlər və Aksiyalar"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK jurnalı"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "İstiqamətlər",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT distribusiyası"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Tədris mərkəzi"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Xidmət mərkəzi"
                        },
                        {
                            link: "https://cloud.muk.az/",
                            name: "MUK Cloud bulud servisləri"
                        }
                    ]
                },
                {
                    menu: "Şirkət haqqında",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK haqqında əsas"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Korporativ profayl"
                        },
                        {
                            link: "/vacancies",
                            name: "Vakansiyalar"
                        }
                    ]
                },
                {
                    menu: "Diller bölməsi",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albaniya",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azərbaycan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Xorvatiya",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Gürcüstan",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Qazaxıstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Qırğızıstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Monqolustan",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbiya",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Sloveniya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tacikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Türkiyə",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Türkmənistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukrayna",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Özbəkistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],

            Header: {
                titleOne: "Beynəlxalq layihə VAD IT distributoru",
                paragraph: "MUK tərəfdaşları bizdə etibarlı multivendor IT distributorunu görürlər, bizim uzunmüddətli təcrübəmizə, texniki səriştəmizə və lazımi qaydada təşkil edilmiş tərəfdaşlıq iş modelimizə etimad edirlər",
                partner: "Tərəfdaş olmaq"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Beynəlxalq distributor",
                    text: "MUK coğrafiyası 16 Avropa və Asiya ölkələrini ehtiva edir və durmadan genişlənir"
                },
                {
                    icon: "fa fa-star",
                    title: "25 ildən artıq uğur",
                    text: "MUK 1997-ci ildən başlayaraq liderlik mövqeyini qoruyub saxlamaqdadır"
                },
                {
                    icon: "fa fa-users",
                    title: "Unikal ekspertiza",
                    text: "MUK mühəndislər komandası istənilən, hətta ən mürəkkəb tapşırığın öhdəsindən gələcək"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ istehsalçı",
                    text: "MUK distributor portfelində 100 çox dünya A-brendi yer alıb və onların sayı dumadan artır"
                }
            ],
            ServicesInfo: {
                title: "MUK fəaliyyət istiqamətləri"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT distribusiyası",
                    text: "MUK – layihə IT biznesinə istiqamətlənmiş VAD distributorudur. Biz 25 ildən çoxdur ki, Avropa və Asiya ölkələrində diller şəbəkəmizi uğurla inkişaf etdiririk. İxtisaslı mütəxəssislər ştatının sayəsində MUK tərəfdaşlarına yüksək səviyyəli  layihə konsaltinqini və texniki dəstəyi təqdim edir, bununla da təklif edilən həllərin əlavə dəyərinin generasiya edir. MUK mühəndisləri konsaltinqi və proqram və aparat həllərinin texniki dəstəyini həyata keçirirlər, mövcud sistemlərin auditini aparırlar və sınaq stendlərinin həyata keçirilməsinə köməklik göstərirlər. Bizim sınaq avadanlığı parkımız real şəraitlərdə geniş tapşırıqlar spektrini modelləşdirməyə və reallaşdırmağa imkan yaradır. MUK optimal həllərin seçilməsi və layihələndirilməsi sahəsində inteqratorlara aktiv köməklik edir. MUK komandasına dünyanın aparıcı IT istehsalçılarının sertifikatlarına malik olan müxtəlif texnoloji istiqamətlərdə çalışan 500 çox mütəxəssis daxildir.",
                    activ1: "Beynəlxalq logistika, anbarların formalaşdırılması ",
                    activ2: "Tərəfdaşlara marketinq və konsaltinq dəstəyi",
                    activ3: "Öz bacarığımız sayəsində həllərin dəyərinin artırılması",
                    activ4: "Məhsulların bazara çıxarılması, irəliləməsi və tələbin formalaşdırılması",
                    activ5: "Texniki dəstək, zəmanət və zəmanətdən sonrakı xidmət",
                    activ6: "Tərəfdaşlıq şəbəkəsinin inkişafı"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider bulud məhsulları",
                    text: "Biznes üçün MUK Cloud Solutions bulud həlləri – müasir kollektiv qarşılıqlı fəaliyyət vasitələrinin təqdim edilməsi ilə biznesin fasiləsiz həyata keçirilməsinə, əməkdaşların iş effektivliyinin və sürətinin artırılmasına istiqamətlənmiş, sürətli starta hazır olan həllər və xidmətlər komplektidir. Onların köməyi ilə siz bulud texnologiyalarını təşkilatınızın infrastrukturuna tez və effektiv şəkildə daxil edə bilərsiniz. Cloud Solution Provider konsepsiyası -  Microsoft Office 365, AZURE, EMS, D365 və aylıq ödənişi dəstəkləyən digər bulud servislərinin əlçatan olduğu satış kanalıdır. MUK infrastrukturun “sıfırdan” yaradılmasını təklif edir. Minimum maliyyə məsrəfləri. Bulud resurslarının icarəsinə və servis xidmətinə optimal əməliyyat xərcləri. İnfrastrukturun miqyaslaşdırılması (müəssisənin artması, yeni ərazi ofisləri, planlaşdırılan yüklənmə artımı). Yerüstü infrastrukturla inteqrasiya edilmiş yeni bulud servisləri.",
                    activ1: "Ehtiyat kopiyalarının (fayllar, virtual maşınlar, verilənlər bazaları) buludda saxlanması.",
                    activ2: "Qəza dayanmalarından müdafiə, bərpa. Virtual maşınlar və ya SQL verilənlər bazaları səviyyəsində yüksək əlçatanlıq klasterləri",
                    activ3: "Mobil qurğuların idarə edilməsi",
                    activ4: "Korporativ informasiyanın və yazışmanın müdafiəsi",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business on-line açılması",
                    activ6: "Veb saytların açılması və sazlanması, saytların buluda miqrasiyası"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service servis mərkəzi",
                    text: "MUK Servis şirkəti 2002-ci ildən başlayaraq kompüter texnikasının təmiri üzrə xidmətləri uğurla göstərir və bugünkü gündə APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, НР, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom və digər istehsalçıların rəsmi servis mərkəzidir. MUK Servis şirkətinin keyfiyyət menecmenti sistemi Beynəlxalq Sertifikatlaşdırma Bürosunun ISO 9001 sertifikatı ilə təsdiqlənib. İstənilən nasazlığın öhdəsindən operativ şəkildə gəlmək üçün əsl mütəxəssis olmaq lazımdır. Bizin ustalar, gündəlik fəaliyyətlərində təcrübə əldə etməklə, istənilən nasazlığı aradan qaldırırlar.  Peşəkarlıq təcrübə ilə gəlir, biz özümüzü təkmilləşdiririk və biliklərimizin səviyyəsini artırırıq. Servis mərkəzinin heyəti sertifikatlaşdırılmış mütəxəssislərdən ibarətdir, bu da sifarişçilərə avadanlıqların keyfiyyətli və peşəkar təmir edilməsi zəmanətini verir. MUK servis keyfiyyətli servis xidmətlərinin göstərilməsi üçün bütün zəruri texniki imkanlara malikdir. Servis mərkəzi Ukrayna, Gürcüstan, Moldova, Tacikistan və Qazaxıstanın ərazisində korporativ müştərilər üçün texniki xidmət, istənilən mürəkkəb səviyyəli zəmanətli və zəmanətsiz təmir işlərini aparır. MUK Servis şirkəti avadanlığın icarəsi və autosorinqi, instalyasiya və texniki xidmət üzrə xidmətləri, həmçinin informasiya-məsləhətləşmə xidmətlərini təqdim edir.",
                    activ1: "Zəmanətli təmir",
                    activ2: "Zəmanətsiz təmir",
                    activ3: "Avadanlığın diaqnostikası",
                    activ4: "Ehtiyat hissələrinin satışı",
                    activ5: "Xidmət müqaviləsinin auditi",
                    activ6: "Avadanlığın icarəsi və autosorinqi"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK tədris mərkəzi",
                    text: "MUK tədris mərkəzi – 15 ildən artıq təcrübəyə və bir sıra unikal avtorizasiyalara, ixtisaslaşdırılmış təlimçilər komandasına və müasir infrastruktura malik olan İT sahəsində təhsil xidmətləri bazarının lideridir. MUK TM-nin portfelinə aparıcı IT şirkətlərinin 300 çox təlim kursları daxildir. Statuslar arasında aşağıdakıları qeyd etmək olar: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner. MUK tədris mərkəzinin ən müasir təlim avadanlıqlarına çıxışı var. Təlimçilərimiz tərəfindən tədrisin keyfiyyəti Ukraynada və onun hüdudları xaricində dinləyicilərin yüksək qiymətləri ilə təsdiqini tapır"
                }
            ],
            Vendors: {
                title: "MUK vendorları",
                country: "Ölkə",
                solution: "Həllər",
                name: "Ad",
                all: "Hamısı",
                namePlaceholder: "Vendorun adını daxil etməyə başlayın",
                notInfo: "İnformasiya daxil edilməyib"
            },
            VendorsForCountry: {
                title: "Ölkədə əlçatan olan MUK vendorları"
            },
            VendorsForSolution: {
                title: "MUK vendorları, həllər üzrə"
            },
            VendorDetail: {
                title: "AVTORİZASİYA OLUNMUŞ DİSTRİBUTOR"
            },
            Gallery: {
                title: "MUK həlləri"
            },
            Distribution: {
                title: "IT distribusiyası"
            },
            Partner: {
                title: "Tərəfdaş olmaq",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telefon",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Göndərmək",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK öz biznesini tərəfdaşlıq və əməkdaşlıq prinsipləri əsasında qurur",
                advantages: "Üstünlüklər",
                paragraph: "MUK yarandığı andan etibarən tədarükçülərlə və sifarişçilərlə münasibətdə şəffaflığa üstünlük vermişdir. Tərəfdaşlıq qaydalarına sədaqət sayəsində MUK bazarın etimadını qazanmış və liderlik reputasiyasını əldə etmişdir",
                Why: [
                    "İnnovasiyalar",
                    "Məsuliyyət",
                    "Dürüstlük",
                    "Bərabər işə qəbul imkanları"

                ],
                Why2: [
                    "Komanda tərkibində iş və hörmət",
                    "Tədris",
                    "Sosial məsuliyyət"
                ]
            },
            News: {
                title: "MUK xəbərləri",
                showAll: "Hamısını göstərmək",
                showMore: "Daha çox göstərmək",
                news: "Xəbər",
                akcii: "Aksiya"
            },
            Vacancies: {
                title: "MUK vakansiyaları",
                resume: "Send a CV",
                country: "Ölkə",
                all: "Hamısı",
                search: "Axtarış",
                namePlaceholder: "Adı daxil etməyə başlayın",
                filterInfo: "Bu filtrlər üzrə vakansiyalar yoxdur",
                notInfo: "İnformasiya daxil edilməyib",
                back: "Back"
            },
            MukReview: {
                title: "Jurnalın buraxılması \"MUK-REVIEW\" ",
                vupysk: "Buraxılış"
            },
            OMuk: {
                title: "MUK haqqında əsas",
                p1: "MUK şirkətlər qrupu öz fəaliyyətinə 1997-ci ildə başlamışdır. Əsas fəaliyyət istiqamətimiz – hibrid və bulud həlləri sahəsində aparıcı IT məhsullarının, məlumatların emalı mərkəzlərinin konvergensiyasının, informasiya təhlükəsizliyinin, mobil qurğuların və əşyalar internetinin, məlumatların və süni intellektin layihə istiqamətli distribusiyası.",
                p2: "Qlobal distributorluq şəbəkəmizin sayəsində biz perspektivli IT vendorlarını və onların yeni məhsullarını lokal bazarlara çıxarırıq, tələbin formalaşdırılmasında fəal iştirak edirik",
                p3: "Biz ekspert texniki və bazar biliklərini tərəfdaşların proqressiv dəstək proqramı ilə birləşdiririk. Dillerlərimizlə sıx əməkdaşlıq etməklə, birlikdə nəticələr əldə etməklə, biz onların dinamik artım və inkişafını təmin etməyə can atırıq. ",
                bp1: "İNFORMASİYA TEXNOLOGİYALARI – BU BİZİK!",
                p4: "MUK şirkəti 25 il bundan öncə informasiya texnologiyaların yayılması sahəsində bir təşəbbüsçü idi. Bugünkü gündə MUK şirkəti texnologiyaları onları işləyib hazırlayanlardan onları tətbiq edib istifadə edənlərə ötürülməsində mühüm rol oynayır.",
                ul: "MUK şirkətini etibarlı tərəfdaş və effektiv distributor kimi səciyyələndirən dörd rəqəm",
                li1: "1. 25 ildən çox təcrübə və etibar",
                li2: "2. 100 çox A-brend səviyyəli vendor (dünyaca məşhur olan və sınaqdan keçmiş məhsulları olan şirkətlər)",
                li3: "3.  Hər bir vendor istiqaməti öz menecerlərinə, preseyl və mühəndislərinə malikdir, buna görə də ştatımıza 500 çox mütəxəssis daxildir.",
                li4: "4. Hazırkı dönəmdə yalnız klassik IT inteqratorlarından deyil, həmçinin öz fəaliyyətlərində bizim məhsullarımızdan istifadə edən istehsal müəssisələri, tikinti şirkətləri, konsaltinq firmaları, proqram təminatlarının ixtiraçılarından ibarət olan 4000 çox aktiv tərəfdaşa xidmət göstəririk.",
                bp2: "STRATEGİYA",
                p5: "Bizim strategiyamız ondan ibarətdir ki, böyük təcrübə, yüksək səriştəlilik və müxtəlif dünya ölkələrində iştirak sayəsində aparıcı IT distributor kimi həm tədarükçülər, həm də resellerlər tərəfindən tanınaq.",
                bp3: "MİSSİYA",
                p6: "Missiyamız – tərəfdaşlarımıza innovasiya həllərini və keyfiyyətli məhsulları vaxtında təqdim etmək.",
                p7: "Biz artmaqda olan bazar tələbatının təmin edilməsi məqsədilə və malların əlçatanlığı və məhsullar haqqında dərin biliklər sayəsində həm tədarükçü, həm də ticarət vasitəçisi üçün dəyəri artırmaqla texnoloji məhsulların və həllərin irəliləməsi istiqamətində fədakarcasına fəaliyyət göstəririk.",
                p8: "MUK tələbin yaradılması və məhsulların bazara çıxarılması istiqamətində, həmçinin tərəfdaşlıq proqramı, tədarük və təlim zənciri sayəsində resellərlərimiz üçün əlverişli imkanların generasiyası istiqamətində çalışır.",
                p9: "Əməkdaşlarımızın imkanlarını genişləndirən, onların nailiyyətlərini tanıyan və daimi dəyişən işgüzar mühitə uyğunlaşmağa kömək edən atmosferin təmin edilməsinə cəhd edirik. MUK əməkdaşlarını dayanıqlı şəxsi və peşəkar inkişafa təşviq edir.",
                bp4: "TƏRƏFDAŞLIQ VƏ MƏSULİYYƏT",
                p10: "MUK işlərin aparılmasının tərəfdaşlıq modelini təbliğ edir. Biz yekun sifarişçilərlə işləmirik və diller şəbəkəsinin inkişafına üstünlük veririk. Tərəfdaşlarımızın yekun sifarişçiləri sırasında yerli biznesin bütün sahələri yer alıb: riteyl, sənaye, maliyyə və dövlət sektoru",
                p11: "Uğura çatma yolunda tərəfdaşlarımızla məsuliyyəti bölüşürük. Kredomuz: “Birlikdə gediriksə, sona qədər birlikdəyik”. Biz çətin vəziyyətlərdə tərəfdaşlarımızı dəstəkləyirik və qələbələrə birlikdə sevinirik və təcrübənin göstərdiyi kimi birgə qələbələrimizin sayı məğlubiyyətlərdən qat-qat çoxdur. ",
                p12: "MUK öz uzunmüddətli fəaliyyəti ilə portfelimizdə rəqabətli bazar mühitində inkişaf və iş üçün bərabər şansların əldə edilməsinə zəmin yaradan multivendor strategiyasının tutarlılığını sübut etdi. Biz tərəfdaşlarımıza layihələrdə iş strategiyasının seçim hüququnu veririk, bu zaman tapşırığın verilməsindən tətbiq və xidmətə qədər bütün satış dövrü boyunca məsləhətlər verməklə kompleks həllərin formalaşdırılmasında köməklik göstəririk ",
                bp5: "DƏYƏRLƏRİMİZ",
                p13: "MUK şirkəti innovasiya, məsuliyyət, dürüstlük, imkanların bərabərliyi və komanda tərkibində iş, hörmət, təlim və sosial məsuliyyət kimi dəyərlərə sadiq qalaraq, öz işgüzar tərəfdaşlarının və əməkdaşlarının uğurlarının artırılmasına köklənib.",
                bp6: "Bərabər işə qəbul imkanları",
                p14: "Vakant vəzifələrə namizədlərin ərizələrinə irq, cins, din, dəri rəngi, milli mənşə, yaş, gender identikliyi və ifadə, əlillik, cinsi oriyentasiya, veteran statusu və ya müəyyən vəzifə kvalifikasiyası ilə bağlı olmayan digər amillər nəzərə alınmadan baxılır.",
                bp7: "Yenilik",
                p15: "Biz daim müştərilərimizə, təchizatçılarımıza və həmkarlarımıza fayda vermək üçün daha yaxşı yollar axtarırıq. Biz dəyişikliklər gözləyirik və onlara uyğunlaşdırılmış həlləri proaktiv şəkildə yaradırıq.",
                bp8: "Məsuliyyət",
                p16: "Biz etdiklərimiz barədə danışırıq və dediyimizi edirik. Biz daima tərəfdaşlarımızın və tədarükçülərimizin gözləntilərinə uyğun olan və ya onları üstələyən nəticələrə nail oluruq.",
                bp9: "Dürüstlük",
                p17: "Biz ən yüksək etik standartlara əməl edirik, hər yerdə, hər zaman etdiyimiz hər bir fəaliyyətdə dürüstlük və ədalətlilik nümayiş etdiririk.",
                bp10: "Komanda tərkibində iş və hörmət",
                p18: "Həmkarlarımızın, tərəfdaşlarımızın və cəmiyyətin hüquqlarına və inanclarına hörmət edirik. Biz ümumi məqsədlərimizə nail olmaq üçün müxtəliflikdən istifadə edərək, başqalarına ləyaqətin, bərabərliyin və etimadın yüksək dərəcəsi ilə yanaşırıq. Bir komanda kimi, fərdlərlə müqayisədə daha çox iş görürük.",
                bp11: "Təlim",
                p19: "Biz məhsuldarlığı artırmaq və şirkəti və özümüzü inkişaf etdirmək üçün daim yeni biliklər əldə edirik",
                bp12: "Sosial məsuliyyət",
                p20: "Biz bütün dünyada müxtəlif maraqlı tərəflər üçün müsbət nəticələri əldə etmək üçün maliyyə, sosial və ekoloji məsuliyyətimizi balanslaşdırmaq üçün imkan axtarırıq. Bu yolda biz tərəfdaşlığa, şəffaflığa və innovasiyalara can atırıq",
                bp13: "NƏYƏ GÖRƏ MUK?",
                p21: "MUK şirkətinin timsalında tərəfdaşlarımız etibarlı distributoru və rəqabətdə əhəmiyyətli üstünlüyü əldə etmiş olurlar",
                p22: "Tərəfdaşlarımız MUK şirkətinin xidmət və servislərinin elastikliyini qeyd edərək, bazarın dəyişən tendensiyalarına sürətlə uyğunlaşırlar. Daha proqressiv tədarükçülərlə işlədiyimiz üçün müştərilərimiz daima bizneslərinin inkişafı üçün həmişə yeni imkanlar tapa bilirlər.",
                p23: "Bizim elastik maliyyə variantları müştərilərimiz üçün işlənib hazırlanmışdır, istər fərdi həllər, istərsə də ixtisaslaşdırılmış kredit xətləri, bununla da tərəfdaşlarımız üçün biznesin aparılmasını asanlaşdırırıq. ",
                p24: "Bütün meydana çıxmış məsələləri biz müştərilərlə iş üzrə menecerlərin və müxtəlif vendorlara təhkim edilmiş məhsullar üzrə mütəxəssislərin köməyi ilə həll edirik. Sizə lazım olan bütün biliklər bir yerdə cəmlənib, bizim peşəkar hazırlığımız və geniş marketinq dəstəyimiz isə etdiklərimizdə əmin olmağınız anlamına gəlir.",
                p25: "MUK – sizə elastikliyi və biznesinizi və sifarişçilərinizin tələbatlarına tez bir şəkildə reaksiya verilməsini təmin edən təcrübəli şirkətdir.",
                p26: "Kommersiya təşəbbüslərimizin diapazonu əvəzolunmaz iş keyfiyyətinə zəmanət verir. Buz həmçinin təcrübəli beynəlxalq logistikadan, təlim və servis mərkəzlərindən, bulud məhsulları bölməsindən faydanın əldə edilməsində müştərilərimizə kömək edə bilərik.",
                p27: "Biz hamıdan yaxşı bilirik ki, yaxşı iş prosesi yaxşı satış deməkdir və başa düşürük ki, reaksiya sürəti, risklərin idarə edilməsi və proaktivlik tərəfdaşımızın biznesinin mühüm hissəsidir və onun müştəri qarşısında reputasiyasının göstəricisidir. Buna görə də biz biznes proseslərinizi yaxşılaşdıran və qarşılıqlı əlaqənin sürətini artıran elektron alətləri yaratdıq.",
                p28: "Biz yolun hər mərhələsində gəlirinizi artırmağa köməklik edirik."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Suallar yaranıb?",
                description: "Bizə elektron məktub göndərmək üçün aşağıdakı formanı doldurun və biz ən qısa müddətdə sizinlə əlaqə saxlayacağıq.",
                send: "Göndərmək",
                nm: "Ad",
                ad: "Ünvan",
                ph: "Telefon",
                em: "Email",
                ms: "Məlumat",
                contactInfo: "Əlaqə informasiyası",
                address: "Ukrayna, Kiyev şəhəri 03151, Donetsk küçəsi 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Bütün hüquqlar qorunur."
            }
        }
    }

    if (lang === "al") {
        text = {
            Navigation: [
                {
                    menu: "Shtete",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Shqipëri",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armeni",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbajxhan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Kroaci",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        /*{
                            link: "/country/by",
                            name: "Bjellorusi",
                            flag: "by.svg",
                            id: 2,
                            iso: "by"
                        },*/
                        {
                            link: "/country/ge",
                            name: "Gjeorgji",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/hu",
                            name: "Hungaria",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakistan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kirgistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldavi",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongoli",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slloveni",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapor",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Taxhikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turqi",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukrainë",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Zgjidhje",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Shitës MUK"
                        },
                        {
                            link: "/solutions",
                            name: "Zgjidhje MUK"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Katalog i produkteve dhe shërbimeve"
                        }
                    ]
                },
                {
                    menu: "Lajme",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Lajme dhe promocione"
                        },
                        {
                            link: "/muk-review",
                            name: "Revista MUK"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Drejtime",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Distribuim  IT"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Qendër trajnimi"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Qendër servisi"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "Shërbime re MUK Cloud"
                        }
                    ]
                },
                {
                    menu: "Për kompaninë",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Pika kyçe MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Profil korporativ"
                        },
                        {
                            link: "/vacancies",
                            name: "Vende pune"
                        }
                    ]
                },
                {
                    menu: "Pjesë për dilerë",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Shqipëri",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armeni",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbajxhan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Kroaci",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                            /*{
                                link: "/country/by",
                                name: "Bjellorusi",
                                flag: "by.svg",
                                id: 2,
                                iso: "by"
                            },*/{
                            link: "https://b2b.muk.ge/",
                            name: "Gjeorgji",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakistan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kirgistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldavi",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongoli",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slloveni",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Taxhikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turqi",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukrainë",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Projekt ndërkombëtar VAD IT distributor",
                paragraph: "Partnerët e MUK na shohin  si distributor i besueshëm IT me më shumë shitës, besojnë në përvojën tonë shumëvjeçare, kompetencën teknike dhe modelit të krijuar mirë të partneritetit.",
                partner: "Si të bëheni partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Distributor ndërkombëtar",
                    text: "Gjeografia e MUK përfshin 16 shtete në Evropë dhe Azi dhe vazhdimisht po zgjerohet"
                },
                {
                    icon: "fa fa-star",
                    title: "Mbi 25 vjet sukses",
                    text: "MUK ka pozicione lideri që nga viti 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Ekspertizë unike",
                    text: "Ekipi inxhinierik i MUK do të merret me çdo detyrë madje edhe me më të vështirën."
                },
                {
                    icon: "fa fa-briefcase",
                    title: "Mbi 100 prodhues",
                    text: "Portofoli distributiv i MUK përfshin më shumë se 100 А-marka globale dhe numri i tyre po rritet vazhdimisht"
                }
            ],
            ServicesInfo: {
                title: "Veprimtaritë e MUK"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Distribuim IT",
                    text: "MUK është distributor VAD i fokusuar në projektet e biznesit IT. E zhvillojmë në mënyrë të suksesshme rrjetin e dilerëve në Evropë dhe Azi për më shumë se 25 vjet.\n Me ndihmë të personelit nga specialistë të certifikuar, MUK u siguron partnerëve nivel të lartë të konsultimeve të projekteve dhe mbështetje teknike, që gjeneron vlerë plotësuese për zgjidhjet e propozuara.\n Inxhinierët e MUK sigurojnë mbështetje konsultuese dhe teknike për zgjidhje softuerike dhe harduer, zbatojnë auditime të sistemeve ekzistuese dhe ndihmojnë gjatë implementimit të platformave të testimit. Flota jonë e pajisjeve për testimin na mundëson që të simulojmë dhe implementojmë spektër të gjerë të detyrave në kushte reale.\n MUK i ndihmon në mënyrë aktive integratorët në zgjedhjen dhe dizajnimin e zgjidhjeve optimale.\n Ekipi i MUK përfshin më shumë se 500 specialistë në zona të ndryshme teknologjike që janë të certifikuara nga prodhues udhëheqës botërorë IT",
                    activ1: "Logjistikë ndërkombëtare, formim i magazinave",
                    activ2: "Marketing dhe mbështetje konsultuese për partnerët",
                    activ3: "Zmadhim të vlerës së zgjidhjeve nëpërmjet kompetencës vetjake",
                    activ4: "Lëshimi i produkteve në treg, promovim dhe gjenerim të kërkesës",
                    activ5: "Mbështetje teknike, garanci dhe shërbim pas garancisë",
                    activ6: "Zhvillim i rrjetit të partnerëve"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Zgjidhje re të MUK Cloud Solution Provider",
                    text: "MUK Cloud Solutions for Business janë paketa zgjidhjes për fillim të shpejtë, qëllimi i të cilit është të sigurohet vazhdimësi në biznes, zmadhim të efikasitetit të punës dhe mobilitetit të të punësuarve me sigurimin e veglave të sigurta bashkëkohore për bashkëpunim.\n Me ndihmën e tyre mund t’i implementoni në mënyrë të shpejtë dhe efikase teknologjitë re në infrastrukturën e organizatës suaj. Koncepti Cloud Solution Provider është kanal i zgjatur në të cilin Microsoft Office 365, AZURE, EMS, D365 dhe shërbime të tjera re janë të disponueshme me pagesë mujore. \nMUK ofron krijim të infrastrukturës “nga zero“. Shpenzime minimale kapitale. Shpenzimet optimale operative për marrjen me qira të resurseve në re dhe mirëmbajtje. Zmadhim i infrastrukturës (rritja e ndërmarrjeve, zyra të reja territoriale, kërcime të planifikuara të ngarkesës). Shërbime të reja në re të integruara me infrastrukturën në tokë",
                    activ1: "Ruajtja e kopjeve rezervë (skedarë, makineri virtuale, baza të dhënash) në re (cloud)",
                    activ2: "Mbrojtje nga “rënia“, rinovimi. Grupe me disponueshmëri të lartë në nivel të makinerive virtuale ose baza të dhënash SQL",
                    activ3: "Menaxhimi me pajisje mobile",
                    activ4: "Mbrojtje të informacioneve korporatave dhe korrespondencë",
                    activ5: "Shpërndarje në SharePoint on-line, Exchange on-line, Skype for business on-line",
                    activ6: "Shpërndarje dhe vendosje në lokacione-interneti, migrim në faqe-interneti në re (cloud)"
                },
                {
                    icon: "fa fa-wrench",
                    name: "Qendër servisi e MUK Service",
                    text: "Kompania MUK Service siguron në mënyrë të suksesshme shërbime për riparimin e kompjuterëve që nga viti 2002 dhe sot është qendre e autorizuar servisi për APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius , Dell EMC, Tescom dhe prodhues të tjerë. Sistemi për menaxhimin me cilësi të kompanisë MUK-Service është i vërtetuar me ISO 9001 në certifikatën e Byrosë për certifikimin ndërkombëtar.\nËshtë i nevojshëm një profesionist i vërtetë për të korrigjuar çdo defekt. Duke fituar përvojë dhe praktikë të përditshme, servisuesit tanë e zgjidhin çdo defekt. Profesionalizmi vjen me përvojë, ne përmirësojmë dhe rrisim nivelin e njohurive tona. Stafi i qendrës së shërbimit përbëhet nga profesionistë të autorizuar të cilët u garantojnë klientëve cilësi të lartë dhe riparim profesional të pajisjeve. MUK Service i ka të gjitha aftësitë e nevojshme teknike për të ofruar shërbim cilësor. Qendra e servisimit kryen riparime të mirëmbajtjes, garanci dhe pa garanci të çdo niveli të ndërlikueshmërisë. Kompania MUK Service ofron pajisje me qira dhe kontraktime të jashtme, shërbime instalimi dhe mirëmbajtjeje, si dhe shërbime informacioni dhe konsultimit për klientët korporatave në Ukrainë, Armeni, Bjellorusi, Gjeorgji, Moldavi, Taxhikistan dhe Kazakistan.",
                    activ1: "Riparim me garanci",
                    activ2: "Riparime pa garanci",
                    activ3: "Diagnostikim hardueri",
                    activ4: "Shitje dhe pjesë rezervë",
                    activ5: "Auditim të kontratave për shërbime",
                    activ6: "Marrje me qira dhe kontraktime të jashtme të pajisjeve"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Qendra e trajtimit të МUК",
                    text: "MUK Training Center është lider në tregun e arsimit IT me më shumë se 15 vjet përvojë dhe një numër të madh autorizimesh unike, ekip nga instruktorë të kualifikuar dhe infrastrukturë moderne për trajnim.\nPortofoli i MUK TC përfshin më shumë se 300 kurse për trajnim nga kompani udhëheqëse IТ. \nStatuset e dukshme përfshijnë: Pearson VUE, Veeam qendër e autorizuar arsimore, HPE qendër edukative, VMware qendër e autorizuar trajnimi, Oracle ofrues i miratuar arsimor, Penta Security qendër edukative, Juniper Networks partner i autorizuar arsimor, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point qendër e autorizuar trajnimi, Fortinet qendër e autorizuar trajnimi, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nQendra për trajnim e MUK ka qasje në pajisjet mësimore më bashkëkohore. Cilësia e mësimdhënies nga ana e instruktorëve tanë është e vërtetuar shumë vjet me notat e larta të studentëve në Ukrainë dhe jashtë shteti."
                }
            ],
            Vendors: {
                title: "Shitës të MUK",
                country: "Shteti",
                solution: "Zgjidhje",
                name: "Emri",
                all: "Gjithçka, Të gjithë/a",
                namePlaceholder: "Filloni ta shkruani emrin e shitësit",
                notInfo: "Informacionet nuk plotësohen"
            },
            VendorsForCountry: {
                title: "Shitësit MUK të disponueshëm në vend"
            },
            VendorsForSolution: {
                title: "Shitës MUK sipas zgjidhjes"
            },
            VendorDetail: {
                title: "DISTRIBUTOR I AUTORIZUAR"
            },
            Gallery: {
                title: "Zgjidhje MUK"
            },
            Distribution: {
                title: "Distribuim IT"
            },
            Partner: {
                title: "Si të bëheni partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Dërgo",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "МUK e ndërton biznesin e tij mbi parimet e partneritetit dhe bashkëpunimit",
                advantages: "Përfitime",
                paragraph: "MUK që nga themelimi i tij fokusohet në transparencën në marrëdhëniet me furnitorët dhe klientët. Përkushtimi i rregullave për partneritet i mundëson MUK që ta fitojë mirëbesimin në treg dhe të ndërtojë reputacion lideri",
                Why: [
                    "Inovacione",
                    "Përgjegjësi",
                    "Ndershmëri",
                    "Mundësi të barabarta punësimi"

                ],
                Why2: [
                    "Punë në ekip dhe respekt",
                    "Arsim",
                    "Përgjegjësi sociale"
                ]
            },
            News: {
                title: "Lajme nga MUK",
                showAll: "Paraqit gjithçka",
                showMore: "Paraqit më shumë",
                news: "Lajme",
                akcii: "Aksione"
            },
            Vacancies: {
                title: "Vende pune",
                resume: "Send a CV",
                country: "Shteti",
                all: "Të gjithë/a",
                search: "Kërkim",
                namePlaceholder: "Filloni të shkruani emër",
                filterInfo: "Sipas filtrave nuk ka vende të lira",
                notInfo: "Informacione nuk janë të plotësuara",
                back: "Back"
            },
            MukReview: {
                title: "Edicione të revistës \"MUK-REVIEW\" ",
                vupysk: "Problem"
            },
            OMuk: {
                title: "Informacione kryesore për MUK",
                p1: "Grupacioni i kompanive MUK filloi me punë në vitin 1997. Fusha jonë kryesore e punës është shpërndarja e orientuar në mënyrë projektuese e produkteve udhëheqëse IT në fushën e zgjidhjeve hibride dhe zgjidhjeve re (cloud), konvergjencë të qendrës së të dhënave, siguri të informacioneve, pajisje mobile dhe Internet të sendeve, analitikë të të dhënave dhe inteligjencë artificiale.",
                p2: "Falë rrjetit tonë global të shpërndarjes, ne sjellim shitës IT me perspektivë dhe produktet e tyre të reja në tregjet lokale, marrim pjesë në mënyrë aktive në formimin e kërkesës",
                p3: "Ne kombinojmë njohuritë e ekspertëve teknike dhe të tregut me një program mbështetës progresiv të partnerëve. Duke punuar ngushtë me dilerët tanë, ne përpiqemi të sigurojmë rritjen dhe zhvillimin e tyre dinamik, duke arritur rezultate së bashku.",
                bp1: "TEKNOLOGJIA E INFORMACIONIT – KËTA JEMI NE!",
                p4: "MUK është pioner në zgjerimin e teknologjisë së informacionit për më shumë se 25 vjet. Sot, MUK luan rol të rëndësishëm në transferimin e teknologjisë nga ata që e zhvillojnë tek ata që e zbatojnë dhe që e përdorin.",
                ul: "Katër numra që e karakterizojnë MUK si partner të besueshëm dhe distributor efikas:",
                li1: "1. Mbi 25 vjet përvojë dhe mirëbesim.",
                li2: "2. Më shumë se 100 shitës të markës-А (kompani me emra botërorë dhe produkte të dëshmuara).",
                li3: "3.  Çdo fushë e shitësve ka menaxherët e saj, para-shitje dhe inxhinierë, kështu që personeli ynë përbëhet nga më shumë se 500 specialistë.",
                li4: "4. Aktualisht ne u shërbejmë më shumë se 4000 partnerëve aktivë, duke përfshirë jo vetëm integruesit klasikë IT, por edhe ndërmarrje prodhuese, kompani ndërtimi, firma këshilluese, zhvillues të softuerit që përdorin produktet tona në dërgesat e tyre.",
                bp2: "STRATEGJI",
                p5: "Strategjia jonë është që të njihemi si nga furnitorët ashtu edhe nga rishitësit si distributorë kryesorë IT, falë përvojës sonë të madhe, kompetencës së lartë dhe pranisë në vende të ndryshme anembanë botës.",
                bp3: "MISIONI",
                p6: "Misioni ynë është t'u ofrojmë partnerëve tanë zgjidhje inovative dhe produkte cilësore në kohë.",
                p7: "Ne punojmë të përkushtuar ndaj avancimit të produkteve dhe zgjidhjeve teknologjike për të përmbushur kërkesën në rritje të tregut dhe për të shtuar vlerën si për furnitorin ashtu edhe për rishitësin përmes disponueshmërisë në kohë të produkteve dhe njohurive të thella të produkteve.",
                p8: "MUK punon në mënyrë sistematike në krijimin e kërkesë dhe futjen e produkteve në treg, si edhe për gjenerimin e mundësive përfituese për rishitësit tanë nëpërmjet programit të partnerëve, zinxhirit efikas të furnizimit dhe trajnimit.",
                p9: "Jemi të përkushtuar në mirëmbajtjen e mjedisit që i autorizon njerëzit tanë, i njeh arritjet e tyre dhe i ndihmon që të përshtaten në ndryshimin e vazhdueshëm të mjedisit rrethues afarist. ",
                bp4: "PARTNERITET DHE PËRGJEGJËSI",
                p10: "MUK i përmbahet një modeli biznesi ekskluzivisht partner. Ne nuk punojmë me klientët fundorë dhe mbështetemi në zhvillimin e rrjetit të dilerëve. Ndër klientët fundorë të partnerëve tanë janë të gjithë sektorët e biznesit vendas: shitje me pakicë, industri, financa dhe sektori publik.",
                p11: "Përgjegjësinë për arritjen e suksesit e ndajmë me partnerët tanë. Kredoja jona: “Ecim së bashku, dhe së bashku shkojmë deri në fund”. I mbështesim partnerët tanë në situata të vështira dhe së bashku festojmë fitore, ashtu siç tregon përvoja, kemi shumë më shumë fitore të përbashkëta sesa humbje.",
                p12: "MUK me punën e saj afatgjate e ka dëshmuar qëndrueshmërinë e strategjisë së saj me shumë shitës, në të cilën të gjithë shitësit në portofolin tonë marrin mundësi të barabarta për t'u zhvilluar dhe për të punuar në një mjedis tregu konkurrues. Ne rezervojmë të drejtën që partnerët të zgjedhin një strategji të punës në projekte, duke ndihmuar në krijimin e zgjidhjeve gjithëpërfshirëse, duke këshilluar për të gjithë ciklin e shitjeve: nga mënjanimi i detyrave deri tek implementimi dhe mirëmbajtja.",
                bp5: "VLERAT TONA",
                p13: "MUK është fokusuar plotësisht në promovimin e suksesit të partnerëve të saj të biznesit dhe punonjësve duke iu përmbajtur vlerave të inovacionit, përgjegjësisë, integritetit, mundësive të barabarta dhe punës në grup, respektit, të mësuarit dhe përgjegjësisë sociale.",
                bp6: "Mundësi të barabarta për punësim",
                p14: "Aplikimet nga kandidatët për pozicione të lira i shqyrtojmë pavarësisht nga raca, gjinia, feja, ngjyra e lëkurës, origjina kombëtare, mosha, identiteti dhe shprehja gjinore, invaliditeti, orientimi seksual, statusi i veteranit ose faktorë të tjerë që nuk lidhen me kualifikimet e një pozicioni të caktuar.",
                bp7: "Inovacioni",
                p15: "Kërkojmë vazhdimisht mënyra më të mira që të sigurojmë përfitime për klientët tanë, furnitorë dhe kolegë. Presim ndryshime në krijimin proaktiv të zgjidhjeve të përshtatshme për ta.",
                bp8: "Përgjegjësi",
                p16: "E themi atë që bëjmë dhe e bëjmë atë që themi. Arrijmë në mënyrë të vazhdueshme rezultate që i plotësojnë ose i tejkalojnë pritjet e partnerëve dhe furnitorëve tanë.",
                bp9: "Ndershmëri",
                p17: "Ne u përmbahemi standardeve më të larta etike duke demonstruar ndershmëri dhe drejtësi në çdo aksion që e ndërmarrim, kudo dhe në çdo kohë.",
                bp10: "Punë në ekip dhe respekt",
                p18: "I respektojmë të drejtat dhe besimet e kolegëve, partnerëve dhe shoqërisë. Ne i trajtojmë të tjerët me nivelin më të lartë të dinjitetit, barazisë dhe besimit duke përdorur diversitetin për të arritur qëllimet tona të përbashkëta. Si ekip ne bëjmë më shumë sesa individualisht.",
                bp11: "Edukim",
                p19: "Fitojmë vazhdimisht njohuri të reja që ta risim produktivitetin dhe të sigurojmë rritje të kompanisë sonë dhe të vetvetes. ",
                bp12: "Përgjegjësi sociale",
                p20: "Kërkojmë në mënyrë aktive mënyra për të balancuar përgjegjësitë tona financiare, sociale dhe ekologjike për të arritur rezultate pozitive për palë të ndryshme në mbarë botën. Në këtë rrugë ne përpiqemi për bashkëpunim, transparencë dhe inovacion.",
                bp13: "PSE MUK?",
                p21: "Me MUK, partnerët tanë fitojnë distributor të besueshëm dhe përparësi të konsiderueshme konkurruese.",
                p22: "Partnerët tanë përshtaten lehtësisht me trendet në ndryshim të tregut, duke vënë në dukje fleksibilitetin e shërbimeve të MUK. Për shkak se ne punojmë me furnitorët më progresivë, klientët tanë gjithmonë gjejnë mundësi të reja për të zhvilluar biznesin e tyre.",
                p23: "Opsionet tona fleksibël të financimit janë të dizajnuara për klientët tanë, pavarësisht nëse është një zgjidhje me porosi ose linja të caktuara krediti, ne e bëjmë biznesin më të lehtë për partnerët tanë.",
                p24: "Ne i zgjidhim të gjitha problemet që shfaqen me ndihmën e menaxherëve të përgatitur për llogari dhe specialistë për produkte të ndara në shitës të ndryshëm. Të gjitha njohuritë që ju nevojiten janë mbledhur në një vend, dhe trajnimi ynë profesional dhe mbështetja e gjerë e marketingut do të thotë që ju mund të jeni të sigurt në gjithçka që bëjmë.",
                p25: "MUK – është kompani me përvojë që ju siguron fleksibilitet dhe përgjigje ndaj nevojave të biznesit dhe klientëve tuaj.",
                p26: "Paleta jonë e iniciativave komerciale ju garanton cilësi të shkëlqyer të punës. Ne gjithashtu mund t'i ndihmojmë klientët tanë të kenë dobi nga logjistika ndërkombëtare me përvojë, nga qendrat për trajnim dhe shërbime, departamenti për produkte re (cloud).",
                p27: "Ne e dimë më mirë se kushdo që një rrjedhë e mirë pune do të thotë shitje të mira dhe ne e kuptojmë se përgjegjësia, proaktiviteti dhe menaxhimi i rrezikut janë një pjesë e rëndësishme e biznesit të suksesshëm të partnerit tonë dhe reputacionit të tij tek klientët. Prandaj, ne kemi krijuar mjete elektronike që i përmirësojnë proceset tuaja afariste dhe e thjeshtësojnë shpejtësinë e interaksionit.",
                p28: "Ne ndihmojmë që t’i zmadhojmë të ardhurat dhe përfitimin tuaj në çdo hap të rrugës."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Nëse keni çfarëdo pyetje?",
                description: "Ju lutemi plotësoni formularin më poshtë që të na dërgoni e-mail dhe ne do t’ju përgjigjemi sa më shpejt të jetë e mundur",
                send: "Dërgo",
                nm: "Emri",
                ad: "Adresa",
                ph: "Telefoni",
                em: "E-mail",
                ms: "Mesazhi",
                contactInfo: "Informacione për kontakt",
                address: "Ukrainë, q. Kiev 03151, rr. Donecka 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Të gjitha të drejtat janë të rezervuara."
            }
        }
    }

    if (lang === "am") {
        text = {
            Navigation: [
                {
                    menu: "Երկրներ",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Ալբանիա",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Հայաստան",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },

                        {
                            link: "/country/az",
                            name: "Ադրբեջան",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Խորվաթիա",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        /*{
                            link: "/country/by",
                            name: "Բելառուս",
                            flag: "by.svg",
                            id: 2,
                            iso: "by"
                        },*/
                        {
                            link: "/country/ge",
                            name: "Վրաստան",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/hu",
                            name: "Հունգարիա",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/kz",
                            name: "Ղազախստան",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Ղրղզստան",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Մոլդովա",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Մոնգոլիա",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Սլովենիա",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Սինգապուր",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Տաջիկստան",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Թուրքիա",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Թուրքմենիստան",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ուկրաինա",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "ՈՒզբեկստան",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Լուծումներ",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK վենդորներ"
                        },
                        {
                            link: "/solutions",
                            name: "MUK լուծումներ"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Պրոդուկտների և ծառայությունների կատալոգ"
                        }
                    ]
                },
                {
                    menu: "Նորություններ",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Նորություններ և ակցիաներ"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK ամսագիր"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Վիդեո"
                        }
                    ]
                },
                {
                    menu: "Ուղղություններ",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "ՏՏ դիստրիբուցիա"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Ուսումնական կենտրոն"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Սպասարկման կենտրոն"
                        },
                        {
                            link: "https://cloud.muk.am/",
                            name: "MUK Cloud ամպային ծառայություններ"
                        }
                    ]
                },
                {
                    menu: "Ընկերության մասին",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Գլխավորը MUK-ի մասին"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Կորպորատիվ պրոֆայլ"
                        },
                        {
                            link: "/vacancies",
                            name: "Թափուր աշխատատեղեր"
                        }
                    ]
                },
                {
                    menu: "Դիլերական բաժին",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ալբանիա",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Հայաստան",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Ադրբեջան",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Խորվաթիա",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                            /*{
                                link: "/country/by",
                                name: "Բելառուս",
                                flag: "by.svg",
                                id: 2,
                                iso: "by"
                            },*/{
                            link: "https://b2b.muk.ge/",
                            name: "Վրաստան",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Ղազախստան",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Ղրղզստան",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Մոլդովա",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Մոնգոլիա",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Սլովենիա",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Տաջիկստան",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Թուրքիա",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Թուրքմենիստան",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ուկրաինա",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "ՈՒզբեկստան",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "VAD IT միջազգային նախագիծ",
                paragraph: "MUK-ի գործընկերները տեսնում են մեզ որպես բազմաթիվ վենդորների ՏՏ հուսալի դիստրիբյուտորի, վստահում են մեր բազմամյա փորձին, տեխնիկական գիտելիքներին և մշակված գործընկերային աշխատանքային  մոդելին ",
                partner: "Դառնալ գործընկեր"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Միջազգային դիստրիբյուտոր",
                    text: "MUK աշխարհագրությունը ներառում է Եվրոպայի և Ասիայի 16 երկիր և անընդհատ ընդլայնվում է"
                },
                {
                    icon: "fa fa-star",
                    title: "25 և ավել տարվա հաջողություն",
                    text: "MUKը պահպանում է առաջնային դիրքեր սկսած 1997թ"
                },
                {
                    icon: "fa fa-users",
                    title: "Յուրահատուկ փորձառություն",
                    text: "MUK ինժեներական խումբը կհաղթահարի ցանկացած, նույնիսկ ամենաբարդ խնդիրը"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ արտադրողներ",
                    text: "MUK-ի դիստրիբուտորական պորտֆելում կան 100ից ավել համաշխարհային А-բրենդներ, և դրանց քանակը անընդհատ ավելանում է"
                }
            ],
            ServicesInfo: {
                title: "MUK-ի գործունեության ուղղություններ"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "ՏՏ դիստրիբուցիա",
                    text: "MUK-ը VAD դիստրիբյուտոր է՝ ուղղված դեպի նախագծային ՏՏ բիզնես։ Մենք 25 և ավել տարի է հաջողությամբ զարգացնում ենք մատակարարման ցանցը Եվրոպայի և Ասիայի երկրներում։  \\nԱրտոնագրված մասնագետների օգնությամբ MUK-ը գործընկերներին է տրամադրում նախագծային խորհրդատվության բարձր մակարդակ և տեխնիկական աջակցություն, որով ապահովում է տրամադրվող լուծումների լրացուցիչ արժեքայնությունը։ \\nMUK-ի ինժեներները իրականացնում են ծրագրային և ապարատային լուծումների խորհրդատվություն և տեխնիկական աջակցություն, իրականացնում են գոյություն ունեցող համակարգերի ստուգումներ և օգնում են թեստային ստենդերի իրականացման ընթացքում։ Թեստային սարքավորման մեր պարկը թույլ է տալիս մոդելավորել և իրական պայմաններում իրականացնել խնդիրների լայն սպեկտր։ \\nMUK-ը ակտիվ կերպով օգնում է ինտեգրատորներին լավագույն լուծումների ընտրության և նախագծման հարցերում։ \\n MUK թիմը ներառում է տարբեր տեխնոլոգիական ուղղությունների 500-ից ավել մասնագետների, որոնք ունեն արտոնագրեր համաշխարհային ՏՏ առաջատար արտադրողներից",
                    activ1: "Միջազգային փոխադրումներ, պահեստի ձևավորում",
                    activ2: "Գործընկերների մարկետինգային և խորհրդատվական աջակցություն",
                    activ3: "Սեփական գիտելիքների հաշվին լուծումների արժեքայնության ավելացում",
                    activ4: "Պրոդուկտների դուրսբերում շուկա, առաջխաղացում և պահանջարկի ձևավորում",
                    activ5: "Տեխնիկական աջակցություն, երաշխիքային և ետերաշխիքային սպասարկում",
                    activ6: "Գործընկերային ցանցի զարգացում"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider ամպային պրոդուկտներ",
                    text: "MUK-ի՝ բիզնեսի համար MUK Cloud Solutions ամպային լուծումները արագ սկզբի համար պատրաստի լուծումների և ծառայությունների հավաքածուներ են՝ ուղղված բիզնեսի անխափանության ապահովմանը, աշխատանքի արդյունավետությանը և աշխատակիցների ճկունության բարձրացմանը՝ հավաքական փոխհամագործակցության ժամանակակից պաշտպանված միջոցների տրամադրմամբ։ \\nԴրանց օգնությամբ Դուք կարող եք Ձեր կազմակերպության ենթակառուցվածքում արագ և արդյունավետ կերպով ներդնել ամպային տեխնոլոգիաներ։ Cloud Solution Provider հայեցակարգը վաճառքների ուղի է, որտեղ հասանելի են Microsoft Office 365, AZURE, EMS, D365 և այլ ամպային ծառայություններ՝ ամսեկան վճարմամբ։ \\nMUK-ը առաջարկում է \"զրոյից\" ենթակառուցվածքի ստեղծում։ Նվազագույն կապիտալ ծախսումներ։ Օպտիմալ գործառնային ծախսեր՝ ամպային ռեսուրսների վարձակալության և սպասարկման համար։ Ենթակառուցվածքի մասշտաբավորում (ձեռնարկության աճ, նոր տարածքային գրասենյակներ, ծանրաբեռնվածության ծրագրվող ալիքներ)։ Նոր ծառայություններ ամպում՝ միավորված ցամաքային ենթակառուցվածքների հետ",
                    activ1: "Պահուստային պատճեների պահպանում (ֆայլեր, վիրտուալ մեքենաներ, տվյալների բազաներ) ամպում",
                    activ2: "Պաշտպանություն վթարային խափանումներից, վերականգնում։ Բարձր հասանելիության քլաստերներ վիրտուալ մեքենաների կամ SQL տվյալների բազաների մակարդակում",
                    activ3: "Բջջային սարքերի կառավարում",
                    activ4: "Կորպորատիվ տեղեկատվության և նամակագրության պաշտպանություն",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business on-line ընդարձակում",
                    activ6: "Վեբ-կայքերի ընդարձակում և կարգավորում, կայքերի տեղափոխում ամպ"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Սերվիս սպասարկման կենտրոն",
                    text: "MUK Սերվիս ընկերությունը համակարգչային տեխնիկայի վերանորոգման ծառայություններ է մատուցում 2002 թվականից և այսօր հանդիսանում է APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, НР, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom և այլ արտադրողների հավատարմագրված սպասարկման կենտրոն։ MUK Սերվիս ընկերության որակի կառավարման համակարգը հաստատված է  Հավատարմագրման Միջազգային Բյուրոյի ISO 9001 սերտիֆիկատով։ \\nՑանկացած անսարքություն արագ կերպով վերացնելու համար անհրաժեշտ է լինել իսկական մասնագետ։ Մեր վարպետները, ստանալով փորձ և ամենօրյա պրակտիկա, վերացնում են ցանկացած անսարքություն։ Արհեստավարժությունը ձեռք է բերվում փորձի հետ, մենք ինքնակատարելագործվում ենք և բարձրացնում ենք մեր գիտելիքների մակարդակը։ Սպասարկման կենտրոնի անձնակազմը կազմված է հավատարմագրված մասնագետներից, ինչը երաշխավորում է պատվիրատուի սարքավորման որակյալ և արհեստավարժ վերանորոգում։ MUK Սերվիսը ունի բոլոր անհրաժեշտ տեխնիկական հնարավորությունները՝ որակյալ սպասարկում ապահովելու համար։ Սերվիս կենտրոնը իրականացնում  է բարդության ցանկացած մակարդակի տեխնիկական սպասարկում, երաշխիքային և ոչ երաշխիքային վերանորոգում։ MUK Սերվիս ընկերությունը տրամադրում է սարքավորման վարձակալության և աութսորսինգի, տեղադրման և տեխնիկական սպասարկման ծառայություններ, ինչպես նաև տեղեկատվական-խորհրդատվական ծառայություններ կորպորատիվ հաճախորդների համար Ուկրաինայի, Հայաստանի, Բելառուսի, Վրաստանի, Մոլդովայի, Տաջիկստանի և Ղազախստանի տարածքում։ ",
                    activ1: "Երաշխիքային վերանորոգում",
                    activ2: "Ոչ երաշխիքային վերանորոգում",
                    activ3: "Սարքավորման ախտորոշում",
                    activ4: "Պահեստամասերի վաճառք",
                    activ5: "Սպասարկման պայմանագրերի աուդիտ",
                    activ6: "Սարքավորման վարձակալություն և աութսորսինգ"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK ուսումնական կենտրոն",
                    text: "MUK ուսումնական կենտրոնը իր ավելի քան 15 տարվա փորձով և մի շարք եզակի հավատարմագրումների, որակավորված հրահանգիչների և ժամանակակից ուսումնական ենթակառուցվածքի առկայությամբ առաջատար է ՏՏ ոլորտի կրթական ծառայությունների շուկայում։ \\nMUK ՈՒԿ պորտֆելը ներառում է առաջատար ՏՏ ընկերությունների 300ից ավել ուսումնական կուրսեր։\\nՍտատուսներից պետք է նշել Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner։ \\nMUK ՈՒԿ հասանելի են ամենաժամանակակից ուսումնական սարքավորումները։ Մեր հրահանգիչների դասավանդման որակը հաստատվում է ունկնդիրների բարձր գնահատականներով ՈՒկրաինայում և նրանից դուրս բազմաթիվ տարիների ընթացքում։"
                }
            ],
            Vendors: {
                title: "MUK վենդորներ",
                country: "Երկիր",
                solution: "Լուծում",
                name: "Անվանում",
                all: "Բոլորը",
                namePlaceholder: "Սկսեք մուտքագրել մատակարարի անվանումը",
                notInfo: "Տեղեկությունը լրացված չէ"
            },
            VendorsForCountry: {
                title: "Երկրում հասանելի MUK վենդորներ"
            },
            VendorsForSolution: {
                title: "MUK վենդորներ ըստ լուծման"
            },
            VendorDetail: {
                title: "ՊԱՇՏՈՆԱԿԱՆ ԴԻՍՏՐԻԲՅՈՒՏՈՐ"
            },
            Gallery: {
                title: "MUK լուծումներ"
            },
            Distribution: {
                title: "ՏՏ դիստրիբուցիա"
            },
            Partner: {
                title: "Դառնալ գործընկեր",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Ուղարկել",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK-ը կառուցում է բիզնեսը գործընկերության և համագործակցության սկզբունքների վրա",
                advantages: "Առավելությունները",
                paragraph: "MUK-ը իր հիմադրման օրվանից շեշտը դնում է մատակարարների և պատվիրատուների հետ հարաբերությունների թափանցիկության վրա։ Գործընկերային կանոններին հավատարիմ մնալը թույլ տվեց MUK-ին շահել շուկայի վստահությունն ու ձեռք բերել առաջատարի համբավ։",
                Why: [
                    "Նորարարություններ",
                    "Պատասխանատվություն",
                    "Ազնվություն",
                    "Աշխատանքի ընդունման տարբեր հնարավորություններ"

                ],
                Why2: [
                    "Աշխատանք թիմում և հարգանք",
                    "Ուսուցում",
                    "Սոցիալական պատասխանատվություն"
                ]
            },
            News: {
                title: "MUK նորություններ",
                showAll: "Ցույց տալ բոլորը",
                showMore: "Ցույց տալ բոլորը",
                news: "Նորություն",
                akcii: "Ակցիա"
            },
            Vacancies: {
                title: "Թափուր աշխատատեղեր",
                resume: "Send a CV",
                country: "Երկիր",
                all: "Բոլորը",
                search: "Փնտրել",
                namePlaceholder: "Սկսեք մուտքագրել անվանումը",
                filterInfo: "Տվյալ ֆիլտրերով թափուր աշխատատեղեր չկան",
                notInfo: "Տեղեկությունը լրացված չէ",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" ամսագրի թողարկումներ",
                vupysk: "Թողարկում"
            },
            OMuk: {
                title: "Գլխավորը MUK-ի մասին",
                p1: "MUK ընկերությունների խումբը իր գործունեությունը սկսել է 1997 թ։ Մեր գործունեության հիմնական ուղղությունն է՝  նախագծային ուղղվածությամբ առաջատար ՏՏ պրոդուկտների դիստրիբուցիա հիբրիդային և ամպային լուծումների , տվյալների մշակման կենտրոնների կոնվերգենցիայի, տեղեկատվական անվտանգության, բջջային սարքավորումների և Ինտերնետ իրերի, տվյալների անալիտիկայի և արհեստական բանականության ոլորտներում։",
                p2: "Ի շնորհիվ մեր գլոբալ դիստրիբյուտորական ցանցի՝ մենք տեղական շուկաներ ենք հանում հեռանկարային ՏՏ վենդորների և նրանց նոր պրոդուկտները, ակտիվ մասնակցում ենք պահանջարկի ձևավորմանը",
                p3: "Մենք համատեղում ենք փորձագիտական տեխնիկական և շուկայական գիտելիքները գործընկերների աջակցության առաջատար ծրագրի հետ։ Սերտ համագործակցելով մեր դիլերների հետ մենք ձգտում ենք ապահովել նրանց դինամիկ աճը և զարգացումը՝ միասին հասնելով արդյունքների ",
                bp1: "ՏԵՂԵԿԱՏՎԱԿԱՆ ՏԵԽՆՈԼՈԳԻԱՆԵՐԸ ՄԵՆՔ ԵՆՔ",
                p4: "MUK ընկերությունը առաջիններից էր ՏՏ տարածման ոլորտում 25 տարի առաջ։ Այսօր MUK-ը կարևոր դեր է խաղում տեխնոլոգիաները մշակողներից դրանք ներդրողներին և օգտագործողներին փոխանցման գործընթացի մեջ։",
                ul: "Չորս թիվ, որ բնութագրում են MUK-ը որպես հուսալի գործընկեր և արդյունավետ դիստրիբյուտորի",
                li1: "1․ Ավելի քան 25 տարվա փորձ և վստահություն",
                li2: "2․ 100-ից ավել А-բռենդ մակարդակի վենդորներ (համաշխարհային համբավ և ստուգված պրոդուկտներ ունեցող ընկերություններ)",
                li3: "3․ Ամեն վենդորային ուղղություն ունի իր մենեջերների, նախնական վաճառքի մասնագետների և ինժեներների թիմ, այդ պատճառով մեր աշխատակիցների քանակը 500-ից ավել է",
                li4: "4․ Այս պահին մենք սպասարկում ենք 4000 ակտիվ գործընկերոջ, որոնց մեջ կան և դասական ՏՏ ինտեգրատորներ, և արտադրական ձեռնարկություններ, շինարարական ընկերություններ, խորհրդատվական ընկերություններ, ծրագրային ապահովում մշակողներ, որոնք կիրառում են մեր պրոդուկտները իրենց մատակարարումներում",
                bp2: "ՌԱԶՄԱՎԱՐՈՒԹՅՈՒՆ",
                p5: "Մեր ռազմավարությունը կայանում է նրանում, որ մեր հսկայական փորձի, բարձր գիտելիքների և աշխարհի տարբեր երկրներում մեր ներկայության շնորհիվ  մեզ որպես առաջատար ՏՏ դիստրիբյուտոր ընդունեն ինչպես մատակարարները, այդպես էլ վերավաճառողները",
                bp3: "ԱՌԱՔԵԼՈՒԹՅՈՒՆ",
                p6: "Մեր առաքելությունն է մեր գործընկերներին ներկայացնել նորարարական լուծումներ և որակյալ արտադրանք ճիշտ ժամանակին",
                p7: "Մենք անձնազոհաբար աշխատում ենք տեխնոլոգիական պրոդուկտների և լուծումների առաջխաղացման ուղղությամբ՝ նպատակ ունենալով բավարարել աճող շուկայական պահանջարկը և ավելացնելով արժեքավորությունը ինչպես մատակարարի, այդպես էլ առևտրային միջնորդի համար՝ ապրանքների հասանելիության և պրոդուկտների մասին խորը գիտելիքների հաշվին։",
                p8: "MUK-ը համակարգորեն աշխատում է պահանջարկի ստեղծման և պրոդուկտների՝ շուկա հանելու վրա, ինչպես նաև մեր վերավաճառողների համար ձեռնտու հնարավորությունների ստեղծման վրա՝ գործընկերային ծրագրի, մատակարման արդյունավետ շղթայի և ուսուցման  միջոցով ",
                p9: "Մենք ձգտում ենք պահպանել այն մթնոլորտը, որը ընդլայնում է մեր աշխատակիցների հնարավորությունները, ընդունում է իրենց նվաճումները և օգնում է հարմարվել անընդհատ փոփոխվող գործարար միջավայրին։ MUK-ը մոտիվացնում է աշխատակիցներին հաստատուն անձանային և մասնագիտական աճի համար։",
                bp4: "ԳՈՐԾԸՆԿԵՐՈՒԹՅՈՒՆ ԵՒ ՊԱՏԱՍԽԱՆԱՏՎՈՒԹՅՈՒՆ",
                p10: "MUK-ը կիրառում է բացառապես գործերի վարման գործընկերային մոդելը։ Մենք չենք աշխատում վերջնական պատվիրատուի հետ և մեր շեշտը դնում ենք դիլերական ցանցի զարգացման վրա։ Մեր գործընկերների վերջնական պատվիրատուների մեջ ներկայացված են հայրենական բիզնեսի բոլոր ճյուղերը՝ մանրածախ վաճառք, արդյունաբերություն, ֆինանսներ և պետական սեկտոր ",
                p11: "Մենք մեր գործընկերների հետ կիսում ենք պատասխանատվությունը հաջողության հասնելու ճանապարհին։ Մեր կարգախոսն է՝ \"Գնում ենք միասին, նշանակում է, գնում ենք միասին մինչև վերջ\"։ Մենք աջակցում ենք մեր գործընկերներին դժվարին իրադրություններում և միասին ուրախանում ենք հաղթանակների համար, և ինչպես ցույց է տալիս փորձը, մենք ունենք ավելի շատ համատեղ հաղթանակներ, քան պարտություններ ",
                p12: "MUK-ը իր բազմամյա աշխատանքով ապացուցել է իր բազմավենդորային մարտավարության կենսունակությունը, որի ժամանակ բոլոր վենդորները մեր պորտֆելում ստանում են հավասար հնարավորություն զարգանալու և աշխատելու մրցակցային շուկայական միջավայրում։ Մենք գործընկերներին ենք թողնում նախագծերում աշխատանքի մարտավարության ընտրության հարցը, միևնույն ժամանակ օգնում ենք ձևավորել համալիր որոշումներ՝ խորհրդատվություն տրամադրելով վաճառքի ողջ ընթացքում՝ խնդրի հանումից մինչև ներդրում և սպասարկում",
                bp5: "ՄԵՐ ԱՐԺԵՔՆԵՐԸ",
                p13: "MUK-ը ամբողջությամբ կենտրոնացած է իր գործընկերների և աշխատակիցների հաջողության ավելացման վրա՝ պահպանելով այնպիսի արժեքներ, ինչպիսիք են՝ նորարարությունները, պատասխանատվությունը, ազնվությունը, հնարավորությունների հավասարությունը և թիմային աշխատանքը, հարգանքը, ուսումը և սոցիալական պատասխանատվությունը",
                bp6: "Աշխատանքի ընդունման տարբեր հնարավորություններ",
                p14: "Թափուր հաստիքների համար թեկնածուների դիմումները մեր կողմից քննվում են առանց ռասայի, սեռի, հավատքի, մաշկի գույնի, ազգային ծագման, տարիքի, սեռական պատկանելության կամ արտահայտման, հաշմանդամության, սեռական կողմնորոշման, վետերանի կարգավիճակի կամ այլ գործոնի վրա ուշադրություն դարձնելով, որը կապ չունի տվյալ պաշտոնի որակավորման հետ։",
                bp7: "Նորարարություն",
                p15: "Մենք անընդհատ փնտրում ենք ավելի լավ միջոցներ՝ մեր հաճախորդներին, մատակարարներին և գործընկերներին օգուտ բերելու համար։ Մենք ակնկալում ենք փոփոխություններ և պրոակտիվ կերպով ստեղծում լուծումներ՝ հարմարեցված դրանց համար",
                bp8: "Պատասխանատվություն",
                p16: "Մենք ասում ենք այն, ինչ անում ենք, և անում ենք այն, ինչ ասում ենք։ Մենք մշտապես հասնում ենք արդյունքների, որոնք համապատասխանում են մեր գործընկերների և մատակարարների սպասումներին կամ գերազանցում են դրանք",
                bp9: "Ազնվություն",
                p17: "Մենք պահպանում ենք էթիկայի ամենաբարձր ստանդարտները՝ ցուցաբերելով ազնվություն և արդարություն ամեն գործողությունում, որը մենք ձեռնարկում ենք, միշտ և ամենուրեք",
                bp10: "Թիմային աշխատանք և հարգանք",
                p18: "Մենք հարգում ենք մեր աշխատակիցների, գործընկերների և հասարակության իրավունքները և համոզմունքները։ Մենք ուրիշներին վերաբերում  ենք արժանապատվության, հավասարության և վստահության բարձրագույն աստիճանով՝ օգտագործելով բազմազանությունը մեր ընդհանուր նպատակներին հասնելու համար։  Ինչպես թիմ մենք կանենք ավելին, քան մենակ",
                bp11: "Ուսուցում",
                p19: "Մենք անընդհատ ձեռք ենք բերում նոր գիտելիքներ, որպեսզի բարձրացնենք արտադրողականությունը և ապահովենք ընկերության և մեր անձնային աճը։",
                bp12: "Սոցիալական պատասխանատվություն",
                p20: "Մենք ակտիվ կերպով փնտրում ենք մեր ֆինանսական, սոցիալական և բնապահպանական պատասխանատվությունը հավասարակշռելու հնարավորություններ՝ ամբողջ աշխարհում տարբեր շահագրգիռ կողմերի համար  դրական արդյունքների հասնելու համար։ Այս ճանապարհին մենք ձգտում ենք համագործակցության, թափանցիկության և նորարարությունների։",
                bp13: "ԻՆՉՈՒ՞ MUK",
                p21: "Ի դեմս MUK-ի՝ մեր գործընկերները ստանում են հուսալի դիստրիբյուտոր և մրցակցության մեջ զգալի առավելություն",
                p22: "Մեր գործընկերները հեշտ հարմարվում են շուկայի փոփոխվող տենդենցներին՝ նշելով MUK-ի սպասարկման և ծառայությունների ճկունությունը։ Քանի որ մենք աշխատում ենք առավել առաջատար մատակարարների հետ, մեր հաճախորդները միշտ գտնում են իրենց բիզնեսը զարգացնելու նոր հնարավորություններ",
                p23: "Ֆինանսավորման մեր ճկուն տարբերակները մշակված են մեր հաճախորդների համար՝ լինի դա անհատական լուծում թե հատուկ վարկային գծեր, մենք թեթևացնում ենք մեր գործընկերների համար բիզնեսի վարումը",
                p24: "Բոլոր ծագող հարցերը մենք լուծում ենք առանձնացված հաճախորդների հետ աշխատող մենեջերների և տարբեր վենդորներին կցված պրոդուկտների մասնագետների միջոցով։ Ձեզ անհրաժեշտ ողջ գիտելիքը կուտակված է մի վայրում, իսկ մեր մասնագիտական պատրաստվածությունը և լայն մարկետինգային աջակցումը նշանակում են, որ դուք կարող եք վստահ լինել այն ամենի մեջ, ինչ որ մենք անում ենք ",
                p25: "MUK-ը փորձառու ընկերություն է, որը ձեզ տրամադրում է ճկունություն և արագ արձագանքում՝ ձեր բիզնեսի և պատվիրատուների պահանջների համար",
                p26: "Կոմերցիոն նախաձեռնությունների մեր ծավալը երաշխավորում է ձեզ աշխատանքի գերազանց որակ։ Մենք նաև կարող ենք օգնել մեր հաճախորդներին ստանալ եկամուտ փորձառու միջազգային լոգիստիկայից, ուսումնական և սպասարկման կենտրոններից, ամպային պրոդուկտների ենթաբաժիններից",
                p27: "Մեզանից լավ ոչ ոք չգիտի, որ լավ աշխատանքային գործընթացը նշանակում է լավ վաճառքներ, և մենք գիտակցում ենք, որ արձագանքման արագությունը, պրոակտիվությունը և ռիսկերի կառավարումը մեր գործընկերոջ հաջողված բիզնեսի և պատվիրատուների մոտ նրա համբավի կարևոր մասն են ",
                p28: "Մենք օգնում ենք ավելացնել ձեր եկամուտը և շահութաբերությունը ճանապարհի ամեն փուլում"

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Առաջացել են հարցեր?",
                description: "Խնդրում ենք լրացրեք ձևը, որ ուղարկեք մեզ էլ․նամակ, և մենք կապ կհաստատենք ձեզ հետ հնարավորինս շուտ",
                send: "Ուղարկել",
                nm: "Անուն",
                ad: "Հասցե",
                ph: "Հեռախոսահամար",
                em: "Email",
                ms: "Հաղորդագրություն",
                contactInfo: "Կոնտակտային տվյալներ",
                address: "Ուկրաինա, Կիև, 03151, Դոնեցկայա փ 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Բոլոր իրավունքները պաշտպանված են."
            }
        }
    }

    if (lang === "ge") {
        text = {
            Navigation: [
                {
                    menu: "ქვეყნები",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "ალბანეთი",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "სომხეთი",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },

                        {
                            link: "/country/az",
                            name: "აზერბაიჯანი",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "ხორვატია",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        /*{
                            link: "/country/by",
                            name: "ბელორუსია",
                            flag: "by.svg",
                            id: 2,
                            iso: "by"
                        },*/
                        {
                            link: "/country/ge",
                            name: "საქართველო",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/hu",
                            name: "უნგრეთი",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/kz",
                            name: "ყაზახეთი",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "ყირგიზეთი",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "მოლდოვა",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "მონღოლეთი",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "სერბეთი",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "სლოვენია",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "სინგაპური",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "ტაჯიკეთი",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "თურქეთი",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "თურქმენეთი",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "უკრაინა",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "უზბეკეთი",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "გადაწყვეტილებები",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK ვენდორები"
                        },
                        {
                            link: "/solutions",
                            name: "MUK გადაწყვეტილებები"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "პროდუქციისა და მომსახურების კატალოგი"
                        }
                    ]
                },
                {
                    menu: "სიახლეები",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "სიახლეები და აქციები"
                        },
                        {
                            link: "/muk-review",
                            name: "ჟურნალი MUK"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "ვიდეო"
                        }
                    ]
                },
                {
                    menu: "მიმართულებები",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT დისტრიბუცია"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "სასწავლო ცენტრი"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Სერვის ცენტრი"
                        },
                        {
                            link: "https://cloud.muk.ge/",
                            name: "MUK ქლაუდ მომსახურება"
                        }
                    ]
                },
                {
                    menu: "კომპანიის შესახებ",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "ძირითადად MUK-ის შესახებ"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "კორპორატიული პროფილი"
                        },
                        {
                            link: "/vacancies",
                            name: "ვაკანსიები"
                        }
                    ]
                },
                {
                    menu: "დილერის განყოფილება",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "ალბანეთი",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "სომხეთი",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "აზერბაიჯანი",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "ხორვატია",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                            /*{
                                link: "/country/by",
                                name: "ბელორუსია",
                                flag: "by.svg",
                                id: 2,
                                iso: "by"
                            },*/{
                            link: "https://b2b.muk.ge/",
                            name: "საქართველო",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "ყაზახეთი",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "ყირგიზეთი",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "მოლდოვა",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "მონღოლეთი",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },

                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "სერბეთი",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "სლოვენია",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "ტაჯიკეთი",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "თურქეთი",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "თურქმენეთი",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "უკრაინა",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "უზბეკეთი",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "საერთაშორისო პროექტის VAD IT დისტრიბუტორი",
                paragraph: "MUK პარტნიორები ჩვენ გვიყურებენ, როგორც სანდო IT დისტრიბუტორს, ისინი ენდობიან ჩვენს მრავალწლიან გამოცდილებას, ტექნიკურ კომპეტენციას და კარგად ჩამოყალიბებული პარტნიორობის მოდელს.",
                partner: "გახდი პარტნიორი"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "საერთაშორისო დისტრიბუტორი",
                    text: "MUK-ის გეოგრაფია მოიცავს ევროპისა და აზიის 16 ქვეყანას და მუდმივად ფართოვდება"
                },
                {
                    icon: "fa fa-star",
                    title: "წარმატების 25 წელზე მეტი",
                    text: "MUK უნარჩუნების ლიდერის პოზიციას 1997 წლიდან"
                },
                {
                    icon: "fa fa-users",
                    title: "უნიკალური გამოცდილება",
                    text: "MUK-ის საინჟინრო გუნდი გაუმკლავდება ნებისმიერ, თუნდაც ყველაზე რთულ ამოცანას"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ მწარმოებელი",
                    text: "MUK-ის სადისტრიბუციო პორტფოლიო მოიცავს 100-ზე მეტ გლობალურ A კლასის ბრენდს და მათი რიცხვი მუდმივად იზრდება"
                }
            ],
            ServicesInfo: {
                title: "MUK-ის საქმიანობის მიმართულებები"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT დისტრიბუცია",
                    text: "MUK არის VAD დისტრიბუტორი, რომელიც ორიენტირებულია პროექტების IT ბიზნესზე. ჩვენ წარმატებით ვავითარებთ სადილერო ქსელს ევროპასა და აზიაში 25 წელზე მეტი ხნის განმავლობაში.\nსერთიფიცირებული სპეციალისტების შემდგარი პერსონალის დახმარებით MUK პარტნიორებს უწევს მაღალი დონის პროექტების კონსულტაციას და ტექნიკურ მხარდაჭერას, რითაც გამოიმუშავებს დამატებით ღირებულებას შემოთავაზებული გადაწყვეტილებებისთვის.\nMUK-ის ინჟინრები უზრუნველყოფენ საკონსულტაციო და ტექნიკურ მხარდაჭერას პროგრამული და ტექნიკის გადაწყვეტილებებისთვის, განახორციელებენ აუდიტს არსებულ სისტემებში და მხარს უჭერენ სატესტო სტენდების რეალიზებას. ჩვენი სატესტო აღჭურვილობის პარკი საშუალებას გვაძლევს მოვახდინოთ დავალებების ფართო სპექტრის სიმულაცია და განხორციელება რეალურ პირობებში. nMUK აქტიურად ეხმარება ინტეგრატორებს ოპტიმალური გადაწყვეტილებების არჩევაში და დიზაინში.\nMUK-ის გუნდი მოიცავს 500-ზე მეტ სპეციალისტს სხვადასხვა ტექნოლოგიების სფეროში, რომლებიც სერტიფიცირებული არიან მსოფლიოს წამყვანი IT მწარმოებლების მიერ.",
                    activ1: "საერთაშორისო ლოგისტიკა, საწყობის ფორმირება",
                    activ2: "მარკეტინგული და საკონსულტაციო მხარდაჭერა პარტნიორებისთვის",
                    activ3: "გადაწყვეტილებების ღირებულების გაზრდა საკუთარი კომპეტენციის მეშვეობით",
                    activ4: "პროდუქციის ბაზარზე გატანა, მოთხოვნის პოპულარიზაცია და გენერირება",
                    activ5: "ტექნიკური მხარდაჭერა, საგარანტიო და გარანტიის შემდგომი მომსახურება",
                    activ6: "პარტნიორთა ქსელის განვითარება"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider ქლაუდ პროდუქტები",
                    text: "MUK ქლაუდ გადაწყვეტილებები ბიზნესისთვის MUK Cloud Solutions არის გადაწყვეტილებებისა და სერვისების სწრაფი სტარტისთვის მზა კომპლექტი, რომელიც მიზნად ისახავს ბიზნესის უწყვეტობის უზრუნველყოფას, მუშაობის ეფექტურობისა და თანამშრომლების მობილურობის გაზრდას, კოლექტიური ურთიერთზემოქმედების თანამედროვე უსაფრთხო საშუალებების უზრუნველყოფით.\nმათი დახმარებით თქვენ შეძლებთ სწრაფად და ეფექტურად დანერგოთ ქლაუდ ტექნოლოგიები თქვენი ორგანიზაციის ინფრასტრუქტურაში. Cloud Solution Provider-ის კონცეფცია არის გაყიდვების არხი, რომელშიც ყოველთვიურად ხელმისაწვდომია Microsoft Office 365, AZURE, EMS, D365 და სხვა ქლაუდ სერვისები.\nMUK გთავაზობთ ინფრასტრუქტურის შექმნას „ნულიდან“. მინიმალური კაპიტალის ხარჯები. ოპტიმალური საოპერაციო ხარჯები ქლაუდის რესურსების ქირისა და ტექნიკური მომსახურებისთვის. ინფრასტრუქტურის მასშტაბირება (საწარმოს ზრდა, ახალი ტერიტორიული ოფისები, დაგეგმილი დატვირთვის გაზრდა). ახალი სერვისები ქლაუდში, რომელიც ინტეგრირებულია სახმელეთო ინფრასტრუქტურასთან.",
                    activ1: "სარეზერვო ასლების (ფაილების, ვირტუალური მანქანების, მონაცემთა ბაზების) შენახვა ქლაუდზე.",
                    activ2: "ავარიიგან დაცვა, აღდგენა. მაღალი ხელმისაწვდომობის კლასტერები ვირტუალური მანქანების ან SQL მონაცემთა ბაზების დონეზე.",
                    activ3: "მობილური მოწყობილობის მართვა",
                    activ4: "კორპორატიული ინფორმაციისა და კორესპონდენციის დაცვა",
                    activ5: "SharePoint-ის ონლაინ განლაგება, გაცვლა ონლაინ, Skype ბიზნესისთვის ონლაინ რეჟიმში",
                    activ6: "ვებსაიტების განლაგება და კონფიგურაცია, საიტების ქლაუდზე მიგრაცია"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK სერვის ცენტრი",
                    text: "MUK სერვისი წარმატებით ახორციელებს კომპიუტერების შეკეთების მომსახურებას 2002 წლიდან და დღეს წარმოადგენს ავტორიზებულ სერვის ცენტრს APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell, EMC, Tescom და სხვა მწარმოებლებისთვის. კომპანია „MUK-სერვისი“-ის ხარისხის მართვის სისტემა დადასტურებულია საერთაშორისო სერტიფიცირების ბიუროს ISO 9001 სერტიფიკატით.\nიმისათვის, რომ სწრაფად გაუმკლავდეთ ნებისმიერ გაუმართაობას, უნდა იყოთ ნამდვილი სპეციალისტი. ჩვენი ოსტატები, გამოცდილებისა და ყოველდღიური პრაქტიკის შეძენით, წყვეტენ ნებისმიერ გაუმართაობას. პროფესიონალიზმი გამოცდილებასთან ერთად მოდის, ჩვენ ვაუმჯობესებთ საკუთარ თავს და ვზრდით ცოდნის დონეს. სერვის ცენტრის პერსონალი დაკომპლექტებულია სერთიფიცირებული სპეციალისტებით, რაც მომხმარებელს უზრუნველყოფს მაღალი ხარისხის და პროფესიონალური აღჭურვილობის შეკეთების გარანტიით. MUK სერვისს აქვს ყველა საჭირო ტექნიკური შესაძლებლობა ხარისხიანი მომსახურების უზრუნველსაყოფად. სერვის ცენტრი ახორციელებს ნებისმიერი სირთულის ტექნიკურ, საგარანტიო და არასაგარანტიო რემონტს. MUK სერვისი უზრუნველყოფს აღჭურვილობის გაქირავებას და აუთსორსინგს, მონტაჟს და ტექნიკურ მომსახურებას, ასევე საინფორმაციო და საკონსულტაციო მომსახურებას კორპორატიული კლიენტებისთვის უკრაინაში, სომხეთში, ბელორუსიაში, საქართველოში, მოლდოვაში, ტაჯიკეთსა და ყაზახეთში.",
                    activ1: "საგარანტიო შეკეთება",
                    activ2: "არასაგარანტიო შეკეთება",
                    activ3: "აღჭურვილობის დიაგნოსტიკა",
                    activ4: "სათადარიგო ნაწილების გაყიდვა",
                    activ5: "მომსახურების ხელშეკრულებების აუდიტი",
                    activ6: "აღჭურვილობის დაქირავება და აუთსორსინგი"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK სასწავლო ცენტრი",
                    text: "MUK სასწავლო ცენტრი წარმოადგენს ბაზრის ლიდერს IT საგანმანათლებლო სერვისებში 15 წელზე მეტი პერიოდის გამოცდილებითა და უნიკალური ავტორიზაციებით, კვალიფიციური ინსტრუქტორების გუნდით და თანამედროვე სასწავლო ინფრასტრუქტურით.\nMUK სასწავლო ცენტრის პორტფოლიო მოიცავს 300-ზე მეტ ტრენინგ კურსს წამყვანი IT კომპანიებისაგან.\nსტატუსებს შორის უნდა აღინიშნოს: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nMUK სასწავლო ცენტრს აქვს წვდომა ყველაზე თანამედროვე სასწავლო აღჭურვილობაზე. ჩვენი ინსტრუქტორების სწავლების ხარისხი მრავალი წლის განმავლობაში დასტურდება სტუდენტების მაღალი შეფასებებით უკრაინაში და მის ფარგლებს გარეთ."
                }
            ],
            Vendors: {
                title: "MUK ვენდორები",
                country: "ქვეყანა",
                solution: "გამოსავალი",
                name: "დასახელება",
                all: "ყველა",
                namePlaceholder: "დაიწყეთ ვენდორის დასახელების აკრეფა",
                notInfo: "ინფორმაცია არ არის შევსებული"
            },
            VendorsForCountry: {
                title: "ქვეყანაში ხელმისაწვდომი MUK ვენდორები"
            },
            VendorsForSolution: {
                title: "MUK ვენდორები, გადაწყვეტილების საფუძველზე"
            },
            VendorDetail: {
                title: "ავტორიზებული დისტრიბუტორი"
            },
            Gallery: {
                title: "MUK გადაწყვეტილებები"
            },
            Distribution: {
                title: "IT დისტრიბუცია"
            },
            Partner: {
                title: "გახდი პარტნიორი",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "გაგზავნა",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK აშენებს ბიზნესს პარტნიორობისა და თანამშრომლობის პრინციპებზე",
                advantages: "უპირატესობები",
                paragraph: "MUK დაარსების დღიდან აქცენტს აკეთებს გამჭვირვალობაზე მომწოდებლებთან და მომხმარებლებთან ურთიერთობაში. პარტნიორობის წესებისადმი ერთგულებამ საშუალება მისცა MUK-ს მოეპოვებინა ნდობა ბაზარზე და შეექმნა ლიდერის რეპუტაცია.",
                Why: [
                    "ინოვაციები",
                    "პასუხისმგებლობა",
                    "პატიოსნება",
                    "დასაქმების თანაბარი შესაძლებლობები"

                ],
                Why2: [
                    "გუნდური მუშაობა და პატივისცემა",
                    "განათლება",
                    "Სოციალური პასუხისმგებლობა"
                ]
            },
            News: {
                title: "MUK სიახლე",
                showAll: "მაჩვენე ყველა",
                showMore: "მეტის ჩვენება",
                news: "სიახლე",
                akcii: "აქცია"
            },
            Vacancies: {
                title: "MUK ვაკანსიები",
                resume: "Send a CV",
                country: "ქვეყანა",
                all: "ყველა",
                search: "ძიება",
                namePlaceholder: "დაიწყეთ დასახელების აკრეფა",
                filterInfo: "მოცემული ფილტრების მიხედვით ვაკანსიები არ არის",
                notInfo: "ინფორმაცია არ არის შევსებული",
                back: "Back"
            },
            MukReview: {
                title: "ჟურნალის \"MUK-REVIEW\" ნომრები",
                vupysk: "გამოცემა"
            },
            OMuk: {
                title: "მთავარი MUK-ის შესახებ",
                p1: "MUK-ის კომპანიების ჯგუფმა საქმიანობა 1997 წელს დაიწყო. ჩვენი მუშაობის ძირითადი სფეროა წამყვანი IT პროდუქტების პროექტზე ორიენტირებული განაწილება ჰიბრიდული და ქლაუდ გადაწყვეტილებების სფეროში, მონაცემთა ცენტრის, ინფორმაციის უსაფრთხოების, მობილური მოწყობილობებისა და ინტერნეტის, მონაცემთა ანალიტიკისა და ხელოვნური ინტელექტის კონვერგენცია.",
                p2: "ჩვენი გლობალური სადისტრიბუციო ქსელის წყალობით, ჩვენ ადგილობრივ ბაზრებზე შემოგვყავს პერსპექტიული IT ვენდორები და მათი ახალი პროდუქტები, აქტიურად ვმონაწილეობთ მოთხოვნის ფორმირებაში.",
                p3: "ჩვენ ვაერთიანებთ საექსპერტო ტექნიკურ და ბაზრის ცოდნას პროგრესული პარტნიორის მხარდაჭერის პროგრამასთან. ჩვენს დილერებთან მჭიდრო თანამშრომლობით, ჩვენ ვცდილობთ ვუზრუნველვყოთ მათი დინამიური ზრდა და განვითარება, ერთად მივაღწიოთ შედეგებს.",
                bp1: "საინფორმაციო ტექნოლოგიები ვართ ჩვენ!",
                p4: "კომპანია MUK 25 წლის განმავლობაში იყო პიონერი საინფორმაციო ტექნოლოგიების გავრცელებაში. დღეს MUK მნიშვნელოვან როლს ასრულებს ტექნოლოგიის გადაცემაში, მათგან, ვინც მას ავითარებს, მათთვის ვინც მას ნერგავს და იყენებს.",
                ul: "ოთხი ციფრი, რომელიც ახასიათებს MUK-ს, როგორც სანდო პარტნიორს და ეფექტურ დისტრიბუტორს:",
                li1: "1. 25 წელზე მეტი გამოცდილება და ნდობა.",
                li2: "2. 100-ზე მეტი A-ბრენდის ვენდორი (კომპანიები მსოფლიო სახელებითა და დადასტურებული პროდუქტებით).",
                li3: "3. თითოეულ ვენდორს ჰყავს თავისი მენეჯერები, წინასწარი გაყიდვები და ინჟინრები, ამიტომ ჩვენი პერსონალი შედგება 500-ზე მეტი სპეციალისტისგან.",
                li4: "4. ამ დროისთვის ჩვენ ვემსახურებით 4000-ზე მეტ აქტიურ პარტნიორს, მათ შორის არა მხოლოდ კლასიკურ IT ინტეგრატორებს, არამედ მწარმოებელ საწარმოებს, სამშენებლო კომპანიებს, საკონსულტაციო ფირმებს, პროგრამული უზრუნველყოფის შემქმნელებს, რომლებიც იყენებენ ჩვენს პროდუქტებს თავიანთ მიწოდებებში.",
                bp2: "სტრატეგია",
                p5: "ჩვენი სტრატეგია მდგომარეობს იმაში, რომ აღიარებულები ვიყოთ როგორც წამყვანი IT დისტრიბუტორი, როგორც მომწოდებლების, ისე გადამყიდველების მიერ, ჩვენი დიდი გამოცდილების, მაღალი კომპეტენციისა და მსოფლიოს სხვადასხვა ქვეყანაში ყოფნის წყალობით.",
                bp3: "მისია",
                p6: "ჩვენი მისიაა, ჩვენს პარტნიორებს ზუსტ ვადებში მივაწოდოთ ინოვაციური გადაწყვეტილებები და ხარისხიანი პროდუქტები.",
                p7: "ჩვენ ერთგულად ვმუშაობთ ტექნოლოგიური პროდუქტებისა და გადაწყვეტილებების წინსვლისთვის, რათა დავაკმაყოფილოთ ბაზრის მზარდი მოთხოვნა და შევძინოთ ღირებულება როგორც მიმწოდებელს, ასევე გადამყიდველს პროდუქტის დროული ხელმისაწვდომობისა და პროდუქტის სიღრმისეული ცოდნის საშუალებით.",
                p8: "MUK სისტემატურად მუშაობს მოთხოვნის შესაქმნასა და პროდუქციის ბაზარზე გამოტანაზე, ასევე ჩვენი გადამყიდველებისთვის მომგებიანი შესაძლებლობების შექმნაზე შვილობილი პროგრამის, ეფექტური მიწოდების ჯაჭვისა და ტრენინგების საშუალებით.",
                p9: "ჩვენ მზად ვართ შევინარჩუნოთ ისეთი გარემო, რომელიც აძლიერებს ჩვენს ხალხს, აღიარებს მათ მიღწევებს და ეხმარება მათ ადაპტირდნენ მუდმივად ცვალებად ბიზნეს გარემოსთან. MUK მოტივაციას უზრდის თანამშრომლებს მდგრადი პიროვნული და პროფესიული ზრდისთვის.",
                bp4: "პარტნიორობა და პასუხისმგებლობა",
                p10: "MUK ექსკლუზიურად აღიარებს ბიზნესის წარმოების პარტნიორულ მოდელს. ჩვენ არ ვმუშაობთ საბოლოო მომხმარებლებთან და ვეყრდნობით დილერის ქსელის განვითარებას. ჩვენი პარტნიორების საბოლოო კლიენტებს შორის წარმოდგენილია შიდა ბიზნესის ყველა სექტორი: საცალო ვაჭრობა, მრეწველობა, ფინანსები და სახელმწიფო სექტორი.",
                p11: "ჩვენ პარტნიორებს ვუზიარებთ პასუხისმგებლობას წარმატების მიღწევაზე. ჩვენი კრედო: \"ჩვენ ერთად მივდივართ, ასე რომ ერთად მივდივართ ბოლომდე\". ჩვენ მხარს ვუჭერთ ჩვენს პარტნიორებს რთულ სიტუაციებში და ერთად ვზეიმობთ გამარჯვებებს და, როგორც გამოცდილებამ აჩვენა, ერთობლივი გამარჯვება გაცილებით მეტი გვაქვს, ვიდრე მარცხი.",
                p12: "MUK-მა თავისი მრავალწლიანი შრომით დაამტკიცა თავისი მრავალპროვაიდერის სტრატეგიის სიცოცხლისუნარიანობა, რომლის დროსაც ჩვენი პორტფოლიოს ყველა მოვაჭრე იღებს თანაბარ შანსს განავითაროს და იმუშაოს კონკურენტულ საბაზრო გარემოში. ჩვენ უფლებას ვუტოვებთ პარტნიორებს აირჩიონ პროექტებში მუშაობის სტრატეგია, ამავდროულად ვეხმარებით მათ კომპლექსური გადაწყვეტილებების შექმნაში, კონსულტაციას ვუწევთ გაყიდვების მთელ ციკლს: ამოცანის ამოღებიდან განხორციელებამდე და მომსახურებამდე.",
                bp5: "ᲩᲕᲔᲜᲘ ᲦᲘᲠᲔᲑᲣᲚᲔᲑᲔᲑᲘ",
                p13: "MUK მთლიანად ორიენტირებულია თავისი ბიზნეს პარტნიორების და თანამშრომლების წარმატების ამაღლებაზე ისეთი ღირებულებების დაცვით, როგორიცაა ინოვაცია, პასუხისმგებლობა, პატიოსნება, თანაბარი შესაძლებლობები და გუნდური მუშაობა, პატივისცემა, სწავლება და სოციალური პასუხისმგებლობა.",
                bp6: "თანაბარი დასაქმების შესაძლებლობა",
                p14: "ვაკანტურ თანამდებობაზე კანდიდატების განაცხადები განიხილება რასის, სქესის, რელიგიის, ფერის, ეროვნული წარმომავლობის, ასაკის, გენდერული იდენტობისა და გამოხატვის, ინვალიდობის, სექსუალური ორიენტაციის, ვეტერანის სტატუსის ან სხვა ფაქტორების გათვალისწინების გარეშე, რომლებიც არ უკავშირდება კონკრეტული თანამდებობისთვის საჭირო კვალიფიკაციას.",
                bp7: "ინოვაცია",
                p15: "ჩვენ მუდმივად ვეძებთ უკეთეს გზებს ჩვენი მომხმარებლებისთვის, მომწოდებლებისა და კოლეგებისთვის ღირებულების შესაძენად. ჩვენ გვაქვს ცვლილებების მოლოდინი და პროაქტიულად ვქმნით მათზე მორგებულ გადაწყვეტილებებს.",
                bp8: "პასუხისმგებლობა",
                p16: "ჩვენ ვამბობთ იმას, რასაც ვაკეთებთ და ვაკეთებთ იმას, რასაც ვამბობთ. ჩვენ მუდმივად ვაღწევთ შედეგს, რომელიც აკმაყოფილებს ან აღემატება ჩვენი პარტნიორების და მომწოდებლების მოლოდინს",
                bp9: "პატიოსნება",
                p17: "ჩვენ ვიცავთ უმაღლეს ეთიკურ სტანდარტებს პატიოსნებისა და სამართლიანობის დემონსტრირებით ყოველ ჩვენს მოქმედებაში, ყველგან და ნებისმიერ დროს.",
                bp10: "გუნდური მუშაობა და პატივისცემა",
                p18: "ჩვენ პატივს ვცემთ ჩვენი კოლეგების, პარტნიორების და საზოგადოების უფლებებსა და რწმენას. ჩვენ ვეპყრობით სხვებს ღირსების, თანასწორობისა და ნდობის უმაღლესი ხარისხით, ვიყენებთ მრავალფეროვნებას ჩვენი საერთო მიზნების მისაღწევად. როგორც გუნდი, ჩვენ უფრო მეტს ვაკეთებთ, ვიდრე ინდივიდუალურად",
                bp11: "განათლება",
                p19: "ჩვენ მუდმივად ვიღებთ ახალ ცოდნას, რათა გავზარდოთ პროდუქტიულობა, კომპანია და საკუთარი თავი",
                bp12: "Სოციალური პასუხისმგებლობა",
                p20: "ჩვენ აქტიურად ვეძებთ გზებს დავაბალანსოთ ჩვენი ფინანსური, სოციალური და გარემოსდაცვითი პასუხისმგებლობები, რათა მივაღწიოთ პოზიტიურ შედეგებს სხვადასხვა დაინტერესებული მხარისთვის მთელს მსოფლიოში. ამ გზაზე ჩვენ ვიბრძვით თანამშრომლობის, გამჭვირვალობისა და ინოვაციისთვის.",
                bp13: "რატომ MUK?",
                p21: "MUK-თან ერთად, ჩვენი პარტნიორები იღებენ საიმედო დისტრიბუტორს და მნიშვნელოვან უპირატესობას კონკურენციაში.",
                p22: "ჩვენი პარტნიორები ადვილად ეგუებიან ბაზრის ცვალებად ტენდენციებს, აღნიშნავენ რა MUK სერვისებისა და მომსახურებების მოქნილობას. ვინაიდან ჩვენ ვმუშაობთ ყველაზე პროგრესულ მომწოდებლებთან, ჩვენი კლიენტები ყოველთვის პოულობენ ახალ შესაძლებლობებს თავიანთი ბიზნესის გასაზრდელად.",
                p23: "ჩვენი ფინანსირების მოქნილი ვარიანტები შექმნილია ჩვენი კლიენტებისთვის, იქნება ეს ინდივიდუალური გადაწყვეტა თუ სპეციალიზირებული საკრედიტო ხაზი, ჩვენ პარტნიორების ვუადვილებთ ბიზნესის მართვას.",
                p24: "ჩვენ ვაგვარებთ ყველა წარმოშობილ საკითხს კლიენტეთან სამუშაოდ გამოყოფილი მენეჯერებისა და პროდუქტების სპეციალისტების დახმარებით, რომლებიც ემაგრებიან ვენდორებს. ყველა თქვენთვის საჭირო ცოდნა არის ერთ ადგილას და ჩვენი პროფესიული მომზადება და ფართო მარკეტინგული მხარდაჭერა ნიშნავს, რომ თქვენ შეგიძლიათ იყოთ დარწმუნებული ყველაფერში, რასაც ვაკეთებთ.",
                p25: "MUK ეს არის გამოცდილი კომპანია, რომელიც გაძლევთ მოქნილობას და თქვენი ბიზნესისა და მომხმარებლების საჭიროებებზე სწრაფ რეაგირებას.",
                p26: "ჩვენი კომერციული ინიციატივების სპექტრი გაძლევთ მუშაობის ბრწყინვალე ხარისხის გარანტიას. ჩვენ ასევე შეგვიძლია დავეხმაროთ ჩვენს კლიენტებს ისარგებლონ გამოცდილი საერთაშორისო ლოგისტიკით, სასწავლო და სერვის ცენტრით, ქლაუდ პროდუქტების განყოფილებებით.",
                p27: "ჩვენ ყველაზე უკეთ ვიცით, რომ კარგი სამუშაო პროცესი ნიშნავს კარგ გაყიდვებს და გვესმის, რომ პასუხისმგებლობა, აქტიურობა და რისკის მართვა ჩვენი პარტნიორის წარმატებული ბიზნესისა და მომხმარებლების წინაშე მისი რეპუტაციის მნიშვნელოვანი ნაწილია. ამიტომ, ჩვენ შევქმენით ელექტრონული ინსტრუმენტები, რომლებიც აუმჯობესებს თქვენს ბიზნეს პროცესებს და ამარტივებს ურთიერთზემოქმედების სიჩქარეს.",
                p28: " ჩვენ დაგეხმარებით გაზარდოთ თქვენი შემოსავალი და მომგებიანობა ყოველ ნაბიჯზე."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "გაჩნდა კითხვები?",
                description: "გთხოვთ, შეავსოთ ქვემოთ მოცემული ფორმა, რომ გამოგვიგზავნოთ ელ.წერილი და ჩვენ დაგიკავშირდებით რაც შეიძლება მალე",
                send: "გაგზავნა",
                nm: "სახელი",
                ad: "მისამართი",
                ph: "ტელეფონი",
                em: "ფოსტა",
                ms: "შეტყობინება",
                contactInfo: "Საკონტაქტო ინფორმაცია",
                address: "უკრაინა, კიევი 03151, ქ. დონეცსკის 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "ყველა უფლება დაცულია."
            }
        }
    }

    if (lang === "kz") {
        text = {
            Navigation: [
                {
                    menu: "Елдер",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Армения",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Әзірбайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hu",
                            name: "Венгрия",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Грузия",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Қазақстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Қырғызстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Моңғолия",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Словакия",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Тәжікстан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Түркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Түрікменстан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Өзбекстан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Шешімдер",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Muk-тің вендорлары"
                        },
                        {
                            link: "/solutions",
                            name: "MUK-тың шешімдері"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Өнімдермен сервисдердің тізімі"
                        }
                    ]
                },
                {
                    menu: "Жаңалықтар",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Жаңалықтар және науқандар"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK журналы"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Ағымдар",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT дистрибьюциясы"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Оқу орталығы"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Сервис орталығы"
                        },
                        {
                            link: "https://cloud.muk.kz/",
                            name: "MUK Cloud бұлтты сервистері"
                        }
                    ]
                },
                {
                    menu: "Компания туралы",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK туралы басты мәліметтер"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Корпоративтік профиль"
                        },
                        {
                            link: "/vacancies",
                            name: "Вакансиялар"
                        }
                    ]
                },
                {
                    menu: "Дилер бөлімі",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Армения",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Әзірбайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Грузия",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Қазақстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Қырғызстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Моңғолия",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },

                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Тәжікстан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Түркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Түрікменстан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Өзбекстан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Халықаралық жобалардың VAD IT дистрибуторы",
                paragraph: "MUK серіктестері бізді сенімді АТ дистрибуторы ретінде қарастырады, біздің көп жылдық тәжірибемізге, техникалық біліктілігімізге және қалыптасқан серіктестік үлгісіне сенеді.",
                partner: "Серіктестік"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Халықаралық дистрибутор",
                    text: "MUK географиясы Еуропа мен Азияның 16 елін қамтиды және үнемі кеңейіп келеді"
                },
                {
                    icon: "fa fa-star",
                    title: "25 жылдан асатын нәтижелі тәжірибеміз бар",
                    text: "MUK 1997 жылдан бастап өз саласында жетекші орын алуда"
                },
                {
                    icon: "fa fa-users",
                    title: "Бірегей сараптама",
                    text: "MUK инженерлік командасы кез келген, тіпті ең қиын тапсырманы орындайды"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ өндірүшілер",
                    text: "MUK дистрибуторлық портфолиосында 100-тен астам жаһандық A-брендтері бар және олардың саны үнемі өсүде"
                }
            ],
            ServicesInfo: {
                title: "MUK-тың қызмет бағыттары"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT дистрибьюциясы",
                    text: "MUK — IT жобалар бизнесіне бағытталған VAD дистрибуторы. Біз Еуропа мен Азиядағы дилерлік желіні 25 жылдан астам табысты дамытып келеміз.\nСертификатталған мамандардың көмегімен MUK серіктестерге жоба бойынша кеңес берудің және техникалық қолдаудың жоғары деңгейін қамтамасыз етеді, бұл ұсынылған шешімдерге қосымша құндылық береді.\nMUK инженерлері бағдарламалық және аппараттық шешімдерге консалтингтік және техникалық қолдауды жүзеге асырады, жүйелердің аудитін жүргізеді және сынақ стендтерін енгізуге көмектеседі. Біздің сынақ жабдығының паркі тапсырмалардың кең ауқымын имитациялауға және жүзеге асыруға мүмкіндік береді.\nMUK интеграторларға оңтайлы шешімдерді таңдауда және жобалауда белсенді түрде көмектеседі.\nMUK командасына әртүрлі технологиялық салалардағы әлемнің жетекші IT өндірушілерінен сертификат алған 500-ден астам мамандар кіреді.",
                    activ1: "Халықаралық логистика, қоймаларды қалыптастыру",
                    activ2: "Серіктестерге маркетингтік және консалтингтік қолдау көрсету",
                    activ3: "Мамандарымыздың біліктілігі мен тәжірибесі арқылы шешімдердің құндылығын арттыру",
                    activ4: "Өнімдерді нарыққа шығару, сұранысты ынталандыру және қалыптастыру",
                    activ5: "Техникалық қолдау, кепілдік және кепілдіктен кейінгі қызмет көрсету",
                    activ6: "Серіктестік желісін дамыту"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider бұлтты өнімдері",
                    text: "Бизнеске арналған MUK Cloud Solutions MUK Cloud Solutions — заманауи қауіпсіз ынтымақтастық құралдарын қамтамасыз ету арқылы бизнестің үздіксіздігін қамтамасыз етуге, жұмыс тиімділігін және қызметкерлердің ұтқырлығын арттыруға бағытталған шешімдер мен қызметтердің жылдам іске қосылатын жиынтықтары.\nОлардың көмегімен сіз жылдам және тиімді жұмыс істей аласыз. ұйымыңыздың инфрақұрылымында бұлтты технологияларды енгізіңіз. Бұлттық шешім провайдері тұжырымдамасы Microsoft Office 365, AZURE, EMS, D365 және басқа бұлттық қызметтер ай сайын қолжетімді болатын сату арнасы.\nMUK инфрақұрылымды «нөлден» құруды ұсынады. Ең аз капиталдық шығындар. Бұлттық ресурстарды жалға алу және техникалық қызмет көрсету үшін оңтайлы операциялық шығындар. Инфрақұрылымды масштабтау (кәсіпорынның өсуі, жаңа аумақтық кеңселер, жоспарланған жүктемелер). Бұлттағы жаңа қызметтер, жер үсті инфрақұрылымымен біріктірілген.",
                    activ1: "Сақтық көшірмелерді (файлдарды, виртуалды машиналарды, дерекқорларды) бұлтта сақтау",
                    activ2: "Апатқа қарсы қорғаныс, қалпына келтіру. Виртуалды машиналар немесе SQL дерекқорлары деңгейінде қол жетімділігі жоғары кластерлер",
                    activ3: "Мобильді құрылғыны басқару",
                    activ4: "Корпоративтік ақпаратты және корреспонденцияны қорғау",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business on-line қондыру",
                    activ6: "Веб-сайттарды орналастыру және конфигурациялау, сайттарды бұлтқа көшіру"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service сервис орталығы",
                    text: "MUK Service 2002 жылдан бері компьютерлерді жөндеу қызметтерін сәтті ұсынып келеді және бүгінде APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, НР, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom және басқа өндірушілер үшін уәкілетті қызмет көрсету орталығы болып табылады. «MUK-Сервис» компаниясының сапа менеджменті жүйесі Халықаралық сертификаттау бюросының ISO 9001 сертификатымен расталған.\nКез келген ақауды тез жою үшін нағыз маман қажет. Біздің шеберлер тәжірибе мен күнделікті дағдыларды дамыта отырып, кез келген ақаулықты жөндейді. Кәсібилік тәжірибемен келеді, өзімізді жетілдіреміз, білім деңгейімізді арттырамыз. Қызмет көрсету орталығының қызметкерлері сертификатталған мамандардан тұрады, бұл тұтынушыларға жабдықты жоғары сапалы және кәсіби жөндеуге кепілдік береді. MUK Сервис сапалы қызмет көрсету үшін барлық қажетті техникалық мүмкіндіктерге ие. Сервистік орталық кез келген күрделілік деңгейіндегі техникалық қызмет көрсетуді, кепілдікті және кепілдіксіз жөндеуді орындайды. MUK Сервис Украина, Армения, Грузия, Молдова, Тәжікстан және Қазақстандағы корпоративтік клиенттер үшін жабдықты жалға алу және аутсорсинг, монтаждау және техникалық қызмет көрсету, сондай-ақ ақпараттық және кеңес беру қызметтерін ұсынады.",
                    activ1: "Кепілді жөндеу",
                    activ2: "Кепілдіксіз жөндеу",
                    activ3: "Жабдықтың диагностикасы",
                    activ4: "Қосалқы бөлшектерді сату",
                    activ5: "Қызмет көрсету келісімшарттарының аудиті",
                    activ6: "Жабдықтарды жалға алу және аутсорсинг"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK оқу орталығы",
                    text: "MUK оқу орталығы 15 жылдан астам тәжірибесі және бірқатар бірегей рұқсаттары, білікті нұсқаушылар тобы және заманауи оқыту инфрақұрылымы бар IT білім беру қызметтері нарығының көшбасшысы болып табылады.\nMUK оқу орталығының портфолиосы жетекші IT компанияларының 300-ден астам оқу курстарын қамтиды. Мәртебелердің арасында: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner-ды атап өтуге болады. MUK оқу орталығы ең заманауи оқу жабдықтарына қол жеткізе алады. Біздің оқытушылардың оқыту сапасы көптеген жылдар бойы Украинадағы және шетелдегі студенттердің жоғары бағаларымен расталып келеді."
                }
            ],
            Vendors: {
                title: "MUK-тың вендорлары",
                country: "Мемлекет",
                solution: "Шешім",
                name: "Аты",
                all: "Толық тізім",
                namePlaceholder: "Вендордың атын теруді бастаңыз",
                notInfo: "Ақпарат толтырылмаған"
            },
            VendorsForCountry: {
                title: "MUK вендорлары: таңдалған мемлекеттегі жұмыс істейтін вендорлар бойынша"
            },
            VendorsForSolution: {
                title: "MUK вендорлары: таңдалған шешімдер бойынша"
            },
            VendorDetail: {
                title: "ӨКІЛЕТТІ ДИСТРИБЮТОР"
            },
            Gallery: {
                title: "MUK шешімдері"
            },
            Distribution: {
                title: "IT дистрибьюциясы"
            },
            Partner: {
                title: "Серіктестік",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Жіберу",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK бизнесті серіктестік пен ынтымақтастық қағидаттары негізінде құрады",
                advantages: "Артықшылықтары",
                paragraph: "MUK негізі қаланған күннен бастап вендорлармен және тұтынушылармен қарым-қатынастың ашықтығына назар аударады. Серіктестік ережелеріне адалдық MUK-қа нарықтың сеніміне ие болуға және көшбасшы ретінде беделді қалыптастыруға мүмкіндік берді.",
                Why: [
                    "Инновациялар",
                    "Жауапкершілік",
                    "Адалдық",
                    "Жұмыспен қамтудың тең мүмкіндігі"

                ],
                Why2: [
                    "Топтық жұмыс және сыйластық",
                    "Үздіксіз оқыту",
                    "Әлеуметтік жауапкершілік"
                ]
            },
            News: {
                title: "MUK жаңалықтары",
                showAll: "барлығын көрсету",
                showMore: "Ары қарай",
                news: "Жаңалықтар",
                akcii: "Науқан"
            },
            Vacancies: {
                title: "Вакансиялар",
                resume: "Send a CV",
                country: "Мемлекет",
                all: "Толық тізім",
                search: "Іздеү",
                namePlaceholder: "Атын теруді бастаңыз",
                filterInfo: "Таңдалған ақпаратқа сәйкес вакансия жоқ",
                notInfo: "Ақпарат толтырылмаған",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" журналының нөмірлері",
                vupysk: "Шығарылым"
            },
            OMuk: {
                title: "MUK туралы негізгі ойлар",
                p1: "MUK компаниялар тобы өз қызметін 1997 жылы бастады. Біздің жұмысымыздың негізгі бағыты гибридті және бұлтты шешімдер, деректер орталығының конвергенциясы, ақпараттық қауіпсіздік, мобильді құрылғылар мен заттардың интернеті, деректерді талдау және жасанды интеллект саласындағы жетекші IT өнімдерін жобаға бағытталған тарату болып табылады.",
                p2: "Жаһандық дистрибуторлық желіміздің арқасында біз перспективті IT өндірүшілерін және олардың жаңа өнімдерін жергілікті нарықтарға шығарамыз, сұранысты қалыптастыруға белсенді қатысамыз.",
                p3: "Біз сарапшылық техникалық және нарықтық білімдерді серіктесті қолдаудың прогрессивті бағдарламасымен біріктіреміз. Біздің дилерлермен тығыз жұмыс жасай отырып, біз олардың серпінді өсуі мен дамуын қамтамасыз етуге тырысамыз, нәтижеге бірге қол жеткіземіз.",
                bp1: "БІЗ НАҒЫЗ АҚПАРАТТЫҚ ТЕХНОЛОГИЯЛАРМЫЗ!",
                p4: "MUK 25 жылдан астам ақпараттық технологияларды таратуда пионер болып табылады. Бүгінгі күні MUK технологияны әзірлеушілерден оны жүзеге асыратын және пайдаланатындарға трансфертте маңызды рөл атқарады.",
                ul: "MUK сенімді серіктес және тиімді дистрибутор ретінде сипаттайтын төрт цифр:",
                li1: "1. 25 жылдан астам тәжірибе және сенім.",
                li2: "2. 100-ден астам A маркалы вендорлар (әлемдік атаулары бар және дәлелденген өнімдері бар компаниялар).",
                li3: "3. Әрбір вендордың саласында өз менеджерлері, сатушылар және инженерлері бар. Сондықтан біздің қызметкерлер 500-ден астам маманнан тұрады.",
                li4: "4. Қазіргі уақытта біз 4000-ден астам белсенді серіктестерге қызмет көрсетеміз, олардың ішінде классикалық IT интеграторлары ғана емес, сонымен қатар біздің өнімдерді жеткізуде пайдаланатын өндірістік кәсіпорындар, құрылыс компаниялары, консалтингтік фирмалар, бағдарламалық жасақтама әзірлеушілері бар.",
                bp2: "СТРАТЕГИЯ",
                p5: "Біздің стратегиямыз – біздің үлкен тәжірибеміздің, жоғары біліктілігіміздің және әлемнің әртүрлі елдерінде болуының арқасында өндірүшілерге де, тұтынұшыларға да жетекші IT дистрибуторы ретінде танылуы.",
                bp3: "МИССИЯ",
                p6: "Біздің миссиямыз Серіктестерімізге инновациялық шешімдер мен сапалы өнімдерді дер кезінде ұсыну болып табылады.",
                p7: "Біз өсіп келе жатқан нарық сұранысын қанағаттандыру және өнімнің уақтылы қол жетімділігі және өнім туралы терең білім арқылы жеткізушіге де, сатушыға да құн қосу үшін технологиялық өнімдер мен шешімдерді жетілдіруге бар ынтамен жұмыс істейміз.",
                p8: "MUK сұранысты құру және өнімді нарыққа шығару, сонымен қатар серіктестік бағдарламасы, тиімді жеткізу тізбегі және оқыту арқылы біздің тұтынушыларымызға тиімді мүмкіндіктер жасау үшін жүйелі түрде жұмыс істейді.",
                p9: "Біз қызметкерлерімізге мүмкіндік беретін, олардың жетістіктерін мойындайтын және олардың үнемі өзгеріп отыратын бизнес-ортаға бейімделуіне көмектесетін ортаны сақтауға ұмтыламыз. MUK қызметкерлерді тұрақты жеке және кәсіби өсуге ынталандырады.",
                bp4: "СЕРІКТЕСТІК ЖӘНЕ ЖАУАПКЕРШІЛІК",
                p10: "MUK тек серіктестік бизнес үлгісін ғибадат етеді. Біз соңғы тұтынушылармен жұмыс істемейміз және дилерлік желінің дамуына сенеміз. Біздің серіктестеріміздің түпкі тұтынушыларының қатарында отандық бизнестің барлық секторлары бар: бөлшек сауда, өнеркәсіп, қаржы және мемлекеттік сектор.",
                p11: "Біз серіктестерімізбен табысқа жету жауапкершілігін бөлісеміз. Біздің кредомыз: «Бірге жүрсек, соңына дейін бірге жүреміз». Біз қиын жағдайларда серіктестерімізді қолдаймыз және жеңістерді бірге тойлаймыз, тәжірибе көрсеткендей, жеңілістерден гөрі бірлескен жеңістеріміз әлдеқайда көп.",
                p12: "MUK өзінің көп жылдық жұмысымен портфолиодағы барлық жеткізушілер бәсекелес нарық жағдайында дамуға және жұмыс істеуге тең мүмкіндікке ие болатын көп жеткізушілер стратегиясының өміршеңдігін дәлелдеді. Біз серіктестердің жобаларда жұмыс істеу стратегиясын таңдау құқығын өзімізде қалдырамыз, сонымен бірге күрделі шешімдерді жасауға көмектесеміз, бүкіл сату циклі бойынша кеңес береміз: тапсырманы жоюдан бастап іске асыруға және техникалық қызмет көрсетуге дейін.",
                bp5: "БІЗДІҢ ҚҰНДЫЛЫҚТАРЫМЫЗ",
                p13: "MUK инновация, жауапкершілік, адалдық, мүмкіндіктер теңдігі және командалық жұмыс, құрмет, оқу және әлеуметтік жауапкершілік құндылықтарын ұстана отырып, өзінің іскер серіктестері мен қызметкерлерінің табысын арттыруға толықтай бағытталған.",
                bp6: "Жұмыспен қамтудың тең мүмкіндігі",
                p14: "Бос лауазымдарға үміткерлердің өтініштерін біз нәсіліне, жынысына, дініне, түсіне, ұлттық тегіне, жасына, жыныстық сәйкестігіне және көзқарасына, мүгедектігіне, жыныстық бағдарына, ардагер мәртебесіне немесе белгілі бір лауазымның біліктілігіне қатысы жоқ басқа факторларға қарамастан қарастырамыз.",
                bp7: "Инновация",
                p15: "Біз тұтынушыларымызға, жеткізушілерімізге және әріптестерімізге құндылық қосудың жақсы жолдарын үнемі іздейміз. Біз өзгерістерді күтеміз және оларға бейімделген шешімдерді белсенді түрде жасаймыз.",
                bp8: "Жауапкершілік",
                p16: "Біз не істейтінімізді ашық айтамыз және айтқанымызды орындаймыз. Біз серіктестеріміз бен өндірүшілеріміздің үміттерін қанағаттандыратын немесе одан асатын нәтижелерге үнемі қол жеткіземіз",
                bp9: "Адалдық",
                p17: "Біз барлық жерде және барлық уақытта әрбір әрекетімізде адалдық пен әділдікті көрсету арқылы ең жоғары этикалық стандарттарды ұстанамыз.",
                bp10: "Топтық жұмыс және сыйластық",
                p18: "Біз әріптестеріміздің, серіктестеріміздің және қоғамның құқықтары мен сенімдерін құрметтейміз. Біз ортақ мақсаттарымызға жету үшін әртүрлілікті пайдалана отырып, басқаларға жоғары дәрежеде абырой, теңдік және сеніммен қараймыз. Жалғыздың нәтижесінен топтың нәтижесі әлдеқайда көп.",
                bp11: "Үздіксіз оқыту",
                p19: "Біз өнімділікті арттыру және компанияны және өзімізді дамыту үшін үнемі жаңа білім аламыз",
                bp12: "Әлеуметтік жауапкершілік",
                p20: "Біз бүкіл әлем бойынша әртүрлі мүдделі тараптар үшін оң нәтижелерге қол жеткізу үшін қаржылық, әлеуметтік және экологиялық жауапкершіліктерімізді теңестіру жолдарын белсенді түрде іздейміз. Осы жолда біз ынтымақтастыққа, ашықтыққа және инновацияға ұмтыламыз.",
                bp13: "НЕГЕ MUK?",
                p21: "MUK көмегімен серіктестеріміз сенімді дистрибуторға және айтарлықтай бәсекелестікке ие болады.",
                p22: "Біздің серіктестер MUK қызметтері мен қызметтерінің икемділігін атап өтіп, өзгермелі нарықтық үрдістерге оңай бейімделеді. Біз ең прогрессивті жеткізушілермен жұмыс істейтіндіктен, біздің клиенттер әрқашан өз бизнесін дамыту үшін жаңа мүмкіндіктер табады.",
                p23: "Біздің икемді қаржыландыру нұсқалары біздің клиенттерге арналған, ол тапсырыс бойынша шешім немесе арнайы несие желілері болсын, біз серіктестерге бизнес жүргізуді жеңілдетеміз.",
                p24: "Біз барлық туындаған мәселелерді арнайы тіркелгі менеджерлерінің және жұқпалы жеткізушілер тағайындаған өнім мамандарының көмегімен шешеміз. Сізге қажетті білімнің барлығы бір жерде, ал біздің кәсіби дайындық пен кең ауқымды маркетингтік қолдауымыз сіз біз жасайтын барлық нәрсеге сенімді бола алатыныңызды білдіреді.",
                p25: "MUK - бұл сіздің бизнесіңіз бен тұтынушыларыңыздың қажеттіліктеріне икемділік пен жауап беретін тәжірибелі компания.",
                p26: "Біздің коммерциялық бастамалар ауқымы сізге тамаша жұмыс сапасына кепілдік береді. Сондай-ақ біз өз клиенттерімізге тәжірибелі халықаралық логистика, оқу және қызмет көрсету орталығы, бұлттық өнім бөлімшесі пайдасына көмектесе аламыз.",
                p27: "Біз жақсы жұмыс үрдісі жақсы сатылымдарды білдіретінін бәрінен де жақсы білеміз және жауаптылық, белсенділік және тәуекелдерді басқару серіктесіміздің табысты бизнесінің және оның тұтынушылар алдындағы беделінің маңызды бөлігі екенін түсінеміз. Сондықтан біз бизнес-процестерді жақсартатын және өзара әрекеттесу жылдамдығын жеңілдететін электрондық құралдарды жасадық.",
                p28: "Біз сіздің табысыңыз бен табыстылығыңызды әр қадамда арттыруға көмектесеміз."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Сұрақтарыңыз болсы?",
                description: "Бізге электрондық хат жіберу үшін төмендегі форманы толтырыңыз, біз сізге мүмкіндігінше тезірек хабарласамыз.",
                send: "Жіберу",
                nm: "Аты",
                ad: "Мекенжай",
                ph: "Телефон",
                em: "Электрондық пошта",
                ms: "Хабар",
                contactInfo: "Байланыс ақпараты",
                address: "Украина, Киев 03151, Донецкская көшесі, 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Барлық құқықтар сақталған."
            }
        }
    }

    if (lang === "kg") {
        text = {
            Navigation: [
                {
                    menu: "Мамлекеттер",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Армения",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Азербайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hu",
                            name: "Венгрия",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Грузия",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Казакстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Кыргызстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Монголия",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Словакия",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Тажикистан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Түркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Түркмөнстан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Өзбекстан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Чечимдер",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK сатуучулары"
                        },
                        {
                            link: "/solutions",
                            name: "MUK чечимдери"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Товарлардын жана кызматтардын каталогу"
                        }
                    ]
                },
                {
                    menu: "Жаңылыктар",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Жаңылыктар жана акциялар"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK журналы"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Видео"
                        }
                    ]
                },
                {
                    menu: "Багыттар",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT бөлүштүрүү"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Окуу борбору"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Кызмат борбору"
                        },
                        {
                            link: "https://cloud.muk.kg/",
                            name: "MUK Cloud булуттуу кызматтары"
                        }
                    ]
                },
                {
                    menu: "КОМПАНИЯ ЖӨНҮНДӨ",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK жөнүндө негизги маалыматтар"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Корпоративдик профайл"
                        },
                        {
                            link: "/vacancies",
                            name: "Бош жумуш орундары"
                        }
                    ]
                },
                {
                    menu: "Дилердик бөлүм",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Армения",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Азербайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Грузия",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Казакстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Кыргызстан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Монголия",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Тажикистан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Түркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Түркмөнстан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Өзбекстан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Эл аралык VAD IT дистрибутордук долбоору",
                paragraph: "MUK компаниясынын өнөктөштөрү бизди ишенимдүү, көп багыттуу IT дистрибутору катары билишет. Биздин көп жылдык тажрыйбабызга, техникалык компетенциябызга жана калыптанып калган өнөктөштүк моделибизге ишенишет.",
                partner: "Биз менен өнөктөш болуу"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Эл аралык дистрибутор",
                    text: "MUK географиясы Европа менен Азиянын 16 өлкөсүн камтыйт жана ар-дайым кеңейүүдө"
                },
                {
                    icon: "fa fa-star",
                    title: "25-жылдан ашык ийгилик",
                    text: "MUK 1997-жылдан бери лидерликти камсыздап келет"
                },
                {
                    icon: "fa fa-users",
                    title: "Уникалдуу экспертиза",
                    text: "MUK компаниясынын инженердик командасы ар-кандай оор жана татаал чечимдерди ишке ашырат"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ өндүрүүчүлөр",
                    text: "MUK дистрибуторунун капчыгында 100тен ашык дүйнөлүк А-бренддерин камтыйт жана алардын саны тынымсыз өсүүдө"
                }
            ],
            ServicesInfo: {
                title: "MUK компаниясынын багыттары жана иш аракеттери"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT бөлүштүрүү",
                    text: "MUK - бул IT долбоорлорунун бизнесине багытталган VAD дистрибутору. Биз 22- жылдан ашык убакыттан бери Европада жана Азияда дилердик тармактарды ийгиликтүү өнүктүрүп келе жатабыз.\nСертификацияланган адистердин жана кызматкерлеринин жардамы менен MUK өнөктөштөргө, жогорку деңгээлдеги долбоордук консалтинг жана техникалык колдоо көрсөтөт, бул сунуш кылгандарга кошумча чечимдерге бааны жаратат. \nMUK инженерлери программалык жана аппараттык чечимдерге консультациялык жана техникалык колдоо көрсөтүшөт, учурдагы системалардын аудитин жүргүзүшөт, жана тесттик стенддерди ишке ашырууга жардам беришет. Биздин тесттик жабдуулар паркыбыз, бизге реалдуу шартта тапшырмалардын кеңири спектрин моделдөөгө жана ишке ашырууга мүмкүндүк берет.\nMUK интеграторлорго оптималдуу чечимдерди тандоодо жана долбоорлоодо жигердүү жардам берет.\nMUK командасына ар-кандай технологиялык багыттагы 500дөн ашык адистер кирет, алар сертификациланган, жана дүйнөнүн алдыңкы IT өндүрүүчүлөрү",
                    activ1: "Эл аралык логистика, складдарды түзүү",
                    activ2: "Өнөктөштөр үчүн маркетингдик жана консалтингдик колдоо",
                    activ3: "Өз компетенттүүлүгүнүн негизинде чечимдердин баалуулугун жогорулатуу",
                    activ4: "Өндүрүлгөн продуктту рынок-базарына алып чыгуу, суроо-талапты көтөрүү жана түзүү",
                    activ5: "Техникалык колдоо, кепилдиктүү тейлөө",
                    activ6: "Өнөктөштүк тармагын өнүктүрүү"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Булуттуу MUK Cloud Solution Provider өндүрүмү",
                    text: "MUK Cloud Solutions for Business MUK Cloud Solutions - бул бизнестин үзгүлтүксүздүгүн камсыздоого, иштин натыйжалуулугун жана кызматкерлердин мобилдүүлүгүн жогорулатууга багытталган чечимдердин жана кызматтардын тез башталгыч топтому, заманбап коопсуз кызматташуу куралдары менен камсыз кылуу.\nАлардын жардамы менен сиз тез жана натыйжалуу иштей аласыз. Уюмуңуздун инфраструктурасында булут технологияларын ишке киргизиңиз. Cloud Solution Provider концепциясы Microsoft Office 365, AZURE, EMS, D365 жана башка булут кызматтары ай сайын жеткиликтүү болгон сатуу каналы.\nMUK инфраструктураны \"нөлдөн баштап\" түзүүнү сунуштайт. Минималдуу капиталдык чыгымдар. Булут ресурстарын ижарага алуу жана тейлөө үчүн оптималдуу операциялык чыгымдар. Инфраструктураны масштабдоо (ишкананын өсүшү, жаңы аймактык бөлүмдөр, пландалган жүктөөлөр). Булуттагы жаңы кызматтар, жер үстүндөгү инфраструктура менен интеграцияланган.",
                    activ1: "Камдык көчүрмөлөрдү (файлдарды, виртуалдык машиналарды, маалымат базаларын) булутта сактоо.",
                    activ2: "Авариялык кыйроолорду коргоо, калыбына келтирүү. Виртуалдык машиналар же маалымат базаларынын SQLдин деңгээлинде жогорку жеткиликтүүлүк кластерлери.",
                    activ3: "Мобилдик аппаратты башкаруу.",
                    activ4: "Корпоративдик маалыматты жана кат-кабарларды коргоо",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business on-lineды жайгаштыруу.",
                    activ6: "Вебсайттарды жайгаштыруу жана конфигурациялоо, сайттарды булутка көчүрүү."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service тейлөө борбору",
                    text: "MUK компаниясы Сервиси 2002-жылдан бери компьютерлерди оңдоо кызматтарын ийгиликтүү көрсөтүп келет жана бүгүнкү күндө APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell үчүн ыйгарым укуктуу тейлөө борбору болуп саналат, EMC, Tescom жана башка өндүрүүчүлөр. \"МУК-Сервис\" компаниясынын сапат менеджмент системасы Эл аралык сертификаттоо бюросунун ISO 9001 сертификаты менен тастыкталган.\nАр кандай бузулууларды тез арада чечүү үчүн сиз чыныгы адис болушуңуз керек. Биздин мастерлер тажрыйбага жана күнүмдүк практикага ээ болуп, ар кандай мүчүлүштүктөрдү жоюп келишет. Кесипкөйлүк тажрыйба менен келет, биз өзүбүздү өркүндөтүп, билим деңгээлигибизди жогорулатып келүүдөбүз. Тейлөө борборунун кызматкерлери сертификацияланган адистерден турат, алар кардарларга жабдууларды сапаттуу жана кесипкөй оңдоого кепилдик берет. MUK Service сапаттуу тейлөөнү камсыз кылуу үчүн бардык керектүү техникалык мүмкүнчүлүктөргө ээ. Тейлөө борбору ар-кандай деңгээлдеги татаалдыктагы тейлөөнү, кепилдикти жана кепилдиксиз оңдоолорду аткарат. MUK Service Украина, Армения, Грузия, Молдова, Тажикстан жана Казакстандагы корпоративдик кардарлар үчүн жабдууларды ижарага алуу жана аутсорсинг, монтаждоо жана тейлөө кызматтарын, ошондой эле маалыматтык жана консультациялык кызматтарды көрсөтөт.",
                    activ1: "Кепилдиктүү оңдоо",
                    activ2: "Кепилдиксиз оңдоо",
                    activ3: "Жабдууларды диагностикалоо",
                    activ4: "Тетиктерди сатуу",
                    activ5: "Тейлөө келишимдеринин аудити",
                    activ6: "Ижара жана жабдуулардын аутсорсинги"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK окутуу борбору",
                    text: "MUK окуу борбору – 15-жылдык тажрыйбалуу, бир катар уникалдуу авторизациялары бар, квалификациялуу окутуучулар командасы, жана заманбап окутуу инфраструктурасы менен IT билим-берүү кызматтары рыногунун лидери.\nMUK TC портфолиосу алдыңкы IT тармагынан 300дөн ашык окуу курстарын камтыйт.\nДаражалуулардын арасынан белгилей кетчүлөр: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner. \nMUK окутуу борбору эң заманбап билим берүү жабдууларына мүмкүнчүлүктөрү бар. Биздин мугалимдер тарабынан окутуунун сапаты, көп жылдар бою Украинада жана чет өлкөлөрдө студенттердин жогорку баа алышы менен тастыкталган."
                }
            ],
            Vendors: {
                title: "MUK сатуучулары",
                country: "Мамлекет",
                solution: "Чечим",
                name: "Аты",
                all: "Баардыгы",
                namePlaceholder: "Сатуучунун атын терип жазыңыз",
                notInfo: "Маалымат толтурулган жок"
            },
            VendorsForCountry: {
                title: "MUK сатуучулары бар, жеткиликтүү өлкөлөр"
            },
            VendorsForSolution: {
                title: "MUK сатуучулары, чечими боюнча"
            },
            VendorDetail: {
                title: "ЫЙГАРЫМ УКУККА ЭЭ ДИСТРИБУТОРЛОР"
            },
            Gallery: {
                title: "MUK чечимдери"
            },
            Distribution: {
                title: "IT бөлүштүрүү"
            },
            Partner: {
                title: "Биз менен өнөктөш болуу",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Жөнөтүү",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK бизнести өнөктөштүк жана кызматташтык принциптеринде курат",
                advantages: "Артыкчылыктар",
                paragraph: "MUK негизделгенден бери, жеткирүүчүлөр жана кардарлар менен мамиленин ачыктыгына басым жасап келет. Өнөктөштүк эрежелерине берилгендик MUKга рыноктун ишенимине ээ болууга, жана лидер катары абройго ээ болууга мүмкүндүк берди",
                Why: [
                    "Инновациялар",
                    "Жоопкерчилик",
                    "Чынчылдык",
                    "Бирдей шартта жумушка орношууга мүмкүнчүлүктөр"

                ],
                Why2: [
                    "Командада иштөө жана урматтоо",
                    "Окутуулар",
                    "Социалдык жоопкерчилик"
                ]
            },
            News: {
                title: "MUK жаңылыктары",
                showAll: "Баардыгын көрсөтүү",
                showMore: "Көбүрөөк көрсөтүү",
                news: "Жаңылык",
                akcii: "Акция"
            },
            Vacancies: {
                title: "MUKтагы жумуш орундары",
                resume: "Send a CV",
                country: "Мамлекет",
                all: "Баардыгы",
                search: "Издөө",
                namePlaceholder: "Атын терип жазыңыз",
                filterInfo: "Бул фильтрлер боюнча бош жумуш орундары жок",
                notInfo: "Маалымат толтурулган жок",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" журналы боюнча сандары",
                vupysk: "Чыгаруу"
            },
            OMuk: {
                title: "MUK тууралу толук маалымат",
                p1: "MUK компаниялар тобу өз ишин 1997-жылы баштаган. Биздин негизги иш багытыбыз гибриддик жана булуттук чечимдер, маалымат борборунун конвергенциясы, маалыматтык коопсуздук, мобилдик түзүлүштөр жана маалыматтык коопсуздук,  маалыматтык аналитика, жана жасалма интеллект тармагындагы алдыңкы IT долбоорлоруна багытталган иш-аракеттерди аткаруу.",
                p2: "Биздин глобалдык бөлүштүрүү тармагыбыздын аркасында биз келечектүү IT сатуучуларды жана алардын жаңы өнүмдөрүн жергиликтүү рынокторго алып келебиз, суроо-талапты түзүүгө активдүү катышабыз.",
                p3: "Биз эксперттик техникалык жана рыноктук билимди прогрессивдүү өнөктөш колдоо программасы менен айкалыштырабыз. Биздин дилерлер менен тыгыз иштешип, биз алардын динамикалык өсүшүн жана өнүгүшүн камсыз кылууга умтулабыз, натыйжаларга бирге жетишебиз.",
                bp1: "МААЛЫМАТТЫК ТЕХНОЛОГИЯЛАР БИЗБИЗ!",
                p4: "MUK 25 жылдан ашуун убакыттан бери маалымат технологияларын жайылтууда пионер болуп саналат. Бүгүнкү күндө MUK технологияны иштеп чыгуучулардан аны ишке ашыруучу жана колдонгондорго өткөрүүдө маанилүү роль ойнойт.",
                ul: "MUK компаниясын ишенимдүү өнөктөш жана эффективдүү дистрибутор катары мүнөздөгөн төрт көрсөткүч:",
                li1: "1. 25 жылдан ашык тажрыйба жана ишеним.",
                li2: "2. 100дөн ашык А брендинин сатуучулары (дүйнөлүк аталыштары жана далилденген продукциялары бар компаниялар).",
                li3: "3. Ар бир сатуучу аймактын өзүнүн менеджерлери, сатуучулары жана инженерлери бар, ошондуктан биздин кызматкерлер 500дөн ашык адистерден турат.",
                li4: "4. Учурда биздин 4000дөн ашык аппараттык жардамтөргө, анын ичинде класс IT интеграторлоруна, эмеса оңдоо иштерине, курулуш иштерине гана, консалтингдик фирмаларга, биздин өнүмдөрдү жеткирүүдө программалык камсыздоону иштеп чыгуучуларга кызмат көрсөтөбүз.",
                bp2: "СТРАТЕГИЯ",
                p5: "Биздин стратегиябыз – биздин чоң тажрыйбабыздын, жогорку компетенттүүлүгүбүздүн жана дүйнөнүн ар кайсы өлкөлөрүндө болушубуздун аркасында жеткирүүчүлөр жана реселлерлер тарабынан алдыңкы IT дистрибутор катары таанылуу.",
                bp3: "МИССИЯ",
                p6: "Биздин миссия - өнөктөштөрүбүздү новатордук чечимдерди жана сапаттуу продуктыларды өз убагында камсыз кылуу",
                p7: "Биз өсүп жаткан рыноктук суроо-талапты канааттандыруу үчүн технологиялык өнүмдөрдү жана чечимдерди өркүндөтүү үчүн жан-дили менен иштейбиз жана продуктунун өз убагында жеткиликтүүлүгү жана терең продукт билими аркылуу жеткирүүчүгө да, сатуучуга да нарк кошуу.",
                p8: "MUK системалуу түрдө суроо-талапты түзүү жана өнүмдөрдү рынокко алып чыгуу, ошондой эле өнөктөштүк программасы, натыйжалуу жеткирүү тизмеги жана окутуу аркылуу биздин сатуучулар үчүн пайдалуу мүмкүнчүлүктөрдү түзүү үчүн иштеп жатат.",
                p9: "Биз элибиздин мүмкүнчүлүктөрүн кеңейткен, алардын жетишкендиктерин тааныган жана аларга дайыма өзгөрүп турган бизнес чөйрөсүнө ыңгайлашууга жардам берген чөйрөнү сактап калууга умтулабыз. MUK туруктуу жеке жана кесиптик өсүү үчүн кызматкерлерди түрткү берет.",
                bp4: "ӨНӨКТӨШТҮК ЖАНА ЖООПКЕРЧИЛИК",
                p10: "MUK бир гана өнөктөш бизнес моделин тааныйт. Биз акыркы кардарлар менен иштебейбиз жана дилердик тармактын өнүгүшүнө таянабыз. Биздин өнөктөштөрдүн акыркы кардарларынын арасында ата мекендик бизнестин бардык тармактары бар: чекене соода, өнөр жай, каржы жана мамлекеттик сектор.",
                p11: "Биз өнөктөштөрүбүз менен ийгиликке жетүү үчүн жоопкерчиликти бөлүшөбүз. Биздин кредобуз: «Биз чогуу барабыз, ошондуктан баарыбыз акырына чейин биргебизБиз оор кырдаалда өнөктөштөрүбүздү колдоп, жеңиштерге бирге кубанабыз, тажрыйба көрсөткөндөй, бизде жеңилүүгө караганда биргелешкен жеңиштер алда канча көп.",
                p12: "MUK өзүнүн көп жылдык иши менен, өзүнүн көп кардарларынын стратегиясынын жашоого жөндөмдүүлүгүн далилдеди, анда биздин портфелдеги бардык сатуучулар атаандаштык рынок чөйрөсүндө өнүгүүгө, жана иштөөгө бирдей мүмкүнчүлүк алышат. Биз өнөктөштөрдүн долбоорлордо иштөө стратегиясын тандоо укугун өзүнө калтырабыз, ошол эле учурда комплекстүү чечимдерди түзүүгө жардам берип, бүткүл сатуу цикли боюнча кеңеш беребиз: тапшырманы алып салуудан баштап ишке ашырууга жана тейлөөгө чейин.",
                bp5: "БИЗДИН БААЛУУЛАРЫБЫЗ",
                p13: "MUK инновациянын, жоопкерчиликтин, ак ниеттүүлүктүн, мүмкүнчүлүктөрдүн тең укуктуулугунун жана командада иштөөнүн, сый-урматтын, окуунун жана социалдык жоопкерчиликтин баалуулуктарын кармануу менен, өзүнүн бизнес өнөктөштөрүнүн жана кызматкерлеринин ийгилигин жогорулатууга багытталган.",
                bp6: "Бирдей жумушка орношуу мүмкүнчүлүгү",
                p14: "Бош орундарга жумушчулука талапкерлердин арыздары расасына, жынысына, динине, түсүнө, улуттук тегине, жашына, гендердик өзгөчөлүгүнө жана көрүнүшүнө, майыптыгына, сексуалдык ориентациясына, ардагер статусуна же белгилүү бир кызматтын квалификациясына байланышпаган башка факторлорго карабастан каралат.",
                bp7: "Инновация",
                p15: "Биз дайыма кардарларыбызга, жеткирүүчүлөрүбүзгө жана кесиптештерибизге баалуулуктарды кошуунун жакшы жолдорун издеп жатабыз. Биз өзгөрүүлөрдү күтөбүз жана аларга ылайыкталган чечимдерди активдүү түрдө түзөбүз.",
                bp8: "Жоопкерчилик",
                p16: "Биз эмне кылсак ошону айтабыз, айтканыбызды кылабыз. Биз дайыма өнөктөштөрүбүздүн күтүүлөрүнө жооп берген же андан ашкан натыйжаларга жетишебиз",
                bp9: "Чынчылдык",
                p17: "Биз бардык жерде жана бардык учурда ар бир иш-аракетибизде чынчылдыкты жана калыстыкты көрсөтүү менен эң жогорку этикалык стандарттарды карманабыз.",
                bp10: "Командада иштөө жана урматтоо",
                p18: "Биз кесиптештерибиздин, өнөктөштөрүбүздүн жана коомдун укуктарын жана ишенимдерин сыйлайбыз. Биз жалпы максаттарыбызга жетүү үчүн ар түрдүүлүктү колдонуп, башкаларга эң жогорку даражадагы кадыр-барк, теңдик жана ишеним менен мамиле кылабыз. Команда катары биз жекече эмес, көбүрөөк жасайбыз",
                bp11: "Окутуу",
                p19: "Өндүрүмдүүлүктү жогорулатуу жана компанияны жана өзүбүздү өстүрүү үчүн, биз ар дайым жаңы билимдерге ээ болуудабыз",
                bp12: "Социалдык жоопкерчилик",
                p20: "Биз бүткүл дүйнө жүзү боюнча ар кандай кызыкдар тараптар үчүн, оң натыйжаларга жетүү үчүн финансылык, социалдык жана экологиялык милдеттерибизди балансташтыруунун жолдорун жигердүү издеп жатабыз. Бул жолдо биз кызматташууга, ачык-айкындуулукка жана инновацияларга умтулабыз.",
                bp13: "ЭМНЕ ҮЧҮН МУК?",
                p21: "MUK менен биздин өнөктөштөр ишенимдүү дистрибутор жана олуттуу атаандаштык артыкчылыкка ээ болушат",
                p22: "Биздин өнөктөштөр MUK кызматтарынын жана кызматтарынын ийкемдүүлүгүн белгилеп, өзгөрүп жаткан рынок тенденцияларына оңой ыңгайлашат. Биз эң прогрессивдүү жеткирүүчүлөр менен иштегендиктен, биздин кардарлар ар дайым бизнесин өнүктүрүү үчүн жаңы мүмкүнчүлүктөрдү табат.",
                p23: "Каржылоонун ийкемдүү варианттары биздин кардарлар үчүн иштелип чыккан, мейли ал заказ кылынган чечим болобу же атайын кредиттик линия болобу, биз өнөктөштөрдүн бизнес жүргүзүүсүн жеңилдетет.",
                p24: "Биз бардык пайда болгон суроолорду атайын эсеп менеджерлеринин жана инфекциялык сатуучулар тарабынан дайындалган продукт адистеринин жардамы менен чечебиз. Сизге керек болгон бардык билимдер бир жерде, жана биздин профессионалдык тренингибиз жана кеңири маркетингдик колдообуз сиз биз жасаган бардык иштерде ишенимдүү боло аласыз.",
                p25: "MUK - бул сиздин бизнесиңиздин жана кардарларыңыздын муктаждыктарына ийкемдүүлүк жана жооп берүүчү тажрыйбалуу компания",
                p26: "Биздин коммерциялык демилгелердин ассортименти сизге жумуштун жогорку сапатына кепилдик берет. Биз ошондой эле кардарларыбызга тажрыйбалуу эл аралык логистика, окутуу жана тейлөө борборунан, булут продуктуларынан пайда алууга жардам бере алабыз.",
                p27: "Жакшы иш процесси жакшы сатууну билдирээрин биз баарынан жакшы билебиз жана жооптуулук, активдүүлүк жана тобокелдиктерди башкаруу өнөктөшүбүздүн ийгиликтүү бизнесинин жана анын кардарлардын алдындагы аброюнун маанилүү бөлүгү экенин түшүнөбүз. Ошондуктан, биз сиздин бизнес процесстериңизди өркүндөтүүчү жана өз ара аракеттенүүнүн ылдамдыгын жөнөкөйлөтүүчү электрондук инструменттерди түздүк.",
                p28: "Биз сиздин кирешеңизди жана кирешелүүлүгүңүздү ар бир кадам сайын жогорулатууга жардам беребиз."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Суроолор пайда болду?",
                description: "Сураныч, бизге электрондук кат жөнөтүү үчүн төмөнкү форманы толтуруңуз, биз сизге мүмкүн болушунча тезирээк жооп беребиз",
                send: "Жөнөтүү",
                nm: "Аты",
                ad: "Дарек",
                ph: "Телефон",
                em: "Email",
                ms: "Сообщение",
                contactInfo: "Байланышуу",
                address: "Украина, Киев шаары 03151, Донецкая 16/2 көч.",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Бардык укуктар корголгон."
            }
        }
    }

    if (lang === "mk") {
        text = {
            Navigation: [
                {
                    menu: "Земји",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Албанија",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Ерменија",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Азербејџан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hu",
                            name: "Унгарија",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/hr",
                            name: "Хрватска",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Грузија",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Киргистан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдавија",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Монголија",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Србија",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словенија",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Таџикистан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Турција",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Туркменистан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Решенија",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Продавачи MUK"
                        },
                        {
                            link: "/solutions",
                            name: "Решенија MUK"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Каталог на производи и услуги"
                        }
                    ]
                },
                {
                    menu: "Вести",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Вести и промоции"
                        },
                        {
                            link: "/muk-review",
                            name: "Списание MUK"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Видео"
                        }
                    ]
                },
                {
                    menu: "Правци",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "ИТ дистрибуција"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Тренинг центар"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Сервисен центар"
                        },
                        {
                            link: "https://cloud.muk.mk/",
                            name: "Облак услуги MUK Cloud"
                        }
                    ]
                },
                {
                    menu: "За компанијата",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Клучни точки за MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Корпоративен профил"
                        },
                        {
                            link: "/vacancies",
                            name: "Работни места"
                        }
                    ]
                },
                {
                    menu: "Дел за дилери",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албанија",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Ерменија",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Азербејџан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хрватска",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Грузија",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Киргистан",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдавија",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Монголија",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Србија",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словенија",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Таџикистан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Турција",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туркменистан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Меѓународен проект VAD IT дистрибутер",
                paragraph: "Партнерите на MUK нè гледаат како доверлив IT дистрибутер со повеќе продавачи, веруваат во нашето долгогодишно искуство, техничка компетентност и добро воспоставен модел на партнерство",
                partner: "Како да станете партнер"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Меѓународен дистрибутер",
                    text: "Географијата на MUK опфаќа 16 земји во Европа и Азија и постојано се проширува"
                },
                {
                    icon: "fa fa-star",
                    title: "Над 25 години успех",
                    text: "MUK има лидерски позиции од 1997 година"
                },
                {
                    icon: "fa fa-users",
                    title: "Уникатна експертиза",
                    text: "Инженерскиот тим на MUK ќе се справи со секоја, дури и најтешка задача"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "Над 100 производители",
                    text: "Дистрибутивното портфолио на MUK вклучува повеќе од 100 глобални А-брендови и"
                }
            ],
            ServicesInfo: {
                title: "нивниот број постојано расте"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Дејностите на MUK",
                    text: "MUK е VAD дистрибутер фокусиран на IT бизнис проекти. Успешно ја развиваме дилерска мрежа во Европа и Азија повеќе од 25 години.\n Со помош на персонал од сертифицирани специјалисти, MUK компанијата им обезбедува на партнерите високо ниво на проектни консултации и техничка поддршка, што генерира дополнителна вредност за предложените решенија.\n Инженерите на MUK обезбедуваат консултантска и техничка поддршка за софтверски и хардверски решенија, спроведуваат ревизии на постоечките системи и помагаат при имплементацијата на тест платформи. Нашата флота на опрема за тестирање ни овозможува да симулираме и имплементираме широк спектар на задачи во реални услови.\n MUK активно им помага на интеграторите во изборот и дизајнирањето оптимални решенија.\nТимот на MUK вклучува повеќе од 500 специјалисти во различни технолошки области кои се сертифицирани од водечки светски IT производители",
                    activ1: "Меѓународна логистика, формирање магацини",
                    activ2: "Маркетинг и консултантска поддршка за партнерите",
                    activ3: "Зголемување на вредноста на решенијата преку сопствената компетентност",
                    activ4: "Лансирање производи на пазарот, промовирање и генерирање на побарувачка",
                    activ5: "Техничка поддршка, гаранција и постгарантен сервис",
                    activ6: "Развој на партнерска мрежа"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Облак решенија на MUK Cloud Solution Provider",
                    text: "MUK Cloud Solutions for Business се пакети решенија и услуги за брз почеток, чија цел е да се обезбеди континуитет на бизнисот, зголемување на работната ефикасност и мобилност на вработените со обезбедување на современи безбедни алатки за соработка.\nСо нивна помош можете брзо и ефикасно да ги имплементирате облак технологиите во инфраструктурата на вашата организација. Концептот Cloud Solution Provider е продажен канал во кој Microsoft Office 365, AZURE, EMS, D365 и други облак услуги се достапни на месечно плаќање. \nMUK нуди создавање на инфраструктура „од нула“. Минимални капитални трошоци. Оптимални оперативни трошоци за изнајмување на ресурси на облак и одржување. Зголемување на инфраструктурата (раст на претпријатијата, нови територијални канцеларии, планирани скокови на оптоварување). Нови услуги во облакот интегрирани со копнената инфраструктура.",
                    activ1: "Чување резервни копии (датотеки, виртуелни машини, бази на податоци) во облакот",
                    activ2: "Заштита од „паѓање“, обновување. Кластери со висока достапност на ниво на виртуелни машини или SQL бази на податоци",
                    activ3: "Управување со мобилни уреди",
                    activ4: "Заштита на корпоративни информации и кореспонденција",
                    activ5: "Распоредување на SharePoint on-line, Exchange on-line, Skype for business on-line",
                    activ6: "Распоредување и поставување на веб-локации, миграција на веб-страници во облакот"
                },
                {
                    icon: "fa fa-wrench",
                    name: "Сервисен центар на MUK",
                    text: "Компанијата MUK Service успешно обезбедува услуги за поправка на компјутери од 2002 година и денес е овластен сервисен центар за APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius , Dell EMC, Tescom и други производители. Квалитетот на системот за управување на компанијата MUK-Service е потврден со ISO 9001 на сертификатот на Бирото за меѓународна сертификација.\nПотребен е вистински професионалец за да се поправи секој дефект. Стекнувајќи искуство и секојдневна пракса, нашите сервисери го решаваат секој дефект. Професионализмот доаѓа со искуство, се усовршуваме и го зголемуваме нивото на нашето знаење. Персоналот на сервисниот центар се состои од овластени професионалци што им гарантира на клиентите висококвалитетна и професионална поправка на опремата. MUK Service ги има сите потребни технички можности за да обезбеди квалитетна услуга. Сервисниот центар врши поправки за одржување, гаранција и без гаранција од кое било ниво на сложеност. Компанијата MUK Service обезбедува изнајмување опрема и аутсорсинг, услуги за инсталација и одржување, како и информации и консултантски услуги за корпоративни клиенти во Украина, Ерменија, Грузија, Молдавија, Таџикистан и Казахстан.",
                    activ1: "Гарантна поправка",
                    activ2: "Поправки без гаранција",
                    activ3: "Хардверска дијагностика",
                    activ4: "Продажба на резервни делови",
                    activ5: "Ревизија на договори за услуги",
                    activ6: "Изнајмување и аутсорсинг на опрема"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Центар за обука на МУК",
                    text: "MUK Training Center е лидер на пазарот на ИТ образование со повеќе од 15 години искуство и голем број уникатни овластувања, тим од квалификувани инструктори и модерна инфраструктура за обука.\n TC порфолиото на MUK  вклучува повеќе од 300 курсеви за обука од водечки ИТ компании. \nЗабележителни статуси вклучуваат: Pearson VUE, Veeam овластен образовен центар, HPE едукативен центар, VMware овластен тренинг центар, Oracle одобрен образовен провајдер, Penta Security едукативен центар, Juniper Networks овластен образовен партнер, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point овластен тренинг центар, Fortinet овластен тренинг центар, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nЦентарот за обука MUK има пристап до најсовремена наставна опрема. Квалитетот на наставата од страна на нашите инструктори е потврден многу години со високите оценки на студентите во Украина и во странство."
                }
            ],
            Vendors: {
                title: "Продавачи на МУК",
                country: "Земја",
                solution: "Решение",
                name: "Име",
                all: "Се, Сите",
                namePlaceholder: "Почнете да го пишувате името на продавачот",
                notInfo: "Информациите не се пополнуваат"
            },
            VendorsForCountry: {
                title: "MUK продавачите достапни во земјата"
            },
            VendorsForSolution: {
                title: "MUK продавачи по решение"
            },
            VendorDetail: {
                title: "ОВЛАСТЕН ДИСТРИБУТЕР"
            },
            Gallery: {
                title: "MUK решенија"
            },
            Distribution: {
                title: "ИТ дистрибуција"
            },
            Partner: {
                title: "Како да станете партнер",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Испрати",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "МUК го гради својот бизнис врз принципите на партнерство и соработка",
                advantages: "Придобивки",
                paragraph: "МUК од своето основање се фокусира на транспарентноста во односите со добавувачите и клиентите. Посветеноста на правилата за партнерство му овозможи на МUК да ја заработи довербата на пазарот и да изгради лидерска репутација",
                Why: [
                    "Иновации",
                    "Одговорност",
                    "Искреност",
                    "Еднакви можности за вработување"

                ],
                Why2: [
                    "Тимска работа и почит",
                    "Обука",
                    "Социјална одговорност"
                ]
            },
            News: {
                title: "Вести од МUК",
                showAll: "Прокажи повеќе",
                showMore: "Пркажи повеќе",
                news: "Вести",
                akcii: "Акции"
            },
            Vacancies: {
                title: "Работни места",
                resume: "Send a CV",
                country: "Земја",
                all: "Сите",
                search: "Пребарување",
                namePlaceholder: "Почнете да пишувате име",
                filterInfo: "Според филтрите нема слободни места",
                notInfo: "Информациите не се пополнети",
                back: "Back"
            },
            MukReview: {
                title: " Изданија на списанието \"MUK-REVIEW\"",
                vupysk: "Проблем"
            },
            OMuk: {
                title: "Главни информации за MUK",
                p1: "Групацијата на компании MUK започна со работа во 1997 година. Нашата главна област на работа е проектно ориентирана дистрибуција на водечки ИТ производи во областа на хибридни и облачни решенија, конвергенција на центрите за податоци, безбедност на информации, мобилни уреди и Интернет на нештата, аналитика на податоци и вештачка интелигенција.",
                p2: "Благодарение на нашата глобална дистрибутивна мрежа, носиме перспективни ИТ вендори и нивните нови производи на локалните пазари, активно учествуваме во формирањето на побарувачката.",
                p3: "Ние комбинираме стручно техничко и пазарно знаење со прогресивна програма за поддршка на партнери. Тесно соработувајќи со нашите дилери, се стремиме да го обезбедиме нивниот динамичен раст и развој, постигнувајќи резултати заедно.",
                bp1: "ИНФОРМАТИЧКИТЕ ТЕХНОЛОГИИ – ТОА СМЕ НИЕ!",
                p4: "MUK компанијата е пионер во ширењето на информатичката технологија повеќе од 25 години. Денес, MUK игра важна улога во трансферот на технологијата од оние кои ја развиваат на оние кои ја спроведуваат и користат.",
                ul: "Четири фигури кои го карактеризираат MUK како доверлив партнер и ефикасен дистрибутер:",
                li1: "1. Над 25 години искуство и доверба.",
                li2: "2. Повеќе од 100 веднори на А-бренд (компании со светски имиња и докажани производи).",
                li3: "3. Секоја вендор на продавачи има свои менаџери, претпродажба и инженери, така што нашиот персонал се состои од повеќе од 500 специјалисти.",
                li4: "4. Во моментов опслужуваме повеќе од 4000 активни партнери, вклучувајќи не само класични ИТ интегратори, туку и производствени претпријатија, градежни компании, консултантски фирми, развивачи на софтвер кои ги користат нашите производи во нивните испораки.",
                bp2: "СТРАТЕГИЈА",
                p5: "Нашата стратегија е да бидеме препознаени и од добавувачите и од препродавачите како водечки ИТ дистрибутер, благодарение на нашето огромно искуство, високата компетентност и присуството во  различни земји во светот.",
                bp3: "МИСИЈА",
                p6: "Нашата мисија е да им обезбедиме на нашите партнери иновативни решенија и квалитетни производи навреме.",
                p7: "Работиме посветено на унапредување на технолошките производи и решенија за да одговориме на растечката побарувачка на пазарот и да додадеме вредност и за добавувачот и за препродавачот преку навремена достапност на производите и длабинско знаење за производите.",
                p8: "MUK систематски работи на создавање побарувачка и носење производи на пазарот, како и генерирање профитабилни можности за нашите препродавачи преку партнерска програма, ефикасен синџир на снабдување и обука.",
                p9: "Посветени сме на одржување на средина која ги овластува нашите луѓе, ги препознава нивните достигнувања и им помага да се прилагодат на постојано менување на деловното опкружување. MUK ги мотивира вработените за одржлив личен и професионален раст.",
                bp4: "ПАРТНЕРСТВО И ОДГОВОРНОСТ",
                p10: "MUK се придржува до исклучиво партнерски бизнис модел. Ние не работиме со крајните  клиенти  и се потпираме врз развојот на дилерската мрежа. Меѓу крајните клиенти на нашите партнери се сите сектори на домашниот бизнис: малопродажба, индустрија, финансии и јавниот сектор.",
                p11: "Одговорноста за постигнување успех ја споделуваме со нашите партнери. Нашето кредо: „Одиме заедно, па заедно одиме до крај“. Ги поддржуваме нашите партнери во тешки ситуации и заедно  славиме победи и, како што покажа искуството, имаме многу повеќе заеднички победи отколку порази.",
                p12: "MUK со својата долгогодишна работа ја докажа одржливоста на својата стратегија за повеќе продавачи, во која сите продавачи во нашето портфолио добиваат еднакви шанси да се развиваат и работат во конкурентна пазарна средина. Го задржуваме правото на партнерите да изберат стратегија за работа во проекти, притоа помагајќи да се создадат сеопфатни решенија, советувајќи за целиот циклус на продажба: од отстранување на задачи до имплементација и одржување.",
                bp5: "НАШИТЕ ВРЕДНОСТИ",
                p13: "MUK е целосно фокусиран на унапредување на успехот на своите деловни партнери и вработени преку придржување кон вредностите на иновативност, одговорност, интегритет, еднакви можности и тимска работа, почит, учење и општествена одговорност.",
                bp6: "Подеднакви можности за вработување",
                p14: "Апликациите од кандидатите за слободни позиции ги разгледуваме без оглед на расата, полот, религијата, бојата на кожата, националното потекло, возраста, родовиот идентитет и изразување, инвалидитет, сексуална ориентација, статус на ветеран или други фактори кои не се поврзани со квалификациите на одредена позиција.",
                bp7: "Иновации",
                p15: "Апликациите од кандидатите за слободни позиции ги разгледуваме без оглед на расата, полот, религијата, бојата на кожата, националното потекло, возраста, родовиот идентитет и изразување, инвалидитет, сексуална ориентација, статус на ветеран или други фактори кои не се поврзани со квалификациите на одредена позиција.",
                bp8: "Одговорност",
                p16: "Го кажуваме тоа што го правиме и го правиме она што го кажуваме. Постојано постигнуваме резултати кои ги исполнуваат или ги надминуваат очекувањата на нашите партнери и добавувачи.",
                bp9: "Чесност",
                p17: "Ние се држиме до највисоките етички стандарди демонстрирајќи чесност и правичност во секоја акција што ја преземаме, секаде и во секое време.",
                bp10: "Тимска работа и почит",
                p18: "Ги почитуваме правата и верувањата на нашите колеги, партнери и општеството. Ние ги третираме другите со највисоко ниво на достоинство, еднаквост и доверба користејќи ја различноста за да ги постигнеме нашите заеднички цели. Како тим правиме повеќе од индивидуално.",
                bp11: "Едукација",
                p19: "Постојано стекнуваме нови знаења за да ја зголемиме продуктивноста и да обезбедиме раст на нашата компанија и на нас самите",
                bp12: "Општествена одговорност",
                p20: "Активно бараме начини да ги балансираме нашите финансиски, социјални и еколошки одговорности за да постигнеме позитивни резултати за различни засегнати страни ширум светот. На овој пат се стремиме кон соработка, транспарентност и иновации.",
                bp13: "ЗАШТО MUK?",
                p21: "Со MUK, нашите партнери добиваат доверлив дистрибутер и значителна конкурентска предност",
                p22: "Нашите партнери лесно се прилагодуваат на променливите трендови на пазарот, забележувајќи ја флексибилноста на услугите на MUK. Бидејќи работиме со најпрогресивните добавувачи, нашите клиенти секогаш наоѓаат нови можности да го развијат својот бизнис",
                p23: "Нашите флексибилни опции за финансирање се дизајнирани за нашите клиенти, без разлика дали се работи за нарачано решение или одредени кредитни линии, ние им го олеснуваме бизнисот на партнерите.",
                p24: "Ние ги решаваме сите проблеми кои се појавуваат со помош на подготвени менаџери за сметки и специјалисти за производи доделени на различни продавачи. Целото знаење што ви треба е собрано на едно место, а нашата професионална обука и обемната маркетинг поддршка значат дека можете да бидете сигурни во сè што правиме",
                p25: "MUK – е искусна компанија која ви обезбедува флексибилност и одговор на потребите на вашиот бизнис и клиенти",
                p26: "Нашата палета на комерцијални иницијативи ви гарантира одличен квалитет на работа. Ние исто така, можеме да им помогнеме на нашите клиенти да имаат корист од искусна меѓународна логистика, центри за обука и услуги, одделот за облак производи.",
                p27: "Знаеме подобро од кој било дека добар работен тек значи добра продажба и разбираме дека одговорноста, проактивноста и управувањето со ризикот се важен дел од успешниот бизнис на нашиот партнер и неговата репутација кај клиентите. Затоа, создадовме електронски алатки кои ги подобруваат вашите деловни процеси и ја поедноставуваат брзината на интеракцијата.",
                p28: "Ние помагаме да ги зголемите вашите приходи и профитабилност на секој чекор од патот."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Ако имате какви било прашања?",
                description: "Ве молиме пополнете го формуларот подолу за да ни испратите на е-пошта и ние ќе ви одговориме што е можно поскоро",
                send: "Испрати",
                nm: "Име",
                ad: "Адреса",
                ph: "Телефон",
                em: "Email",
                ms: "Порака",
                contactInfo: "Информации за контакт",
                address: "Украина, г.Киев 03151, ул. Донецка 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Сите права се заштитени."
            }
        }
    }

    if (lang === "md") {
        text = {
            Navigation: [
                {
                    menu: "Țări",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/hu",
                            name: "Ungaria",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapore",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Solutii",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Vendorii MUK"
                        },
                        {
                            link: "/solutions",
                            name: "Solutii MUK"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Catalogul produselor  si a serviciilor"
                        }
                    ]
                },
                {
                    menu: "Noutăți",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Noutăți și oferte"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK journal"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "ACTIVITIES",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Distributie IT"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Training center"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Service Centru"
                        },
                        {
                            link: "https://cloud.muk.md/",
                            name: "MUK Cloud services"
                        }
                    ]
                },
                {
                    menu: "Despre companie",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Informatie de baza despre MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Profil corporativ"
                        },
                        {
                            link: "/vacancies",
                            name: "Oferte de munca"
                        }
                    ]
                },
                {
                    menu: "Sectia Dealeri",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Proiect International VAD IT distribuitor",
                paragraph: "Partenerii MUK ne caracterizeaza ca fiind un distribuitor IT de încredere cu mai mulți furnizori, au încredere în anii noștri de experiență, expertiza tehnică și tipul de parteneriat bine stabilit.",
                partner: "Devine partener"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Distribuitor International",
                    text: "Geografia include 16 țări din Europa și Asia și continuă să se extindă"
                },
                {
                    icon: "fa fa-star",
                    title: "Peste 25 de ani de succes",
                    text: "MUK detine statutul de lider din anul 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Expertiza unica",
                    text: "Echipa de ingineri poate face față chiar și celei mai complicate sarcini"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ producatori",
                    text: "Portofoliul companiei MUK conține peste 100 de mărci internaționale A și este în continuă creștere"
                }
            ],
            ServicesInfo: {
                title: "Domeniul de activitate al MUK"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Distributie IT",
                    text: "MUK este un distribuitor VAD axat pe afaceri de proiecte IT. Am dezvoltat cu succes o rețea de dealeri în Europa și Asia de mai bine de 25 de ani. \nCu ajutorul unui personal de specialiști atestați, compania MUK oferă partenerilor un nivel înalt de consultanță de proiect și suport tehnic care generează valoare suplimentară pentru soluțiile propuse.\nInginerii MUK oferă consultanță și suport tehnic pentru soluții software și hardware, efectuează audituri a sistemelor existente și ajutor la implementarea bancilor de testare. Stocul nostru de echipamente de testare ne permite să simulăm și să implementăm o gamă largă de sarcini în condiții reale. \nMUK ajută în mod activ integratorii în alegerea și proiectarea soluțiilor optime.\nEchipa MUK include peste 500 de specialiști în diverse domenii tehnologice, care sunt certificați de cei mai importanti producători IT din lume.",
                    activ1: "Logistica internationala, formarea stocurilor",
                    activ2: "Suport de marketing și consultanță pentru parteneri",
                    activ3: "Creșterea valorii soluțiilor prin propria noastră expertiză",
                    activ4: "Lansarea produsului, promovarea și generarea cerintelor",
                    activ5: "Suport tehnic, garanție și service post-garanție",
                    activ6: "Dezvoltarea rețelei de parteneri"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider Cloud",
                    text: "MUK Cloud Solutions for Business sunt suite de soluții și servicii cu pornire rapidă care vizează asigurarea continuității afacerii, creșterea eficienței muncii și mobilității angajaților prin furnizarea de instrumente moderne de colaborare securizată.\nCu ajutorul acestora, puteți implementa rapid și eficient tehnologiile cloud în infrastructura organizației dumneavoastră. Conceptul Cloud Solution Provider este un canal de vânzare în care Microsoft Office 365, AZURE, EMS, D365 și alte servicii cloud sunt disponibile pe bază de plată lunară.\nMUK oferă crearea unei infrastructuri „de la zero”. Costuri minime de capital. Costuri optime de operare pentru închirierea resurselor cloud și întreținere. Scalarea infrastructurii (creșterea întreprinderii, noi birouri teritoriale, explozii de încărcare planificate). Servicii noi în cloud integrate cu infrastructura la sol.",
                    activ1: "Stocarea backup-urilor (fișiere, mașini virtuale, baze de date) în cloud.",
                    activ2: "Crash protection, recovery. Cluster de înaltă disponibilitate la nivel de mașini virtuale sau baze de date SQL.",
                    activ3: "Mobile device management.",
                    activ4: "Corporate information si correspondece protection",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business implementare on-line ",
                    activ6: "Implementarea și setarea site-urilor web, migrarea site-urilor web în cloud."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service centru.",
                    text: "Compania MUK Service furnizează cu succes servicii de reparații computere din 2002, iar astăzi este un centru de service autorizat pentru APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius. , Dell EMC, Tescom și alți producători. Sistemul de management al calității al companiei MUK-Service este confirmat de certificatul ISO 9001 al Biroului de Certificare Internațională.\nEste nevoie de un adevărat profesionist pentru a remedia orice defecțiune. Dobândind experiență și practică zilnică, reparatorii noștri rezolvă orice defecțiune. Profesionalismul vine cu experienta, ne imbunatatim si ne crestem nivelul cunostintelor. Personalul centrului de service este format din profesioniști certificați, ceea ce garantează clienților repararea echipamentelor de înaltă calitate și profesionale. MUK Service dispune de toate capacitățile tehnice necesare pentru a oferi un serviciu de calitate. Centrul de service efectuează întreținere, reparații în garanție și fără garanție de orice nivel de complexitate. Compania MUK Service oferă servicii de închiriere și outsourcing de echipamente, instalare și întreținere, precum și servicii de informare și consultanță pentru clienții corporativi din Ucraina, Armenia, Georgia, Moldova, Tadjikistan și Kazahstan.",
                    activ1: "Reparatie in garantie",
                    activ2: "Reparatie post garantie",
                    activ3: "Diagnosticarea echipamentelor",
                    activ4: "Vanzare piese de schimb",
                    activ5: "Auditul contractelor de servicii",
                    activ6: "Închiriere de echipamente și outsorcing"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Centru de instruire MUK",
                    text: "Centrul de instruire MUK este lider de piață în servicii educaționale IT, cu mai mult de 15 ani de experiență și o serie de autorizații unice, o echipă de instructori calificați și o infrastructură modernă de formare.\nPortofoliul MUK TC include peste 300 de cursuri de formare de la cei mai buni IT. companii.\nStătările demne de remarcat includ: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, Partener de instruire ITIL, partener de servicii educaționale Dell-EMC, Centru de instruire Autodesk, Centru de instruire Grandstream, Centru de instruire autorizat Check Point, Centru de instruire autorizat Fortinet, Centru de instruire CommScope, Centru de învățare Cisco, Partener de formare certificat Red Hat.\nCentrul de instruire MUK are acces la cele mai moderne echipamente educaționale. De multe ani, calitatea predării de către instructorii noștri a fost confirmată de notele ridicate ale studenților din Ucraina și din străinătate"
                }
            ],
            Vendors: {
                title: "Vendorii MUK",
                country: "Tara",
                solution: "Solutie",
                name: "Nume",
                all: "Vezi toate",
                namePlaceholder: "Începeți să introduceți denumirea Vendorului",
                notInfo: "Informațiile nu sunt completate"
            },
            VendorsForCountry: {
                title: "Vendorii MUK disponibili în țară"
            },
            VendorsForSolution: {
                title: "Vendorii MUK după soluție"
            },
            VendorDetail: {
                title: "DISTRIBUITOR AUTORIZAT"
            },
            Gallery: {
                title: "Solutii MUK"
            },
            Distribution: {
                title: "Distributie IT"
            },
            Partner: {
                title: "Devine partener",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Trimite",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK își construiește afacerea pe principiile parteneriatului și cooperării",
                advantages: "Beneficii",
                paragraph: "MUK s-a concentrat pe transparență în relațiile cu furnizorii și clienții încă de la înființare. Devotamentul față de regulile parteneriatului a permis MUK să câștige încrederea pieței și să construiască reputația unui lider",
                Why: [
                    "Inovatii",
                    "Responsabilitati",
                    "Integritate",
                    "Șanse egale de angajare"

                ],
                Why2: [
                    "Munca in echipa si respect",
                    "Instruire",
                    "Responsabilitate socială"
                ]
            },
            News: {
                title: "Stiri MUK",
                showAll: "Afișați mai multe",
                showMore: "Afișați mai multe",
                news: "Noutati",
                akcii: "Afacere"
            },
            Vacancies: {
                title: "Cariera",
                resume: "Send a CV",
                country: "Tara",
                all: "Vezi toate",
                search: "Cauta",
                namePlaceholder: "Începeți să tastați numele",
                filterInfo: "Nu există locuri de muncă care să corespundă acestor filtre",
                notInfo: "Informațiile nu sunt completate",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" probleme de jurnal",
                vupysk: "Problema"
            },
            OMuk: {
                title: "Informatie de baza despre MUK",
                p1: "Grupul de companii MUK și-a început activitatea în 1997. Domeniul nostru principal de activitate este distribuția orientată pe proiecte a produselor IT de vârf în domeniul soluțiilor hibride și cloud, convergenței centrelor de date, securității informațiilor, dispozitivelor mobile și Internetul lucrurilor, analiza datelor și inteligența artificială.",
                p2: "Datorită rețelei noastre globale de distribuție, aducem furnizori IT promițători și noile lor produse pe piețele locale și participăm activ la formarea cererii",
                p3: "Combinăm cunoștințele tehnice și de piață experte cu un program progresiv de asistență pentru parteneri. Lucrând îndeaproape cu dealerii noștri, ne străduim să le asigurăm creșterea și dezvoltarea dinamică, obținând rezultate împreună.",
                bp1: "NOI SUNTEM TEHNOLOGII INFORMAȚIONALE!",
                p4: "Compania MUK este un pionier în distribuția tehnologiilor informaționale de peste 25 de ani. Astăzi, MUK joacă un rol important în transferul de tehnologii de la cei care îl dezvoltă către cei care îl implementează și îl folosesc.",
                ul: "Iată cele patru cifre care caracterizează MUK ca partener de încredere și distribuitor eficient:",
                li1: "1. Peste 25 de ani de experiență și încredere.",
                li2: "2. Peste 100 de furnizori de nivel A-brand (companii cunoscute la nivel mondial cu produse dovedite).",
                li3: "3. Fiecare Vendor are propriii manageri, prevânzări și ingineri, astfel că personalul nostru este format din peste 500 de specialiști.",
                li4: "4. În prezent deservim peste 4000 de parteneri activi, inclusiv nu numai integratori IT clasici, ci și întreprinderi de producție, companii de construcții, companii de consultanță, dezvoltatori de software care folosesc produsele noastre în livrările lor.",
                bp2: "STRATEGIA",
                p5: "Strategia noastră este să fim recunoscuți atât de furnizori, cât și de revânzători ca un distribuitor IT de top, datorită experienței noastre vaste, competenței înalte și prezenței în diferite țări ale lumii.",
                bp3: "MISIUNEA",
                p6: "Misiunea noastră este să oferim partenerilor noștri soluții inovatoare și produse de calitate la timp",
                p7: "Lucrăm cu dedicație pentru a promova produse și soluții tehnologice pentru a satisface cererea în creștere a pieței și pentru a adăuga valoare atât furnizorului, cât și revânzătorului, prin disponibilitatea promptă a produselor și cunoașterea aprofundată a produsului.",
                p8: "MUK lucrează sistematic pentru a crea cerere și lansare de produse, precum și pentru a genera oportunități profitabile pentru revânzătorii noștri printr-un program de afiliere, un lanț de aprovizionare eficient și instruire.",
                p9: "Ne străduim să menținem un mediu care sa dăm putere oamenilor noștri, sa le recunoaștem realizările și sa îi ajutăm să se adapteze la un mediu de afaceri în continuă schimbare. MUK motivează angajații pentru o creștere personală și profesională durabilă.",
                bp4: "PARTENERIAT ȘI RESPONSABILITATE",
                p10: "MUK aderă la un model de afaceri exclusiv de  parteneriat. Nu lucrăm cu clienții finali și ne bazăm pe dezvoltarea rețelei de dealeri. Printre clienții finali ai partenerilor noștri se numără toate sectoarele de afaceri interne: retail, industrie, finanțe și sectorul public.",
                p11: "Împărtășim responsabilitatea obținerii succesului cu partenerii noștri. Credo-ul nostru: „Daca mergem împreună -  suntem împreună până la capăt”. Ne sprijinim partenerii în situații dificile și sărbătorim împreună victoriile și, după cum a demonstrat experiența, avem mult mai multe victorii comune decât înfrângeri.",
                p12: "Cu mulți ani de muncă, MUK și-a dovedit viabilitatea strategiei sale cu mai mulți furnizori, în care toți furnizorii din portofoliul nostru au șanse egale de a se dezvolta și de a lucra într-un mediu de piață competitiv. Noi rezervăm dreptul partenerilor de a alege o strategie de lucru la proiecte, ajutând în același timp la crearea de soluții complexe, oferind consiliere pe întregul ciclu de vânzări: de la eliminarea sarcinilor până la implementare și întreținere.",
                bp5: "VALORILE NOASTRE",
                p13: "MUK se concentrează pe deplin pe sporirea succesului partenerilor săi de afaceri și al angajaților săi prin aderarea la valorile inovației, responsabilitatea, integritatea, șansele egale și munca în echipă, respectul, învățarea și responsabilitatea socială.",
                bp6: "Șanse egale de angajare",
                p14: "Luăm în considerare cererile de angajare de la candidați fără a ține cont de rasă, sex, religie, culoare a pielii, origine etnică, vârstă, identitate și expresie de gen, dizabilitate, orientare sexuală, statut de veteran sau alți factori care nu au legătură cu calificarea pentru o anumită poziție.",
                bp7: "Inovaţie",
                p15: "Căutăm în mod constant modalități mai bune de a oferi beneficii clienților, furnizorilor și colegilor noștri. Anticipăm schimbări în crearea proactivă a soluțiilor potrivite pentru ei.",
                bp8: "Responsabilitati",
                p16: "Spunem ceea ce facem și facem ceea ce spunem. Obținem în mod constant rezultate care îndeplinesc sau depășesc așteptările partenerilor și furnizorilor noștri.",
                bp9: "Integritate",
                p17: "Menținem cele mai înalte standarde etice demonstrând integritate și corectitudine în fiecare acțiune pe care o întreprindem, oriunde și în orice moment.",
                bp10: "Munca in echipa si respect",
                p18: "Respectăm drepturile și convingerile colegilor, partenerilor și societății. Îi tratăm pe ceilalți cu cel mai înalt nivel de demnitate, egalitate și încredere folosind diversitatea pentru a ne atinge obiectivele comune. Ca o echipă facem mai mult decât individual.",
                bp11: "Training",
                p19: "Învățăm constant să creștem productivitatea și să asigurăm creșterea companiei noastre.",
                bp12: "Responsabilitati sociale",
                p20: "Căutăm în mod activ modalități de a ne echilibra responsabilitățile financiare, sociale și ecologice pentru a obține rezultate pozitive pentru diferite părți interesate din întreaga lume. Pe această cale ne străduim spre cooperare, transparență și inovație.",
                bp13: "DE CE MUK ?",
                p21: "Cu MUK, partenerii noștri obțin un distribuitor de încredere și un avantaj competitiv semnificativ.",
                p22: "Partenerii noștri se adaptează cu ușurință la tendințele de schimbare ale pieței, remarcând flexibilitatea serviciilor MUK. Deoarece lucrăm cu cei mai progresi furnizori, clienții noștri găsesc mereu noi oportunități de a-și dezvolta afacerea.",
                p23: "Opțiunile noastre flexibile de finanțare sunt concepute pentru clienții noștri, fie că este vorba de o soluție personalizată sau de linii de credit dedicate, facilităm partenerilor să facă afaceri.",
                p24: "Rezolvăm toate problemele apărute cu ajutorul account-managerilor dedicați și specialiștilor de produse alocați pentru diferiti Vendori. Toate cunoștințele de care aveți nevoie sunt adunate într-un singur loc, iar pregătirea noastră profesională și suportul extins de marketing înseamnă că puteți fi sigur în tot ceea ce facem.",
                p25: "MUK este o companie cu experiență care vă oferă flexibilitate și receptivitate la nevoile afacerii și ale clienților dumneavoastră.",
                p26: "Gama noastră de inițiative comerciale vă garantează o calitate excelentă a muncii. De asemenea, ne putem ajuta clienții să beneficieze de logistică internațională cu experiență, centre de instruire și service, departament de produse cloud.",
                p27: "Știm mai bine decât oricine că un flux de lucru bun înseamnă vânzări bune și înțelegem că receptivitatea, proactivitatea și gestionarea riscurilor sunt o parte importantă a afacerii de succes a partenerului nostru și a reputației acestora în rândul clienților. Prin urmare, am creat instrumente electronice care vă îmbunătățesc procesele de afaceri și simplifică viteza de interacțiune.",
                p28: "Vă ajutăm să vă creșteți veniturile și profitabilitatea la fiecare pas."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Daca aveti careva intrebari?",
                description: "Vă rugăm să completați următorul formular pentru a ne trimite un e-mail și vă vom contacta în cel mai scurt timp posibil.",
                send: "Trimite",
                nm: "Nume",
                ad: "Adresa",
                ph: "Numar de telefon",
                em: "Email",
                ms: "Mesaj",
                contactInfo: "Detalii contact",
                address: "16/2 Donetska str., Kyiv 03151, Ukraine",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "All rights reserved."
            }
        }
    }

    if (lang === "mn") {
        text = {
            Navigation: [
                {
                    menu: "Улс орнууд",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Албани",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Армен",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Азербайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорват",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Гүрж",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Киргиз",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдав",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Монгол",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Серби",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словени",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Тажикстан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Турк",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Туркменистан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/hu",
                            name: "Унгар",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ua",
                            name: "Украин",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Шийдэл",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK борлуулагчид"
                        },
                        {
                            link: "/solutions",
                            name: "MUK шийдлүүд"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Бүтээгдэхүүн, үйлчилгээний каталог"
                        }
                    ]
                },
                {
                    menu: "Мэдээ",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Мэдээ, хямдрал"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK сэтгүүл"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Видео"
                        }
                    ]
                },
                {
                    menu: "Чиглэл",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Мэдээллийн технологийн дистрибьюшн"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Сургалтын төв"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Үйлчилгээний төв"
                        },
                        {
                            link: "https://cloud.muk.mn/",
                            name: "MUK Cloud үйлчилгээ"
                        }
                    ]
                },
                {
                    menu: "Компанийн тухай",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK-ийн талаархи үндсэн мэдээлэл"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Байгууллагын профайл"
                        },
                        {
                            link: "/vacancies",
                            name: "Ажлын байр"
                        }
                    ]
                },
                {
                    menu: "Дилерийн хэсэг",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албани",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Армен",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Азербайжан",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хорват",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Гүрж",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Казахстан",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Киргиз",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдав",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Монгол",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Серби",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словени",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Тажикстан",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Турк",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туркменистан",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Украин",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Узбекистан",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Олон улсын төслийн VAD IT дистрибьютер",
                paragraph: "MUK-ийн түншүүд нь олон үйлдвэрлэгчтэй хамтран ажилладаг мэдээллийн технологийн найдвартай дистрибьютерийг биднээс харж, бидний олон жилийн туршлага, техникийн туршлага, тогтсон түншлэлийн ажилд итгэдэг.",
                partner: "Түнш болох"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Олон улсын дистрибьютер",
                    text: "Газарзүй нь Европ, Азийн 16 улсыг багтаасан бөгөөд улам өргөжиж байна"
                },
                {
                    icon: "fa fa-star",
                    title: "25 гаруй жилийн амжилт",
                    text: "МУК нь 1997 оноос хойш тэргүүлэх байр суурь эзлэж байна"
                },
                {
                    icon: "fa fa-users",
                    title: "Давтагдашгүй дүн шинжилгээ",
                    text: "MUK-ийн чадварлаг инженерүүдийн баг хамгийн төвөгтэй ажлыг ч даван туулж чадна"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ гаруй үйлдвэрлэгч",
                    text: "MUK дистрибьютерийн багцад олон улсын 100 гаруй А брэндүүд багтсан бөгөөд тасралтгүй өссөөр байна."
                }
            ],
            ServicesInfo: {
                title: "MUK үйл ажиллагааны хамрах хүрээ"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Мэдээллийн технологийн тархалт",
                    text: "MUK бол мэдээллийн технологийн төслийн бизнест чиглэсэн VAD борлуулагч юм. Бид 25 жил гаруйн хугацаанд Европ, Азид дилерийн сүлжээг амжилттай хөгжүүлж байна. \nМэргэшсэн мэргэжилтнүүдийн тусламжтайгаар MUK компани нь түншүүддээ төслийн өндөр түвшний зөвлөгөө, техникийн дэмжлэг үзүүлж, санал болгож буй шийдлүүдэд нэмэлт үнэ цэнийг бий болгодог.\nMUK-ийн инженерүүд програм хангамж, техник хангамжийн шийдлүүдэд зөвлөх, техникийн дэмжлэг үзүүлж, аудит хийдэг. Одоо байгаа системүүдийн талаар болон туршилтын ажлыг хэрэгжүүлэхэд тусладаг. Туршилтын тоног төхөөрөмжийн нөөц нь бидэнд бодит нөхцөлд өргөн хүрээний даалгавруудыг загварчилж, хэрэгжүүлэх боломжийг олгодог. \nMUK нь интеграторуудад оновчтой шийдлүүдийг сонгох, боловсруулахад идэвхтэй тусалдаг.\nMUK-ийн багт төрөл бүрийн технологийн чиглэлээр ажилладаг 500 гаруй мэргэжилтнүүд багтдаг бөгөөд тэдгээр нь дэлхийн тэргүүлэгч мэдээллийн технологийн үйлдвэрлэгчдээс баталгаажсан байдаг.",
                    activ1: "Олон улсын ложистик, нөөц агуулах бүрдүүлэх",
                    activ2: "Түншүүдэд маркетинг, зөвлөх үйлчилгээ үзүүлэх",
                    activ3: "Өөрийн мэргэжлээр дамжуулан шийдлийн үнэ цэнийг нэмэгдүүлэх",
                    activ4: "Бүтээгдэхүүний нээлт, сурталчилгаа, эрэлтийг бий болгох",
                    activ5: "Техникийн дэмжлэг, баталгаат хугацаа, баталгаат хугацааны дараах үйлчилгээ",
                    activ6: "Түншийн сүлжээг хөгжүүлэх"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider Cloud бүтээгдэхүүн",
                    text: "MUK Cloud Solutions for Business нь орчин үеийн аюулгүй хамтын ажиллагааны хэрэгслээр хангаснаар бизнесийн тасралтгүй байдлыг хангах, ажилчдын ажлын үр ашиг, хөдөлгөөнийг нэмэгдүүлэхэд чиглэгдсэн шийдэл, үйлчилгээний хурд бүхий багц юм.\nТэдгээрийн тусламжтайгаар та үүлэн технологид суурилан ажлаа хурдан шуурхай бөгөөд үр дүнтэй хэрэгжүүлэх боломжтой. танай байгууллагын дэд бүтэц. Cloud Solution Provider концепци нь Microsoft Office 365, AZURE, EMS, D365 болон бусад үүлэн үйлчилгээг сар бүр төлж авах боломжтой борлуулалтын суваг юм.\nMUK нь \"эхнээс нь\" дэд бүтцийг бий болгохыг санал болгож байна. Хамгийн бага хөрөнгийн зардал. Үүлний нөөцийг (зай) түрээслэх, засвар үйлчилгээ хийхэд хамгийн оновчтой үйл ажиллагааны ухаалаг зардал. Дэд бүтцийн өргөтгөл (аж ахуйн нэгжийн өсөлт, шинэ оффисууд, төлөвлөсөн ачааллын тэсрэлт). Газрын дэд бүтэцтэй нэгтгэсэн үүлэн дэх шинэ үйлчилгээнүүд.",
                    activ1: "Нөөцлөлтийг (файл, виртуал машин, мэдээллийн сан) үүлэн дээр хадгалах.",
                    activ2: "Гэмтлийн хамгаалалт, сэргээх. Виртуал машин эсвэл SQL мэдээллийн сангийн түвшинд өндөр хүртээмжтэй кластер үүсгэх.",
                    activ3: "Мобайл төхөөрөмжийн удирдлага.",
                    activ4: "Байгууллагын мэдээлэл, захидал харилцааны хамгаалалт",
                    activ5: "SharePoint on-line, Exchange on-line, Skype for business онлайн нээлт.",
                    activ6: "Вэбсайтуудыг байршуулах, тохируулах, вэбсайтуудыг үүл рүү шилжүүлэх."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK үйлчилгээний төв.",
                    text: "MUK Service компани нь 2002 оноос хойш компьютер засварын үйлчилгээг амжилттай үзүүлж ирсэн бөгөөд өнөөдөр APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom болон бусад үйлдвэрлэгч компаниудын үйлчилгээний эрхтэй төв юм. MUK-Service компанийн чанарын удирдлагын тогтолцоо нь Олон улсын ISO 9001 гэрчилгээгээр баталгаажсан.\nАливаа эвдрэлийг арилгахад жинхэнэ мэргэжлийн хүн хэрэгтэй. Өдөр тутмын дадлага хийснээр өндөр туршлагатай болсон манай засварчид аливаа эвдрэлийг түргэн шуурхай арилгадаг. Мэргэжлийн ур чадвар туршлагаар ирдэг, бид өөрсдийгөө сайжруулж, мэдлэгийнхээ түвшинг үргэлж дээшлүүлдэг. Үйлчилгээний төвийн ажилтнууд нь мэргэшсэн мэргэжилтнүүдээс бүрддэг бөгөөд энэ нь үйлчлүүлэгчдэд өндөр чанартай, мэргэжлийн тоног төхөөрөмжийн засвар үйлчилгээг баталгаатай үзүүлдэг. MUK Service нь чанартай үйлчилгээ үзүүлэх техникийн бүхий л боломжуудтай. Үйлчилгээний төв нь аливаа түвшний нарийн төвөгтэй засвар үйлчилгээ, баталгаат болон баталгаат бус засварыг гүйцэтгэдэг. MUK Service компани нь Украин, Армени, Гүрж, Молдав, Тажикистан, Казахстан зэрэг улсын байгууллагын үйлчлүүлэгчдэд зориулсан тоног төхөөрөмжийн түрээс, аутсорсинг, суурилуулалт, засвар үйлчилгээ, мэдээлэл, зөвлөх үйлчилгээ үзүүлдэг.",
                    activ1: "Баталгаат засвар",
                    activ2: "Баталгаат бус засвар",
                    activ3: "Тоног төхөөрөмжийн оношлогоо",
                    activ4: "Сэлбэг хэрэгслийн худалдаа",
                    activ5: "Үйлчилгээний гэрээний аудит",
                    activ6: "Тоног төхөөрөмжийн түрээс, аутсорсинг"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK сургалтын төв",
                    text: "MUK сургалтын төв нь 15-аас дээш жилийн туршлагатай, хэд хэдэн өвөрмөц зөвшөөрөлтэй, чадварлаг багш нарын баг, орчин үеийн сургалтын дэд бүтэцтэй мэдээллийн технологийн боловсролын үйлчилгээний зах зээлд тэргүүлэгч юм.\nMUK TC-ийн багцад мэдээллийн технологийн тэргүүлэгч компаниудын 300 гаруй сургалт багтсан болно.\n Үүний дотор Pearson VUE, Veeam эрх бүхий боловсролын төв, HPE боловсролын төв, VMware эрх бүхий сургалтын төв, Oracle-ийн зөвшөөрөгдсөн боловсролын үйлчилгээ үзүүлэгч, Пента аюулгүй байдлын боловсролын төв, Juniper Networks боловсролын эрх бүхий түнш, LearnQuest IBM боловсролын түнш, Microsoft боловсролын мөнгөн түнш, ITIL сургалтын түнш, Dell-EMC боловсролын үйлчилгээний түнш, Autodesk сургалтын төв, Grandstream сургалтын төв, Check Point эрх бүхий сургалтын төв, Fortinet эрх бүхий сургалтын төв, CommScope сургалтын төв, Cisco сургалтын төв, Red Hat-ийн гэрчилгээтэй сургалтын түнш гэдгийг онцлох хэрэгтэй.\nMUK сургалтын төв нь хамгийн орчин үеийн боловсролын тоног төхөөрөмжтэй сургалтын чанар нь Украин болон гадаад дахь оюутнуудын өндөр үнэлгээгээр нотлогдсон."
                }
            ],
            Vendors: {
                title: "MUK борлуулагчид",
                country: "Улс",
                solution: "Шийдэл",
                name: "Нэр",
                all: "Бүгд",
                namePlaceholder: "Худалдаалагчийн нэрийг бичиж эхлээрэй",
                notInfo: "Мэдээлэл бөглөгдөөгүй байна"
            },
            VendorsForCountry: {
                title: "MUK борлуулагчид тус улсад байдаг"
            },
            VendorsForSolution: {
                title: "MUK борлуулагчид шийдлээр"
            },
            VendorDetail: {
                title: "ЭРХ БҮХИЙ ДИСТРИБЬЮТЕР"
            },
            Gallery: {
                title: "MUK шийдлүүд"
            },
            Distribution: {
                title: "Мэдээллийн технологийн тархалт"
            },
            Partner: {
                title: "Түнш болох",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Илгээх",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK бизнесээ түншлэл, хамтын ажиллагааны зарчмаар байгуулдаг",
                advantages: "Ашиг тус",
                paragraph: "МУК байгуулагдсан цагаасаа эхлэн ханган нийлүүлэгч, үйлчлүүлэгчидтэй харилцах харилцаагаа ил тод байлгахад анхаарч ирсэн. Нөхөрлөлийн дүрэмд үнэнч байх нь МУК-д зах зээлийн итгэлийг олж, лидерийн нэр хүндийг бий болгох боломжийг олгосон.",
                Why: [
                    "Инноваци",
                    "Хариуцлага",
                    "Шударга байдал",
                    "Ажил эрхлэлтийн тэгш боломж"

                ],
                Why2: [
                    "Багийн ажил, хүндэтгэл",
                    "Сургалт",
                    "Нийгмийн хариуцлага"
                ]
            },
            News: {
                title: "MUK мэдээ",
                showAll: "Дэлгэрэнгүй харуулах",
                showMore: "Нэмэлтээр харуулах",
                news: "Мэдээ",
                akcii: "Гэрээ"
            },
            Vacancies: {
                title: "MUK нээлттэй ажлын байр",
                resume: "Send a CV",
                country: "Улс",
                all: "Бүгд",
                search: "Хайх",
                namePlaceholder: "Нэрийг нь оруулж эхлээрэй",
                filterInfo: "Эдгээр шүүлтүүрт тохирох сул орон тоо алга",
                notInfo: "Мэдээлэл бөглөөгүй байна",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" сэтгүүлийн дугаарууд",
                vupysk: "Дугаар"
            },
            OMuk: {
                title: "MUK-ийн талаархи үндсэн мэдээлэл",
                p1: "MUK групп компаниуд нь 1997 онд үйл ажиллагаагаа эхлүүлсэн. Бидний ажлын үндсэн чиглэл нь холимог хосолсон болон үүлэн шийдэл, дата төвийн конвергенц, мэдээллийн аюулгүй байдал, хөдөлгөөнт төхөөрөмж, интернетийн чиглэлээр тэргүүлэгч IT бүтээгдэхүүнийг төсөлд суурилан түгээх, өгөгдлийн аналитик ба хиймэл оюун ухааныг хөгжүүлэх.",
                p2: "Дэлхийн даяр түгсэн дистрибьютерийн сүлжээнийхээ ачаар бид ирээдүйтэй мэдээллийн технологийн үйлдвэрлэгчид болон тэдний шинэ бүтээгдэхүүнийг орон нутгийн зах зээлд гаргаж, эрэлтийг бүрдүүлэхэд идэвхтэй оролцдог.",
                p3: "Бид мэргэжилтнүүдийн техникийн болон зах зээлийн мэдлэгийг дэвшилтэт түншийг дэмжих хөтөлбөртэй хослуулдаг. Бид дилерүүдтэйгээ нягт хамтран ажиллаж, тэдний динамик өсөлт, хөгжлийг хангах, хамтдаа үр дүнд хүрэхийг эрмэлздэг.",
                bp1: "БИД БОЛ МЭДЭЭЛЛИЙН ТЕХНОЛОГИ!",
                p4: "MUK компани нь 25 гаруй жилийн турш мэдээллийн технологийн дистрибьюшнийг хэрэгжүүлж эхэлсэн анхдагч компани юм. Өнөөдөр МУК нь технологи хөгжүүлэгчийг хэрэглэгчидтэй холбоход чухал үүрэг гүйцэтгэж байна.",
                ul: "MUK-ийг найдвартай түнш, үр ашигтай борлуулагч гэж тодорхойлсон дөрвөн тоо энд байна:",
                li1: "1. 25-өөс дээш жилийн туршлага, итгэлцэл.",
                li2: "2. А-брэндийн 100 гаруй борлуулагчид (дэлхийд алдартай, баталгаатай бүтээгдэхүүнтэй компаниуд).",
                li3: "3. Борлуулагчийн бүс бүр өөрийн гэсэн менежер, борлуулалтын өмнөх үйлчилгээ үзүүлэх мэргэжилтнүүд болон инженерүүдтэй. Манай инженер техникийн ажилтнуудын баг 500 гаруй мэргэжилтнүүдээс бүрддэг.",
                li4: "4. Одоогийн байдлаар бид 4000 гаруй идэвхтэй түншүүдэд үйлчилж байна, үүнд зөвхөн сонгодог мэдээллийн технологийн интеграторууд төдийгүй үйлдвэрлэлийн аж ахуйн нэгжүүд, барилгын компаниуд, зөвлөх компаниуд, манай бүтээгдэхүүнийг хүргэхдээ ашигладаг програм хангамж хөгжүүлэгчид орно.",
                bp2: "СТРАТЕГИ",
                p5: "Бидний стратеги бол дэлхийн олон улс орнуудад туршлага, өндөр ур чадвар, идэвх, оролцооныхоо ачаар ханган нийлүүлэгчид болон борлуулагчидийн хүлээн зөвшөөрсөн  мэдээллийн технологийн манлайлагч дистрибьютер гэдгээрээ хүлээн зөвшөөрөгдөх явдал юм.",
                bp3: "ЭРХЭМ ЗОРИЛГО",
                p6: "Бидний эрхэм зорилго бол түншүүдээ шинэлэг шийдэл, чанартай бүтээгдэхүүнээр цаг тухайд нь хангах явдал юм",
                p7: "Бид өсөн нэмэгдэж буй зах зээлийн эрэлт хэрэгцээг хангах технологийн бүтээгдэхүүн, шийдлүүдийг сурталчлахын төлөө тууштай ажиллаж, бүтээгдэхүүний бэлэн байдал, бүтээгдэхүүний гүнзгий мэдлэгээр ханган нийлүүлэгч болон борлуулагчдад үнэ цэнийг нэмэгдүүлэх болно.",
                p8: "MUK нь түншлэлийн хөтөлбөр, үр ашигтай нийлүүлэлтийн сүлжээ, сургалтаар дамжуулан манай борлуулагчдад ашигтай боломжуудыг бий болгохын зэрэгцээ бүтээгдэхүүний эрэлт,  хэрэгцээг бий болгохын тулд системтэй ажиллаж байна.",
                p9: "Бид хүмүүсээ чадавхжуулах, тэдний ололт амжилтыг хүлээн зөвшөөрөх, байнга өөрчлөгдөж буй бизнесийн орчинд дасан зохицоход нь туслах орчныг хадгалахыг эрмэлздэг. MUK нь ажилчдыг хувийн болон мэргэжлийн тогтвортой өсөлтөд нь урамшуулдаг.",
                bp4: "ТҮНШЛЭЛ, ХАРИУЦЛАГА",
                p10: "MUK нь зөвхөн түншийн бизнесийн загварыг баримталдаг. Бид эцсийн үйлчлүүлэгчидтэй ажилладаггүй бөгөөд дилерийн сүлжээг хөгжүүлдэг. Манай түншүүдийн эцсийн үйлчлүүлэгчдийн дунд жижиглэн худалдаа, аж үйлдвэр, санхүү, төрийн салбар гэх мэт дотоодын бизнесийн бүх салбарууд байдаг.",
                p11: "Бид түншүүдтэйгээ амжилтанд хүрэх үүрэг хариуцлагыг хуваалцдаг. Бидний итгэл үнэмшил: \"Хамтдаа явна гэдэг нь эцсээ хүртэл хамт гэсэн үг .\" Бид хүнд хэцүү нөхцөлд түншүүдээ дэмжиж, ялалтыг хамтдаа тэмдэглэдэг бөгөөд туршлагаас харахад ялагдал гэхээсээ илүү нийтлэг ялалтууд байдаг.",
                p12: "MUK нь олон жилийн ажлынхаа үр дүнд манай багцын бүх борлуулагчид зах зээлийн өрсөлдөөнт орчинд хөгжиж, ажиллах тэгш боломжийг олгодог олон үйлдвэрлэгчийн стратеги хэрэгжих боломжтойг нотолсон. Бид түншүүддээ төсөл дээр ажиллах стратеги сонгохын зэрэгцээ нарийн төвөгтэй шийдлүүдийг бий болгоход тусалж, борлуулалтын бүх мөчлөгийн талаар зөвлөгөө өгөх эрхтэй: даалгавар авахаас эхлээд хэрэгжүүлэх, засвар үйлчилгээ үзүүлэх хүртэл.",
                bp5: "БИДНИЙ ҮНЭ ЦЭНЭ",
                p13: "MUK нь инноваци, хариуцлага, үнэнч шударга байдал, тэгш боломж ба багаар ажиллах, хүндэтгэл, суралцах, нийгмийн хариуцлага гэсэн үнэт зүйлсийг баримтлан бизнесийн түншүүд, ажилчдынхаа амжилтыг дээшлүүлэхэд бүх анхаарлаа хандуулдаг.",
                bp6: "Ажил эрхлэлтийн тэгш боломж",
                p14: "Бид нэр дэвшигчдийн ажилд орох хүсэлтийг арьс өнгө, хүйс, шашин шүтлэг, арьсны өнгө, үндэс угсаа, нас, хүйсийн баримжаа, илэрхийлэл, хөгжлийн бэрхшээл, бэлгийн чиг хандлага, ахмад дайны байдал болон тодорхой албан тушаалд тэнцэхтэй холбоогүй бусад хүчин зүйлээс үл хамааран авч үздэг.",
                bp7: "Инноваци",
                p15: "Бид үйлчлүүлэгчид, ханган нийлүүлэгчид болон хамтран ажиллагсаддаа ашиг тусаа өгөх илүү сайн арга замыг байнга эрэлхийлж байдаг. Тэдэнд тохирсон шийдлүүдийг идэвхтэй бий болгодог ба өөрчлөлтийг авчирдаг.",
                bp8: "Хариуцлага",
                p16: "Бид хийх зүйлээ хэлдэг, хэлсэн зүйлээ хийдэг. Бид түншүүд болон ханган нийлүүлэгчдийнхээ хүлээлтийг хангасан эсвэл давсан үр дүнд байнга хүрдэг",
                bp9: "Шударга байдал",
                p17: "Бид хаана ч, хэзээ ч хийж буй үйлдэл бүрдээ шударга байж, шударга ёсыг харуулдаг ба ёс зүйн дээд хэм хэмжээг баримталдаг.",
                bp10: "Багийн ажил, хүндэтгэл",
                p18: "Бид хамтран ажиллагсад, түншүүд, тэгш эрх, итгэл үнэмшлийг хүндэтгэдэг. Бид нийтлэг зорилгодоо хүрэхийн тулд олон талт байдлыг ашиглан бусад хүмүүст дээд зэргийн нэр төр, тэгш эрх, итгэлцлээр ханддаг. Багийн хувьд бид хувь хүнээс илүү ихийг хийдэг.",
                bp11: "Сургалт",
                p19: "Бид бүтээмжийг нэмэгдүүлэх, компанийнхаа болон өөрийнхөө өсөлтийг хангахын тулд байнга суралцаж байна",
                bp12: "Нийгмийн хариуцлага",
                p20: "Бид дэлхий даяар бүх сонирхогч талуудад адил тэгш эерэг үр дүнд хүрэхийн тулд тогтвортой санхүү, нийгэм, экологийн үүрэг хариуцлага хүлээж тэнцвэржүүлэх арга замыг байнга эрэлхийлдэг. Энэ замд бид хамтын ажиллагаа, ил тод байдал, инновацийг эрмэлздэг.",
                bp13: "ЯАГААД MUK гэж?",
                p21: "MUK-ийн тусламжтайгаар манай түншүүд найдвартай борлуулагчтай болж, өрсөлдөхүйц давуу талыг олж авдаг",
                p22: "Манай түншүүд өөрчлөгдөж буй зах зээлийн чиг хандлагад амархан дасан зохицож, MUK-ийн үйлчилгээний уян хатан байдлыг тэмдэглэж байна. Бид хамгийн дэвшилтэт ханган нийлүүлэгчидтэй хамтран ажилладаг тул үйлчлүүлэгчид маань бизнесээ өргөжүүлэх шинэ боломжийг үргэлж олж хардаг",
                p23: "Манай уян хатан санхүүжилтийн сонголтууд нь тусгайлсан зээлийн шийдэл эсвэл нэг хэрэглэгчид зориулсан зээлийн шугам гэх мэт үйлчлүүлэгчиддээ зориулагдсан уян хатан санхүүжилтийг хэрэгжүүлдэг. Бид түншүүдийнхээ бизнес хийх нөхцлийг улам хялбар болгодог.",
                p24: "Бид гарч буй бүх асуудлыг борлуулагч тус бүрт хуваарилагдсан менежерүүд болон бүтээгдэхүүний мэргэжилтнүүдийн тусламжтайгаар шийддэг. Танд хэрэгтэй бүх мэдлэгийг нэг дор цуглуулдаг бөгөөд бидний мэргэжлийн сургалт, маркетингийн өргөн дэмжлэг нь бидний хийж буй бүх зүйлд итгэлтэй байх болно гэсэн үг юм.",
                p25: "MUK бол таны бизнес болон үйлчлүүлэгчдийнхээ хэрэгцээнд уян хатан, хариу үйлдэл үзүүлэх туршлагатай компани юм.",
                p26: "Манай бизнесийн санаачилга нь танд ажлын маш сайн чанарыг баталгаа болгодог. Мөн бид үйлчлүүлэгчдэдээ олон улсын туршлагатай ложистик, сургалт, үйлчилгээний төв, үүлэн бүтээгдэхүүний хэлтсээс шаардлагатай ашиг тус хүртэхэд нь тусалдаг.",
                p27: "Сайн ажлын процесс нь сайн борлуулалт гэсэн үг гэдгийг бид хэнээс ч илүү сайн мэддэг бөгөөд хариу үйлдэл, идэвхтэй байдал, эрсдэлийн менежмент нь манай түншийн амжилттай бизнес болон үйлчлүүлэгчидтэй харилцах нэр хүндийн чухал хэсэг гэдгийг бид ойлгодог. Тиймээс бид таны бизнесийн үйл явцыг сайжруулж, харилцан үйлчлэлийн хурдыг хялбаршуулах цахим хэрэгслүүдийг бүтээсэн.",
                p28: "Бид алхам тутамдаа таны орлого, ашгийг нэмэгдүүлэхэд тусалдаг"

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Хэрэв танд асуулт байвал?",
                description: "Дараах маягтыг бөглөж бидэнд и-мэйл илгээнэ үү, бид тантай аль болох хурдан холбогдох болно.",
                send: "Илгээх",
                nm: "Нэр",
                ad: "Хаяг",
                ph: "Утас",
                em: "И-мэйл",
                ms: "Захиа",
                contactInfo: "Холбоо барих мэдээлэл",
                address: "Украин, Киев 03151, Донецкийн гудамж 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Бүх эрх хуулиар хамгаалагдсан."
            }
        }
    }

    if (lang === "si") {
        text = {
            Navigation: [
                {
                    menu: "Države",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albanija",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenija",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbajdžan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Hrvaška",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Gruzija",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazahstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kirgizistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/hu",
                            name: "Madžarsk",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/md",
                            name: "Moldavija",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolija",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Srbija",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenija",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapur",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tadžikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turčija",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukrajina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Rešitve",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK vendorji"
                        },
                        {
                            link: "/solutions",
                            name: "MUK rešitve"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Katalog produktov in rešitev"
                        }
                    ]
                },
                {
                    menu: "Novice",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Novice in dogovori"
                        },
                        {
                            link: "/muk-review",
                            name: "Revija MUK"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Področja",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "Distribucija IT"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Center za usposabljanje"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Servisni center"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "Storitve v oblaku MUK"
                        }
                    ]
                },
                {
                    menu: "O podjetju",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Glavne informacije o MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Profil podjetja"
                        },
                        {
                            link: "/vacancies",
                            name: "Službe"
                        }
                    ]
                },
                {
                    menu: "Oddelek za trgovce",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albanija",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenija",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbajdžan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Hrvaška",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Gruzija",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazahstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kirgizistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldavija",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolija",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Srbija",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenija",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tadžikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turčija",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukrajina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Mednarodni projekt VAD IT distributer",
                paragraph: "Partnerji MUK v nas vidijo zanesljivega IT distributerja z več ponudniki, zaupajo našim dolgoletnim izkušnjam, tehničnemu strokovnemu znanju in uveljavljenemu partnerskemu delu",
                partner: "Postanite partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Mednarodni distributer",
                    text: "Naše podjetje je prisotno v 16 državah Evrope in Azije in se še naprej širi"
                },
                {
                    icon: "fa fa-star",
                    title: "Več kot 25 let uspeha",
                    text: "MUK ima vodilni položaj od leta 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Edinstveno strokovno znanje",
                    text: "Ekipa inženirjev se lahko spopade tudi z najbolj zapleteno nalogo"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ proizvajalcev",
                    text: "Portfelj distributerja MUK vsebuje več kot 100 mednarodnih A-blagovnih znamk in se nenehno povečuje"
                }
            ],
            ServicesInfo: {
                title: "MUK obseg dejavnosti"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "Distribucija IT",
                    text: "MUK je distributer VAD, osredotočen na poslovanje IT projektov. Že več kot 25 let uspešno razvijamo zastopniško mrežo v Evropi in Aziji. \nS pomočjo osebja certificiranih strokovnjakov podjetje MUK partnerjem zagotavlja visoko raven projektnega svetovanja in tehnične podpore, ki ustvarja dodatno vrednost za predlagane rešitve.\nInženirji MUK nudijo svetovanje in tehnično podporo za programske in strojne rešitve, izvajajo revizije obstoječih sistemov in pomoč pri implementaciji testnih miz. Naša zaloga testne opreme nam omogoča simulacijo in izvedbo širokega spektra nalog v realnih pogojih. \nMUK aktivno pomaga integratorjem pri izbiri in oblikovanju optimalnih rešitev.\nMUK ekipa vključuje več kot 500 strokovnjakov na različnih tehnoloških področjih, ki so certificirani s strani vodilnih svetovnih proizvajalcev IT",
                    activ1: "Mednarodna logistika, oblikovanje zalog",
                    activ2: "Marketinška in svetovalna podpora partnerjem",
                    activ3: "Povečanje vrednosti rešitev z lastnim strokovnim znanjem",
                    activ4: "Predstavitev izdelkov, promocija in ustvarjanje povpraševanja",
                    activ5: "Tehnična podpora, garancijski in pogarancijski servis",
                    activ6: "Razvoj partnerske mreže"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider Izdelki v oblaku",
                    text: "MUK Cloud Solutions for Business so paketi rešitev in storitev za hitri zagon, katerih cilj je zagotavljanje neprekinjenega poslovanja, povečanje delovne učinkovitosti in mobilnosti zaposlenih z zagotavljanjem sodobnih orodij za varno sodelovanje.\nZ njihovo pomočjo lahko hitro in učinkovito implementirate oblačne tehnologije v infrastrukturo vaše organizacije. Koncept ponudnika rešitev v oblaku je prodajni kanal, v katerem so Microsoft Office 365, AZURE, EMS, D365 in druge storitve v oblaku, na voljo na podlagi mesečnega plačila.\nMUK ponuja ustvarjanje infrastrukture \"iz nič\". Minimalni stroški kapitala. Optimalni obratovalni stroški za najem virov v oblaku in vzdrževanje. Skaliranje infrastrukture (rast podjetja, novi teritorialni uradi, načrtovani izbruhi obremenitve). Nove storitve v oblaku, integrirane z zemeljsko infrastrukturo.",
                    activ1: "Shranjevanje varnostnih kopij (datoteke, virtualni stroji, baze podatkov) v oblaku",
                    activ2: "Zaščita pred zlomom sistema, obnovitev. Gruča visoke razpoložljivosti na ravni virtualnih strojev ali baz podatkov SQL",
                    activ3: "Upravljanje mobilnih naprav",
                    activ4: "Zaščita korporativnih informacij in korespondence",
                    activ5: "SharePoint on-line, Exchange on-line, Skype za podjetja on-line uvajanje",
                    activ6: "Postavitev in nastavitev spletnih strani, selitev spletnih strani v oblak"
                },
                {
                    icon: "fa fa-wrench",
                    name: "Servisni center MUK",
                    text: "Podjetje MUK Service že od leta 2002 uspešno opravlja storitve popravil računalnikov in je danes pooblaščeni servis za APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius , Dell EMC, Tescom in drugi proizvajalci.Sistem vodenja kakovosti podjetja MUK-Service je potrjen s certifikatom ISO 9001 Urada za mednarodno certificiranje.\nPotreben je pravi profesionalec, da odpravi morebitno okvaro. Z nabiranjem izkušenj in vsakodnevne prakse naši serviserji odpravijo vsako okvaro. MUK Service ima vse potrebne tehnične zmogljivosti za zagotavljanje kakovostne storitve. Servisni center izvaja vzdrževalna, garancijska in negarancijska popravila katere koli stopnje zahtevnosti. Podjetje MUK Service zagotavlja najem opreme in zunanje izvajanje, montažo in vzdrževanje ter informacijske in svetovalne storitve za pravne osebe v Ukrajini, Armeniji, Gruziji, Moldaviji, Tadžikistanu in Kazahstanu.",
                    activ1: "Garancijska popravila",
                    activ2: "Popravilo brez garancije",
                    activ3: "Diagnostika opreme",
                    activ4: "Prodaja rezervnih delov",
                    activ5: "Revizija pogodbe o storitvah",
                    activ6: "Najem opreme in zunanje izvajanje"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Center za usposabljanje MUK",
                    text: "MUK Training Center je vodilni na trgu IT izobraževalnih storitev z več kot 15-letnimi izkušnjami in številnimi edinstvenimi pooblastili, ekipo usposobljenih inštruktorjev in sodobno izobraževalno infrastrukturo.\nPortfelj MUK TC vključuje več kot 300 izobraževalnih tečajev vodilnih IT podjetja. Omembe vredni statusi vključujejo: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner , partner za izobraževalne storitve Dell-EMC, izobraževalni center Autodesk, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.\nMUK Center za usposabljanje ima dostop do najsodobnejše izobraževalne opreme. Kakovost poučevanja s strani naših inštruktorjev za mnoge slušatelje potrjujejo visoke ocene študentov v Ukrajini in tujini."
                }
            ],
            Vendors: {
                title: "Prodajalci MUK",
                country: "Država",
                solution: "Rešitev",
                name: "Ime",
                all: "Vse pravice pridržane",
                namePlaceholder: "Vnesite ime prodajalca",
                notInfo: "Podatki niso izpolnjeni"
            },
            VendorsForCountry: {
                title: "Prodajalci MUK so na voljo v državi"
            },
            VendorsForSolution: {
                title: "Prodajalci MUK z rešitvami"
            },
            VendorDetail: {
                title: "POOBLAŠČENI DISTRIBUTER"
            },
            Gallery: {
                title: "Rešitve MUK"
            },
            Distribution: {
                title: "Distribucija IT"
            },
            Partner: {
                title: "Postanite partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Pošljite",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK svoje poslovanje gradi na načelih partnerstva in sodelovanja",
                advantages: "Prednosti",
                paragraph: "MUK se že od ustanovitve osredotoča na transparentnost odnosov z dobavitelji in kupci. Predanost pravilom partnerstva je MUK-u omogočila, da si pridobi zaupanje trga in zgradi ugled vodilnega",
                Why: [
                    "Inovacije",
                    "Odgovornost",
                    "Integriteta",
                    "Enake zaposlitvene možnosti"

                ],
                Why2: [
                    "Timsko delo in spoštovanje",
                    "Usposabljanje",
                    "Družbena odgovornost"
                ]
            },
            News: {
                title: "MUK novice",
                showAll: "Pokaži več",
                showMore: "Pokaži več",
                news: "Novice",
                akcii: "Dogovor"
            },
            Vacancies: {
                title: "Kariere",
                resume: "Send a CV",
                country: "Država",
                all: "Vse",
                search: "Iskanje",
                namePlaceholder: "Vnesite ime",
                filterInfo: "S temi filtri ne ustreza nobeno delovno mesto",
                notInfo: "Podatki niso izpolnjeni",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" Številke revije",
                vupysk: "Težava"
            },
            OMuk: {
                title: "Glavne informacije o MUK",
                p1: "Skupina podjetij MUK je začela svojo dejavnost leta 1997. Naše glavno področje delovanja je projektno usmerjena distribucija vodilnih IT produktov na področju hibridnih in oblačnih rešitev, konvergence podatkovnih centrov, informacijske varnosti, mobilnih naprav in interneta stvari, analitiko podatkov in umetno inteligenco.",
                p2: "Zahvaljujoč naši globalni distribucijski mreži prinašamo obetavne ponudnike IT in njihove nove izdelke na lokalne trge ter aktivno sodelujemo pri oblikovanju povpraševanja",
                p3: "Združujemo strokovno tehnično in tržno znanje s progresivnim programom podpore partnerjem. V tesnem sodelovanju z našimi trgovci si prizadevamo zagotoviti njihovo dinamično rast in razvoj ter skupaj dosegati rezultate.",
                bp1: "MI SMO INFORMACIJSKA TEHNOLOGIJA!",
                p4: "Podjetje MUK je že več kot 25 let pionir v distribuciji informacijske tehnologije. Danes ima MUK pomembno vlogo pri prenosu tehnologij od tistih, ki ga razvijajo, na tiste, ki ga izvajajo in uporabljajo.",
                ul: "Tu so štiri številke, ki označujejo MUK kot zanesljivega partnerja in učinkovitega distributerja:",
                li1: "1. Več kot 25 let izkušenj in zaupanja.",
                li2: "2. Več kot 100 prodajalcev ravni blagovne znamke A (svetovno znana podjetja s preverjenimi izdelki).",
                li3: "3. Območje vsakega prodajalca ima svoje vodje, predprodajo in inženirje, zato naše osebje sestavlja več kot 500 strokovnjakov.",
                li4: "4. Trenutno služimo več kot 4000 aktivnim partnerjem, vključno z ne le klasičnimi IT integratorji, temveč tudi s proizvodnimi podjetji, gradbenimi podjetji, svetovalnimi podjetji, razvijalci programske opreme, ki uporabljajo naše izdelke pri svojih dobavah.",
                bp2: "STRATEGIJA",
                p5: "Naša strategija je, da nas tako dobavitelji kot preprodajalci prepoznajo kot vodilni distributer IT, zahvaljujoč bogatim izkušnjam, visoki usposobljenosti in prisotnosti v različnih državah sveta.",
                bp3: "POSLANSTVO",
                p6: "Naše poslanstvo je našim partnerjem zagotoviti inovativne rešitve in kakovostne izdelke pravočasno.",
                p7: "Predano si prizadevamo za promocijo tehnoloških izdelkov in rešitev za izpolnjevanje naraščajočega povpraševanja na trgu in dodajanje vrednosti tako dobaviteljem kot preprodajalcem s hitro razpoložljivostjo izdelkov in poglobljenim poznavanjem izdelkov.",
                p8: "MUK si sistematično prizadeva za ustvarjanje povpraševanja in lansiranja izdelkov ter ustvarjanje dobičkonosnih priložnosti za naše prodajalce s pomočjo partnerskega programa, učinkovite dobavne verige in usposabljanja.",
                p9: "Prizadevamo si vzdrževati okolje, ki našim ljudem daje moč, priznava njihove dosežke in jim pomaga pri prilagajanju na nenehno spreminjajoče se poslovno okolje. MUK motivira zaposlene za trajnostno osebno in poklicno rast.",
                bp4: "PARTNERSTVO IN ODGOVORNOST",
                p10: "MUK se drži izključno partnerskega poslovnega modela. Ne sodelujemo s končnimi kupci in se zanašamo na razvoj trgovske mreže. Med končnimi kupci naših partnerjev so vsi sektorji domačega poslovanja: maloprodaja, industrija, finance in javni sektor",
                p11: "S partnerji si delimo odgovornost za doseganje uspeha. Naš moto: \"Gremo skupaj, torej gremo skupaj do konca.\" V težkih situacijah podpiramo naše partnerje in skupaj slavimo zmage, kot kažejo izkušnje, pa imamo veliko več skupnih zmag kot porazov.",
                p12: "MUK je s svojim dolgoletnim delom dokazal izvedljivost svoje multivendor strategije, v kateri imajo vsi prodajalci v našem portfelju enake možnosti za razvoj in delo v konkurenčnem tržnem okolju. Pridržujemo si pravico, da partnerji izberejo strategijo za delo na projektih, hkrati pa pomagajo pri ustvarjanju kompleksnih rešitev, svetujejo pri celotnem prodajnem ciklu: od odstranitve naloge do izvedbe in vzdrževanja.",
                bp5: "NAŠE VREDNOTE",
                p13: "MUK je v celoti usmerjen v povečevanje uspeha svojih poslovnih partnerjev in zaposlenih z spoštovanjem vrednot inovativnosti, odgovornosti, integritete, enakih možnosti in timskega dela, spoštovanja, učenja in družbene odgovornosti.",
                bp6: "Enake zaposlitvene možnosti",
                p14: "Prošnje za zaposlitev kandidatov obravnavamo ne glede na raso, spol, vero, barvo kože, etnično ozadje, starost, spolno identiteto in izražanje, invalidnost, spolno usmerjenost, status veterana ali druge dejavnike, ki niso povezani s kvalifikacijami za določeno delovno mesto.",
                bp7: "Inovativnost",
                p15: "Nenehno iščemo boljše načine za zagotavljanje koristi našim strankam, dobaviteljem in sodelavcem. Predvidevamo spremembe v proaktivnem ustvarjanju rešitev, ki jim ustrezajo.",
                bp8: "Odgovornost",
                p16: "Govorimo, kar delamo, in delamo, kar rečemo. Dosledno dosegamo rezultate, ki izpolnjujejo ali presegajo pričakovanja naših partnerjev in dobaviteljev",
                bp9: "Integriteta",
                p17: "Ohranjamo najvišje etične standarde, ki dokazujejo integriteto in poštenost v vsakem našem dejanju, povsod in kadarkoli.",
                bp10: "Timsko delo in spoštovanje",
                p18: "Spoštujemo pravice in prepričanja naših sodelavcev, partnerjev in družbe. Z drugimi ravnamo z najvišjo stopnjo dostojanstva, enakosti in zaupanja z uporabo raznolikosti za doseganje naših skupnih ciljev. Kot ekipa naredimo več kot posamezno.",
                bp11: "Usposabljanje",
                p19: "Nenehno se učimo povečevati produktivnost in zagotavljati rast našega podjetja in sebe",
                bp12: "Družbena odgovornost",
                p20: "Aktivno iščemo načine za uravnoteženje naše finančne, družbene in ekološke odgovornosti, da bi dosegli pozitivne rezultate za različne deležnike po vsem svetu. Na tej poti stremimo k sodelovanju, transparentnosti in inovativnosti.",
                bp13: "ZAKAJ MUK?",
                p21: "Z MUK-om naši partnerji dobijo zanesljivega distributerja in pomembno konkurenčno prednost",
                p22: "Naši partnerji se zlahka prilagajajo spreminjajočim se tržnim trendom ob upoštevanju fleksibilnosti storitev MUK. Ker sodelujemo z najnaprednejšimi dobavitelji, naše stranke vedno najdejo nove priložnosti za rast svojega poslovanja.",
                p23: "Naše prilagodljive možnosti financiranja so zasnovane za naše stranke, ne glede na to, ali gre za rešitev po meri ali namenske kreditne linije, partnerjem olajšamo poslovanje.",
                p24: "Vse nastajajoče težave rešujemo s pomočjo predanih upraviteljev računov in strokovnjakov za izdelke, dodeljenih različnim prodajalcem. Vse znanje, ki ga potrebujete, je zbrano na enem mestu, naše strokovno usposabljanje in obsežna marketinška podpora pa pomenita, da ste lahko prepričani v vse kar počnemo.",
                p25: "MUK je izkušeno podjetje, ki vam zagotavlja fleksibilnost in odzivnost na potrebe vašega podjetja in strank",
                p26: "Naša ponudba komercialnih pobud vam zagotavlja odlično kakovost dela. Prav tako lahko našim strankam pomagamo izkoristiti izkušene mednarodne logistične, izobraževalne in servisne centre, oddelek za izdelke v oblaku.",
                p27: "Bolje kot kdorkoli vemo, da dober potek dela pomeni dobro prodajo, in razumemo, da so odzivnost, proaktivnost in obvladovanje tveganj pomemben del uspešnega poslovanja našega partnerja in njegovega ugleda pri strankah. Zato smo ustvarili elektronska orodja, ki izboljšujejo vaše poslovne procese in poenostavljajo hitrost interakcije.",
                p28: "Pomagamo povečati vaš dohodek in dobičkonosnost na vsakem koraku."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Če imate kakršna koli vprašanja?",
                description: "Prosimo, izpolnite spodnji obrazec, nam pošljite e-pošto in stopili bomo v stik z vami v najkrajšem možnem času.",
                send: "Pošljite",
                nm: "Ime",
                ad: "Naslov",
                ph: "Telefon",
                em: "Email",
                ms: "Sporočilo",
                contactInfo: "Kontaktni podatki",
                address: "Donetska 16/2, Kijev 03151, Ukrajina",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Vse pravice pridržane."
            }
        }
    }

    if (lang === "tj") {
        text = {
            Navigation: [
                {
                    menu: "Кишварҳо",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Арманистон",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Озарбойҷон",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hu",
                            name: "Венгрия",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/hr",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Гурҷистон",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Қазоқистон",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Қирғизистон",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Муғулистон",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Сингапур",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Тоҷикистон",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Туркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Туркманистон",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Узбекистон",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Қарорҳо",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "Вендорҳои МУК"
                        },
                        {
                            link: "/solutions",
                            name: "Қарорҳои МУК"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Каталоги маҳсулот ва хизматрасониҳо"
                        }
                    ]
                },
                {
                    menu: "Ахбор",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Хабарҳо ва аҳдҳо"
                        },
                        {
                            link: "/muk-review",
                            name: "Маҷаллаи МУК"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Видео"
                        }
                    ]
                },
                {
                    menu: "Соҳаҳо",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT дистрибутсия"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Маркази таълимӣ"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Маркази хизматрасонӣ"
                        },
                        {
                            link: "https://cloud.muk.tj/",
                            name: "Хизматрасониҳои облакавии MUK Cloud"
                        }
                    ]
                },
                {
                    menu: "Дар бораи ширкат",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Маълумоти асосӣ дар бораи MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Профили корпоративӣ"
                        },
                        {
                            link: "/vacancies",
                            name: "Ҷойҳои холии корӣ"
                        }
                    ]
                },
                {
                    menu: "Бахши фурушандагон",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Албания",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Арманистон",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Озарбойҷон",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Хорватия",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Гурҷистон",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Қазоқистон",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Қирғизистон",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Молдова",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Муғулистон",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Сербия",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Словения",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Тоҷикистон",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туркия",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Туркманистон",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Украина",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Узбекистон",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Дистрибутори лоиҳавии байналмиллалӣ VAD IT",
                paragraph: "Шарикони МУК моро ҳамчун IT дистрибутори бисёрвендораи боэътимод мебинанд, ба таҷрибаи чандинсолаи корӣ, салоҳияти техникӣ ва модели беҳтарини ҳамкорӣ боварӣ менамоянд",
                partner: "Шарик шавед"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Дистрибутори байналмиллалӣ",
                    text: "Ҷуғрофияи MUK 16 кишвари Аврупо ва Осиёро дар бар гирифта, вадоимо васеъ мешавад"
                },
                {
                    icon: "fa fa-star",
                    title: "Зиёда аз 25 соли муваффақият",
                    text: "МУК аз соли 1997 унвони пешсафро нигоҳ медорад"
                },
                {
                    icon: "fa fa-users",
                    title: "Озмоиши нодир",
                    text: "Гурӯҳи муҳандисони MUK аз ӯҳдаи ҳама гуна, ҳатто душвортарин вазифа мебароянд."
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ истеҳсолкунандагон",
                    text: "Портфели дистрибютории MUK зиёда аз 100 бренди ҷаҳонии синфи A-ро дар бар мегирад ва шумораи онҳо мунтазам меафзояд"
                }
            ],
            ServicesInfo: {
                title: "Равияи фаъолияти MUK"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT дистрибутсия",
                    text: "MUK – VAD дистрибутор буда ба IT тиҷорати лоиҳавӣ нигаронида шудааст. Мо зиёда аз 25 сол шабакаи дилериро дар Аврупо ва Осиё бомуваффақият инкишоф дода истодаем. Ба кӯмаки ҳайати мутахассисони сертификатдошта, MUK ба шарикон сатҳи баланди машваратҳои лоиҳавӣ ва дастгирии техникиро пешкаш карда,  ҳамин тавр барои қарорҳои пешниҳодшуда арзиши иловагӣ меорад. Муҳандисони MUK барои қарорҳои нармафзор ва дастгоҳҳо кӯмаки маҳваратӣ ва техникӣ расонида, инчунин аудити системаҳои мавҷудбуда гузаронида ва дар татбиқи стендҳои санҷишӣ кӯмак менамоянд. Парки таҷҳизотҳои озмоишии мо, имконияти тақлид ва амалӣ сохтани доираи васеъи вазифаҳоро дар шароити воқеъӣ медиҳад. MUK ба интеграторҳо дар интихоб ва тарҳрезии қарорҳои оптималӣ фаъолона кӯмак мерасонад.Ба ҳайати MUK зиёда аз 500 мутахассиси соҳаҳои гуногуни технологӣ шомиланд, ки дорои шаҳодатномаҳои IT истеҳсолкунандагони пешбари ҷаҳонӣ мебошанд.",
                    activ1: "Логистикаи байналмиллалӣ, ташаккули анбор",
                    activ2: "Дастгирии маркетингӣ ва машваратии шарикон",
                    activ3: "Баланд бардоштани арзиши қарорҳо тавассути салоҳияти худ",
                    activ4: "Ба бозор баровардани маҳсулот, пешбурд ва пайдо намудани талабот",
                    activ5: "Дастгирии техникӣ, хидматрасонии кафолатӣ ва пас аз кафолатӣ",
                    activ6: "Рушди шабакаи шарикӣ"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Маҳсулоти облакавӣ MUK Cloud Solution Provider",
                    text: "Қарорҳои облакавии MUK барои тиҷорат MUK Cloud Solutions - ин маҷмӯи қарорҳо ва хидматҳое буда, барои оғози кор омодаанд, ки барои  таъмини муттасилии тиҷорат, баланд бардоштани самаранокии кор ва ҳаракати кормандон, таъмини абзорҳои муосири ҳамкории бехатар нигаронида шудаанд. Бо ёрии онҳо шумо метавонед технологияҳои абриро дар инфрасохтори ташкилоти худ зуд ва самаранок татбиқ намоед. Консепсияи Cloud Solution Provider канали фурӯшест, ки дар он Microsoft Office 365, AZURE, EMS, D365 ва дигар хидматҳои облакавӣ бо маблағгузории ҳармоҳа дастрасанд. MUK ташкилшавии инфрасохторро \"аз сифр\" пешниҳод менамояд.Хароҷоти оптималии амалиётӣ барои иҷораи захираҳои облакаввӣ ва нигоҳдорӣ пешкаш менамояд.Миқёспазирии инфрасохтор (афзоиши корхона, идораҳои нави ҳудудӣ, таркишҳои сарбории ба нақша гирифташуда Хилматрасониҳои нави облакавие, ки бо инфрасохтори заминӣ муттаҳид шудаанд.",
                    activ1: "Нигоҳ доштани нусхаҳои эҳтиётӣ (файлҳо, мошинҳои виртуалӣ, пойгоҳи додаҳо) дар облако",
                    activ2: "Муҳофизат аз ҳолвтҳои садамавӣ барқарорсозӣ. Кластерҳои дастрасии баланд дар сатҳи мошинҳои виртуалӣ ё пойгоҳи додаҳои SQL",
                    activ3: "Идоракунии дастгоҳи мобилӣ",
                    activ4: "Ҳифзи иттилоот ва мукотибаи корпоративӣ",
                    activ5: "Ҷойгиркунии SharePoint on-line, Exchange on-line, Skype for business on-line",
                    activ6: "Ҷойгиркунӣ ва насби вебсайтҳо, муҳоҷирати сайтҳо ба облако"
                },
                {
                    icon: "fa fa-wrench",
                    name: "Маркази хизматрасонии MUK Service",
                    text: "Ширкати MUK Сервис аз соли 2002 бомуваффақият хидматрасонии таъмири компютерҳоро пешкаш мекунад ва имрӯз як маркази ваколатдори хидматрасонии APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell . EMC, Tescom ва дигар истеҳсолкунандагон мебошад.Системаи идоракунии сифати ширкати «МУК-Сервис» бо сертификати ISO 9001 Бюрои Сертификатсияи Байналмилалӣ тасдиқ карда шудааст. Барои зуд бартараф кардани ҳама гуна камбудиҳо, шумо бояд мутахассиси воқеӣ бошед. Устодони мо бо андӯхтани таҷриба ва амалияи ҳаррӯза ҳама гуна камбудиҳоро бартараф менамоянд. Кордонӣ бо таҷриба меояд, мо худамонро такмил медиҳем ва савияи донишамонро баланд мебардорем. Кормандони маркази хидматрасонӣ аз мутахассисони сертификатсиядор иборатанд, ки ба мизоҷон таъмири баландсифат ва касбии таҷҳизотро кафолат медиҳанд.MUK Сервис дорои тамоми имкониятҳои техникии зарурӣ барои расонидани хидмати босифат мебошад.Маркази хидматрасонӣ хидматрасонии техникӣ, кафолатнок ва бе кафолати ҳама гуна сатҳи мураккабиро анҷом медиҳад.MUK Сервис кироя ва аутсорсинги таҷҳизот , насб ва хидматрасонии техникӣ, инчунин хидматҳои иттилоотӣ ва машваратиро барои муштариёни корпоративӣ дар Украина, Арманистон, Гурҷистон, Молдова, Тоҷикистон ва Қазоқистон пешниҳод мекунад.",
                    activ1: "Таъмири кафолатнок",
                    activ2: "Таъмири бекафолат",
                    activ3: "Ташхиси таҷҳизот",
                    activ4: "Фурӯши қисмҳои эҳтиётӣ",
                    activ5: "Аудити шартномаҳои хизматрасонӣ",
                    activ6: "Иҷора ва аутсорсинги таҷҳизот"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "Маркази таълимии MUK",
                    text: "Маркази таълимии MUK пешво дар бозори хидматрасонии таълими IT буда, дорои  таҷрибаи беш аз 15 сол ва як қатор иҷозатномаҳои беназир, гурӯҳи омӯзгорони соҳибихтисос ва инфрасохтори муосири таълимӣ мебошад.Портфели MUK зиёда аз 300 курсҳои омӯзиширо аз ширкатҳои пешрафтаи IT дар бар мегирад.Дар байни статусҳои мазкур бояд қайд кард:Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner.Маркази таълимии MUK ба таҷҳизоти замонавии таълим дастрасӣ дорад. Сифати таълим аз ҷониби омӯзгорони мо солҳои зиёд бо баҳои баланди донишҷӯён дар Украина ва хориҷа тасдиқ карда шудааст."
                }
            ],
            Vendors: {
                title: "Вендорҳои МУК",
                country: "Кишвар",
                solution: "Қарор",
                name: "Номгӯ",
                all: "Ҳама",
                namePlaceholder: "Номи вендорро ворид намоед",
                notInfo: "Маълумот пур карда нашудааст"
            },
            VendorsForCountry: {
                title: "Вендорҳои МУК, ки дар кишвар дастрасанд"
            },
            VendorsForSolution: {
                title: "Вендорҳои МУК, аз рӯи қарорҳо"
            },
            VendorDetail: {
                title: "Дистрибутори ваколатдор"
            },
            Gallery: {
                title: "Қарорҳои МУК"
            },
            Distribution: {
                title: "IT дистрибутсия"
            },
            Partner: {
                title: "Шарик шавед",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Ирсол намудан",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK тиҷоратро бо принсипҳои шарикӣ ва ҳамкорӣ бунёд мекунад",
                advantages: "Афзалиятҳо",
                paragraph: "MUK аз замони таъсисёбӣ ба шаффофият дар муносибатҳо бо таъминкунандагон ва мизоҷон диққати ҷиддӣ медиҳад. Садоқат ба қоидаҳои шарикӣ ба MUK имкон дод, ки эътимоди бозорро ба даст оварад ва ҳамчун пешво обрӯ пайдо кунад.",
                Why: [
                    "Навоварӣ",
                    "Масъулият",
                    "Бошарафӣ",
                    "Имконияти баробари шуғли аҳолӣ"

                ],
                Why2: [
                    "Кори дастаҷамъона ва эҳтиром",
                    "Таълим",
                    "Масъулияти иҷтимоӣ"
                ]
            },
            News: {
                title: "Ахборҳои МУК",
                showAll: "Ҳама нишондон",
                showMore: "Бештар нишондод",
                news: "Ахбор",
                akcii: "Иқдом"
            },
            Vacancies: {
                title: "Ҷойҳои холии корӣ",
                resume: "Send a CV",
                country: "Кишвар",
                all: "Ҳама",
                search: "Ҷустуҷӯ",
                namePlaceholder: "Номро ворид намоед",
                filterInfo: "Мувофиқи филтрҳо ҷойҳои холии корӣ нестанд",
                notInfo: "Маълумот пур карда нашудааст",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" Нашри маҷаллаи",
                vupysk: "Нашр"
            },
            OMuk: {
                title: "Нуқтаҳои асосӣ дар бораи MUK",
                p1: "Гурӯҳи ширкатҳои MUK фаъолияти худро соли 1997 оғоз кардааст. Самти асосии фаъолияти мо - дистрибутсияи лоиҳавии IT маҳсулотҳои пешбар дар соҳаи қарорҳои гибридӣ ва облакавӣ, конвергенсияи марказҳои коркард бо маълумот, амнияти иттилоотӣ, дастгоҳҳои мобилӣ ва Интернети ашё, таҳлили додаҳо ва зеҳни сунъӣ мебошад.",
                p2: "Бо шарофати шабакаи дистрибутории глобали, мо вендорҳои умедбахши IT ва маҳсулоти нави онҳоро ба бозорҳои маҳаллӣ пешкаш намуда, дар ташаккули талабот фаъолона иштирок менамоем.",
                p3: "Мо донишҳои коршиносони техникӣ ва бозорро бо барномаи пешрафтаи дастгирии шарикон муттаҳид мекунем. Бо дилерҳои худ ҳамкории зич дошта,кӯшиш мекунем, ки афзоиш ва рушди динамикии онҳоро таъмин намуда, якҷоя ба натиҷаҳо ноил гардем.",
                bp1: "ТЕХНОЛОГИЯҲОИ ИНФОРМАТСИОНӢ - мо мебошем!",
                p4: "MUK дар тӯли зиёда аз 25 сол пешрав дар паҳнкунии технологияҳои иттилоотӣ мебошад. Имрӯз MUK дар интиқоли технология аз онҳое, ки онро таҳия мекунанд, ба онҳое, ки онро амалӣ ва истифода мебаранд, нақши муҳим мебозад",
                ul: "Чаҳор рақам, ки MUK-ро ҳамчун шарики боэътимод ва дистрибютори муассир тавсиф мекунанд:",
                li1: "1. Зиёда аз 25 сол таҷриба ва эътимод.",
                li2: "2. Зиёда аз 100 вендорҳои бренди A (ширкатҳо бо номҳои ҷаҳонӣ ва маҳсулоти исботшуда).",
                li3: "3. Ҳар як равия вендорҳо менеҷерҳо, пресейл ва муҳандисони худро дорад, бинобар ин, ҳайати мо аз зиёда аз 500 мутахассис иборат аст.",
                li4: "4. Дар айни замон мо ба зиёда аз 4000 шарикони фаъол, аз ҷумла на танҳо ба интеграторҳои классикии IT, балки ба корхонаҳои истеҳсолӣ, ширкатҳои сохтмонӣ, ширкатҳои консалтингӣ, таҳиягарони нармафзор, ки маҳсулоти моро ҳангоми интиқоли худ истифода мебаранд, хизмат мерасонем.",
                bp2: "Стратегия",
                p5: "Стратегияи мо аз ҷониби ҳам таъминкунандагон ва ҳам фурӯшандагон ҳамчун дистрибютори пешбари IT ба шарофати таҷрибаи азим, салоҳияти баланд ва ҳузури мо дар кишварҳои гуногуни ҷаҳон эътироф карда мешавад.",
                bp3: "Миссия",
                p6: "Ҳадафи мо ин аст, ки ба шарикони худ сари вақт бо қарорҳои инноватсионӣ ва маҳсулоти босифат таъмин намоем.",
                p7: "Мо барои пешбурди маҳсулот ва қарорҳои технологӣ бо мақсади қонеъ кардани талаботи афзояндаи бозор ва илова кардани арзиш ба ҳам таъминкунанда ва ҳам фурӯшанда тавассути дастрасии саривақтии маҳсулот ва дониши амиқи маҳсулот  амалӣ менамоем.",
                p8: "MUK барои ташкили талабот ва ба бозор баровардани маҳсулот, инчунин фароҳам овардани имкониятҳои фоидаовар барои фурӯшандагони мо тавассути барномаи шарикӣ, занҷири самараноки таъминот ва омӯзиш мунтазам кор менамояд.",
                p9: "Мо кушиш менамоем то ки муҳитеро нигоҳ дорем, ки ба мардуми мо тавонмандӣ бахшад, дастовардҳои онҳоро эътироф кунад ва ба онҳо дар мутобиқ шудан ба муҳити доимо тағйирёбандаи тиҷорат кӯмак кунад. MUK кормандонро барои рушди устувори шахсӣ ва касбӣ ҳавасманд мекунад.",
                bp4: "Ҳамкорӣ ва масъулият",
                p10: "MUK  модели тиҷоратии шарикиро эътироф мекунад.\n" +
                    "Мо бо муштариёни ниҳоӣ кор намекунем ва ба рушди шабакаи дилерҳо такя мекунем. Дар байни муштариёни ниҳоии шарикони мо ҳамаи соҳаҳои тиҷорати ватанӣ: чакана, саноат, молия ва бахши давлатӣ мебошанд.",
                p11: "Мо барои ба даст овардани муваффақият, масъулиятро бо шарикони худ тақсим мекунем. Ақидаи мо - \"якҷоя ҳамкорӣ менамоем ва то охир якҷоя ҳамсафар мебошем\". Мо шарикони худро дар вазъиятҳои душвор дастгирӣ карда, якҷоя аз ғалабахо шод мегардем ва чунон ки таҷриба нишон дод, назар ба мағлубият бисёртар ғалабаҳо дорем.",
                p12: "MUK, бо таҷрибаи чандинсолаи устувории стратегияи бисёрвендораи худро исбот кард, ки дар он ҳамаи вендорони дар портфели мо буда,  имкони баробар барои рушд ва кор дар муҳити рақобати бозор доранд.Мо ҳуқуқи шариконро нигоҳ медорем, ки стратегияи кор дар лоиҳаҳоро интихоб кунанд ва ҳамзамон дар такмили қарори мураккаб кӯмак расонанд ва дар давоми  давраи фурӯш маслиҳат диҳанд: аз бартараф кардани вазифаҳо то татбиқ ва хидматрасонӣ.",
                bp5: "АРЗИШХОИ МО",
                p13: "MUK пурра барои вусъати муваффақияти шарикон ва кормандони тиҷоратии худ тавассути риояи арзишҳои навоварӣ, масъулият, шафофият, баробарии имкониятҳо ва кори дастаҷамъӣ, эҳтиром, омӯзиш ва масъулияти иҷтимоӣ нигарон мебошад.",
                bp6: "Имконияти баробари шуғли аҳолӣ",
                p14: "Дархостҳои номзадҳо ба ҷойҳои холӣ аз ҷониби мо новобаста аз нажод, ҷинс, дин, ранги пӯст, пайдоиши миллӣ, синну сол, ҳувияти ҷинсӣ ва баён, маъюбӣ, тамоюли ҷинсӣ, мақоми собиқадор ва дигар омилҳое баррасӣ мешаванд, ки ба тахассуси вазифаи муайян алоқаманд нестанд.",
                bp7: "Навоварӣ",
                p15: "Мо ҳамавақт роҳҳои беҳтари овардани фоида ба мизоҷон, таъминкунандагон ва ҳамкоронамон меҷӯем.",
                bp8: "Масъулият",
                p16: "Мо он чизеро иҷро мекунем, мегӯем ва он чизеро, ки мегӯем, иҷро мекунем. Мо пайваста ба натиҷаҳое ноил мешавем, ки ба интизориҳои шарикон ва таъминкунандагони мо мувофиқат мекунанд ё зиёдтаранд.",
                bp9: "Бошарафӣ",
                p17: "Мо дар ҳама ҷо ва дар ҳама вақт дар ҳар амале, ки анҷом медиҳем, ростқавлӣ ва адолатро нишон дода, худро ба меъёрҳои олии ахлоқӣ нигоҳ медорем.",
                bp10: "Кори дастаҷамъона ва эҳтиром",
                p18: "Мо ҳуқуқ ва эътиқоди ҳамкорон, шарикон ва ҷомеаи худро эҳтиром мекунем. Мо ба дигарон бо дараҷаи баландтарини шаъну шараф, баробарӣ ва эътимод муносибат мекунем ва аз гуногунӣ барои ноил шудан ба ҳадафҳои муштаракамон истифода мебарем. Назар ба алоҳидагӣ, мо ҳамчун даста зиёдтар фоида мебинем.",
                bp11: "Таълим",
                p19: "Мо ҳамавақт донишҳои навро барои баланд бардоштани ҳосилнокӣ ва рушди ширкат ва худ ба даст меорем.",
                bp12: "Масъулияти иҷтимоӣ",
                p20: "Мо фаъолона роҳҳои мувозинати ӯҳдадориҳои молиявӣ, иҷтимоӣ ва экологии худро ҷустуҷӯ мекунем, то ба натиҷаҳои мусбӣ барои ҷонибҳои гуногуни манфиатдор дар саросари ҷаҳон ноил гардем. Дар ин роҳ мо барои ҳамкорӣ, шаффофият ва навоварӣ кӯшиш менамоем.",
                bp13: "Чаро МУК?",
                p21: "Бо MUK шарикони мо дистрибютори боэътимод ва бартарии назарраси рақобатӣ ба даст меоранд",
                p22: "Шарикони мо ба тамоюлҳои тағйирёбандаи бозор ба осонӣ мутобиқ мешаванд ва чандирии хидматҳо ва хидматрасониҳои MUK-ро қайд мекунанд. Азбаски мо бо вендорҳои пешрафта кор мекунем, мизоҷони мо ҳамеша барои рушди тиҷорати худ имкониятҳои нав пайдо мекунанд.",
                p23: "Вариантҳои чандири маблағгузории мо барои мизоҷони мо тарҳрезӣ шудаанд, хоҳ он як қарори фармоишӣ бошад ё нақшаҳои кредитии махсус, мо барои шарикон тиҷоратро осон мегардонем.",
                p24: "Мо ҳама масъалаҳои пайдошавандаро бо кӯмаки менеҷерони  махсус ва мутахассисони маҳсулот, ки ба вендорҳои гуногун таъин шудаанд, ҳал мекунем.Ҳама донишҳое, ки ба шумо лозим аст, дар як ҷо ҷамъшудаанд ва омӯзиши касбӣ ва дастгирии маркетингии мо маънои онро дорад, ки шумо метавонед ба ҳама фаъолияте, ки мо анҷом медиҳем, боварӣ дошта бошед.",
                p25: "MUK ширкати ботаҷрибаест, ки ба шумо чандирӣ ва вокуниши зудро ба тиҷорат ва муштариёни шумо медиҳад",
                p26: "Маҷмӯи ташаббусҳои тиҷоратии мо ба шумо сифати аълои корро кафолат медиҳад. Мо инчунин метавонем ба мизоҷони худ кӯмак расонем, ки аз як маркази ботаҷрибаи байналмилалии логистика, марказҳои омӯзиш ва хидматрасонӣ, шӯъбаи маҳсулоти облакавӣ баҳра баранд.",
                p27: "Мо аз дигарон бештар  медонем, ки ҷараёни хуби корӣ маънои фурӯши хубро дорад ва мо дарк мекунем, ки ҷавобгарӣ, фаъолӣ ва идоракунии хавфҳо қисми муҳими тиҷорати муваффақи шарики мо ва эътибори ӯ дар назди мизоҷон мебошанд. Аз ин рӯ, мо асбобҳои электронӣ офаридаем, ки равандҳои тиҷоратии шуморо беҳтар мекунанд ва суръати муоширатро содда менамоянд.",
                p28: "Мо ба баланд бардоштани фоида ва даромаднокии шумо дар ҳар қадам кӯмак мерасонем"

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Оё саволе пайдо шуд?",
                description: "Лутфан саволномаи зеринро пур намоед, то ки ба мо мактуби электронӣ ирсол намоед ва мо зуд бо Шумо тамос хоҳад гирифт.",
                send: "Ирсол намудан",
                nm: "Ном",
                ad: "Суроға",
                ph: "Телефон",
                em: "Email",
                ms: "Паём",
                contactInfo: "Маълумот барои тамос",
                address: "Украина, ш. Киев 03151, куч. Донетская 16\\2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Ҳама ҳуқуқҳо маҳфузанд."
            }
        }
    }

    if (lang === "tr") {
        text = {
            Navigation: [
                {
                    menu: "Ülkeler",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Arnavutluk",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Ermenistan",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaycan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Hırvatistan",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Gürcistan",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakistan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kırgızistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/hu",
                            name: "Macaristan",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Moğolistan",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Sırbistan",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapore",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tacikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Türkiye",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukrayna",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Özbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Çözümler",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK satıcıları"
                        },
                        {
                            link: "/solutions",
                            name: "MUK çözümleri"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Ürün ve hizmet kataloğu"
                        }
                    ]
                },
                {
                    menu: "Haberler",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Haberler ve Fırsatlar"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK dergisi"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Spheres",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "BT Dağıtımı"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Eğitim Merkezi"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Servis Merkezi"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "MUK Bulut hizmetleri"
                        }
                    ]
                },
                {
                    menu: "Şirket hakkında",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK hakkında temel bilgiler"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Kurumsal Profil"
                        },
                        {
                            link: "/vacancies",
                            name: "İşler"
                        }
                    ]
                },
                {
                    menu: "Bayi bölümü",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Arnavutluk",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Ermenistan",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaycan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Hırvatistan",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Gürcistan",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakistan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kırgızistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Moğolistan",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Sırbistan",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tacikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Türkiye",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukrayna",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Özbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Uluslararası katma değerli distribütör",
                paragraph: "MUK İş Ortakları, multi-vendor çözümlerimize, yılların deneyimine, teknik uzmanlığımıza ve gelişmiş iş ortaklığı modellerimize güveniyor.",
                partner: "İş Ortağımız Olun"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Uluslararası distribütör",
                    text: "Asya ve Avrupa'da 16 ülkede hizmet veriyoruz ve büyümeye devam ediyoruz."
                },
                {
                    icon: "fa fa-star",
                    title: "25 yılı aşkın başarı",
                    text: "MUK 1997'den beri lider konumunda"
                },
                {
                    icon: "fa fa-users",
                    title: "Benzersiz uzmanlık",
                    text: "Mühendislerden oluşan ekip, en karmaşık görevin bile üstesinden gelebilir"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100'den fazla üretici",
                    text: "MUK distribütörünün portföyü 100'den fazla uluslararası A markası içermektedir ve sürekli büyümektedir."
                }
            ],
            ServicesInfo: {
                title: "MUK faaliyet kapsamı"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "BT Dağıtımı",
                    text: "MUK, BT proje işine odaklanan bir Katma Değerli distribütördür. 25 yılı aşkın süredir Avrupa ve Asya'da başarılı bir bayi ağı geliştiriyoruz.  MUK şirketi, sertifikalı uzmanlardan oluşan bir kadronun yardımıyla, ortaklarına önerilen çözümler için ek değer yaratan yüksek düzeyde proje danışmanlığı ve teknik destek sağlar.  MUK'ta mühendisler, yazılım ve donanım çözümleri için danışmanlık ve teknik destek sağlar, mevcut sistemlerin denetimlerini yapar ve test tezgahlarının uygulanmasına yardımcı olur. Test ekipmanı stoğumuz, gerçek koşullarda çok çeşitli görevleri simüle etmemize ve uygulamamıza olanak tanır.  MUK'ta, entegratörlere optimal çözümleri seçme ve tasarlama konusunda aktif olarak yardımcı olur. MUK ekibinde, dünyanın önde gelen BT üreticileri tarafından sertifikalandırılmış, çeşitli teknoloji alanlarında 500'den fazla uzman yer almaktadır.",
                    activ1: "Uluslararası lojistik, stok oluşumu",
                    activ2: "İş ortakları için pazarlama ve danışmanlık desteği",
                    activ3: "Çözümlerin değerini kendi uzmanlığımızla artırırız",
                    activ4: "Ürün lansmanı, promosyon ve talep oluşturma",
                    activ5: "Teknik destek, garanti ve garanti sonrası servis",
                    activ6: "İş ortağı ağı geliştirme"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Bulut Çözümü Sağlayıcısı Bulut ürünleri",
                    text: "İşletmeler için MUK Bulut Çözümleri, modern güvenli işbirliği araçlarının sağlanmasıyla iş sürekliliğini sağlamayı, iş verimliliğini ve çalışanların hareketliliğini artırmayı amaçlayan hızlı başlangıçlı çözüm ve hizmet paketleridir. Bunların yardımıyla, kuruluşunuzun altyapısında bulut teknolojilerini hızlı ve verimli bir şekilde uygulayabilirsiniz. Bulut Çözümü Sağlayıcı konsepti, Microsoft Office 365, AZURE, EMS, D365 ve diğer bulut hizmetlerinin aylık ödeme bazında sunulduğu bir satış kanalıdır. Bulut kaynaklarının kiralanması ve bakımı için optimum işletme maliyetleri. Altyapı ölçeklendirme (kurumsal büyüme, yeni bölgesel ofisler, planlı yük artışları). Yer altyapısıyla entegre bulutta yeni hizmetler.",
                    activ1: "Yedeklerinizi bulut ortamında saklayın.",
                    activ2: "Çökme koruması, kurtarma. Sanal makineler veya SQL veritabanları düzeyinde yüksek kullanılabilirlik kümesi.",
                    activ3: "Mobil cihaz Yönetimi.",
                    activ4: "Kurumsal bilgi ve yazışma koruması",
                    activ5: "Son kullanıcılarınız için Sharepoint, Exchange, Teams dağıtımı.",
                    activ6: "Web sitelerinin kurulumu ve ayarlanması, web sitelerinin buluta taşınması."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service merkezi",
                    text: "MUK Service şirketi 2002 yılından bu yana başarıyla bilgisayar/donanım onarım hizmetleri vermektedir ve bugün APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom ve diğer üreticiler için yetkili servis merkezidir. MUK-Service şirketinin kalite yönetim sistemi, Uluslararası Sertifikasyon Bürosu sertifikasının ISO 9001'i tarafından onaylanmıştır. Servis merkezi personeli, müşterilere yüksek kaliteli ve profesyonel ekipman onarımını garanti eden sertifikalı profesyonellerden oluşur. MUK Service, kaliteli bir hizmet sunmak için gerekli tüm teknik yeteneklere sahiptir. Servis merkezi, herhangi bir karmaşıklık düzeyinde bakım, garanti kapsamında ve garanti dışı onarımlar gerçekleştirir. MUK Service şirketi, Ukrayna, Ermenistan, Beyaz Rusya, Gürcistan, Moldova, Tacikistan ve Kazakistan'daki kurumsal müşteriler için ekipman kiralama ve dış kaynak kullanımı, kurulum ve bakım hizmetlerinin yanı sıra bilgi ve danışmanlık hizmetleri sunmaktadır.",
                    activ1: "Garanti kapsamında onarım",
                    activ2: "Garanti dışı onarım",
                    activ3: "Ekipman arıza tanılama",
                    activ4: "Yedek parça satışı",
                    activ5: "Hizmet sözleşmeleri denetimi",
                    activ6: "Ekipman kiralama ve dış kaynak kullanımı"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK eğitim merkezi",
                    text: "MUK Eğitim Merkezi, 15 yılı aşkın tecrübesi ve çok sayıda benzersiz yetkilendirmesi, kalifiye eğitmen kadrosu ve modern eğitim altyapısı ile BT eğitim hizmetlerinde pazar lideridir.MUK Eğitim Merkezi portföyü, önde gelen BT şirketlerinden 300'den fazla eğitim kursu içerir. Kayda değer statüler arasında şunlar yer alır: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner. MUK Eğitim merkezinde en modern eğitim ekipmanlarına erişim vardır. Yıllar boyunca, eğitmenlerimiz tarafından verilen öğretimin kalitesi, Ukrayna ve yurtdışındaki öğrencilerin aldıkları yüksek notlarla onaylanmıştır."
                }
            ],
            Vendors: {
                title: "Sahip olduğumuz markalar",
                country: "Ülke",
                solution: "Çözüm",
                name: "İsim",
                all: "Tümü",
                namePlaceholder: "Satıcının adını yazmaya başlayın",
                notInfo: "Bilgiler doldurulmadı"
            },
            VendorsForCountry: {
                title: "Ülkede bulunan MUK satıcıları"
            },
            VendorsForSolution: {
                title: "Çözüme göre MUK satıcıları"
            },
            VendorDetail: {
                title: "YETKİLİ DAĞITICI"
            },
            Gallery: {
                title: "MUK çözümleri"
            },
            Distribution: {
                title: "BT Dağıtımı"
            },
            Partner: {
                title: "İş Ortağımız Olun",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Gönder",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK işini ortaklık ve işbirliği ilkeleri üzerine inşa eder.",
                advantages: "Faydalar",
                paragraph: "MUK, kuruluşundan bu yana tedarikçileri ve müşterileri ile ilişkilerinde şeffaflığa odaklanmaktadır. Ortaklık kurallarına bağlılık, MUK'un pazarın güvenini kazanmasına ve bir lider itibarı oluşturmasına olanak sağlamıştır.",
                Why: [
                    "Yenilikler",
                    "Sorumluluk",
                    "Bütünlük",
                    "Eşit istihdam fırsatları"

                ],
                Why2: [
                    "Takım çalışması ve saygı",
                    "Eğitim",
                    "Sosyal sorumluluk"
                ]
            },
            News: {
                title: "MUK haberleri",
                showAll: "Daha fazlasını göster",
                showMore: "Daha fazlasını göster",
                news: "Haberler",
                akcii: "Dağıtım"
            },
            Vacancies: {
                title: "Kariyer",
                resume: "Send a CV",
                country: "Ülke",
                all: "Tümü",
                search: "Arama",
                namePlaceholder: "İsmi yazmaya başlayın",
                filterInfo: "Bu filtrelerle eşleşen iş yok",
                notInfo: "Bilgiler doldurulmadı",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" dergi sayısı",
                vupysk: "Sayı"
            },
            OMuk: {
                title: "MUK hakkında temel bilgiler",
                p1: "MUK şirketler grubu faaliyetlerine 1997 yılında başlamıştır. Ana çalışma alanımız hibrit ve bulut çözümleri, veri merkezi yakınsaması, bilgi güvenliği, mobil cihazlar ve nesnelerin interneti, veri analitiği ve yapay zeka alanında lider BT ürünlerinin proje odaklı dağıtımıdır.",
                p2: "Global dağıtım ağımız sayesinde gelecek vadeden BT tedarikçilerini ve yeni ürünlerini yerel pazarlara ulaştırıyor ve talep oluşumuna aktif olarak katılıyoruz.",
                p3: "Uzman teknik ve pazar bilgisini ilerici bir ortak destek programı ile birleştiriyoruz. Bayilerimizle yakın işbirliği içinde çalışarak, dinamik büyümelerini ve gelişmelerini sağlamak ve birlikte sonuçlara ulaşmak için çalışıyoruz.",
                bp1: "BİLGİ TEKNOLOJİLERİNDE UZMANIZ!",
                p4: "MUK şirketi, 25 yılı aşkın bir süredir bilgi teknolojileri çözümlerini dağıtımında öncü olmuştur. Günümüzde MUK, teknolojilerin onu geliştirenlerden uygulayan ve kullananlara aktarılmasında önemli bir rol oynamaktadır.",
                ul: "MUK'u güvenilir bir ortak ve verimli bir distribütör olarak nitelendiren dört unsur:",
                li1: "1. 25 yılı aşkın deneyim ve güven.",
                li2: "2. Marka düzeyinde 100'den fazla satıcı (kanıtlanmış ürünlere sahip dünya çapında bilinen şirketler).",
                li3: "3. Her satıcının kendi yöneticileri, satış öncesi ve mühendisleri vardır, bu nedenle personelimiz 500'den fazla uzmandan oluşmaktadır.",
                li4: "4. Şu anda sadece klasik BT entegratörlerine değil, aynı zamanda teslimatlarında ürünlerimizi kullanan imalat şirketleri, inşaat şirketleri, danışmanlık şirketleri, yazılım geliştiricileri de dahil olmak üzere 4000'den fazla aktif ortağa hizmet veriyoruz.",
                bp2: "STRATEJİ",
                p5: "Stratejimiz, engin deneyimimiz, yüksek yetkinliğimiz ve dünyanın farklı ülkelerindeki varlığımız sayesinde hem tedarikçiler hem de bayiler tarafından lider bir BT distribütörü olarak tanınmaktır.",
                bp3: "MİSYON",
                p6: "Misyonumuz, Ortaklarımıza tam zamanında yenilikçi çözümler ve kaliteli ürünler sunmaktır.",
                p7: "Artan pazar talebini karşılamak ve hızlı ürün mevcudiyeti ve derinlemesine ürün bilgisi aracılığıyla hem tedarikçiye hem de satıcıya değer katmak amacıyla teknoloji ürünlerini ve çözümlerini teşvik etmek için özveriyle çalışıyoruz.",
                p8: "MUK, bir ortaklık programı, verimli bir tedarik zinciri ve eğitim yoluyla bayilerimiz için karlı fırsatlar yaratmanın yanı sıra talep ve ürün lansmanı yaratmak amacıyla sistematik olarak çalışmaktadır.",
                p9: "Çalışanlarımızı güçlendiren, başarılarını takdir eden ve sürekli değişen iş ortamına uyum sağlamalarına yardımcı olan bir ortamı sürdürmek için çalışıyoruz. MUK, çalışanları sürdürülebilir kişisel ve profesyonel gelişim için motive ediyor.",
                bp4: "İŞ ORTAKLIĞI VE SORUMLULUK",
                p10: "MUK, tamamen bayi iş  ortaklığı modeline bağlıdır. Son kullanıcılarla çalışmaz, bayi ağının gelişimine katkı sağlamaktadır.İş Ortaklarımızın nihai müşterileri arasında yerel ticaretin tüm sektörleri bulunmaktadır: perakende, sanayi, finans ve kamu sektörü.",
                p11: "Başarıya ulaşmanın sorumluluğunu iş ortaklarımızla paylaşmaktayız. Bizim inancımız: \" Sonuna kadar birlikteyiz.\" Ortaklarımızı zor durumlarda destekliyoruz ve zaferleri birlikte kutluyoruz ve deneyimlerin gösterdiği gibi, yenilgilerden çok daha fazla ortak zaferimiz var.",
                p12: "Uzun yıllara dayanan çalışmalarıyla MUK, portföyümüzdeki tüm satıcıların rekabetçi bir pazar ortamında gelişme ve çalışma konusunda eşit şansa sahip olduğu çok satıcılı stratejisinin uygulanabilirliğini kanıtlamıştır. İş Ortaklarımızın projelerde çalışmak için bir strateji seçme hakkını saklı tutarız ve karmaşık çözümler oluşturmaya yardımcı oluruz, tüm satış döngüsünde tavsiyelerde bulunuruz.",
                bp5: "Degerlerimiz",
                p13: "MUK, yenilikçilik, sorumluluk, dürüstlük, fırsat eşitliği ve ekip çalışması, saygı, öğrenme ve sosyal sorumluluk değerlerine bağlı kalarak tamamen iş ortaklarının ve çalışanlarının başarısını artırmaya  odaklanmıştır.",
                bp6: "Eşit istihdam fırsatları",
                p14: "Adayların iş başvurularını ırk, cinsiyet, din, ten rengi, etnik köken, yaş, cinsiyet kimliği ve ifadesi, engellilik, cinsel yönelim, gazilik durumu veya belirli bir pozisyon için yeterlilikle ilgili olmayan diğer faktörler dikkate alınmaksızın değerlendiriyoruz.",
                bp7: "Yenilik",
                p15: "Müşterilerimize, tedarikçilerimize ve iş arkadaşlarımıza fayda sağlamak için sürekli olarak daha iyi yollar arıyoruz. Proaktif olarak onlara uygun çözümler yaratmada değişiklikleri öngörüyoruz",
                bp8: "Sorumluluk",
                p16: "Sonuç odaklıyız. Gerek İş ortaklarımızın gerekse de tedarikçilerimizin beklentilerini karşılayan ve aşan sonuçlara her zaman  ulaşırız",
                bp9: "Bütünlük",
                p17: "Her yerde ve her zaman yaptığımız her eylemde dürüstlük ve adalet gösteren en yüksek etik standartları koruyoruz.",
                bp10: "Takım çalışması ve saygı",
                p18: "Meslektaşlarımızın, ortaklarımızın ve toplumun haklarına ve inançlarına saygı duyarız. Ortak hedeflerimize ulaşmak için çeşitliliği kullanarak başkalarına en yüksek düzeyde itibar, eşitlik ve güven ile davranırız. Takım olarak bireyselden daha fazlasını yapıyoruz.",
                bp11: "Eğitim",
                p19: "Verimliliği artırmak, şirketi ve kendimizi geliştirmek için sürekli yeni bilgiler ediniyoruz.",
                bp12: "Sosyal sorumluluk",
                p20: "Dünya çapında çeşitli paydaşlar için olumlu sonuçlar elde etmek amacıyla aktif olarak finansal, sosyal ve ekolojik sorumluluklarımızı dengelemenin yollarını  arıyoruz. Bu yolda iş birliği, şeffaflık ve yenilikler için çalışıyoruz.",
                bp13: "NEDEN MUK?",
                p21: "MUK ile iş ortaklarımız güvenilir bir distribütör ve önemli bir rekabet avantajı elde ediyor",
                p22: "İş Ortaklarımız, MUK hizmetlerinin esnekliğini dikkate alarak değişen pazar trendlerine kolayca uyum sağlar. En ilerici tedarikçilerle çalıştığımız için müşterilerimiz her zaman işlerini büyütmek için yeni fırsatlar bulurlar.",
                p23: "Gerek özel  proje , gerekse de  sürekli kredi limiti  tahsisi olsun, esnek finansman seçeneklerimiz iş ortaklarımızın  başarısına odaklıdır",
                p24: "Ortaya çıkan tüm sorunları, farklı satıcılara atanmış özel hesap yöneticileri ve ürün uzmanları yardımıyla çözüyoruz. İhtiyacınız olan tüm bilgiler tek bir yerde toplanmıştır ve profesyonel eğitimimiz ve kapsamlı pazarlama desteğimiz, yaptığımız her şeyden emin olabileceğiniz anlamına gelir.",
                p25: "MUK, işletmenizin ve müşterilerinizin ihtiyaçlarına esneklik ve yanıt verme olanağı sağlayan deneyimli bir şirkettir.",
                p26: "Ticari girişimler yelpazemiz size mükemmel bir iş kalitesini garanti eder. Ayrıca müşterilerimizin deneyimli uluslararası lojistik, eğitim ve hizmet merkezlerinden, bulut ürünleri departmanından faydalanmalarına yardımcı olabiliriz.",
                p27: "İyi bir iş akışının iyi satışlar anlamına geldiğini herkesten daha iyi biliyoruz ve hızlı yanıt verme, proaktiflik ve risk yönetiminin iş ortağımızın başarılı işinin ve müşteriler nezdindeki itibarının önemli bir parçası olduğunu anlıyoruz. Bu nedenle iş süreçlerinizi iyileştiren ve etkileşim hızını kolaylaştıran elektronik araçlar oluşturduk.",
                p28: "Her adımda gelirinizi ve karlılığınızı artırmanıza yardımcı oluyoruz."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Eğer herhangi bir sorunuz varsa?",
                description: "Bize e-posta göndermek için lütfen aşağıdaki formu doldurun, sizinle en kısa sürede iletişime geçeceğiz.",
                send: "Gönder",
                nm: "İsim",
                ad: "Adres",
                ph: "Telefon",
                em: "Eposta",
                ms: "Mesaj",
                contactInfo: "İletişim detayları",
                address: "16/2 Donetska str., Kyiv 03151, Ukrayna",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Tüm hakları saklıdır."
            }
        }
    }

    if (lang === "tm") {
        text = {
            Navigation: [
                {
                    menu: "Ýurtlar",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albaniýa",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Ermenistan",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaýjan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Horwatiýa",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Gruziýa",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Gazagystan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Gyrgyzystan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldowa",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongoliýa",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbiýa",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Sloweniýa",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapur",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Täjigistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Türkiýe",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Türkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/hu",
                            name: "Wengriýa",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Özbegistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Çözgütler",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK satyjylary"
                        },
                        {
                            link: "/solutions",
                            name: "MUK çözgütleri"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Önümleriň we hyzmatlaryň katalogy"
                        }
                    ]
                },
                {
                    menu: "Habarlar",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Habarlar we paýnamalar"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK žurnaly"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Wideo"
                        }
                    ]
                },
                {
                    menu: "Ugurlar",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT paýlanyşy"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Okuw merkezi"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Hyzmat merkezi"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "MUK bulut hyzmatlary"
                        }
                    ]
                },
                {
                    menu: "Kompaniýa hakda",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK hakda esasy pikirler"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Korporatiw profil"
                        },
                        {
                            link: "/vacancies",
                            name: "Işler"
                        }
                    ]
                },
                {
                    menu: "Dealer section",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albaniýa",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Ermenistan",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaýjan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Horwatiýa",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Gruziýa",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Gazagystan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Gyrgyzystan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldowa",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongoliýa",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbiýa",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Sloweniýa",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Täjigistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Türkiýe",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Türkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Özbegistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Halkara taslama VAD IT paýlaýjy",
                paragraph: "MUK hyzmatdaşlary bizi ygtybarly köp satyjy IT paýlaýjy hökmünde görýärler, köp ýyllyk tejribämize, tehniki başarnyklarymyza we döredilen hyzmatdaşlyk modelimize ynanýarlar.",
                partner: "Hyzmatdaş boluň"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Halkara paýlaýjy",
                    text: "MUK-yň geografiýasy Ýewropada we Aziýada 16 ýurdy öz içine alýar we yzygiderli giňelýär"
                },
                {
                    icon: "fa fa-star",
                    title: "25 ýyldan gowrak üstünlik",
                    text: "MUK 1997-nji ýyldan bäri lider bolup gelýär"
                },
                {
                    icon: "fa fa-users",
                    title: "Aýratyn tejribe",
                    text: "MUK-yň inžener topary islendik, hatda iň kyn meseläni hem çözer."
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ öndüriji",
                    text: "MUK-yň paýlaýyş portfelinde 100-den gowrak bütindünýä A-marka bar we olaryň sany yzygiderli artýar"
                }
            ],
            ServicesInfo: {
                title: "MUK çäreleri"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT paýlanyşy",
                    text: "MUK, IT taslamasynyň işine gönükdirilen VAD paýlaýjysydyr. 25 ýyldan gowrak bäri Ýewropada we Aziýada diler toruny üstünlikli ösdürýäris. \n Şahadatnamaly hünärmenleriň kömegi bilen, MUK hyzmatdaşlara ýokary derejeli taslama maslahat beriş we tehniki goldaw berýär, bu bolsa teklip edilýän çözgütlere goşmaça baha berýär. \nMUK inženerleri programma üpjünçiligi we apparat çözgütleri üçin maslahat beriş we tehniki goldaw amala aşyrýarlar, bar bolan ulgamlary barlaýarlar we synag stendlaryny durmuşa geçirmäge kömek edýärler. Synag enjamlarymyz, hakyky şertlerde köp sanly meseläni simulirlemäge we durmuşa geçirmäge mümkinçilik berýär. \nMUK iň amatly çözgütleri saýlamakda we taslamakda integratorlara işjeň kömek edýär. \nMUK toparyna dünýäniň öňdebaryjy IT öndürijilerinden şahadatnamalary bolan dürli tehnologiýa ugurlary boýunça 500-den gowrak hünärmen girýär.",
                    activ1: "Halkara logistika, ammar döretmek",
                    activ2: "Hyzmatdaşlar üçin marketing we maslahat beriş goldawy",
                    activ3: "Öz başarnygyňyz bilen kararlaryň bahasyny ýokarlandyrmak",
                    activ4: "Önümleri bazara çykarmak, islegi öňe sürmek we döretmek",
                    activ5: "Tehniki goldaw, kepillik we kepillikden soňky hyzmat",
                    activ6: "Hyzmatdaş toruň ösüşi"
                },
                {
                    icon: "fa fa-cloud",
                    name: "Bulut önümleri MUK Bulut çözgüdi üpjün ediji",
                    text: "Işewürlik üçin MUK Cloud Solutions, häzirki zaman ygtybarly hyzmatdaşlyk gurallary bilen işiň dowamlylygyny, iş netijeliligini we hereketliligini ýokarlandyrmaga gönükdirilen çözgütleriň we hyzmatlaryň çalt başlaýan toplumlarydyr. \n Olaryň kömegi bilen Siz guramaňyzyň infrastrukturasynda bulut tehnologiýalaryny çalt we täsirli ornaşdyryp bilersiňiz. “Cloud Solution Provider” düşünjesi, Microsoft Office 365, AZURE, EMS, D365 we beýleki bulut hyzmatlarynyň her aýda tölegli satuw kanalydyr. \nMUK “noldan” infrastrukturany döretmegi teklip edýär. Iň az maýa çykdajylary. Bulut çeşmelerini kärendesine almak we tehniki hyzmat etmek üçin amatly iş çykdajylary. Infrastrukturany ulaltmak (kärhananyň ösüşi, täze territorial ofisler, meýilleşdirilen ýük partlamalary). Bulutdaky täze hyzmatlar, ýerüsti infrastruktura bilen birleşdirilen.",
                    activ1: "Bulutda ätiýaçlyk nusgalaryny (faýllary, wirtual maşynlary, maglumat bazalaryny) saklamak.",
                    activ2: "Betbagtçylykdan goramak, dikeltmek. Wirtual maşynlar ýa-da SQL maglumat bazalary derejesinde ýokary elýeterlilik toparlary.",
                    activ3: "Jübi enjamlaryny dolandyrmak.",
                    activ4: "Korporatiw maglumatlary we hat alyşmalary goramak.",
                    activ5: "“SharePoint” -i onlaýn ýerleşdirmek, “Onlaýn” alyş-çalyş, onlaýn iş üçin “Skype”.",
                    activ6: "Web sahypalarynyň ýerleşdirilmegi we konfigurasiýasy, sahypalaryň buluda göçmegi."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK hyzmat merkezi",
                    text: "MUK Serwis 2002-nji ýyldan bäri kompýuter abatlaýyş hyzmatlaryny üstünlikli üpjün edýär we şu gün APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom we beýleki öndürijileriň ygtyýarly hyzmat merkezidir. \"MUK-Serwis\" kompaniýasynyň hil dolandyryş ulgamy, Halkara Sertifikasiýa Býurosynyň ISO 9001 şahadatnamasy bilen tassyklanýar. \n Islendik näsazlygy çalt çözmek üçin hakyky hünärmen bolmaly. Ussatlarymyz, tejribe we gündelik tejribe toplap, islendik näsazlygy çözýärler. Hünär ussatlygy tejribe bilen gelýär, özümizi kämilleşdirýäris we bilimlerimiziň derejesini ýokarlandyrýarys. Hyzmat merkeziniň işgärleri müşderilere ýokary hilli we hünär enjamlaryny abatlamagy kepillendirýän hünärmenlerden ybaratdyr. MUK Serwis ýokary hilli hyzmat bermek üçin ähli zerur tehniki mümkinçiliklere eýedir. Hyzmat merkezi islendik çylşyrymly tehniki hyzmat, kepillikli we kepilliksiz abatlaýyş işlerini ýerine ýetirýär. MUK Serwis enjamlary kärendesine almak we autsorsing, gurnama we tehniki hyzmat, şeýle hem Ukraina, Ermenistan, Gruziýa, Moldowa, Täjigistan we Gazagystanda korporatiw müşderiler üçin maglumat we maslahat hyzmatlaryny hödürleýär.",
                    activ1: "Kepillikli abatlamak",
                    activ2: "Kepilliksiz abatlamak",
                    activ3: "Enjamlary anyklamak",
                    activ4: "Ätiýaçlyk şaýlaryny satmak",
                    activ5: "Hyzmat şertnamalarynyň barlagy",
                    activ6: "Enjamlary kärendesine almak we autsorsing"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK okuw merkezi",
                    text: "MUK okuw merkezi, 15 ýyldan gowrak tejribe we birnäçe özboluşly ygtyýarnama, ökde mugallymlar topary we häzirki zaman okuw infrastrukturasy bolan IT bilim hyzmatlarynda bazar lideridir. \n MUK OM portfelinde öňdebaryjy IT kompaniýalarynyň 300-den gowrak okuw kursy bar. \n Statuslaryň arasynda: Pearson VUE, Veeam Ygtyýarly Bilim Merkezi, HPE Bilim Merkezi, VMware Ygtyýarly Okuw Merkezi, Oracle tarapyndan Tassyklanan Bilim Üpjünçisi, Penta Howpsuzlyk Bilim Merkezi, Juniper Networks Ygtyýarly Bilim Hyzmatdaşy, LearnQuest IBM Bilim Hyzmatdaşy, Microsoft Bilim Kümüş Hyzmatdaşy, ITIL Okuw Hyzmatdaşy, Dell-EMC Bilim Hyzmatlarynyň Hyzmatdaşy, Autodesk Okuw Merkezi, Grandstream Okuw Merkezi, Check Point Ygtyýarly Okuw Merkezi, Fortinet Ygtyýarly Okuw Merkezi, CommScope Okuw Merkezi, Cisco Okuw Merkezi, Red Hat Kepillendirilen Okuw Hyzmatdaşy. \nMUK okuw merkeziniň iň döwrebap okuw enjamlaryna elýeterliligi bar. Mugallymlarymyzyň okatmagyň hili, köp ýyllaryň dowamynda Ukrainada we daşary ýurtlarda diňleýjileriň ýokary bahalary bilen tassyklanýar"
                }
            ],
            Vendors: {
                title: "MUK satyjylary",
                country: "Ýurt",
                solution: "Çözgüt",
                name: "Ady",
                all: "Hemmesi",
                namePlaceholder: "Satyjynyň adyny ýazyp başlaň",
                notInfo: "Maglumat doldurylmady"
            },
            VendorsForCountry: {
                title: "MUK satyjylary, ýurtda bar bolan"
            },
            VendorsForSolution: {
                title: "MUK satyjylary, çözgüt boýunça"
            },
            VendorDetail: {
                title: "YGTYÝARLY PAÝLAÝJY"
            },
            Gallery: {
                title: "MUK çözgütleri"
            },
            Distribution: {
                title: "IT paýlanyşy"
            },
            Partner: {
                title: "Hyzmatdaş boluň",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Iber",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK ýoldaşlygyň we hyzmatdaşlygyň ýörelgelerine esaslanýar",
                advantages: "Üstünlikleri",
                paragraph: "MUK döredilen gününden bäri üpjün edijiler we müşderiler bilen gatnaşyklarda aç-açanlyga ünsi jemleýär. Hyzmatdaşlygyň düzgünlerine wepalylyk MUK-a bazaryň ynamyny gazanmaga we lider hökmünde abraý gazanmaga mümkinçilik berdi",
                Why: [
                    "Innowasiýa",
                    "Jogapkärçilik",
                    "Dogruçyllyk",
                    "Deň hukukly iş mümkinçiligi"

                ],
                Why2: [
                    "Toparlaýyn iş we hormat",
                    "Bilim",
                    "Jemgyýetçilik jogapkärçiligi"
                ]
            },
            News: {
                title: "MUK habarlary",
                showAll: "Hemmesini görkez",
                showMore: "Has köp görkez",
                news: "Habarlar",
                akcii: "Aksiýa"
            },
            Vacancies: {
                title: "Boş wezipe",
                resume: "Send a CV",
                country: "Ýurt",
                all: "Hemmesi",
                search: "Gözlemek",
                namePlaceholder: "Ady ýazyp başlaň",
                filterInfo: "Süzgüçlere görä boş wezipe ýok",
                notInfo: "Maglumat doldurylmady",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" journal issues",
                vupysk: "Goýberiliş"
            },
            OMuk: {
                title: "MUK hakda esasy maglumat",
                p1: "MUK kompaniýalar topary öz işine 1997-nji ýylda başlady. Esasy iş ugrumyz, gibrid we bulut çözgütleri, maglumat merkeziniň ýakynlygy, maglumat howpsuzlygy, ykjam enjamlar we zatlaryň interneti, maglumat seljerişi we emeli intellekt ýaly öňdebaryjy IT önümleriniň taslama gönükdirilen paýlanyşy.",
                p2: "Global paýlaýyş ulgamymyzyň kömegi bilen, geljegi uly IT satyjylaryny we olaryň täze önümlerini ýerli bazarlara getirýäris, islegiň döremegine işjeň gatnaşýarys",
                p3: "Hünärmen tehniki we bazar bilimlerini öňdebaryjy hyzmatdaş goldaw programmasy bilen birleşdirýäris. Dilerlerimiz bilen ýakyndan işleşip, bilelikde netijelere ýetip, olaryň dinamiki ösüşini we kämilleşdirmegini üpjün etmäge çalyşýarys.",
                bp1: "MAGLUMAT TEHNOLOGIÝASY BU BIZ!",
                p4: "MUK 25 ýyldan gowrak wagt bäri maglumat tehnologiýalaryny ýaýratmakda öňdebaryjy bolup gelýär. Häzirki wagtda MUK tehnologiýany ösdürýänlerden ony durmuşa geçirýänlere we ulanýanlara geçirmekde möhüm rol oýnaýar.",
                ul: "MUK-y ygtybarly hyzmatdaş we netijeli paýlaýjy hökmünde häsiýetlendirýän dört san:",
                li1: "1. 25 ýyldan gowrak tejribe we ynam.",
                li2: "2. 100-den gowrak A markaly satyjy (dünýä belli atlary we özüni görkezen önümleri bolan kompaniýalar).",
                li3: "3. Her bir satyjy ugrynyň öz dolandyryjylary, satuwdan öň hünärmenleri we inženerleri bar, şonuň üçin işgärlerimiz 500-den gowrak hünärmenden ybarat.",
                li4: "4. Häzirki wagtda 4000-den gowrak işjeň hyzmatdaşlara hyzmat edýäris, şol sanda diňe bir nusgawy IT integratorlary däl, eýsem önümlerimizi üpjünçilikde ulanýan önümçilik kärhanalary, gurluşyk kompaniýalary, maslahat beriş firmalary, programma üpjünçileri.",
                bp2: "STRATEGIÝA",
                p5: "Biziň strategiýamyz, uly tejribämiz, ýokary başarnyklylygymyz we dünýäniň dürli ýurtlarynda barlygymyz sebäpli üpjün edijiler we satyjylar tarapyndan öňdebaryjy IT paýlaýjy hökmünde ykrar edilmeli.",
                bp3: "MISSIÝA",
                p6: "Biziň missiýamyz hyzmatdaşlarymyza innowasiýa çözgütleri we ýokary hilli önümleri wagtynda bermek.",
                p7: "Ösýän bazar islegini kanagatlandyrmak we önümiň wagtynda bolmagy we önümiň çuňňur bilimi arkaly üpjün edijä we satyja baha goşmak üçin tehnologiýa önümlerini we çözgütlerini öňe sürmek üçin aýratyn işleýäris.",
                p8: "MUK islegi döretmek we önümleri bazara çykarmak, şeýle hem şahamça programmasy, netijeli üpjünçilik zynjyry we okuw arkaly satyjylarymyz üçin girdeji gazanmak üçin yzygiderli işleýär.",
                p9: "Işgärlerimize kuwwat berýän, gazananlaryny ykrar edýän we hemişe üýtgeýän iş gurşawyna uýgunlaşmaga kömek edýän şertleri saklamagy maksat edinýäris. MUK işgärleri şahsy we hünär taýdan ösmek üçin höweslendirýär. ",
                bp4: "HYZMATDAŞLYK WE JOGAPKÄRÇILIK",
                p10: "MUK aýratyn hyzmatdaş işewürlik modelini ulanýar. Ahyrky müşderiler bilen işlemeýäris we diler torunyň ösüşine bil baglaýarys. Hyzmatdaşlarymyzyň ahyrky müşderileriniň arasynda içerki işiň ähli pudaklary: bölek satuw, senagat, maliýe we jemgyýetçilik pudagy bar",
                p11: "Üstünlige ýetmek üçin jogapkärçiligimizi hyzmatdaşlarymyz bilen paýlaşýarys. Dünýägaraýyşymyz: \"Bile gidýäris, şonuň üçin ahyryna çenli bilelikde gidýäris\". Kyn ýagdaýlarda hyzmatdaşlarymyzy goldaýarys we ýeňişleri bilelikde belleýäris we tejribäniň görkezişi ýaly ýeňlişlerden has köp bilelikdäki ýeňişlerimiz bar.",
                p12: "MUK, köp ýyllyk işi bilen, portfelimizdäki ähli satyjylar bäsdeşlik bazarynda ösmek we işlemek üçin deň mümkinçilik alýan köp satyjy strategiýasynyň durmuşa ukyplydygyny subut etdi. Hyzmatdaşlaryň taslamalarda işlemek üçin strategiýany saýlamak hukugyny özünde saklaýarys, şol bir wagtyň özünde, ähli satuw siklinde çylşyrymly çözgütleri döretmäge kömek edýäris: meseläni aýyrmakdan başlap ýerine ýetirişe we tehniki hyzmatyna çenli.",
                bp5: "BIZIAL GYMMATLARYMYZ",
                p13: "MUK, innowasiýa, jogapkärçilik, dogrulyk, mümkinçilikleriň deňligi we toparlaýyn işlemek, hormatlamak, öwrenmek we jemgyýetçilik jogapkärçiliginiň gymmatlyklaryna eýerip, işewür hyzmatdaşlarynyň we işgärleriniň üstünliklerini ýokarlandyrmaga doly üns berýär.",
                bp6: "Deň hukukly iş mümkinçiligi",
                p14: "Boş wezipelere dalaşgärleriň arzalary tire-taýpa, jyns, din, deriniň reňki, milli gelip çykyşy, ýaşy, jyns aýratynlygy we aňlatmasy, maýyplygy, jynsy ugry, weteran ýagdaýy ýa-da belli bir wezipäniň kärine bagly bolmadyk beýleki faktorlary hasaba almazdan seredilýär.",
                bp7: "Innowasiýa",
                p15: "Müşderilerimize, üpjün edijilerimize we kärdeşlerimize gymmatlyk goşmagyň has gowy usullaryny gözleýäris. Üýtgeşmelere garaşýarys we olara laýyk çözgütleri işjeň ýagdaýda döredýäris.",
                bp8: "Jogapkärçilik",
                p16: "Näme edýändigimizi aýdýarys we aýdýan zatlarymyzy edýäris. Hyzmatdaşlarymyzyň we üpjün edijilerimiziň isleglerine laýyk gelýän ýa-da ondan ýokary netijeleri yzygiderli gazanýarys",
                bp9: "Dogruçyllyk",
                p17: "Her bir işimizde, hemme ýerde we hemişe dogruçyllygy we adalatlylygy görkezmek bilen iň ýokary ahlak kadalaryny goldaýarys.",
                bp10: "Toparlaýyn iş we hormat",
                p18: "Biz kärdeşlerimiziň, hyzmatdaşlarymyzyň we jemgyýetimiziň hukuklaryna we ynançlaryna hormat goýýarys. Bilelikdäki maksatlarymyza ýetmek üçin dürlüligi ulanyp, başgalara iň ýokary mertebe, deňlik we ynam bilen çemeleşýäris. Topar hökmünde aýrybaşgalykdan köp zat edýäris",
                bp11: "Bilim",
                p19: "Önümçiligi ýokarlandyrmak we kompaniýany we özümizi ösdürmek üçin elmydama täze bilim alýarys.",
                bp12: "Jemgyýetçilik jogapkärçiligi",
                p20: "Dünýäniň dürli gyzyklanýan taraplary üçin peýdaly netijelere ýetmek üçin maliýe, jemgyýetçilik we daşky gurşaw jogapkärçiligimizi deňleşdirmegiň ýollaryny işjeň gözleýäris. Bu ýolda hyzmatdaşlyga, aç-açanlyga we täzelige çalyşýarys.",
                bp13: "Näme üçin MUK?",
                p21: "MUK bilen hyzmatdaşlarymyz ygtybarly paýlaýjy we möhüm bäsdeşlik artykmaçlygyny alýarlar",
                p22: "Hyzmatdaşlarymyz MUK hyzmatlarynyň we ýardamynyň çeýeligini belläp, üýtgeýän bazar meýillerine aňsatlyk bilen uýgunlaşýarlar. Iň öňdebaryjy üpjün edijiler bilen işleýändigimiz sebäpli, müşderilerimiz öz işini ösdürmek üçin elmydama täze mümkinçilikler tapýarlar.",
                p23: "Çeýe maliýeleşdiriş wariantlarymyz müşderilerimiz üçin döredildi, aýratyn çözgüt ýa-da ýöriteleşdirilen karz ugurlary bolsun, hyzmatdaşlara iş alyp barmagy aňsatlaşdyrýarys.",
                p24: "Ýüze çykýan ähli meseleleri aýry satyjylar tarapyndan bellenen hasap dolandyryjylarynyň we önüm hünärmenleriniň kömegi bilen çözýäris. Size zerur bilimleriň hemmesi bir ýerde, hünär taýýarlygymyz we giňişleýin marketing goldawy, her bir işimize ynamly bolup biljekdigiňizi aňladýar.",
                p25: "MUK, işiňiziň we müşderileriňiziň talaplaryna çeýeligi we çalt seslenmegi berýän tejribeli kompaniýa",
                p26: "Biziň täjirçilik başlangyçlarymyz, işiň hilini kepillendirýär. Şeýle hem, müşderilerimize tejribeli halkara logistika, okuw we hyzmat merkezi, bulut önümleriniň bölünişiginden peýdalanmaga kömek edip bileris.",
                p27: "Gowy iş akymynyň gowy satuwy aňladýandygyny her kimden has gowy bilýäris we seslenmegiň tizligi, işjeňlik we töwekgelçiligi dolandyrmak hyzmatdaşymyzyň üstünlikli işiniň we müşderiler bilen abraýynyň möhüm bölegidigine düşünýäris. Şonuň üçin biz siziň iş amallaryňyzy gowulandyrýan we özara täsiriň tizligini aňsatlaşdyrýan elektron gurallaryny döretdik.",
                p28: " Her ädimde girdejiňizi we girdejiligiňizi ýokarlandyrmaga kömek edýäris."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Soraglar ýüze çykdy?",
                description: "Bize e-poçta ibermek üçin aşakdaky formany doldurmagyňyzy haýyş edýäris we mümkin boldugyça gysga wagtda size gaýdyp geleris",
                send: "Iber",
                nm: "Ady",
                ad: "Salgysy",
                ph: "Telefon",
                em: "E-poçta iberiň",
                ms: "Habar",
                contactInfo: "Şahsy maglumatlar",
                address: "Ukraina, Kiýew 03151, köç. Donetskskaýa 16/2",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Ähli hukuklar goralandyr."
            }
        }
    }

    if (lang === "uz") {
        text = {
            Navigation: [
                {
                    menu: "Davlatlar",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albaniya",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armeniya",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azarbayjon",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Xorvatiya",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Gruziya",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Qozog'iston",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Qirg'iziston",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mo'g'uliston",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbiya",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Sloveniya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapur",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tojikiston",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Kurka",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmaniston",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/hu",
                            name: "Vengriya",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "O'zbekiston",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Yechimlar",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK sotuvchilari"
                        },
                        {
                            link: "/solutions",
                            name: "MUK yechimlari"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Mahsulotlar va xizmatlar katalogi"
                        }
                    ]
                },
                {
                    menu: "Yangiliklar",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Yangiliklar va takliflar"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK jurnali"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Sferalar",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "ITni taqsimlash"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "O'quv markazi"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Xizmat ko'rsatish markazi"
                        },
                        {
                            link: "https://cloud.muk.uz/",
                            name: "MUK Cloud xizmatlari"
                        }
                    ]
                },
                {
                    menu: "Kompaniya haqida",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "MUK haqida asosiy ma'lumotlar"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Korporativ profil"
                        },
                        {
                            link: "/vacancies",
                            name: "Ishlar"
                        }
                    ]
                },
                {
                    menu: "Dilerlar bo'limi",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albaniya",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armeniya",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azarbayjon",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Xorvatiya",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Gruziya",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Qozog'iston",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Qirg'iziston",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mo'g'uliston",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbiya",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Sloveniya",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tojikiston",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Kurka",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmaniston",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "O'zbekiston",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Xalqaro loyiha VAD IT distribyutori",
                paragraph: "MUK hamkorlari bizda ishonchli ko'p sotuvchili AT distribyutorini ko'radilar, ular bizning ko'p yillik tajribamiz, texnik tajribamiz va yaxshi tashkil etilgan hamkorlik turiga ishonishadi.",
                partner: "Hamkor bo'ling"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Xalqaro distribyutor",
                    text: "Geografiya Yevropa va Osiyoning 16 ta davlatini o'z ichiga oladi va kengayishda davom etmoqda"
                },
                {
                    icon: "fa fa-star",
                    title: "25 yildan ortiq muvaffaqiyat",
                    text: "MUK 1997 yildan beri yetakchilik lavozimini egallab kelmoqda"
                },
                {
                    icon: "fa fa-users",
                    title: "Noyob tajriba",
                    text: "Muhandislar jamoasi hatto eng murakkab vazifani ham engishga qodir"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100 dan ortiq ishlab chiqaruvchilar",
                    text: "MUK distribyutorlari portfeli 100 dan ortiq xalqaro A-brendlarini o'z ichiga oladi va u doimiy ravishda o'sib bormoqda."
                }
            ],
            ServicesInfo: {
                title: "MUK faoliyat doirasi"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "ITni taqsimlash",
                    text: "MUK - bu IT-loyiha biznesiga yo'naltirilgan VAD distribyutori. Biz 25 yildan ortiq vaqt davomida Evropa va Osiyoda dilerlik tarmog'ini muvaffaqiyatli rivojlantirmoqdamiz. \nSertifikatlangan mutaxassislar shtabi yordamida MUK kompaniyasi hamkorlarga taklif etilayotgan yechimlar uchun qoʻshimcha qiymat yaratadigan yuqori darajadagi loyihalar boʻyicha maslahat va texnik yordam koʻrsatadi.\nMUK muhandislari dasturiy-apparat yechimlari uchun konsalting va texnik yordam koʻrsatadilar, auditlar oʻtkazadilar. mavjud tizimlar va test stendlarini amalga oshirishda yordam beradi. Bizning sinov uskunalari zaxiramiz bizga real sharoitlarda keng ko'lamli vazifalarni taqlid qilish va amalga oshirish imkonini beradi. \nMUK integratorlarga optimal yechimlarni tanlash va loyihalashda faol yordam beradi.\nMUK jamoasi turli texnologiya sohalari bo‘yicha dunyoning yetakchi IT-ishlab chiqaruvchilari tomonidan sertifikatlangan 500 dan ortiq mutaxassislarni o‘z ichiga oladi.",
                    activ1: "Xalqaro logistika, zaxiralarni shakllantirish",
                    activ2: "Hamkorlar uchun marketing va konsalting yordami",
                    activ3: "O'z tajribamiz orqali yechimlar qiymatini oshirish",
                    activ4: "Mahsulotni ishga tushirish, ilgari surish va talabni shakllantirish",
                    activ5: "Texnik yordam, kafolat va kafolatdan keyingi xizmat ko'rsatish",
                    activ6: "Hamkorlar tarmog'ini rivojlantirish"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider Cloud mahsulotlari",
                    text: "MUK Cloud Solutions for Business – zamonaviy xavfsiz hamkorlik vositalarini taqdim etgan holda biznes uzluksizligini ta’minlashga, ish samaradorligini va xodimlarning harakatchanligini oshirishga qaratilgan yechimlar va xizmatlarning tezkor to‘plamidir.\nUlar yordamida siz bulutli texnologiyalarni tez va samarali joriy etishingiz mumkin. tashkilotingiz infratuzilmasi. Cloud Solution Provider kontseptsiyasi Microsoft Office 365, AZURE, EMS, D365 va boshqa bulut xizmatlaridan oylik to‘lov asosida foydalanish mumkin bo‘lgan savdo kanalidir.\nMUK “noldan” infratuzilma yaratishni taklif qiladi. Minimal kapital xarajatlar. Bulutli resurslarni ijaraga olish va texnik xizmat ko'rsatish uchun optimal operatsion xarajatlar. Infratuzilmani kengaytirish (korxonaning o'sishi, yangi hududiy idoralar, rejalashtirilgan yuk portlashlari). Bulutdagi yangi xizmatlar yer usti infratuzilmasi bilan birlashtirilgan.",
                    activ1: "Zaxira nusxalarini (fayllar, virtual mashinalar, ma'lumotlar bazalari) bulutda saqlash.",
                    activ2: "Avariyadan himoya qilish, tiklash. Virtual mashinalar yoki SQL ma'lumotlar bazalari darajasida yuqori mavjudlik klasteri.",
                    activ3: "Mobil qurilmalarni boshqarish.",
                    activ4: "Korporativ ma'lumotlar va yozishmalarni himoya qilish",
                    activ5: "SharePoint on-line, Exchange on-layn, Skype biznes uchun on-layn tarqatish.",
                    activ6: "Veb-saytlarni joylashtirish va sozlash, veb-saytlarni bulutga ko'chirish."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK xizmat ko'rsatish markazi.",
                    text: "MUK Service kompaniyasi 2002-yildan buyon kompyuterlarni taʼmirlash xizmatlarini muvaffaqiyatli taqdim etib kelmoqda va bugungi kunda u APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius uchun vakolatli servis markazi hisoblanadi. , Dell EMC, Tescom va boshqa ishlab chiqaruvchilar. MUK-Servis kompaniyasining sifat menejmenti tizimi Xalqaro sertifikatlashtirish byurosining ISO 9001 sertifikati bilan tasdiqlangan.\nHar qanday nosozlikni bartaraf etish uchun haqiqiy professional kerak. Tajriba va kundalik amaliyotga ega bo'lgan ta'mirchilarimiz har qanday nosozlikni bartaraf etishadi. Professionallik tajriba bilan birga keladi, biz o'zimizni takomillashtiramiz va bilim saviyasini oshiramiz. Xizmat ko'rsatish markazi xodimlari sertifikatlangan mutaxassislardan iborat bo'lib, mijozlarga uskunalarni yuqori sifatli va professional ta'mirlashni kafolatlaydi. MUK Service sifatli xizmat ko'rsatish uchun barcha zarur texnik imkoniyatlarga ega. Xizmat ko'rsatish markazi har qanday murakkablik darajasidagi texnik xizmat ko'rsatish, kafolatli va kafolatsiz ta'mirlashni amalga oshiradi. MUK Service kompaniyasi Ukraina, Armaniston, Gruziya, Moldova, Tojikiston va Qozog'istondagi korporativ mijozlar uchun uskunalar ijarasi va autsorsing, o'rnatish va texnik xizmat ko'rsatish, shuningdek, axborot va konsalting xizmatlarini taqdim etadi.",
                    activ1: "Kafolat ta'mirlash",
                    activ2: "Kafolatsiz ta'mirlash",
                    activ3: "Uskunalar diagnostikasi",
                    activ4: "Ehtiyot qismlar sotish",
                    activ5: "Xizmat shartnomalari auditi",
                    activ6: "Uskunalarni ijaraga olish va autsorsing"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK o'quv markazi",
                    text: "MUK oʻquv markazi 15 yildan ortiq tajribaga va bir qator noyob ruxsatlarga, malakali oʻqituvchilar jamoasiga va zamonaviy oʻquv infratuzilmasiga ega boʻlgan IT taʼlim xizmatlari bozori yetakchisi hisoblanadi.\nMUK TC portfeli yetakchi IT sohasining 300 dan ortiq oʻquv kurslarini oʻz ichiga oladi. kompaniyalar.\nE'tiborga molik maqomlarga quyidagilar kiradi: Pearson VUE, Veeam vakolatli ta'lim markazi, HPE ta'lim markazi, VMware vakolatli o'quv markazi, Oracle tomonidan tasdiqlangan ta'lim provayderi, Penta xavfsizlik ta'lim markazi, Juniper Networks vakolatli ta'lim hamkori, LearnQuest IBM ta'lim hamkori, Microsoft Education Silver hamkori, ITIL oʻquv hamkori, Dell-EMC Education Services hamkori, Autodesk oʻquv markazi, Grandstream oʻquv markazi, Check Point vakolatli oʻquv markazi, Fortinet vakolatli oʻquv markazi, CommScope oʻquv markazi, Cisco oʻquv markazi, Red Hat sertifikatlangan oʻquv hamkori.\nMUK oʻquv markazi kirish huquqiga ega. eng zamonaviy o'quv jihozlariga. Ko'pchilik uchun o'qituvchilarimiz tomonidan o'qitish sifati Ukraina va xorijdagi talabalarning yuqori baholari bilan tasdiqlangan."
                }
            ],
            Vendors: {
                title: "MUK sotuvchilari",
                country: "Mamlakat",
                solution: "Yechim",
                name: "Ism",
                all: "Hammasi",
                namePlaceholder: "Sotuvchining ismini yozishni boshlang",
                notInfo: "Ma'lumotlar to'ldirilmagan"
            },
            VendorsForCountry: {
                title: "Mamlakatda MUK sotuvchilari mavjud"
            },
            VendorsForSolution: {
                title: "Yechim bo'yicha MUK sotuvchilari"
            },
            VendorDetail: {
                title: "Vakolatli DISTRIBUTOR"
            },
            Gallery: {
                title: "MUK yechimlari"
            },
            Distribution: {
                title: "ITni taqsimlash"
            },
            Partner: {
                title: "Hamkor bo'ling",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Yuborish",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK o'z biznesini sheriklik va hamkorlik tamoyillari asosida quradi",
                advantages: "Foyda",
                paragraph: "MUK tashkil etilganidan beri yetkazib beruvchilar va mijozlar bilan munosabatlarda shaffoflikka e'tibor qaratib keladi. Hamkorlik qoidalariga sodiqlik MUKga bozor ishonchini qozonish va yetakchi obro‘sini oshirish imkonini berdi.",
                Why: [
                    "Innovatsiyalar",
                    "Mas'uliyat",
                    "Butunlik",
                    "Teng ish imkoniyatlari"

                ],
                Why2: [
                    "Jamoaviy ish va hurmat",
                    "Trening",
                    "Ijtimoiy javobgarlik"
                ]
            },
            News: {
                title: "MUK yangiliklari",
                showAll: "Ko'proq ko'rsatish",
                showMore: "Ko'proq ko'rsatish",
                news: "Yangiliklar",
                akcii: "Bitim"
            },
            Vacancies: {
                title: "Karyeralar",
                resume: "Send a CV",
                country: "Mamlakat",
                all: "Hammasi",
                search: "Qidirmoq",
                namePlaceholder: "Ismni yozishni boshlang",
                filterInfo: "Bu filtrlarga mos keladigan ish topilmadi",
                notInfo: "Ma'lumotlar to'ldirilmagan",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" jurnali soni",
                vupysk: "Nashr"
            },
            OMuk: {
                title: "MUK haqida asosiy ma'lumotlar",
                p1: "MUK kompaniyalar guruhi oʻz faoliyatini 1997 yilda boshlagan. Bizning asosiy ish yoʻnalishimiz gibrid va bulutli yechimlar, maʼlumotlar markazlari konvergentsiyasi, axborot xavfsizligi, mobil qurilmalar va narsalar interneti sohasida yetakchi IT mahsulotlarini loyihaga yoʻnaltirilgan tarqatish, ma'lumotlar tahlili va sun'iy intellekt.",
                p2: "Global tarqatish tarmog'imiz tufayli biz istiqbolli IT-sotuvchilarni va ularning yangi mahsulotlarini mahalliy bozorlarga olib chiqamiz va talabni shakllantirishda faol ishtirok etamiz.",
                p3: "Biz professional texnik va bozor bilimlarini ilg'or hamkorlarni qo'llab-quvvatlash dasturi bilan birlashtiramiz. Dilerlarimiz bilan yaqindan hamkorlik qilib, biz ularning dinamik o'sishi va rivojlanishini ta'minlashga, birgalikda natijalarga erishishga intilamiz.",
                bp1: "BIZ AXBOROT TEXNOLOGIYALARIMIZ!",
                p4: "MUK kompaniyasi 25 yildan ortiq axborot texnologiyalarini tarqatishda kashshof hisoblanadi. Bugungi kunda MUK texnologiyalarni uni ishlab chiquvchilardan uni amalga oshiruvchi va ishlatadiganlarga o'tkazishda muhim rol o'ynaydi.",
                ul: "Mana, MUKni ishonchli hamkor va samarali distribyutor sifatida tavsiflovchi to'rtta raqam:",
                li1: "1. 25 yildan ortiq tajriba va ishonch.",
                li2: "2. A-brend darajasidagi 100 dan ortiq sotuvchilar (tasdiqlangan mahsulotlarga ega butun dunyo bo'ylab mashhur kompaniyalar).",
                li3: "3. Har bir sotuvchi hududining o'z menejerlari, sotuvchilari va muhandislari bor, shuning uchun bizning xodimlarimiz 500 dan ortiq mutaxassislardan iborat.",
                li4: "4. Hozirda biz 4000 dan ortiq faol hamkorlarga, jumladan, nafaqat klassik IT integratorlari, balki ishlab chiqarish korxonalari, qurilish kompaniyalari, konsalting kompaniyalari, mahsulotlarimizdan yetkazib berishda foydalanadigan dasturiy taʼminot ishlab chiqaruvchilariga xizmat koʻrsatamiz.",
                bp2: "STRATEGIYA",
                p5: "Bizning strategiyamiz katta tajribamiz, yuqori malakamiz va dunyoning turli mamlakatlaridagi mavjudligimiz tufayli yetkazib beruvchilar va sotuvchilar tomonidan yetakchi IT distribyutor sifatida tan olinishidir.",
                bp3: "MISSIYA",
                p6: "Bizning vazifamiz hamkorlarimizga innovatsion yechimlar va sifatli mahsulotlarni o‘z vaqtida taqdim etishdan iborat.",
                p7: "Biz o'sib borayotgan bozor talabini qondirish va mahsulotning tezkor mavjudligi va chuqur mahsulot bilimi orqali yetkazib beruvchiga ham, sotuvchiga ham qiymat qo'shish uchun texnologik mahsulotlar va echimlarni ilgari surish uchun astoydil ishlaymiz.",
                p8: "MUK talab va mahsulotlarni ishlab chiqarishni yaratish, shuningdek, hamkorlik dasturi, samarali ta'minot zanjiri va treninglar orqali sotuvchilarimiz uchun foydali imkoniyatlar yaratish bo'yicha tizimli ravishda ishlamoqda.",
                p9: "Biz odamlarimizga imkoniyat beradigan, ularning yutuqlarini tan oladigan va doimiy o‘zgaruvchan biznes muhitiga moslashishga yordam beradigan muhitni saqlashga intilamiz. MUK xodimlarni barqaror shaxsiy va professional o'sishga undaydi.",
                bp4: "HAMKORLIK VA MAS'uliyat",
                p10: "MUK faqat hamkor biznes modeliga amal qiladi. Biz oxirgi mijozlar bilan ishlamaymiz va dilerlik tarmog'ining rivojlanishiga tayanamiz. Hamkorlarimizning yakuniy mijozlari orasida mahalliy biznesning barcha tarmoqlari bor: chakana savdo, sanoat, moliya va davlat sektori.",
                p11: "Biz hamkorlarimiz bilan muvaffaqiyatga erishish uchun mas'uliyatni baham ko'ramiz. Bizning kredomiz: \"Biz birga boramiz, shuning uchun biz oxirigacha birga boramiz.\" Biz qiyin vaziyatlarda hamkorlarimizni qo'llab-quvvatlaymiz va g'alabalarni birgalikda nishonlaymiz va tajriba shuni ko'rsatadiki, bizda mag'lubiyatlardan ko'ra ko'proq umumiy g'alabalar mavjud.",
                p12: "O'zining ko'p yillik faoliyati bilan MUK o'zining ko'p sotuvchi strategiyasining hayotiyligini isbotladi, bunda bizning portfelimizdagi barcha sotuvchilar raqobatbardosh bozor muhitida rivojlanish va ishlash uchun teng imkoniyatga ega bo'ladilar. Biz hamkorlarga loyihalarda ishlash strategiyasini tanlash huquqini o'zida saqlab qolamiz, shu bilan birga kompleks yechimlarni yaratishga yordam beramiz, butun savdo tsikli bo'yicha maslahat beramiz: topshiriqni olib tashlashdan boshlab amalga oshirish va texnik xizmat ko'rsatishgacha.",
                bp5: "BIZNING QADIRLARIMIZ",
                p13: "MUK innovatsiyalar, mas'uliyat, halollik, teng imkoniyatlar va jamoaviy ish, hurmat, o'rganish va ijtimoiy mas'uliyat qadriyatlariga rioya qilish orqali o'z biznes hamkorlari va xodimlarining muvaffaqiyatini oshirishga to'liq e'tibor qaratadi.",
                bp6: "Teng ish imkoniyatlari",
                p14: "Biz nomzodlarning ishga arizalarini irqi, jinsi, dini, terining rangi, etnik kelib chiqishi, yoshi, jinsi va ifodasi, nogironligi, jinsiy orientatsiyasi, faxriy maqomi yoki ma'lum bir lavozimga malaka bilan bog'liq bo'lmagan boshqa omillardan qat'i nazar ko'rib chiqamiz.",
                bp7: "Innovatsiyalar",
                p15: "Biz doimo mijozlarimiz, yetkazib beruvchilar va hamkasblarimizga imtiyozlar berishning yaxshiroq usullarini qidiramiz. Biz o'zgarishlarni proaktiv ravishda ularga mos keladigan echimlarni yaratishda kutamiz.",
                bp8: "Mas'uliyat",
                p16: "Biz nima qilayotganimizni aytamiz va aytganimizni qilamiz. Biz doimiy ravishda hamkorlarimiz va yetkazib beruvchilarimiz kutgan natijalarga erishamiz.",
                bp9: "Butunlik",
                p17: "Biz hamma joyda va har doim qilgan har bir harakatimizda halollik va adolatni ko'rsatadigan eng yuqori axloqiy me'yorlarni qo'llab-quvvatlaymiz.",
                bp10: "Jamoaviy ish va hurmat",
                p18: "Biz hamkasblarimiz, hamkorlarimiz va jamiyatimizning huquq va e’tiqodlarini hurmat qilamiz. Biz boshqalarga eng yuqori darajadagi qadr-qimmat, tenglik va ishonch bilan munosabatda bo'lib, umumiy maqsadlarimizga erishish uchun xilma-xillikdan foydalanamiz. Jamoa sifatida biz individualdan ko'proq narsani qilamiz.",
                bp11: "Trening",
                p19: "Biz doimo samaradorlikni oshirish va kompaniyamiz va o'zimiz o'sishini ta'minlashni o'rganamiz.",
                bp12: "Ijtimoiy javobgarlik",
                p20: "Biz butun dunyo bo'ylab turli manfaatdor tomonlar uchun ijobiy natijalarga erishish uchun moliyaviy, ijtimoiy va ekologik mas'uliyatimizni muvozanatlash yo'llarini faol ravishda qidiramiz. Bu yo'lda biz hamkorlik, shaffoflik va innovatsiyalarga intilamiz.",
                bp13: "NEGA MUK?",
                p21: "MUK bilan bizning hamkorlarimiz ishonchli distribyutor va sezilarli raqobatdosh ustunlikka ega bo'lishadi.",
                p22: "Bizning hamkorlarimiz MUK xizmatlarining moslashuvchanligini ta'kidlagan holda o'zgaruvchan bozor tendentsiyalariga osongina moslashadi. Biz eng ilg'or yetkazib beruvchilar bilan ishlayotganimiz sababli, mijozlarimiz har doim o'z bizneslarini rivojlantirish uchun yangi imkoniyatlar topadilar",
                p23: "Bizning moslashuvchan moliyalashtirish variantlarimiz mijozlarimiz uchun mo'ljallangan, xoh bu buyurtma bo'ladimi, xoh maxsus kredit liniyalari bo'ladimi, biz hamkorlar uchun biznesni osonlashtiramiz.",
                p24: "Biz barcha yuzaga keladigan muammolarni turli sotuvchilarga ajratilgan maxsus hisob menejerlari va mahsulot mutaxassislari yordamida hal qilamiz. Sizga kerak bo'lgan barcha bilimlar bir joyda to'planadi va bizning professional ta'limimiz va keng ko'lamli marketing yordamimiz biz qilayotgan har bir narsaga ishonch hosil qilishingizni anglatadi.",
                p25: "MUK - bu sizning biznesingiz va mijozlaringiz ehtiyojlariga moslashuvchanlik va javob berishni ta'minlaydigan tajribali kompaniya.",
                p26: "Bizning tijorat tashabbuslarimiz assortimenti sizga mukammal ish sifatini kafolatlaydi. Shuningdek, biz mijozlarimizga tajribali xalqaro logistika, o'quv va xizmat ko'rsatish markazlari, bulutli mahsulotlar bo'limidan foydalanishda yordam bera olamiz.",
                p27: "Biz hammadan ko‘ra yaxshi ish jarayoni yaxshi savdoni anglatishini yaxshi bilamiz va biz sezgirlik, faollik va risklarni boshqarish hamkorimizning muvaffaqiyatli biznesining muhim qismi va ularning mijozlar oldidagi obro‘-e’tibori ekanligini tushunamiz. Shuning uchun biz biznes jarayonlaringizni yaxshilaydigan va o'zaro aloqa tezligini soddalashtiradigan elektron vositalarni yaratdik.",
                p28: "Biz sizning daromadingiz va rentabelligingizni har qadamda oshirishga yordam beramiz."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Savollaringiz bo'lsa?",
                description: "Iltimos, bizga elektron pochta xabarini yuborish uchun quyidagi shaklni to'ldiring va biz imkon qadar tezroq siz bilan bog'lanamiz.",
                send: "Yuborish",
                nm: "Ism",
                ad: "Manzil",
                ph: "Telefon",
                em: "Elektron pochta",
                ms: "Xabar",
                contactInfo: "Aloqa tafsilotlari",
                address: "16/2 Donetska ko'chasi, Kiyev 03151, Ukraina",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Barcha huquqlar himoyalangan."
            }
        }
    }

    if (lang === "hr") {
        text = {
            Navigation: [
                {
                    menu: "Države",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albanija",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenija",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbajdžan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Hrvatska",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        /*{
                            link: "/country/by",
                            name: "Bjelorusija",
                            flag: "by.svg",
                            id: 2,
                            iso: "by"
                        },*/
                        {
                            link: "/country/ge",
                            name: "Gruzija",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazahstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kirgistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/hu",
                            name: "Mađarska",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/md",
                            name: "Moldavija",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolija",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Srbija",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenija",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapur",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tadžikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turska",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukrajina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Rješenja",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK dobavljači"
                        },
                        {
                            link: "/solutions",
                            name: "MUK rješenja"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Katalog proizvoda i usluga"
                        }
                    ]
                },
                {
                    menu: "Novosti",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "Novosti i promocije"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK magazin"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "Smjer",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT distribucija"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Trening centar"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Servisni centar"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "Muk Cloud usluge"
                        }
                    ]
                },
                {
                    menu: "O tvrtki",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "Glavne informacije o MUK-u"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Korporativni profil"
                        },
                        {
                            link: "/vacancies",
                            name: "Poslovi"
                        }
                    ]
                },
                {
                    menu: "Odjel dealera",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albanija",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenija",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbajdžan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Hrvatska",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                            /*{
                                link: "/country/by",
                                name: "Bjelorusija",
                                flag: "by.svg",
                                id: 2,
                                iso: "by"
                            },*/{
                            link: "https://b2b.muk.ge/",
                            name: "Gruzija",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazahstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kirgistan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldavija",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolija",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Srbija",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenija",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tadžikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turska",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukrajina",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "Međunarodni projektni VAD IT distributer",
                paragraph: "MUK Partneri u nama vide pouzdanog  IT distributera , vjeruju našem dugogodišnjem iskustvu, tehničkoj stručnosti i dobro uspostavljenoj vrsti partnerstva",
                partner: "Postanite partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "Međunarodni distributer",
                    text: "Prisutni smo u 16 zemalja Europe i Azije i nastavljamo se širiti"
                },
                {
                    icon: "fa fa-star",
                    title: "Više od 25 godina uspješng poslovanja",
                    text: "MUK drži vodeću poziciju od 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Jedinstvena stručnost",
                    text: "Tim inženjera može se nositi i s najkompliciranijim zadatkom"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ proizvođača",
                    text: "Portfelj  MUK-a sadrži više od 100 međunarodnih A-brandova i kontinuirano raste"
                }
            ],
            ServicesInfo: {
                title: "Opseg aktivnosti MUK-a"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT distribucija",
                    text: "MUK je VAD distributer usmjeren na poslovanje s IT projektima.Više od 25 godine uspješno razvijamo mrežu trgovaca u Europi i Aziji.Uz pomoć osoblja certificiranih stručnjaka, tvrtka MUK partnerima pruža visoku razinu podrške,savjetodavne i tehničke koja generira dodatnu vrijednost za predložena rješenja.MUK inženjeri pružaju savjetodavnu i tehničku podršku za softverska i hardverska rješenja, provode revizije postojećih sustava i pomažu u implementaciji istih.Naš lager testne opreme omogućuje nam simulaciju i provedbu širokog spektra zadataka u stvarnim uvjetima.MUK aktivno pomaže integratorima u odabiru i dizajniranju optimalnih rješenja.MUK tim uključuje više od 500 stručnjaka u različitim tehnološkim područjima koji su certificirani od strane vodećih svjetskih IT proizvođača",
                    activ1: "Međunarodna logistika, formiranje zaliha",
                    activ2: "Marketinška i savjetodavna podrška partnerima",
                    activ3: "Povećanje vrijednosti rješenja kroz vlastitu ekspertizu",
                    activ4: "Lansiranje proizvoda, promocija i generiranje potražnje",
                    activ5: "Tehnička podrška, jamstveni i post-jamstveni servis",
                    activ6: "Razvoj partnerske mreže"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider Cloud Proizvodi u oblaku",
                    text: "MUK Business Cloud Solutions su quick-start paketi rješenja i usluga usmjerenih na osiguranje kontinuiteta poslovanja, povećanje radne učinkovitosti i mobilnosti zaposlenika uz pružanje suvremenih alata za sigurnu suradnju.Uz njihovu pomoć možete brzo i učinkovito implementirati tehnologije oblaka u infrastrukturu svoje tvrtke ili ustanove.Koncept Cloud Solution Provider prodajni je kanal u kojem su na mjesečnoj osnovi plaćanja dostupni Microsoft Office 365, AZURE, EMS, D365 i druge usluge u oblaku.MUK nudi stvaranje infrastrukture 'od nule'.Minimalni kapitalni troškovi.Optimalni operativni troškovi za najam resursa u oblaku i održavanje.Skaliranje infrastrukture (rast poduzeća, novi teritorijalni uredi, planirani izboji opterećenja). Nove usluge u oblaku integrirane s zemaljskom infrastrukturom.",
                    activ1: "Spremanje sigurnosnih kopija (datoteka, virtualnih strojeva, baza podataka) u oblaku.",
                    activ2: "Zaštita od rušenja, oporavak. Klaster visoke dostupnosti na razini virtualnih strojeva ili SQL baza podataka.",
                    activ3: "Upravljanje mobilnim uređajima.",
                    activ4: "Korporativne informacije i zaštita korespondencije.",
                    activ5: "Implementacija SharePoint on-line, Exchange on-line, Skype za tvrtke on-line.",
                    activ6: "Implementacija i postavljanje web stranica, migracija web stranica u oblak."
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK servisni centar",
                    text: "Tvrtka MUK Servis uspješno pruža usluge popravka računala od 2002. godine, a danas je ovlašteni servisni centar za APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom i druge proizvođače. Sustav upravljanja kvalitetom tvrtke MUK-Servis potvrđuje CERTIFIKAT ISO 9001 ureda za međunarodnu certifikaciju.Potreban je pravi profesionalac da bi se popravio bilo kakav kvar.Stječući iskustvo i svakodnevnu praksu, naši serviseri rješavaju svaki kvar.Profesionalnost dolazi s iskustvom, usavršavamo se i povećavamo razinu našeg znanja.Osoblje servisnog centra sastoji se od certificiranih stručnjaka koji kupcima jamče kvalitetan i profesionalan popravak opreme.MUK servis ima sve potrebne tehničke mogućnosti za pružanje kvalitetne usluge.Servisni centar obavlja održavanja,popravke u jamstvu i van jamstva bilo koje razine složenosti.Tvrtka MUK Servis pruža usluge iznajmljivanja i outsourcinga opreme, ugradnje i održavanja, kao i informacijske i konzultantske usluge za korporativne klijente u Ukrajini, Armeniji, Bjelorusiji, Gruziji, Moldaviji, Tadžikistanu i Kazahstanu.",
                    activ1: "Popravak u jamstvu",
                    activ2: "Popravak van jamstva",
                    activ3: "Dijagnostika opreme",
                    activ4: "Prodaja rezervnih dijelova",
                    activ5: "Revizija ugovora o servisiranju",
                    activ6: "Najam opreme i outsourcing"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK trening centar",
                    text: "MUK Centar za obuku tržišni je lider u it obrazovnim uslugama s više od 15 godina iskustva i nizom jedinstvenih ovlaštenja,uz tim kvalificiranih instruktora i modernom infrastrukturom za obuku.Portfelj MUK Centra za obuku uključuje više od 300 tečajeva obuke vodećih IT tvrtki.Značajni statusi uključuju: Pearson VUE, Veeam ovlašteni obrazovni centar, HPE edukacijski centar, VMware ovlašteni centar za obuku, Oracle odobreni pružatelj obrazovanja, Penta Security Education Center, Juniper Networks ovlašteni obrazovni partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner,ITIL-ov partner za obuku, Dell-EMC partner za obrazovne usluge, Centar za obuku Autodesk, Grandstream centar za učenje, ovlašteni centar za obuku kontrolne točke, ovlašteni centar za obuku Fortinet, CommScope centar za obuku, Cisco centar za učenje, Partner za obuku s certifikatom Red Hat.MUK Centar za obuku ima pristup najmodernijoj obrazovnoj opremi. Kvalitetu nastave naših instruktora potvrdile su visoke ocjene studenata u Ukrajini i inozemstvu."
                }
            ],
            Vendors: {
                title: "Muk dobavljači",
                country: "Država",
                solution: "Rješenja",
                name: "Naziv",
                all: "Svi",
                namePlaceholder: "Počnite upisivati ime dobavljača",
                notInfo: "Podaci nisu ispunjeni"
            },
            VendorsForCountry: {
                title: "Dobavljači MUK-a dostupni u zemlji"
            },
            VendorsForSolution: {
                title: "MUK dobavljači po rješenjima"
            },
            VendorDetail: {
                title: "Autorizirani distributer"
            },
            Gallery: {
                title: "MUK rješenja"
            },
            Distribution: {
                title: "IT distribucija"
            },
            Partner: {
                title: "Postanite partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Pošalji",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK svoje poslovanje gradi na načelima partnerstva i suradnje",
                advantages: "Prednosti",
                paragraph: "MUK se od svog osnutka usredotočuje na transparentnost u odnosima s dobavljačima i kupcima. Predanost pravilima partnerstva omogućila je MUK-u da stekne povjerenje tržišta i izgradi ugled lidera",
                Why: [
                    "Inovacije",
                    "Odgovornost",
                    "Integritet",
                    "Jednake mogućnosti zapošljavanja"

                ],
                Why2: [
                    "Timski rad i poštovanje",
                    "Trening",
                    "Društvena odgovornost"
                ]
            },
            News: {
                title: "MUK novosti",
                showAll: "Pokaži više",
                showMore: "Pokaži više",
                news: "Novosti",
                akcii: "Promocija"
            },
            Vacancies: {
                title: "Karijera",
                resume: "Send a CV",
                country: "Država",
                all: "Sve",
                search: "Traži",
                namePlaceholder: "Počnite upisivati ime",
                filterInfo: "Nema poslova koji se podudaraju s tim filtrima",
                notInfo: "Podaci nisu ispunjeni",
                back: "Back"
            },
            MukReview: {
                title: " \"MUK-REVIEW\" magazin",
                vupysk: "Izdati"
            },
            OMuk: {
                title: "Glavne informacije o MUK-u",
                p1: "Naše glavno područje rada je projektno orijentirana distribucija vodećih IT proizvoda u području hibridnih i cloud rješenja, konvergencije podatkovnih centara, informacijske sigurnosti, mobilnih uređaja i interneta stvari, analitike podataka i umjetne inteligencije.Grupa tvrtki MUK započela je s radom 1997. godine.",
                p2: "Zahvaljujući našoj globalnoj distribucijskoj mreži, donosimo obećavajuće IT dobavljače i njihove nove proizvode na lokalna tržišta i aktivno sudjelujemo u formiranju potražnje.",
                p3: "Stručno tehničko i tržišno znanje kombiniramo s progresivnim programom podrške partnerima.Usko surađujući s našim partnerima, nastojimo osigurati njihov dinamičan rast i razvoj, postižući rezultate zajedno.",
                bp1: "MI SMO INFORMACIJSKE TEHNOLOGIJE!",
                p4: "Tvrtka MUK pionir je u distribuciji informacijske tehnologije više od 25 godina.Danas MUK igra važnu ulogu u prijenosu tehnologija s onih koji ga razvijaju na one koji ga implementiraju i koriste.",
                ul: "Evo četiri točke koje karakteriziraju MUK kao pouzdanog partnera i učinkovitog distributera:",
                li1: "1. Više od 25 godine iskustva i povjerenja.",
                li2: "2. Više od 100 dobavljača na razini A-branda (svjetski poznate tvrtke s dokazanim proizvodima).",
                li3: "3. Područje svakog dobavljača ima svoje menadžere, presales odjele i inženjere, tako da se naše osoblje sastoji od više od 500 stručnjaka.",
                li4: "4. Trenutno opslužujemo više od 4000 aktivnih partnera, uključujući ne samo klasične IT integratore, već i proizvodne pogone, građevinske tvrtke, konzultantske tvrtke, programere softvera koji koriste naše proizvode u svojim isporukama.",
                bp2: "STRATEGIJA",
                p5: "Našu strategiju trebaju prepoznati i dobavljači i partneri kao vodećeg IT distributera, zahvaljujući našem velikom iskustvu, visokoj kompetenciji i prisutnosti u različitim zemljama svijeta.",
                bp3: "MISIJA",
                p6: "Naša misija je pružiti našim partnerima inovativna rješenja i kvalitetne proizvode na vrijeme",
                p7: "Predano radimo na promicanju tehnoloških proizvoda i rješenja kako bismo zadovoljili rastuću potražnju na tržištu i dodali vrijednost dobavljaču i prodavaču brzom dostupnošću proizvoda i dubinskim znanjem o proizvodima.",
                p8: "MUK sustavno radi na stvaranju potražnje i lansiranju proizvoda, kao i na stvaranju profitabilnih mogućnosti za naše partnere kroz partnerski program, učinkovit lanac opskrbe i obuku.",
                p9: "Nastojimo održati okruženje koje osnažuje naše ljude, prepoznaje njihova postignuća i pomaže im da se prilagode poslovnom okruženju koje se stalno mijenja.MUK motivira zaposlenike za održiv osobni i profesionalni rast.",
                bp4: "PARTNERSTVO I ODGOVORNOST",
                p10: "MUK se pridržava isključivo partnerskog poslovnog modela. Ne radimo s krajnjim kupcima i oslanjamo se na razvoj mreže trgovaca.Među krajnjim kupcima naših partnera nalaze se svi sektori domaćeg poslovanja: maloprodaja, industrija, financije i javni sektor.",
                p11: "Odgovornost za postizanje uspjeha dijelimo s našim partnerima.Naš kredo: \"Idemo zajedno, pa idemo zajedno do kraja.\" Podržavamo naše partnere u teškim situacijama i zajedno slavimo pobjede, a kako je iskustvo pokazalo, imamo puno više zajedničkih pobjeda nego poraza.",
                p12: "Svojim dugogodišnjim radom MUK je dokazao održivost svoje strategije s više dobavljača u kojoj svi dobavljači u našem portfelju dobivaju jednaku priliku za razvoj i rad u konkurentnom tržišnom okruženju.Zadržavamo pravo partnera da odaberu strategiju za rad na projektima uz pomoć u stvaranju složenih rješenja, savjetujući cijeli prodajni ciklus: od uklanjanja zadataka do provedbe i održavanja.",
                bp5: "NAŠE VRIJEDNOSTI",
                p13: "MUK je u potpunosti usredotočen na poboljšanje uspjeha svojih poslovnih partnera i zaposlenika pridržavajući se vrijednosti inovacija, odgovornosti, integriteta, jednakih mogućnosti i timskog rada, poštovanja, učenja i društvene odgovornosti.",
                bp6: "Jednake mogućnosti zapošljavanja",
                p14: "Razmatramo prijave kandidata za posao bez obzira na rasu, spol, vjeru, boju kože, etničko podrijetlo, dob, rodni identitet i izražavanje, invaliditet, seksualnu orijentaciju, status veterana ili druge čimbenike koji nisu povezani s kvalifikacijom za određeno radno mjesto.",
                bp7: "Inovacija",
                p15: "Neprestano tražimo bolje načine za pružanje pogodnosti našim klijentima, dobavljačima i kolegama. Očekujemo promjene u proaktivnom stvaranju rješenja koja im odgovaraju.",
                bp8: "Odgovornost",
                p16: "Kažemo ono što radimo i radimo ono što kažemo. Dosljedno postižemo rezultate koji ispunjavaju ili premašuju očekivanja naših partnera i dobavljača.",
                bp9: "Integritet",
                p17: "Održavamo najviše etičke standarde koji pokazuju integritet i pravednost u svakoj akciji koju poduzmemo, svugdje i u svakom trenutku.",
                bp10: "Timski rad i poštovanje",
                p18: "Poštujemo prava i uvjerenja naših kolega, partnera i društva.Prema drugima se odnosimo s najvišom razinom dostojanstva, jednakosti i povjerenja koristeći raznolikost za postizanje naših zajedničkih ciljeva.Kao tim možemo više nego pojedinac.",
                bp11: "Trening",
                p19: "Neprestano učimo povećati produktivnost i osigurati rast naše tvrtke i nas samih.",
                bp12: "Socijalna odgovornost",
                p20: "Aktivno tražimo načine za uravnoteženje naših financijskih, socijalnih i ekoloških odgovornosti kako bismo postigli pozitivne rezultate za različite dioničare širom svijeta.Na tom putu nastojimo surađivati transparentnošću i inovacijama.",
                bp13: "ZAŠTO MUK?",
                p21: "Uz MUK, naši partneri dobivaju pouzdanog distributera i značajnu konkurentsku prednost.",
                p22: "Naši partneri lako se prilagođavaju promjenjivim tržišnim trendovima ističući fleksibilnost MUK usluga.Budući da surađujemo s najnaprednijim dobavljačima, naši klijenti uvijek pronalaze nove mogućnosti za rast poslovanja.",
                p23: "Naše fleksibilne mogućnosti financiranja dizajnirane su za naše klijente, bilo da se radi o prilagođenom rješenju ili namjenskim kreditnim linijama, olakšavamo partnerima poslovanje.",
                p24: "Sve nastale probleme rješavamo uz pomoć product managera i specijalista za proizvode svih dobavljača.",
                p25: "MUK je iskusna tvrtka koja vam pruža fleksibilnost i odaziv na potrebe vašeg poslovanja i kupaca.",
                p26: "Naš asortiman komercijalnih inicijativa jamči vam izvrsnu kvalitetu rada.Također možemo pomoći našim klijentima da iskoriste iskusne međunarodne logističke, trening i servisne centre kao i odjel za proizvode u oblaku.",
                p27: "Bolje od ikoga znamo da dobar tijek rada znači dobru prodaju i razumijemo da su odaziv, proaktivnost i upravljanje rizicima važan dio uspješnog poslovanja našeg partnera i njihove reputacije kod kupaca.Stoga smo stvorili elektroničke alate koji poboljšavaju vaše poslovne procese i pojednostavljuju brzinu interakcije.",
                p28: "Pomažemo povećati vaše prihode i profitabilnost na svakom koraku."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "Ako imate bilo kakvih pitanja?",
                description: "Molimo vas da ispunite sljedeći obrazac kako biste nam poslali email i u najkraćem mogućem roku ćemo biti u kontaktu s vama",
                send: "Pošalji",
                nm: "Ime",
                ad: "Adresa",
                ph: "Telefon",
                em: "Email",
                ms: "Poruka",
                contactInfo: "Kontakt",
                address: "16/2 Donetska str., Kijev,03151, Ukrajina",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "Sva prava pridržana."
            }
        }
    }

    if (lang === "rs") {
        text = {
            Navigation: [
                {
                    menu: "Countries",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/hu",
                            name: "Мађарска",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapore",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Solutions",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK vendors"
                        },
                        {
                            link: "/solutions",
                            name: "MUK solutions"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Catalogue of products and services"
                        }
                    ]
                },
                {
                    menu: "News",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "News and Deals"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK journal"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "ACTIVITIES",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT Distribution"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Training center"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Service center"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "MUK Cloud services"
                        }
                    ]
                },
                {
                    menu: "About company",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "About MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Corporative profile"
                        },
                        {
                            link: "/vacancies",
                            name: "Careers"
                        }
                    ]
                },
                {
                    menu: "Dealer section",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "INTERNATIONAL PROJECT VALUE-ADDED IT DISTRIBUTOR",
                paragraph: "Welcome to MUK – a reliable multi-vendor IT distributor. We earned credibility through years of experience, technical expertise and well-established partnership type of work with MUK Partners.",
                partner: "Become a partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "International distributor",
                    text: "MUK operates in 16 countries of Europe and Asia, and continue to expand"
                },
                {
                    icon: "fa fa-star",
                    title: "25+ years of success",
                    text: "MUK holds a leading position in distribution since 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Unique expertise",
                    text: "Teams of engineers handle the most complicated tasks"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ manufacturers",
                    text: "MUK distributor’s portfolio contains more than 100 international A-brands and never cease to grow"
                }
            ],
            ServicesInfo: {
                title: "MUK Scope of Activities"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT Distribution",
                    text: "MUK is a value-added distributor focused on IT project business. We have been successfully developing a dealer network in Europe and Asia for more than 25 years. With the help of our certified specialists, MUK company provides partners with the high level of project consulting and technical support to generate additional value for the proposed solutions. MUK engineers ensure consulting and technical support for software and hardware solutions, conduct audits of existing systems and help with the implementation of test benches. Our stock of test equipment allows us to simulate and implement a wide range of tasks in real conditions. MUK actively assists integrators in choosing and designing optimal solutions. The MUK team includes over 500 specialists in various technology areas who are certified by the world's leading IT manufacturers.",
                    activ1: "International logistics, formation of stocks",
                    activ2: "Marketing and consulting support for partners",
                    activ3: "Increasing solutions’ value through our own expertize",
                    activ4: "Product launch, promotion and demand generation",
                    activ5: "Technical support, warranty and post-warranty service",
                    activ6: "Partner network development"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider, Cloud products",
                    text: "MUK Cloud Solutions for Business are quick-start suites of solutions and services aimed at ensuring business continuity, increasing work efficiency and mobility of employees with the provision of modern secure collaboration tools. With their help, you can quickly and efficiently implement cloud technologies in the infrastructure of your organization. The Cloud Solution Provider concept is a sales channel, in which Microsoft Office 365, AZURE, EMS, D365 and other cloud services are available on a monthly payment basis. MUK offers the creation of infrastructure 'from scratch'. Minimum capital costs. Optimal operating costs for cloud resources rental and maintenance. Infrastructure scaling – enterprise growth, new territorial offices, planned load bursts. New cloud services integrated with ground infrastructure.",
                    activ1: "Storing backups (files, virtual machines, databases) in the cloud",
                    activ2: "Crash protection, recovery. High availability cluster at virtual machines or SQL databases level",
                    activ3: "Mobile device management",
                    activ4: "Corporate information and correspondence protection",
                    activ5: "SharePoint online, Exchange online, Skype for business online deployment",
                    activ6: "Deployment and setting of websites, migration of websites to the cloud"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service Center",
                    text: "It takes a true professional to fix any malfunction. Gaining experience and daily practice, our repairers ensure the best quality of service. As professionalism comes with experience, MUK Service company has been successfully providing computer repair services since 2002, and today we are an authorized service center for APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom and other manufacturers. MUK Service quality management system is confirmed by the ISO 9001 of the Bureau of International Certification. Our service center has all necessary technical capabilities and certified professionals to guarantee our clients high-quality equipment repair. The service center performs maintenance, warranty and non-warranty repairs of any level of complexity. MUK Service company provides equipment rental and outsourcing, installation and maintenance services, as well as information and consulting services for corporate clients in Ukraine, Armenia, Georgia, Moldova, Tajikistan and Kazakhstan.",
                    activ1: "Warranty repair",
                    activ2: "Non-warranty repair",
                    activ3: "Equipment diagnostics",
                    activ4: "Spare parts sale",
                    activ5: "Service contracts audit",
                    activ6: "Outsourcing and equipment rental"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK Training Center",
                    text: "MUK Training Center is a market leader in IT educational services with more than 15 years of experience, a number of unique authorizations, a team of qualified instructors, and a modern training infrastructure. The MUK TC portfolio is based on 300+ training courses from leading IT companies. Noteworthy statuses include: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner, and many others. MUK Training center has access to the best of modern educational equipment. The quality of our training programs has received the highest marks from students in Ukraine and abroad."
                }
            ],
            Vendors: {
                title: "MUK vendors",
                country: "Country",
                solution: "Solution",
                name: "Name",
                all: "All",
                namePlaceholder: "Start typing the vendor's name",
                notInfo: "Information is not filled in"
            },
            VendorsForCountry: {
                title: "MUK vendors available in the country"
            },
            VendorsForSolution: {
                title: "MUK vendors by solution"
            },
            VendorDetail: {
                title: "AUTHORIZED DISTRIBUTOR"
            },
            Gallery: {
                title: "MUK solutions"
            },
            Distribution: {
                title: "IT Distribution"
            },
            Partner: {
                title: "Become a partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK builds its business on the partnership and cooperation principles",
                advantages: "Benefits",
                paragraph: "MUK has been focusing on transparency in relations with suppliers and customers since its foundation. Devotion to the rules of partnership has allowed MUK to earn the trust of the market and build a leader's reputation.",
                Why: [
                    "Innovations",
                    "Responsibility",
                    "Integrity",
                    "Equal employment opportunities"

                ],
                Why2: [
                    "Teamwork and respect",
                    "Training",
                    "Social responsibility"
                ]
            },
            News: {
                title: "MUK news",
                showAll: "Show more",
                showMore: "Show more",
                news: "News",
                akcii: "Deal"
            },
            Vacancies: {
                title: "Careers",
                resume: "Send a CV",
                country: "Country",
                all: "All",
                search: "Search",
                namePlaceholder: "Start typing the name",
                filterInfo: "No jobs matching these filters",
                notInfo: "Information is not filled in",
                back: "Back"

            },
            MukReview: {
                title: " \"MUK-REVIEW\" journal issues",
                vupysk: "Issue"
            },
            OMuk: {
                title: "About MUK",
                p1: "The MUK group of companies started its activity in 1997. Our main area of work is the project-oriented distribution of leading IT products in the field of hybrid and cloud solutions, data center convergence, information security, mobile devices and the Internet of things, data analytics and artificial intelligence.",
                p2: "Thanks to our global distribution network, we bring promising IT vendors and their new products to local markets and actively participate in demand formation.",
                p3: "We combine expert technical and market knowledge with a progressive partner support program. Working closely with our dealers, we strive to ensure their dynamic growth and development, achieving results together.",
                bp1: "WE ARE THE INFORMATION TECHNOLOGIES!",
                p4: "MUK company has been a pioneer in information technology distribution for over 25 years. Today, MUK plays an important role in transferring technologies from those who develop it to those who implement and use it.",
                ul: "Here are the four figures characterizing MUK as a reliable partner and efficient distributor:",
                li1: "1. More than 25 years of experience and trust.",
                li2: "2. More than 100 vendors of A-brand level (worldwide known companies with proven products).",
                li3: "3. Each vendor's area has its managers, presales and engineers, so our staff consists of over 500 specialists.",
                li4: "4. We currently serve over 4000 active partners, including classical IT integrators but manufacturing enterprises, construction companies, consulting companies, and software developers who use our products in their deliveries.",
                bp2: "STRATEGY",
                p5: "Our strategy is to be recognized by both suppliers and resellers as a leading IT distributor, thanks to our vast experience, high competence and presence in different countries of the world.",
                bp3: "MISSION",
                p6: "Our mission is to provide our Partners with innovative solutions and quality products just in time.",
                p7: "We work dedicatedly to promote technology products and solutions to meet growing market demand and add value to both suppliers and resellers through prompt product availability and in-depth product knowledge.",
                p8: "MUK is systematically working to create demand and product launch, as well as generate profitable opportunities for our resellers through an affiliate program, an efficient supply chain and training.",
                p9: "We strive to maintain an environment that empowers our people, recognizes their accomplishments and helps them adapt to an ever-changing business environment. MUK motivates employees for sustainable personal and professional growth.",
                bp4: "PARTNERSHIP AND RESPONSIBILITY",
                p10: "MUK adheres to an exclusive partner business model. We do not work with end customers and rely on the development of the dealer network. Among our partners' end customers are all domestic business sectors: retail, industry, finance and the public sector.",
                p11: "We share the responsibility for achieving success with our partners. Our credo: \"We go together, so we go together to the end.\" We support our partners in difficult situations and celebrate victories together, and, as experience has shown, we have much more common wins than defeats.",
                p12: "With its many years of work, MUK has proven the viability of its multi-vendor strategy in which all vendors in our portfolio get an equal chance to develop and work in a competitive market environment. We reserve the right for partners to choose a strategy for working on projects while helping to create complex solutions, advising on the entire sales cycle: from task removal to implementation and maintenance.",
                bp5: "OUR VALUES",
                p13: "MUK is fully focused on enhancing the success of its business partners and employees by adhering to the values of innovation, responsibility, integrity, equal opportunities and teamwork, respect, learning and social responsibility.",
                bp6: "Equal employment opportunities",
                p14: "We consider job applications from candidates without regard to race, gender, religion, skin color, ethnical background, age, gender identity and expression, disability, sexual orientation, veteran status or other factors not related to qualification for a certain position.",
                bp7: "Innovation",
                p15: "We are constantly looking for better ways to benefit our clients, suppliers and colleagues. We anticipate changes in proactively creating solutions fit for them.",
                bp8: "Responsibility",
                p16: "We say what we do, and we do what we say. We consistently achieve results that meet or exceed the expectations of our partners and suppliers.",
                bp9: "Integrity",
                p17: "We maintain the highest ethical standards demonstrating integrity and fairness in every action we take, everywhere and at all times.",
                bp10: "Teamwork and respect",
                p18: "We respect the rights and beliefs of our colleagues, partners and society. We treat others with the highest level of dignity, equality and trust, using diversity to achieve our common goals. As a team, we do more than individually.",
                bp11: "Training",
                p19: "We are constantly learning to increase productivity and to ensure the growth of our company and ourselves.",
                bp12: "Social responsibility",
                p20: "We actively look for ways to balance our financial, social and ecological responsibilities to achieve positive results for various stakeholders worldwide. On this path, we strive to cooperation, transparency and innovation.",
                bp13: "WHY MUK?",
                p21: "Our partners get a reliable distributor and a significant competitive edge with MUK.",
                p22: "Our partners easily adapt to changing market trends noting the flexibility of MUK services. Since we work with the most progressive suppliers, our clients always find new opportunities to grow their businesses.",
                p23: "Our flexible financing options are designed for our clients, whether it's a bespoke solution or dedicated credit lines, we make it easy for partners to do business.",
                p24: "We resolve all arising issues with the help of dedicated account managers and product specialists assigned to different vendors. All the knowledge you need is gathered in one place, and our professional training and extensive marketing support mean you can be sure in everything we do.",
                p25: "MUK is an experienced company providing you with flexibility and responsiveness to the needs of your business and customers.",
                p26: "Our commercial initiatives range guarantees you an excellent quality of work. We also can help our clients benefit from experienced international logistics, training and service centers, cloud products department.",
                p27: "We know better than anyone that a good workflow means good sales, and we understand that responsiveness, proactivity and risk management are an important part of our partner's successful business and their reputation with customers. Therefore, we have created electronic tools that improve your business processes and simplify the speed of interaction.",
                p28: "We help increase your income and profitability every step of the way."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "If you have any questions?",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                send: "Send",
                nm: "Name",
                ad: "Address",
                ph: "Telephone",
                em: "Email",
                ms: "Message",
                contactInfo: "Contact details",
                address: "16/2 Donetska str., Kyiv 03151, Ukraine",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "All rights reserved."
            }
        }
    }

    if (lang === "bg") {
        text = {
            Navigation: [
                {
                    menu: "Countries",
                    href: "#header",
                    podmenu: [
                        {
                            link: "/country/al",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "/country/am",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "/country/az",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "/country/bg",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "/country/hr",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "/country/ge",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "/country/kz",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "/country/kg",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "/country/mk",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "/country/md",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "/country/mn",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "/country/ae",
                            name: "United Arab Emirates",
                            flag: "ae.png",
                            id: 23,
                            iso: "ae"
                        },
                        {
                            link: "/country/rs",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "/country/si",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "/country/sk",
                            name: "Slovakia",
                            flag: "sk.svg",
                            id: 29,
                            iso: "sk"
                        },
                        {
                            link: "/country/sg",
                            name: "Singapore",
                            flag: "sg.svg",
                            id: 26,
                            iso: "sg"
                        },
                        {
                            link: "/country/tj",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "/country/tr",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "/country/tm",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "/country/hu",
                            name: "Унгария",
                            flag: "hu.png",
                            id: 24,
                            iso: "hu"
                        },
                        {
                            link: "/country/ua",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "/country/uz",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                },
                {
                    menu: "Solutions",
                    href: "#features",
                    podmenu: [
                        {
                            link: "/vendors",
                            name: "MUK vendors"
                        },
                        {
                            link: "/solutions",
                            name: "MUK solutions"
                        },
                        {
                            link: "https://muk.group/download/files/katalog_muk.pdf",
                            name: "Catalogue of products and services"
                        }
                    ]
                },
                {
                    menu: "News",
                    href: "#portfolio",
                    podmenu: [
                        {
                            link: "/all-news",
                            name: "News and Deals"
                        },
                        {
                            link: "/muk-review",
                            name: "MUK journal"
                        },
                        {
                            link: "https://www.youtube.com/user/MediaMuk",
                            name: "Video"
                        }
                    ]
                },
                {
                    menu: "ACTIVITIES",
                    href: "",
                    podmenu: [
                        {
                            link: "/distribution",
                            name: "IT Distribution"
                        },
                        {
                            link: "https://muk.training/en/",
                            name: "Training center"
                        },
                        {
                            link: "https://service.muk.ua/",
                            name: "Service center"
                        },
                        {
                            link: "https://cloud.muk.ua/",
                            name: "MUK Cloud services"
                        }
                    ]
                },
                {
                    menu: "About company",
                    href: "#about",
                    podmenu: [
                        {
                            link: "/about-muk",
                            name: "About MUK"
                        },
                        {
                            link: "https://muk.group/download/files/en_corporate_profile.pdf",
                            name: "Corporative profile"
                        },
                        {
                            link: "/vacancies",
                            name: "Careers"
                        }
                    ]
                },
                {
                    menu: "Dealer section",
                    href: "",
                    podmenu: [
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Albania",
                            flag: "al.png",
                            id: 12,
                            iso: "al"
                        },
                        {
                            link: "https://b2b.muk.am/",
                            name: "Armenia",
                            flag: "am.svg",
                            id: 1,
                            iso: "am"
                        },
                        {
                            link: "https://b2b.muk.az/",
                            name: "Azerbaijan",
                            flag: "az.svg",
                            id: 20,
                            iso: "az"
                        },
                        {
                            link: "http://b2b.mukcomputers.bg/",
                            name: "Bulgaria",
                            flag: "bg.png",
                            id: 22,
                            iso: "bg"
                        },
                        {
                            link: "https://b2b.muk.com.hr/",
                            name: "Croatia",
                            flag: "hr.png",
                            id: 18,
                            iso: "hr"
                        },
                        {
                            link: "https://b2b.muk.ge/",
                            name: "Georgia",
                            flag: "ge.svg",
                            id: 3,
                            iso: "ge"
                        },
                        {
                            link: "https://b2bnew.muk.kz/",
                            name: "Kazakhstan",
                            flag: "kz.png",
                            id: 4,
                            iso: "kz"
                        },
                        {
                            link: "https://b2b.muk.kg/",
                            name: "Kyrgyzstan",
                            flag: "kg.png",
                            id: 5,
                            iso: "kg"
                        },
                        {
                            link: "https://b2b.muk.mk/",
                            name: "North Macedonia",
                            flag: "mk.png",
                            id: 15,
                            iso: "mk"
                        },
                        {
                            link: "https://b2b.muk.md/",
                            name: "Moldova",
                            flag: "md.png",
                            id: 6,
                            iso: "md"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Mongolia",
                            flag: "mn.png",
                            id: 7,
                            iso: "mn"
                        },
                        {
                            link: "https://b2b.muk.co.rs/",
                            name: "Serbia",
                            flag: "rs.png",
                            id: 16,
                            iso: "rs"
                        },
                        {
                            link: "https://b2b.muk.si/",
                            name: "Slovenia",
                            flag: "si.png",
                            id: 17,
                            iso: "si"
                        },
                        {
                            link: "https://b2b.muk.tj/",
                            name: "Tajikistan",
                            flag: "tj.png",
                            id: 8,
                            iso: "tj"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkey",
                            flag: "tr.svg",
                            id: 21,
                            iso: "tr"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Turkmenistan",
                            flag: "tm.png",
                            id: 9,
                            iso: "tm"
                        },
                        {
                            link: "https://b2b.muk.ua/",
                            name: "Ukraine",
                            flag: "ua.png",
                            id: 11,
                            iso: "ua"
                        },
                        {
                            link: "https://b2b.muk.uz/",
                            name: "Uzbekistan",
                            flag: "uz.svg",
                            id: 10,
                            iso: "uz"
                        }
                    ]
                }
            ],
            Header: {
                titleOne: "INTERNATIONAL PROJECT VALUE-ADDED IT DISTRIBUTOR",
                paragraph: "Welcome to MUK – a reliable multi-vendor IT distributor. We earned credibility through years of experience, technical expertise and well-established partnership type of work with MUK Partners.",
                partner: "Become a partner"
            },
            Features: [
                {
                    icon: "fa fa-globe",
                    title: "International distributor",
                    text: "MUK operates in 16 countries of Europe and Asia, and continue to expand"
                },
                {
                    icon: "fa fa-star",
                    title: "25+ years of success",
                    text: "MUK holds a leading position in distribution since 1997"
                },
                {
                    icon: "fa fa-users",
                    title: "Unique expertise",
                    text: "Teams of engineers handle the most complicated tasks"
                },
                {
                    icon: "fa fa-briefcase",
                    title: "100+ manufacturers",
                    text: "MUK distributor’s portfolio contains more than 100 international A-brands and never cease to grow"
                }
            ],
            ServicesInfo: {
                title: "MUK Scope of Activities"
            },
            Services: [
                {
                    icon: "fa fa-truck",
                    name: "IT Distribution",
                    text: "MUK is a value-added distributor focused on IT project business. We have been successfully developing a dealer network in Europe and Asia for more than 25 years. With the help of our certified specialists, MUK company provides partners with the high level of project consulting and technical support to generate additional value for the proposed solutions. MUK engineers ensure consulting and technical support for software and hardware solutions, conduct audits of existing systems and help with the implementation of test benches. Our stock of test equipment allows us to simulate and implement a wide range of tasks in real conditions. MUK actively assists integrators in choosing and designing optimal solutions. The MUK team includes over 500 specialists in various technology areas who are certified by the world's leading IT manufacturers.",
                    activ1: "International logistics, formation of stocks",
                    activ2: "Marketing and consulting support for partners",
                    activ3: "Increasing solutions’ value through our own expertize",
                    activ4: "Product launch, promotion and demand generation",
                    activ5: "Technical support, warranty and post-warranty service",
                    activ6: "Partner network development"
                },
                {
                    icon: "fa fa-cloud",
                    name: "MUK Cloud Solution Provider, Cloud products",
                    text: "MUK Cloud Solutions for Business are quick-start suites of solutions and services aimed at ensuring business continuity, increasing work efficiency and mobility of employees with the provision of modern secure collaboration tools. With their help, you can quickly and efficiently implement cloud technologies in the infrastructure of your organization. The Cloud Solution Provider concept is a sales channel, in which Microsoft Office 365, AZURE, EMS, D365 and other cloud services are available on a monthly payment basis. MUK offers the creation of infrastructure 'from scratch'. Minimum capital costs. Optimal operating costs for cloud resources rental and maintenance. Infrastructure scaling – enterprise growth, new territorial offices, planned load bursts. New cloud services integrated with ground infrastructure.",
                    activ1: "Storing backups (files, virtual machines, databases) in the cloud",
                    activ2: "Crash protection, recovery. High availability cluster at virtual machines or SQL databases level",
                    activ3: "Mobile device management",
                    activ4: "Corporate information and correspondence protection",
                    activ5: "SharePoint online, Exchange online, Skype for business online deployment",
                    activ6: "Deployment and setting of websites, migration of websites to the cloud"
                },
                {
                    icon: "fa fa-wrench",
                    name: "MUK Service Center",
                    text: "It takes a true professional to fix any malfunction. Gaining experience and daily practice, our repairers ensure the best quality of service. As professionalism comes with experience, MUK Service company has been successfully providing computer repair services since 2002, and today we are an authorized service center for APC, Hitachi Vantara, Checkpoint, Extreme Networks, Cisco, Oracle, Tripp-Lite, Grandstream, HP, Fortinet, IBM, Fujitsu, EnGenius, Dell EMC, Tescom and other manufacturers. MUK Service quality management system is confirmed by the ISO 9001 of the Bureau of International Certification. Our service center has all necessary technical capabilities and certified professionals to guarantee our clients high-quality equipment repair. The service center performs maintenance, warranty and non-warranty repairs of any level of complexity. MUK Service company provides equipment rental and outsourcing, installation and maintenance services, as well as information and consulting services for corporate clients in Ukraine, Armenia, Georgia, Moldova, Tajikistan and Kazakhstan.",
                    activ1: "Warranty repair",
                    activ2: "Non-warranty repair",
                    activ3: "Equipment diagnostics",
                    activ4: "Spare parts sale",
                    activ5: "Service contracts audit",
                    activ6: "Outsourcing and equipment rental"
                },
                {
                    icon: "fa fa-graduation-cap",
                    name: "MUK Training Center",
                    text: "MUK Training Center is a market leader in IT educational services with more than 15 years of experience, a number of unique authorizations, a team of qualified instructors, and a modern training infrastructure. The MUK TC portfolio is based on 300+ training courses from leading IT companies. Noteworthy statuses include: Pearson VUE, Veeam Authorized Education Center, HPE Education Center, VMware Authorized Training Center, Oracle Approved Education Provider, Penta Security Education Center, Juniper Networks Authorized Education Partner, LearnQuest IBM Education Partner, Microsoft Education Silver Partner, ITIL Training Partner, Dell-EMC Education Services Partner, Autodesk Training Center, Grandstream Learning Center, Check Point Authorized Training Center, Fortinet Authorized Training Center, CommScope Training Center, Cisco Learning Center, Red Hat Certified Training Partner, and many others. MUK Training center has access to the best of modern educational equipment. The quality of our training programs has received the highest marks from students in Ukraine and abroad."
                }
            ],
            Vendors: {
                title: "MUK vendors",
                country: "Country",
                solution: "Solution",
                name: "Name",
                all: "All",
                namePlaceholder: "Start typing the vendor's name",
                notInfo: "Information is not filled in"
            },
            VendorsForCountry: {
                title: "MUK vendors available in the country"
            },
            VendorsForSolution: {
                title: "MUK vendors by solution"
            },
            VendorDetail: {
                title: "AUTHORIZED DISTRIBUTOR"
            },
            Gallery: {
                title: "MUK solutions"
            },
            Distribution: {
                title: "IT Distribution"
            },
            Partner: {
                title: "Become a partner",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                com: "Company",
                sitecom: "Site company",
                dir: "Direction of activity",
                found: "How did you find out about us",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            Resume: {
                title: "Send a CV",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                vac: "Interested vacancy",
                nm: "Full Name",
                ph: "Telephone",
                em: "Email",
                file: "CV (PDF or DOC)",
                note: "Cover letter",
                send: "Send",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk"
            },
            About: {
                title: "MUK builds its business on the partnership and cooperation principles",
                advantages: "Benefits",
                paragraph: "MUK has been focusing on transparency in relations with suppliers and customers since its foundation. Devotion to the rules of partnership has allowed MUK to earn the trust of the market and build a leader's reputation.",
                Why: [
                    "Innovations",
                    "Responsibility",
                    "Integrity",
                    "Equal employment opportunities"

                ],
                Why2: [
                    "Teamwork and respect",
                    "Training",
                    "Social responsibility"
                ]
            },
            News: {
                title: "MUK news",
                showAll: "Show more",
                showMore: "Show more",
                news: "News",
                akcii: "Deal"
            },
            Vacancies: {
                title: "Careers",
                resume: "Send a CV",
                country: "Country",
                all: "All",
                search: "Search",
                namePlaceholder: "Start typing the name",
                filterInfo: "No jobs matching these filters",
                notInfo: "Information is not filled in",
                back: "Back"

            },
            MukReview: {
                title: " \"MUK-REVIEW\" journal issues",
                vupysk: "Issue"
            },
            OMuk: {
                title: "About MUK",
                p1: "The MUK group of companies started its activity in 1997. Our main area of work is the project-oriented distribution of leading IT products in the field of hybrid and cloud solutions, data center convergence, information security, mobile devices and the Internet of things, data analytics and artificial intelligence.",
                p2: "Thanks to our global distribution network, we bring promising IT vendors and their new products to local markets and actively participate in demand formation.",
                p3: "We combine expert technical and market knowledge with a progressive partner support program. Working closely with our dealers, we strive to ensure their dynamic growth and development, achieving results together.",
                bp1: "WE ARE THE INFORMATION TECHNOLOGIES!",
                p4: "MUK company has been a pioneer in information technology distribution for over 25 years. Today, MUK plays an important role in transferring technologies from those who develop it to those who implement and use it.",
                ul: "Here are the four figures characterizing MUK as a reliable partner and efficient distributor:",
                li1: "1. More than 25 years of experience and trust.",
                li2: "2. More than 100 vendors of A-brand level (worldwide known companies with proven products).",
                li3: "3. Each vendor's area has its managers, presales and engineers, so our staff consists of over 500 specialists.",
                li4: "4. We currently serve over 4000 active partners, including classical IT integrators but manufacturing enterprises, construction companies, consulting companies, and software developers who use our products in their deliveries.",
                bp2: "STRATEGY",
                p5: "Our strategy is to be recognized by both suppliers and resellers as a leading IT distributor, thanks to our vast experience, high competence and presence in different countries of the world.",
                bp3: "MISSION",
                p6: "Our mission is to provide our Partners with innovative solutions and quality products just in time.",
                p7: "We work dedicatedly to promote technology products and solutions to meet growing market demand and add value to both suppliers and resellers through prompt product availability and in-depth product knowledge.",
                p8: "MUK is systematically working to create demand and product launch, as well as generate profitable opportunities for our resellers through an affiliate program, an efficient supply chain and training.",
                p9: "We strive to maintain an environment that empowers our people, recognizes their accomplishments and helps them adapt to an ever-changing business environment. MUK motivates employees for sustainable personal and professional growth.",
                bp4: "PARTNERSHIP AND RESPONSIBILITY",
                p10: "MUK adheres to an exclusive partner business model. We do not work with end customers and rely on the development of the dealer network. Among our partners' end customers are all domestic business sectors: retail, industry, finance and the public sector.",
                p11: "We share the responsibility for achieving success with our partners. Our credo: \"We go together, so we go together to the end.\" We support our partners in difficult situations and celebrate victories together, and, as experience has shown, we have much more common wins than defeats.",
                p12: "With its many years of work, MUK has proven the viability of its multi-vendor strategy in which all vendors in our portfolio get an equal chance to develop and work in a competitive market environment. We reserve the right for partners to choose a strategy for working on projects while helping to create complex solutions, advising on the entire sales cycle: from task removal to implementation and maintenance.",
                bp5: "OUR VALUES",
                p13: "MUK is fully focused on enhancing the success of its business partners and employees by adhering to the values of innovation, responsibility, integrity, equal opportunities and teamwork, respect, learning and social responsibility.",
                bp6: "Equal employment opportunities",
                p14: "We consider job applications from candidates without regard to race, gender, religion, skin color, ethnical background, age, gender identity and expression, disability, sexual orientation, veteran status or other factors not related to qualification for a certain position.",
                bp7: "Innovation",
                p15: "We are constantly looking for better ways to benefit our clients, suppliers and colleagues. We anticipate changes in proactively creating solutions fit for them.",
                bp8: "Responsibility",
                p16: "We say what we do, and we do what we say. We consistently achieve results that meet or exceed the expectations of our partners and suppliers.",
                bp9: "Integrity",
                p17: "We maintain the highest ethical standards demonstrating integrity and fairness in every action we take, everywhere and at all times.",
                bp10: "Teamwork and respect",
                p18: "We respect the rights and beliefs of our colleagues, partners and society. We treat others with the highest level of dignity, equality and trust, using diversity to achieve our common goals. As a team, we  do more than individually.",
                bp11: "Training",
                p19: "We are constantly learning to increase productivity and to ensure the growth of our company and ourselves.",
                bp12: "Social responsibility",
                p20: "We actively look for ways to balance our financial, social and ecological responsibilities to achieve positive results for various stakeholders worldwide. On this path, we strive to cooperation, transparency and innovation.",
                bp13: "WHY MUK?",
                p21: "Our partners get a reliable distributor and a significant competitive edge with MUK.",
                p22: "Our partners easily adapt to changing market trends noting the flexibility of MUK services. Since we work with the most progressive suppliers, our clients always find new opportunities to grow their businesses.",
                p23: "Our flexible financing options are designed for our clients, whether it's a bespoke solution or dedicated credit lines, we make it easy for partners to do business.",
                p24: "We resolve all arising issues with the help of dedicated account managers and product specialists assigned to different vendors. All the knowledge you need is gathered in one place, and our professional training and extensive marketing support mean you can be sure in everything we do.",
                p25: "MUK is an experienced company providing you with flexibility and responsiveness to the needs of your business and customers.",
                p26: "Our commercial initiatives range guarantees you an excellent quality of work. We also can help our clients benefit from experienced international logistics, training and service centers, cloud products department.",
                p27: "We know better than anyone that a good workflow means good sales, and we understand that responsiveness, proactivity and risk management are an important part of our partner's successful business and their reputation with customers. Therefore, we have created electronic tools that improve your business processes and simplify the speed of interaction.",
                p28: "We help increase your income and profitability every step of the way."

            },
            Privacy: {
                title: "Privacy Policy and Terms of Use",
                p1: "I agree to the terms of confidentiality and authorize the use of my personal data for lawful purposes.",
                bp1: "Personal data",
                p2: "To comply with the requirements of the Law of Ukraine \"On the Protection of Personal Data\", I agree to the processing of my personal data in order to ensure the implementation of civil law relations, including verification of the information specified in the registration form.",
                p3: "We value your right to privacy and non-disclosure of your personal information. This Privacy Policy is a rule shared by all employees of our company and governs the collection and use of personal information that may be requested / received when visiting our website and application.",
                bp2: "How We Collect Information",
                p4: "Personal information, as already noted above, comes directly from you, and with your confirmation. So, when you register on the site, we receive the information you provide.",
                bp3: "Disclosure and transfer of data",
                p5: "The information we collect is used exclusively on the site and in the exhibition application, as well as in services that are related to the organization of the event. We may provide general data to our partners to provide services according to the topic of the marketing campaign/webinar/event for which registration has been received from the participant/user. We disclose personal information only in cases determined by the current legislation of Ukraine.",
                bp4: "Newsletters",
                p6: "You also agree to receive information, including advertising, and allow you to send SMS, mailings using information and communication services such as Viber, as well as other types of mailings and notifications using any means of communication.",
                bp5: "Updates to this warning",
                p7: "We may unilaterally change or update portions of this policy at any time without notice. Please review the Privacy Policy from time to time to be aware of its changes and updates. All changes to this Privacy Policy are effective from the moment they are posted.",
                p8: "If any part of this Privacy Policy is held invalid or unenforceable, the other parts thereof will remain in effect.",
            },
            Contact: {
                question: "If you have any questions?",
                description: "Please fill in the following form to send us an e-mail and we will get in contact with you as soon as possible.",
                send: "Send",
                nm: "Name",
                ad: "Address",
                ph: "Telephone",
                em: "Email",
                ms: "Message",
                contactInfo: "Contact details",
                address: "16/2 Donetska str., Kyiv 03151, Ukraine",
                phone: "(044) 492-29-09, 594-97-97",
                email: "info@muk.international",
                facebook: "https://www.facebook.com/MUKGROUP",
                twitter: "https://twitter.com/muk_ua",
                youtube: "https://www.youtube.com/user/MediaMuk",
                footer: "All rights reserved."
            }
        }
    }

    return text
}


